const legend = ['FIPS', 'Winter', 'Storm', 'Flood', 'Fire', 'Heat', 'Drought', 'Hurricane'];

  // Object keys are county FIPS, first object is corresponding Winter risk, second object is storm data etc...
const disasters =
[
  {
    "1001": 17,
    "1003": 5,
    "1005": 7,
    "1007": 18,
    "1009": 33,
    "1011": 11,
    "1013": 6,
    "1015": 32,
    "1017": 21,
    "1019": 32,
    "1021": 19,
    "1023": 13,
    "1025": 24,
    "1027": 21,
    "1029": 28,
    "1031": 3,
    "1033": 68,
    "1035": 8,
    "1037": 17,
    "1039": 10,
    "1041": 6,
    "1043": 72,
    "1045": 4,
    "1047": 13,
    "1049": 92,
    "1051": 18,
    "1053": 6,
    "1055": 31,
    "1057": 23,
    "1059": 68,
    "1061": 3,
    "1063": 17,
    "1065": 17,
    "1067": 4,
    "1069": 3,
    "1071": 91,
    "1073": 48,
    "1075": 26,
    "1077": 78,
    "1079": 69,
    "1081": 18,
    "1083": 73,
    "1085": 11,
    "1087": 10,
    "1089": 135,
    "1091": 13,
    "1093": 27,
    "1095": 79,
    "1097": 4,
    "1099": 10,
    "1101": 44,
    "1103": 76,
    "1105": 14,
    "1107": 21,
    "1109": 10,
    "1111": 22,
    "1113": 13,
    "1115": 24,
    "1117": 24,
    "1119": 17,
    "1121": 26,
    "1123": 21,
    "1125": 32,
    "1127": 23,
    "1129": 12,
    "1131": 10,
    "1133": 26,
    "2013": 66,
    "2016": 162,
    "2020": 126,
    "2050": 241,
    "2060": 45,
    "2068": 161,
    "2070": 45,
    "2090": 133,
    "2100": 175,
    "2110": 274,
    "2122": 242,
    "2130": 100,
    "2150": 74,
    "2164": 140,
    "2170": 117,
    "2180": 431,
    "2185": 583,
    "2188": 399,
    "2201": 0,
    "2220": 249,
    "2232": 0,
    "2240": 86,
    "2261": 254,
    "2270": 0,
    "2280": 0,
    "2282": 101,
    "2290": 449,
    "4001": 157,
    "4003": 41,
    "4005": 403,
    "4007": 46,
    "4009": 43,
    "4011": 21,
    "4012": 0,
    "4013": 0,
    "4015": 48,
    "4017": 233,
    "4019": 43,
    "4021": 37,
    "4023": 17,
    "4025": 81,
    "4027": 0,
    "5001": 45,
    "5003": 20,
    "5005": 79,
    "5007": 44,
    "5009": 94,
    "5011": 36,
    "5013": 37,
    "5015": 43,
    "5017": 19,
    "5019": 42,
    "5021": 52,
    "5023": 62,
    "5025": 43,
    "5027": 30,
    "5029": 55,
    "5031": 54,
    "5033": 25,
    "5035": 42,
    "5037": 43,
    "5039": 46,
    "5041": 37,
    "5043": 43,
    "5045": 57,
    "5047": 23,
    "5049": 72,
    "5051": 55,
    "5053": 52,
    "5055": 56,
    "5057": 32,
    "5059": 52,
    "5061": 35,
    "5063": 67,
    "5065": 70,
    "5067": 61,
    "5069": 55,
    "5071": 59,
    "5073": 29,
    "5075": 54,
    "5077": 35,
    "5079": 40,
    "5081": 30,
    "5083": 61,
    "5085": 58,
    "5087": 43,
    "5089": 76,
    "5091": 34,
    "5093": 51,
    "5095": 49,
    "5097": 58,
    "5099": 32,
    "5101": 81,
    "5103": 39,
    "5105": 57,
    "5107": 26,
    "5109": 40,
    "5111": 45,
    "5113": 62,
    "5115": 60,
    "5117": 50,
    "5119": 63,
    "5121": 54,
    "5123": 38,
    "5125": 58,
    "5127": 59,
    "5129": 77,
    "5131": 26,
    "5133": 31,
    "5135": 77,
    "5137": 67,
    "5139": 31,
    "5141": 67,
    "5143": 39,
    "5145": 59,
    "5147": 53,
    "5149": 56,
    "6001": 3,
    "6003": 826,
    "6005": 331,
    "6007": 181,
    "6009": 310,
    "6011": 81,
    "6013": 3,
    "6015": 6,
    "6017": 882,
    "6019": 0,
    "6021": 62,
    "6023": 67,
    "6025": 0,
    "6027": 73,
    "6029": 0,
    "6031": 0,
    "6033": 74,
    "6035": 413,
    "6037": 109,
    "6039": 0,
    "6041": 7,
    "6043": 0,
    "6045": 34,
    "6047": 0,
    "6049": 247,
    "6051": 249,
    "6053": 8,
    "6055": 6,
    "6057": 868,
    "6059": 8,
    "6061": 882,
    "6063": 413,
    "6065": 88,
    "6067": 26,
    "6069": 3,
    "6071": 132,
    "6073": 77,
    "6075": 9,
    "6077": 26,
    "6079": 17,
    "6081": 4,
    "6083": 64,
    "6085": 7,
    "6087": 3,
    "6089": 411,
    "6091": 520,
    "6093": 727,
    "6095": 26,
    "6097": 7,
    "6099": 21,
    "6101": 28,
    "6103": 267,
    "6105": 54,
    "6107": 1,
    "6109": 310,
    "6111": 100,
    "6113": 21,
    "6115": 296,
    "8001": 185,
    "8003": 354,
    "8005": 309,
    "8007": 687,
    "8009": 23,
    "8011": 14,
    "8013": 761,
    "8014": 242,
    "8015": 549,
    "8017": 52,
    "8019": 428,
    "8021": 363,
    "8023": 616,
    "8025": 14,
    "8027": 611,
    "8029": 1584,
    "8031": 125,
    "8033": 775,
    "8035": 428,
    "8037": 1344,
    "8039": 197,
    "8041": 271,
    "8043": 626,
    "8045": 2482,
    "8047": 428,
    "8049": 608,
    "8051": 1443,
    "8053": 1021,
    "8055": 964,
    "8057": 328,
    "8059": 545,
    "8061": 33,
    "8063": 73,
    "8065": 332,
    "8067": 671,
    "8069": 477,
    "8071": 378,
    "8073": 73,
    "8075": 51,
    "8077": 1594,
    "8079": 463,
    "8081": 1584,
    "8083": 668,
    "8085": 1861,
    "8087": 45,
    "8089": 16,
    "8091": 848,
    "8093": 467,
    "8095": 27,
    "8097": 797,
    "8099": 19,
    "8101": 283,
    "8103": 1151,
    "8105": 663,
    "8107": 1803,
    "8109": 730,
    "8111": 484,
    "8113": 1623,
    "8115": 39,
    "8117": 296,
    "8119": 186,
    "8121": 51,
    "8123": 171,
    "8125": 71,
    "9001": 187,
    "9003": 111,
    "9005": 283,
    "9007": 130,
    "9009": 172,
    "9011": 128,
    "9013": 103,
    "9015": 97,
    "10001": 165,
    "10003": 206,
    "10005": 281,
    "11001": 123,
    "12001": 0,
    "12003": 2,
    "12005": 4,
    "12007": 1,
    "12009": 8,
    "12011": 18,
    "12013": 1,
    "12015": 0,
    "12017": 1,
    "12019": 4,
    "12021": 34,
    "12023": 0,
    "12027": 38,
    "12029": 2,
    "12031": 10,
    "12033": 4,
    "12035": 7,
    "12037": 4,
    "12039": 2,
    "12041": 2,
    "12043": 27,
    "12045": 3,
    "12047": 1,
    "12049": 43,
    "12051": 29,
    "12053": 2,
    "12055": 38,
    "12057": 1,
    "12059": 3,
    "12061": 5,
    "12063": 4,
    "12065": 4,
    "12067": 2,
    "12069": 8,
    "12071": 0,
    "12073": 5,
    "12075": 3,
    "12077": 2,
    "12079": 2,
    "12081": 1,
    "12083": 0,
    "12085": 4,
    "12086": 27,
    "12087": 0,
    "12089": 3,
    "12091": 3,
    "12093": 5,
    "12095": 7,
    "12097": 5,
    "12099": 35,
    "12101": 2,
    "12103": 9,
    "12105": 51,
    "12107": 3,
    "12109": 3,
    "12111": 5,
    "12113": 2,
    "12115": 1,
    "12117": 7,
    "12119": 85,
    "12121": 1,
    "12123": 4,
    "12125": 1,
    "12127": 9,
    "12129": 4,
    "12131": 7,
    "12133": 2,
    "13001": 6,
    "13003": 1,
    "13005": 5,
    "13007": 4,
    "13009": 27,
    "13011": 62,
    "13013": 46,
    "13015": 50,
    "13017": 6,
    "13019": 3,
    "13021": 25,
    "13023": 20,
    "13025": 2,
    "13027": 3,
    "13029": 8,
    "13031": 13,
    "13033": 8,
    "13035": 29,
    "13037": 5,
    "13039": 1,
    "13043": 9,
    "13045": 47,
    "13047": 60,
    "13049": 0,
    "13051": 13,
    "13053": 21,
    "13055": 54,
    "13057": 64,
    "13059": 44,
    "13061": 5,
    "13063": 42,
    "13065": 3,
    "13067": 54,
    "13069": 4,
    "13071": 4,
    "13073": 9,
    "13075": 3,
    "13077": 40,
    "13079": 23,
    "13081": 19,
    "13083": 68,
    "13085": 79,
    "13087": 4,
    "13089": 47,
    "13091": 20,
    "13093": 20,
    "13095": 4,
    "13097": 45,
    "13099": 4,
    "13101": 0,
    "13103": 8,
    "13105": 44,
    "13107": 23,
    "13109": 9,
    "13111": 82,
    "13113": 40,
    "13115": 53,
    "13117": 58,
    "13119": 51,
    "13121": 91,
    "13123": 79,
    "13125": 22,
    "13127": 3,
    "13129": 54,
    "13131": 3,
    "13133": 32,
    "13135": 51,
    "13137": 78,
    "13139": 61,
    "13141": 26,
    "13143": 40,
    "13145": 25,
    "13147": 47,
    "13149": 32,
    "13151": 34,
    "13153": 22,
    "13155": 6,
    "13157": 48,
    "13159": 30,
    "13161": 8,
    "13163": 22,
    "13165": 9,
    "13167": 24,
    "13169": 27,
    "13171": 28,
    "13173": 3,
    "13175": 22,
    "13177": 6,
    "13179": 11,
    "13181": 10,
    "13183": 4,
    "13185": 3,
    "13187": 83,
    "13189": 9,
    "13191": 12,
    "13193": 20,
    "13195": 49,
    "13197": 21,
    "13199": 29,
    "13201": 3,
    "13205": 3,
    "13207": 28,
    "13209": 18,
    "13211": 30,
    "13213": 65,
    "13215": 27,
    "13217": 36,
    "13219": 42,
    "13221": 39,
    "13223": 47,
    "13225": 23,
    "13227": 74,
    "13229": 3,
    "13231": 28,
    "13233": 46,
    "13235": 20,
    "13237": 28,
    "13239": 8,
    "13241": 108,
    "13243": 5,
    "13245": 8,
    "13247": 37,
    "13249": 21,
    "13251": 13,
    "13253": 3,
    "13255": 36,
    "13257": 64,
    "13259": 21,
    "13261": 19,
    "13263": 24,
    "13265": 30,
    "13267": 8,
    "13269": 23,
    "13271": 20,
    "13273": 5,
    "13275": 3,
    "13277": 5,
    "13279": 19,
    "13281": 88,
    "13283": 19,
    "13285": 28,
    "13287": 5,
    "13289": 24,
    "13291": 92,
    "13293": 26,
    "13295": 60,
    "13297": 75,
    "13299": 0,
    "13301": 25,
    "13303": 25,
    "13305": 2,
    "13307": 20,
    "13309": 18,
    "13311": 86,
    "13313": 59,
    "13315": 19,
    "13317": 34,
    "13319": 23,
    "13321": 6,
    "15001": 35,
    "15003": 16,
    "15005": 0,
    "15007": 18,
    "15009": 3,
    "16001": 23,
    "16003": 118,
    "16005": 5,
    "16007": 2,
    "16009": 446,
    "16011": 6,
    "16013": 7,
    "16015": 109,
    "16017": 412,
    "16019": 3,
    "16021": 412,
    "16023": 2,
    "16025": 150,
    "16027": 41,
    "16029": 6,
    "16031": 3,
    "16033": 3,
    "16035": 272,
    "16037": 5,
    "16039": 173,
    "16041": 1,
    "16043": 112,
    "16045": 149,
    "16047": 35,
    "16049": 286,
    "16051": 1,
    "16053": 35,
    "16055": 922,
    "16057": 446,
    "16059": 126,
    "16061": 67,
    "16063": 1,
    "16065": 1,
    "16067": 2,
    "16069": 81,
    "16071": 0,
    "16073": 109,
    "16075": 41,
    "16077": 6,
    "16079": 328,
    "16081": 2,
    "16083": 59,
    "16085": 108,
    "16087": 159,
    "17001": 51,
    "17003": 123,
    "17005": 45,
    "17007": 50,
    "17009": 49,
    "17011": 137,
    "17013": 46,
    "17015": 160,
    "17017": 45,
    "17019": 59,
    "17021": 42,
    "17023": 27,
    "17025": 31,
    "17027": 43,
    "17029": 36,
    "17031": 172,
    "17033": 31,
    "17035": 28,
    "17037": 56,
    "17039": 47,
    "17041": 38,
    "17043": 67,
    "17045": 34,
    "17047": 147,
    "17049": 32,
    "17051": 47,
    "17053": 34,
    "17055": 147,
    "17057": 59,
    "17059": 136,
    "17061": 43,
    "17063": 47,
    "17065": 142,
    "17067": 124,
    "17069": 129,
    "17071": 121,
    "17073": 148,
    "17075": 40,
    "17077": 146,
    "17079": 27,
    "17081": 156,
    "17083": 51,
    "17085": 159,
    "17087": 138,
    "17089": 70,
    "17091": 46,
    "17093": 49,
    "17095": 58,
    "17097": 63,
    "17099": 53,
    "17101": 31,
    "17103": 54,
    "17105": 47,
    "17107": 49,
    "17109": 121,
    "17111": 62,
    "17113": 67,
    "17115": 42,
    "17117": 49,
    "17119": 54,
    "17121": 42,
    "17123": 56,
    "17125": 49,
    "17127": 120,
    "17129": 37,
    "17131": 134,
    "17133": 46,
    "17135": 46,
    "17137": 44,
    "17139": 36,
    "17141": 53,
    "17143": 67,
    "17145": 146,
    "17147": 45,
    "17149": 46,
    "17151": 131,
    "17153": 122,
    "17155": 129,
    "17157": 38,
    "17159": 25,
    "17161": 151,
    "17163": 48,
    "17165": 141,
    "17167": 54,
    "17169": 51,
    "17171": 38,
    "17173": 39,
    "17175": 56,
    "17177": 157,
    "17179": 56,
    "17181": 137,
    "17183": 48,
    "17185": 146,
    "17187": 124,
    "17189": 42,
    "17191": 148,
    "17193": 149,
    "17195": 148,
    "17197": 71,
    "17199": 140,
    "17201": 57,
    "17203": 55,
    "18001": 57,
    "18003": 72,
    "18005": 28,
    "18007": 31,
    "18009": 48,
    "18011": 34,
    "18013": 27,
    "18015": 29,
    "18017": 58,
    "18019": 36,
    "18021": 28,
    "18023": 36,
    "18025": 32,
    "18027": 24,
    "18029": 91,
    "18031": 27,
    "18033": 62,
    "18035": 38,
    "18037": 30,
    "18039": 87,
    "18041": 81,
    "18043": 34,
    "18045": 32,
    "18047": 87,
    "18049": 62,
    "18051": 143,
    "18053": 51,
    "18055": 22,
    "18057": 35,
    "18059": 33,
    "18061": 33,
    "18063": 37,
    "18065": 36,
    "18067": 32,
    "18069": 60,
    "18071": 32,
    "18073": 48,
    "18075": 52,
    "18077": 31,
    "18079": 23,
    "18081": 28,
    "18083": 26,
    "18085": 78,
    "18087": 71,
    "18089": 63,
    "18091": 105,
    "18093": 29,
    "18095": 40,
    "18097": 52,
    "18099": 74,
    "18101": 23,
    "18103": 62,
    "18105": 31,
    "18107": 30,
    "18109": 33,
    "18111": 42,
    "18113": 70,
    "18115": 50,
    "18117": 30,
    "18119": 27,
    "18121": 29,
    "18123": 30,
    "18125": 141,
    "18127": 69,
    "18129": 147,
    "18131": 52,
    "18133": 31,
    "18135": 33,
    "18137": 84,
    "18139": 27,
    "18141": 102,
    "18143": 31,
    "18145": 28,
    "18147": 141,
    "18149": 67,
    "18151": 65,
    "18153": 22,
    "18155": 50,
    "18157": 32,
    "18159": 32,
    "18161": 55,
    "18163": 146,
    "18165": 24,
    "18167": 30,
    "18169": 58,
    "18171": 29,
    "18173": 140,
    "18175": 30,
    "18177": 82,
    "18179": 58,
    "18181": 47,
    "18183": 67,
    "19001": 75,
    "19003": 67,
    "19005": 89,
    "19007": 67,
    "19009": 75,
    "19011": 166,
    "19013": 86,
    "19015": 93,
    "19017": 88,
    "19019": 166,
    "19021": 138,
    "19023": 94,
    "19025": 94,
    "19027": 82,
    "19029": 76,
    "19031": 153,
    "19033": 105,
    "19035": 138,
    "19037": 93,
    "19039": 78,
    "19041": 150,
    "19043": 92,
    "19045": 158,
    "19047": 81,
    "19049": 90,
    "19051": 58,
    "19053": 74,
    "19055": 167,
    "19057": 133,
    "19059": 160,
    "19061": 170,
    "19063": 103,
    "19065": 98,
    "19067": 91,
    "19069": 104,
    "19071": 79,
    "19073": 90,
    "19075": 92,
    "19077": 78,
    "19079": 93,
    "19081": 109,
    "19083": 93,
    "19085": 117,
    "19087": 134,
    "19089": 94,
    "19091": 101,
    "19093": 127,
    "19095": 155,
    "19097": 162,
    "19099": 79,
    "19101": 127,
    "19103": 158,
    "19105": 168,
    "19107": 137,
    "19109": 110,
    "19111": 127,
    "19113": 172,
    "19115": 136,
    "19117": 76,
    "19119": 158,
    "19121": 81,
    "19123": 70,
    "19125": 78,
    "19127": 80,
    "19129": 81,
    "19131": 101,
    "19133": 102,
    "19135": 73,
    "19137": 71,
    "19139": 144,
    "19141": 148,
    "19143": 164,
    "19145": 68,
    "19147": 99,
    "19149": 123,
    "19151": 97,
    "19153": 88,
    "19155": 106,
    "19157": 76,
    "19159": 75,
    "19161": 91,
    "19163": 149,
    "19165": 96,
    "19167": 144,
    "19169": 92,
    "19171": 85,
    "19173": 71,
    "19175": 78,
    "19177": 129,
    "19179": 69,
    "19181": 76,
    "19183": 139,
    "19185": 70,
    "19187": 98,
    "19189": 105,
    "19191": 105,
    "19193": 118,
    "19195": 103,
    "19197": 103,
    "20001": 39,
    "20003": 60,
    "20005": 43,
    "20007": 61,
    "20009": 43,
    "20011": 30,
    "20013": 74,
    "20015": 49,
    "20017": 33,
    "20019": 36,
    "20021": 33,
    "20023": 65,
    "20025": 67,
    "20027": 70,
    "20029": 71,
    "20031": 70,
    "20033": 60,
    "20035": 45,
    "20037": 36,
    "20039": 57,
    "20041": 76,
    "20043": 38,
    "20045": 82,
    "20047": 64,
    "20049": 39,
    "20051": 66,
    "20053": 52,
    "20055": 76,
    "20057": 82,
    "20059": 63,
    "20061": 81,
    "20063": 52,
    "20065": 48,
    "20067": 64,
    "20069": 70,
    "20071": 48,
    "20073": 40,
    "20075": 56,
    "20077": 40,
    "20079": 52,
    "20081": 66,
    "20083": 68,
    "20085": 77,
    "20087": 75,
    "20089": 85,
    "20091": 55,
    "20093": 59,
    "20095": 54,
    "20097": 67,
    "20099": 33,
    "20101": 67,
    "20103": 50,
    "20105": 38,
    "20107": 47,
    "20109": 58,
    "20111": 76,
    "20113": 55,
    "20115": 50,
    "20117": 81,
    "20119": 66,
    "20121": 44,
    "20123": 72,
    "20125": 40,
    "20127": 69,
    "20129": 57,
    "20131": 76,
    "20133": 39,
    "20135": 74,
    "20137": 50,
    "20139": 73,
    "20141": 80,
    "20143": 73,
    "20145": 69,
    "20147": 78,
    "20149": 82,
    "20151": 58,
    "20153": 64,
    "20155": 63,
    "20157": 68,
    "20159": 47,
    "20161": 78,
    "20163": 74,
    "20165": 65,
    "20167": 43,
    "20169": 50,
    "20171": 67,
    "20173": 61,
    "20175": 60,
    "20177": 87,
    "20179": 54,
    "20181": 77,
    "20183": 85,
    "20185": 71,
    "20187": 66,
    "20189": 56,
    "20191": 39,
    "20193": 67,
    "20195": 71,
    "20197": 79,
    "20199": 53,
    "20201": 73,
    "20203": 49,
    "20205": 38,
    "20207": 31,
    "20209": 49,
    "21001": 19,
    "21003": 18,
    "21005": 29,
    "21007": 126,
    "21009": 23,
    "21011": 65,
    "21013": 106,
    "21015": 92,
    "21017": 30,
    "21019": 64,
    "21021": 26,
    "21023": 55,
    "21025": 188,
    "21027": 31,
    "21029": 34,
    "21031": 20,
    "21033": 132,
    "21035": 111,
    "21037": 60,
    "21039": 116,
    "21041": 40,
    "21043": 68,
    "21045": 18,
    "21047": 122,
    "21049": 26,
    "21051": 66,
    "21053": 18,
    "21055": 132,
    "21057": 18,
    "21059": 141,
    "21061": 20,
    "21063": 75,
    "21065": 66,
    "21067": 36,
    "21069": 70,
    "21071": 142,
    "21073": 31,
    "21075": 117,
    "21077": 70,
    "21079": 23,
    "21081": 57,
    "21083": 120,
    "21085": 30,
    "21087": 17,
    "21089": 69,
    "21091": 29,
    "21093": 36,
    "21095": 152,
    "21097": 30,
    "21099": 25,
    "21101": 140,
    "21103": 32,
    "21105": 114,
    "21107": 131,
    "21109": 81,
    "21111": 37,
    "21113": 26,
    "21115": 88,
    "21117": 62,
    "21119": 84,
    "21121": 62,
    "21123": 27,
    "21125": 81,
    "21127": 64,
    "21129": 91,
    "21131": 96,
    "21133": 207,
    "21135": 55,
    "21137": 20,
    "21139": 131,
    "21141": 19,
    "21143": 126,
    "21145": 127,
    "21147": 54,
    "21149": 131,
    "21151": 24,
    "21153": 82,
    "21155": 20,
    "21157": 122,
    "21159": 80,
    "21161": 59,
    "21163": 30,
    "21165": 73,
    "21167": 26,
    "21169": 17,
    "21171": 15,
    "21173": 61,
    "21175": 112,
    "21177": 128,
    "21179": 29,
    "21181": 27,
    "21183": 26,
    "21185": 31,
    "21187": 48,
    "21189": 81,
    "21191": 49,
    "21193": 144,
    "21195": 177,
    "21197": 103,
    "21199": 81,
    "21201": 43,
    "21203": 62,
    "21205": 87,
    "21207": 16,
    "21209": 32,
    "21211": 30,
    "21213": 19,
    "21215": 28,
    "21217": 21,
    "21219": 118,
    "21221": 115,
    "21223": 27,
    "21225": 139,
    "21227": 21,
    "21229": 23,
    "21231": 53,
    "21233": 135,
    "21235": 61,
    "21237": 93,
    "21239": 27,
    "22001": 10,
    "22003": 17,
    "22005": 5,
    "22007": 6,
    "22009": 20,
    "22011": 13,
    "22013": 21,
    "22015": 22,
    "22017": 24,
    "22019": 11,
    "22021": 19,
    "22023": 10,
    "22025": 12,
    "22027": 26,
    "22029": 11,
    "22031": 16,
    "22033": 11,
    "22035": 15,
    "22037": 12,
    "22039": 14,
    "22041": 12,
    "22043": 18,
    "22045": 10,
    "22047": 8,
    "22049": 19,
    "22051": 10,
    "22053": 11,
    "22055": 13,
    "22057": 12,
    "22059": 18,
    "22061": 21,
    "22063": 10,
    "22065": 14,
    "22067": 17,
    "22069": 19,
    "22071": 7,
    "22073": 23,
    "22075": 9,
    "22077": 17,
    "22079": 25,
    "22081": 17,
    "22083": 12,
    "22085": 17,
    "22087": 8,
    "22089": 5,
    "22091": 10,
    "22093": 6,
    "22095": 8,
    "22097": 14,
    "22099": 19,
    "22101": 8,
    "22103": 10,
    "22105": 7,
    "22107": 11,
    "22109": 10,
    "22111": 25,
    "22113": 11,
    "22115": 20,
    "22117": 9,
    "22119": 23,
    "22121": 11,
    "22123": 16,
    "22125": 15,
    "22127": 18,
    "23001": 190,
    "23003": 580,
    "23005": 360,
    "23007": 377,
    "23009": 285,
    "23011": 181,
    "23013": 160,
    "23015": 159,
    "23017": 385,
    "23019": 492,
    "23021": 480,
    "23023": 166,
    "23025": 520,
    "23027": 329,
    "23029": 421,
    "23031": 345,
    "24001": 347,
    "24003": 320,
    "24005": 548,
    "24009": 117,
    "24011": 143,
    "24013": 219,
    "24015": 348,
    "24017": 258,
    "24019": 77,
    "24021": 232,
    "24023": 189,
    "24025": 101,
    "24027": 92,
    "24029": 300,
    "24031": 91,
    "24033": 153,
    "24035": 302,
    "24037": 226,
    "24039": 67,
    "24041": 141,
    "24043": 213,
    "24045": 75,
    "24047": 120,
    "24510": 168,
    "25001": 65,
    "25003": 356,
    "25005": 161,
    "25007": 46,
    "25009": 225,
    "25011": 238,
    "25013": 213,
    "25015": 215,
    "25017": 298,
    "25019": 43,
    "25021": 389,
    "25023": 234,
    "25025": 95,
    "25027": 264,
    "26001": 53,
    "26003": 343,
    "26005": 151,
    "26007": 72,
    "26009": 147,
    "26011": 48,
    "26013": 247,
    "26015": 75,
    "26017": 72,
    "26019": 96,
    "26021": 124,
    "26023": 65,
    "26025": 65,
    "26027": 107,
    "26029": 0,
    "26031": 94,
    "26033": 0,
    "26035": 59,
    "26037": 50,
    "26039": 83,
    "26041": 198,
    "26043": 149,
    "26045": 58,
    "26047": 117,
    "26049": 79,
    "26051": 47,
    "26053": 299,
    "26055": 118,
    "26057": 56,
    "26059": 60,
    "26061": 455,
    "26063": 78,
    "26065": 57,
    "26067": 60,
    "26069": 57,
    "26071": 152,
    "26073": 57,
    "26075": 59,
    "26077": 88,
    "26079": 128,
    "26081": 105,
    "26083": 238,
    "26085": 81,
    "26087": 76,
    "26089": 125,
    "26091": 70,
    "26093": 75,
    "26095": 214,
    "26097": 0,
    "26099": 74,
    "26101": 91,
    "26103": 325,
    "26105": 110,
    "26107": 65,
    "26109": 145,
    "26111": 71,
    "26113": 77,
    "26115": 61,
    "26117": 70,
    "26119": 64,
    "26121": 117,
    "26123": 80,
    "26125": 79,
    "26127": 115,
    "26129": 57,
    "26131": 331,
    "26133": 64,
    "26135": 58,
    "26137": 124,
    "26139": 143,
    "26141": 70,
    "26143": 64,
    "26145": 79,
    "26147": 86,
    "26149": 73,
    "26151": 92,
    "26153": 277,
    "26155": 67,
    "26157": 73,
    "26159": 130,
    "26161": 73,
    "26163": 76,
    "26165": 69,
    "27001": 151,
    "27003": 78,
    "27005": 260,
    "27007": 220,
    "27009": 86,
    "27011": 122,
    "27013": 106,
    "27015": 106,
    "27017": 143,
    "27019": 91,
    "27021": 158,
    "27023": 119,
    "27025": 73,
    "27027": 166,
    "27029": 233,
    "27031": 232,
    "27033": 169,
    "27035": 81,
    "27037": 90,
    "27039": 110,
    "27041": 107,
    "27043": 106,
    "27045": 108,
    "27047": 99,
    "27049": 95,
    "27051": 126,
    "27053": 89,
    "27055": 86,
    "27057": 113,
    "27059": 73,
    "27061": 164,
    "27063": 175,
    "27065": 77,
    "27067": 107,
    "27069": 161,
    "27071": 87,
    "27073": 121,
    "27075": 237,
    "27077": 109,
    "27079": 93,
    "27081": 158,
    "27083": 161,
    "27085": 93,
    "27087": 139,
    "27089": 290,
    "27091": 108,
    "27093": 85,
    "27095": 87,
    "27097": 85,
    "27099": 111,
    "27101": 170,
    "27103": 103,
    "27105": 179,
    "27107": 164,
    "27109": 121,
    "27111": 250,
    "27113": 130,
    "27115": 82,
    "27117": 168,
    "27119": 315,
    "27121": 103,
    "27123": 79,
    "27125": 133,
    "27127": 105,
    "27129": 112,
    "27131": 90,
    "27133": 161,
    "27135": 129,
    "27137": 472,
    "27139": 88,
    "27141": 76,
    "27143": 97,
    "27145": 101,
    "27147": 100,
    "27149": 106,
    "27151": 117,
    "27153": 90,
    "27155": 116,
    "27157": 98,
    "27159": 99,
    "27161": 98,
    "27163": 86,
    "27165": 92,
    "27167": 152,
    "27169": 99,
    "27171": 80,
    "27173": 109,
    "28001": 13,
    "28003": 31,
    "28005": 17,
    "28007": 18,
    "28009": 37,
    "28011": 28,
    "28013": 17,
    "28015": 15,
    "28017": 19,
    "28019": 18,
    "28021": 13,
    "28023": 10,
    "28025": 17,
    "28027": 22,
    "28029": 15,
    "28031": 12,
    "28033": 39,
    "28035": 9,
    "28037": 11,
    "28039": 6,
    "28041": 9,
    "28043": 16,
    "28045": 8,
    "28047": 8,
    "28049": 17,
    "28051": 15,
    "28053": 16,
    "28055": 16,
    "28057": 23,
    "28059": 8,
    "28061": 13,
    "28063": 12,
    "28065": 12,
    "28067": 13,
    "28069": 15,
    "28071": 26,
    "28073": 7,
    "28075": 17,
    "28077": 11,
    "28079": 15,
    "28081": 20,
    "28083": 17,
    "28085": 12,
    "28087": 19,
    "28089": 16,
    "28091": 9,
    "28093": 37,
    "28095": 20,
    "28097": 15,
    "28099": 13,
    "28101": 17,
    "28103": 18,
    "28105": 21,
    "28107": 21,
    "28109": 9,
    "28111": 7,
    "28113": 11,
    "28115": 23,
    "28117": 25,
    "28119": 19,
    "28121": 17,
    "28123": 15,
    "28125": 16,
    "28127": 13,
    "28129": 13,
    "28131": 5,
    "28133": 24,
    "28135": 16,
    "28137": 30,
    "28139": 35,
    "28141": 25,
    "28143": 34,
    "28145": 26,
    "28147": 11,
    "28149": 16,
    "28151": 23,
    "28153": 12,
    "28155": 18,
    "28157": 13,
    "28159": 18,
    "28161": 21,
    "28163": 18,
    "29001": 49,
    "29003": 46,
    "29005": 43,
    "29007": 48,
    "29009": 36,
    "29011": 34,
    "29013": 40,
    "29015": 32,
    "29017": 140,
    "29019": 52,
    "29021": 43,
    "29023": 123,
    "29025": 43,
    "29027": 47,
    "29029": 36,
    "29031": 141,
    "29033": 39,
    "29035": 129,
    "29037": 51,
    "29039": 35,
    "29041": 38,
    "29043": 37,
    "29045": 112,
    "29047": 48,
    "29049": 46,
    "29051": 45,
    "29053": 34,
    "29055": 46,
    "29057": 34,
    "29059": 37,
    "29061": 55,
    "29063": 49,
    "29065": 34,
    "29067": 35,
    "29069": 54,
    "29071": 50,
    "29073": 48,
    "29075": 46,
    "29077": 42,
    "29079": 50,
    "29081": 50,
    "29083": 48,
    "29085": 33,
    "29087": 37,
    "29089": 28,
    "29091": 32,
    "29093": 40,
    "29095": 65,
    "29097": 36,
    "29099": 52,
    "29101": 42,
    "29103": 46,
    "29105": 41,
    "29107": 45,
    "29109": 38,
    "29111": 48,
    "29113": 52,
    "29115": 43,
    "29117": 42,
    "29119": 30,
    "29121": 40,
    "29123": 38,
    "29125": 28,
    "29127": 50,
    "29129": 47,
    "29131": 29,
    "29133": 104,
    "29135": 45,
    "29137": 47,
    "29139": 48,
    "29141": 31,
    "29143": 103,
    "29145": 35,
    "29147": 49,
    "29149": 30,
    "29151": 44,
    "29153": 31,
    "29155": 50,
    "29157": 140,
    "29159": 42,
    "29161": 31,
    "29163": 46,
    "29165": 55,
    "29167": 36,
    "29169": 31,
    "29171": 51,
    "29173": 52,
    "29175": 32,
    "29177": 40,
    "29179": 38,
    "29181": 123,
    "29183": 53,
    "29185": 31,
    "29186": 40,
    "29187": 39,
    "29189": 55,
    "29195": 37,
    "29197": 50,
    "29199": 110,
    "29201": 124,
    "29203": 33,
    "29205": 46,
    "29207": 120,
    "29209": 35,
    "29211": 48,
    "29213": 33,
    "29215": 37,
    "29217": 33,
    "29219": 50,
    "29221": 42,
    "29223": 136,
    "29225": 42,
    "29227": 46,
    "29229": 38,
    "29510": 51,
    "30001": 95,
    "30003": 124,
    "30005": 58,
    "30007": 37,
    "30009": 311,
    "30011": 74,
    "30013": 156,
    "30015": 95,
    "30017": 71,
    "30019": 94,
    "30021": 96,
    "30023": 222,
    "30025": 60,
    "30027": 102,
    "30029": 671,
    "30031": 297,
    "30033": 89,
    "30035": 324,
    "30037": 81,
    "30039": 618,
    "30041": 88,
    "30043": 95,
    "30045": 111,
    "30047": 635,
    "30049": 292,
    "30051": 26,
    "30053": 219,
    "30055": 90,
    "30057": 158,
    "30059": 127,
    "30061": 283,
    "30063": 814,
    "30065": 75,
    "30067": 409,
    "30069": 60,
    "30071": 192,
    "30073": 292,
    "30075": 72,
    "30077": 405,
    "30079": 76,
    "30081": 348,
    "30083": 96,
    "30085": 182,
    "30087": 101,
    "30089": 669,
    "30091": 108,
    "30093": 222,
    "30095": 331,
    "30097": 305,
    "30099": 177,
    "30101": 44,
    "30103": 48,
    "30105": 185,
    "30107": 168,
    "30109": 81,
    "30111": 92,
    "31001": 94,
    "31003": 116,
    "31005": 49,
    "31007": 55,
    "31009": 62,
    "31011": 90,
    "31013": 77,
    "31015": 66,
    "31017": 66,
    "31019": 97,
    "31021": 104,
    "31023": 95,
    "31025": 93,
    "31027": 126,
    "31029": 44,
    "31031": 135,
    "31033": 97,
    "31035": 95,
    "31037": 93,
    "31039": 108,
    "31041": 66,
    "31043": 105,
    "31045": 87,
    "31047": 94,
    "31049": 46,
    "31051": 106,
    "31053": 109,
    "31055": 112,
    "31057": 62,
    "31059": 94,
    "31061": 92,
    "31063": 41,
    "31065": 93,
    "31067": 79,
    "31069": 52,
    "31071": 56,
    "31073": 86,
    "31075": 58,
    "31077": 84,
    "31079": 91,
    "31081": 88,
    "31083": 88,
    "31085": 40,
    "31087": 60,
    "31089": 64,
    "31091": 58,
    "31093": 83,
    "31095": 77,
    "31097": 74,
    "31099": 85,
    "31101": 41,
    "31103": 66,
    "31105": 78,
    "31107": 127,
    "31109": 108,
    "31111": 47,
    "31113": 54,
    "31115": 60,
    "31117": 54,
    "31119": 112,
    "31121": 81,
    "31123": 54,
    "31125": 81,
    "31127": 72,
    "31129": 95,
    "31131": 82,
    "31133": 66,
    "31135": 44,
    "31137": 87,
    "31139": 117,
    "31141": 97,
    "31143": 85,
    "31145": 50,
    "31147": 67,
    "31149": 65,
    "31151": 89,
    "31153": 107,
    "31155": 107,
    "31157": 92,
    "31159": 98,
    "31161": 74,
    "31163": 84,
    "31165": 92,
    "31167": 105,
    "31169": 92,
    "31171": 56,
    "31173": 110,
    "31175": 87,
    "31177": 108,
    "31179": 122,
    "31181": 100,
    "31183": 54,
    "31185": 87,
    "32001": 33,
    "32003": 118,
    "32005": 389,
    "32007": 209,
    "32009": 23,
    "32011": 101,
    "32013": 30,
    "32015": 101,
    "32017": 51,
    "32019": 244,
    "32021": 31,
    "32023": 111,
    "32027": 33,
    "32029": 179,
    "32031": 429,
    "32033": 159,
    "32510": 389,
    "33001": 183,
    "33003": 381,
    "33005": 119,
    "33007": 375,
    "33009": 335,
    "33011": 195,
    "33013": 180,
    "33015": 313,
    "33017": 179,
    "33019": 175,
    "34001": 316,
    "34003": 63,
    "34005": 350,
    "34007": 206,
    "34009": 287,
    "34011": 176,
    "34013": 60,
    "34015": 203,
    "34017": 62,
    "34019": 254,
    "34021": 212,
    "34023": 203,
    "34025": 351,
    "34027": 291,
    "34029": 345,
    "34031": 147,
    "34033": 181,
    "34035": 238,
    "34037": 383,
    "34039": 58,
    "34041": 293,
    "35001": 106,
    "35003": 77,
    "35005": 31,
    "35006": 65,
    "35007": 225,
    "35009": 20,
    "35011": 22,
    "35013": 3,
    "35015": 61,
    "35017": 12,
    "35019": 30,
    "35021": 25,
    "35023": 2,
    "35025": 51,
    "35027": 88,
    "35028": 48,
    "35029": 3,
    "35031": 116,
    "35033": 188,
    "35035": 14,
    "35037": 27,
    "35039": 340,
    "35041": 19,
    "35043": 208,
    "35045": 101,
    "35047": 311,
    "35049": 306,
    "35051": 8,
    "35053": 105,
    "35055": 283,
    "35057": 149,
    "35059": 70,
    "35061": 100,
    "36001": 342,
    "36003": 79,
    "36005": 67,
    "36007": 99,
    "36009": 195,
    "36011": 207,
    "36013": 199,
    "36015": 71,
    "36017": 104,
    "36019": 411,
    "36021": 331,
    "36023": 98,
    "36025": 113,
    "36027": 310,
    "36029": 279,
    "36031": 413,
    "36033": 424,
    "36035": 332,
    "36037": 99,
    "36039": 351,
    "36041": 227,
    "36043": 417,
    "36045": 180,
    "36047": 54,
    "36049": 245,
    "36051": 87,
    "36053": 147,
    "36055": 102,
    "36057": 170,
    "36059": 62,
    "36061": 62,
    "36063": 90,
    "36065": 350,
    "36067": 159,
    "36069": 80,
    "36071": 109,
    "36073": 82,
    "36075": 270,
    "36077": 109,
    "36079": 88,
    "36081": 55,
    "36083": 359,
    "36085": 51,
    "36087": 73,
    "36089": 535,
    "36091": 383,
    "36093": 336,
    "36095": 183,
    "36097": 74,
    "36099": 73,
    "36101": 74,
    "36103": 293,
    "36105": 93,
    "36107": 79,
    "36109": 82,
    "36111": 323,
    "36113": 350,
    "36115": 336,
    "36117": 115,
    "36119": 167,
    "36121": 149,
    "36123": 67,
    "37001": 69,
    "37003": 115,
    "37005": 70,
    "37007": 34,
    "37009": 102,
    "37011": 364,
    "37013": 29,
    "37015": 44,
    "37017": 25,
    "37019": 8,
    "37021": 244,
    "37023": 136,
    "37025": 68,
    "37027": 140,
    "37029": 37,
    "37031": 0,
    "37033": 39,
    "37035": 110,
    "37037": 48,
    "37039": 39,
    "37041": 38,
    "37043": 24,
    "37045": 83,
    "37047": 17,
    "37049": 0,
    "37051": 36,
    "37053": 59,
    "37055": 20,
    "37057": 67,
    "37059": 106,
    "37061": 31,
    "37063": 57,
    "37065": 45,
    "37067": 72,
    "37069": 55,
    "37071": 73,
    "37073": 44,
    "37075": 205,
    "37077": 60,
    "37079": 27,
    "37081": 69,
    "37083": 48,
    "37085": 51,
    "37087": 262,
    "37089": 153,
    "37091": 45,
    "37093": 31,
    "37095": 25,
    "37097": 111,
    "37099": 341,
    "37101": 53,
    "37103": 26,
    "37105": 47,
    "37107": 32,
    "37109": 82,
    "37111": 127,
    "37113": 163,
    "37115": 286,
    "37117": 33,
    "37119": 73,
    "37121": 346,
    "37123": 43,
    "37125": 42,
    "37127": 53,
    "37129": 14,
    "37131": 47,
    "37133": 0,
    "37135": 66,
    "37137": 23,
    "37139": 35,
    "37141": 12,
    "37143": 39,
    "37145": 68,
    "37147": 33,
    "37149": 92,
    "37151": 59,
    "37153": 36,
    "37155": 27,
    "37157": 46,
    "37159": 96,
    "37161": 90,
    "37163": 33,
    "37165": 32,
    "37167": 42,
    "37169": 45,
    "37171": 59,
    "37173": 234,
    "37175": 148,
    "37177": 26,
    "37179": 52,
    "37181": 57,
    "37183": 57,
    "37185": 52,
    "37187": 31,
    "37189": 107,
    "37191": 35,
    "37193": 56,
    "37195": 47,
    "37197": 39,
    "37199": 342,
    "38001": 84,
    "38003": 173,
    "38005": 167,
    "38007": 88,
    "38009": 125,
    "38011": 84,
    "38013": 108,
    "38015": 98,
    "38017": 177,
    "38019": 170,
    "38021": 107,
    "38023": 96,
    "38025": 106,
    "38027": 160,
    "38029": 92,
    "38031": 119,
    "38033": 84,
    "38035": 177,
    "38037": 94,
    "38039": 168,
    "38041": 86,
    "38043": 102,
    "38045": 112,
    "38047": 99,
    "38049": 127,
    "38051": 99,
    "38053": 101,
    "38055": 114,
    "38057": 102,
    "38059": 108,
    "38061": 113,
    "38063": 167,
    "38065": 95,
    "38067": 176,
    "38069": 117,
    "38071": 165,
    "38073": 162,
    "38075": 122,
    "38077": 164,
    "38079": 115,
    "38081": 154,
    "38083": 110,
    "38085": 99,
    "38087": 85,
    "38089": 89,
    "38091": 167,
    "38093": 116,
    "38095": 159,
    "38097": 172,
    "38099": 310,
    "38101": 122,
    "38103": 123,
    "38105": 99,
    "39001": 93,
    "39003": 59,
    "39005": 55,
    "39007": 198,
    "39009": 80,
    "39011": 94,
    "39013": 29,
    "39015": 94,
    "39017": 108,
    "39019": 30,
    "39021": 96,
    "39023": 101,
    "39025": 94,
    "39027": 107,
    "39029": 48,
    "39031": 27,
    "39033": 35,
    "39035": 113,
    "39037": 106,
    "39039": 55,
    "39041": 91,
    "39043": 41,
    "39045": 87,
    "39047": 86,
    "39049": 107,
    "39051": 55,
    "39053": 66,
    "39055": 157,
    "39057": 95,
    "39059": 27,
    "39061": 102,
    "39063": 32,
    "39065": 78,
    "39067": 29,
    "39069": 56,
    "39071": 94,
    "39073": 81,
    "39075": 36,
    "39077": 41,
    "39079": 75,
    "39081": 36,
    "39083": 35,
    "39085": 116,
    "39087": 63,
    "39089": 87,
    "39091": 101,
    "39093": 55,
    "39095": 46,
    "39097": 78,
    "39099": 41,
    "39101": 32,
    "39103": 60,
    "39105": 74,
    "39107": 89,
    "39109": 92,
    "39111": 23,
    "39113": 117,
    "39115": 79,
    "39117": 34,
    "39119": 31,
    "39121": 22,
    "39123": 41,
    "39125": 65,
    "39127": 84,
    "39129": 86,
    "39131": 80,
    "39133": 63,
    "39135": 99,
    "39137": 62,
    "39139": 50,
    "39141": 86,
    "39143": 42,
    "39145": 89,
    "39147": 36,
    "39149": 90,
    "39151": 40,
    "39153": 68,
    "39155": 71,
    "39157": 40,
    "39159": 89,
    "39161": 65,
    "39163": 79,
    "39165": 103,
    "39167": 73,
    "39169": 41,
    "39171": 51,
    "39173": 44,
    "39175": 29,
    "40001": 30,
    "40003": 63,
    "40005": 31,
    "40007": 96,
    "40009": 56,
    "40011": 57,
    "40013": 36,
    "40015": 56,
    "40017": 60,
    "40019": 34,
    "40021": 33,
    "40023": 24,
    "40025": 115,
    "40027": 51,
    "40029": 37,
    "40031": 46,
    "40033": 32,
    "40035": 38,
    "40037": 32,
    "40039": 54,
    "40041": 39,
    "40043": 63,
    "40045": 53,
    "40047": 72,
    "40049": 45,
    "40051": 51,
    "40053": 70,
    "40055": 37,
    "40057": 34,
    "40059": 59,
    "40061": 27,
    "40063": 35,
    "40065": 39,
    "40067": 27,
    "40069": 35,
    "40071": 75,
    "40073": 59,
    "40075": 41,
    "40077": 26,
    "40079": 34,
    "40081": 50,
    "40083": 61,
    "40085": 27,
    "40087": 48,
    "40089": 36,
    "40091": 31,
    "40093": 63,
    "40095": 29,
    "40097": 35,
    "40099": 33,
    "40101": 36,
    "40103": 58,
    "40105": 40,
    "40107": 31,
    "40109": 64,
    "40111": 36,
    "40113": 46,
    "40115": 35,
    "40117": 40,
    "40119": 57,
    "40121": 32,
    "40123": 41,
    "40125": 43,
    "40127": 29,
    "40129": 49,
    "40131": 38,
    "40133": 35,
    "40135": 27,
    "40137": 38,
    "40139": 111,
    "40141": 29,
    "40143": 44,
    "40145": 35,
    "40147": 44,
    "40149": 46,
    "40151": 61,
    "40153": 68,
    "41001": 59,
    "41003": 97,
    "41005": 401,
    "41007": 96,
    "41009": 146,
    "41011": 218,
    "41013": 54,
    "41015": 369,
    "41017": 91,
    "41019": 296,
    "41021": 84,
    "41023": 85,
    "41025": 33,
    "41027": 371,
    "41029": 243,
    "41031": 139,
    "41033": 187,
    "41035": 385,
    "41037": 289,
    "41039": 244,
    "41041": 70,
    "41043": 348,
    "41045": 37,
    "41047": 341,
    "41049": 92,
    "41051": 436,
    "41053": 90,
    "41055": 48,
    "41057": 96,
    "41059": 147,
    "41061": 182,
    "41063": 108,
    "41065": 100,
    "41067": 118,
    "41069": 101,
    "41071": 95,
    "42001": 64,
    "42003": 65,
    "42005": 54,
    "42007": 43,
    "42009": 66,
    "42011": 280,
    "42013": 65,
    "42015": 72,
    "42017": 153,
    "42019": 55,
    "42021": 105,
    "42023": 75,
    "42025": 427,
    "42027": 153,
    "42029": 155,
    "42031": 64,
    "42033": 69,
    "42035": 136,
    "42037": 64,
    "42039": 156,
    "42041": 54,
    "42043": 57,
    "42045": 205,
    "42047": 72,
    "42049": 323,
    "42051": 60,
    "42053": 75,
    "42055": 60,
    "42057": 56,
    "42059": 32,
    "42061": 58,
    "42063": 62,
    "42065": 72,
    "42067": 58,
    "42069": 79,
    "42071": 64,
    "42073": 46,
    "42075": 58,
    "42077": 288,
    "42079": 75,
    "42081": 147,
    "42083": 99,
    "42085": 70,
    "42087": 54,
    "42089": 446,
    "42091": 153,
    "42093": 58,
    "42095": 293,
    "42097": 58,
    "42099": 52,
    "42101": 203,
    "42103": 75,
    "42105": 90,
    "42107": 71,
    "42109": 57,
    "42111": 120,
    "42113": 104,
    "42115": 87,
    "42117": 88,
    "42119": 60,
    "42121": 85,
    "42123": 111,
    "42125": 41,
    "42127": 124,
    "42129": 67,
    "42131": 70,
    "42133": 67,
    "44001": 58,
    "44003": 160,
    "44005": 58,
    "44007": 191,
    "44009": 72,
    "45001": 46,
    "45003": 11,
    "45005": 14,
    "45007": 66,
    "45009": 11,
    "45011": 8,
    "45013": 16,
    "45015": 27,
    "45017": 12,
    "45019": 30,
    "45021": 80,
    "45023": 47,
    "45025": 29,
    "45027": 12,
    "45029": 28,
    "45031": 23,
    "45033": 21,
    "45035": 23,
    "45037": 12,
    "45039": 25,
    "45041": 19,
    "45043": 7,
    "45045": 186,
    "45047": 44,
    "45049": 12,
    "45051": 4,
    "45053": 12,
    "45055": 25,
    "45057": 0,
    "45059": 53,
    "45061": 19,
    "45063": 21,
    "45065": 12,
    "45067": 16,
    "45069": 24,
    "45071": 25,
    "45073": 172,
    "45075": 15,
    "45077": 170,
    "45079": 21,
    "45081": 17,
    "45083": 91,
    "45085": 22,
    "45087": 50,
    "45089": 12,
    "45091": 67,
    "46003": 129,
    "46005": 138,
    "46007": 85,
    "46009": 127,
    "46011": 152,
    "46013": 120,
    "46015": 124,
    "46017": 83,
    "46019": 107,
    "46021": 88,
    "46023": 125,
    "46025": 119,
    "46027": 120,
    "46029": 123,
    "46031": 87,
    "46033": 205,
    "46035": 129,
    "46037": 132,
    "46039": 129,
    "46041": 92,
    "46043": 119,
    "46045": 114,
    "46047": 145,
    "46049": 104,
    "46051": 143,
    "46053": 117,
    "46055": 84,
    "46057": 124,
    "46059": 100,
    "46061": 130,
    "46063": 97,
    "46065": 89,
    "46067": 134,
    "46069": 90,
    "46071": 91,
    "46073": 118,
    "46075": 82,
    "46077": 140,
    "46079": 152,
    "46081": 311,
    "46083": 155,
    "46085": 87,
    "46087": 148,
    "46089": 108,
    "46091": 133,
    "46093": 419,
    "46095": 76,
    "46097": 134,
    "46099": 165,
    "46101": 155,
    "46103": 311,
    "46105": 89,
    "46107": 90,
    "46109": 141,
    "46111": 125,
    "46113": 0,
    "46115": 115,
    "46117": 81,
    "46119": 91,
    "46121": 80,
    "46123": 78,
    "46125": 141,
    "46127": 126,
    "46129": 87,
    "46135": 132,
    "46137": 80,
    "47001": 32,
    "47003": 38,
    "47005": 39,
    "47007": 28,
    "47009": 86,
    "47011": 38,
    "47013": 47,
    "47015": 32,
    "47017": 47,
    "47019": 114,
    "47021": 37,
    "47023": 40,
    "47025": 45,
    "47027": 44,
    "47029": 104,
    "47031": 41,
    "47033": 48,
    "47035": 81,
    "47037": 59,
    "47039": 34,
    "47041": 42,
    "47043": 51,
    "47045": 51,
    "47047": 42,
    "47049": 91,
    "47051": 115,
    "47053": 50,
    "47055": 31,
    "47057": 33,
    "47059": 97,
    "47061": 40,
    "47063": 45,
    "47065": 46,
    "47067": 37,
    "47069": 40,
    "47071": 37,
    "47073": 43,
    "47075": 46,
    "47077": 42,
    "47079": 50,
    "47081": 49,
    "47083": 32,
    "47085": 30,
    "47087": 34,
    "47089": 40,
    "47091": 71,
    "47093": 43,
    "47095": 50,
    "47097": 48,
    "47099": 38,
    "47101": 31,
    "47103": 78,
    "47105": 31,
    "47107": 30,
    "47109": 35,
    "47111": 42,
    "47113": 48,
    "47115": 26,
    "47117": 39,
    "47119": 41,
    "47121": 22,
    "47123": 63,
    "47125": 54,
    "47127": 77,
    "47129": 39,
    "47131": 49,
    "47133": 66,
    "47135": 31,
    "47137": 53,
    "47139": 52,
    "47141": 84,
    "47143": 27,
    "47145": 40,
    "47147": 53,
    "47149": 48,
    "47151": 40,
    "47153": 31,
    "47155": 138,
    "47157": 53,
    "47159": 44,
    "47161": 43,
    "47163": 69,
    "47165": 68,
    "47167": 47,
    "47169": 19,
    "47171": 79,
    "47173": 28,
    "47175": 37,
    "47177": 55,
    "47179": 65,
    "47181": 26,
    "47183": 51,
    "47185": 50,
    "47187": 52,
    "47189": 49,
    "48001": 20,
    "48003": 18,
    "48005": 20,
    "48007": 4,
    "48009": 19,
    "48011": 62,
    "48013": 5,
    "48015": 8,
    "48017": 63,
    "48019": 16,
    "48021": 14,
    "48023": 20,
    "48025": 8,
    "48027": 31,
    "48029": 20,
    "48031": 17,
    "48033": 14,
    "48035": 21,
    "48037": 32,
    "48039": 5,
    "48041": 15,
    "48043": 0,
    "48045": 57,
    "48047": 44,
    "48049": 33,
    "48051": 13,
    "48053": 16,
    "48055": 14,
    "48057": 6,
    "48059": 48,
    "48061": 36,
    "48063": 28,
    "48065": 79,
    "48067": 28,
    "48069": 68,
    "48071": 3,
    "48073": 20,
    "48075": 43,
    "48077": 24,
    "48079": 51,
    "48081": 39,
    "48083": 31,
    "48085": 57,
    "48087": 46,
    "48089": 6,
    "48091": 17,
    "48093": 23,
    "48095": 30,
    "48097": 37,
    "48099": 20,
    "48101": 36,
    "48103": 8,
    "48105": 22,
    "48107": 52,
    "48109": 15,
    "48111": 112,
    "48113": 70,
    "48115": 19,
    "48117": 72,
    "48119": 20,
    "48121": 52,
    "48123": 7,
    "48125": 33,
    "48127": 1,
    "48129": 54,
    "48131": 6,
    "48133": 34,
    "48135": 18,
    "48137": 16,
    "48139": 29,
    "48141": 3,
    "48143": 35,
    "48145": 14,
    "48147": 32,
    "48149": 13,
    "48151": 38,
    "48153": 58,
    "48155": 21,
    "48157": 8,
    "48159": 32,
    "48161": 15,
    "48163": 4,
    "48165": 19,
    "48167": 4,
    "48169": 43,
    "48171": 25,
    "48173": 10,
    "48175": 7,
    "48177": 7,
    "48179": 71,
    "48181": 49,
    "48183": 27,
    "48185": 8,
    "48187": 11,
    "48189": 67,
    "48191": 48,
    "48193": 19,
    "48195": 86,
    "48197": 31,
    "48199": 12,
    "48201": 22,
    "48203": 24,
    "48205": 96,
    "48207": 46,
    "48209": 15,
    "48211": 69,
    "48213": 20,
    "48215": 35,
    "48217": 26,
    "48219": 55,
    "48221": 33,
    "48223": 29,
    "48225": 8,
    "48227": 16,
    "48229": 1,
    "48231": 32,
    "48233": 78,
    "48235": 29,
    "48237": 38,
    "48239": 4,
    "48241": 10,
    "48243": 0,
    "48245": 12,
    "48247": 42,
    "48249": 7,
    "48251": 28,
    "48253": 46,
    "48255": 5,
    "48257": 32,
    "48259": 18,
    "48261": 49,
    "48263": 24,
    "48265": 26,
    "48267": 22,
    "48269": 25,
    "48271": 5,
    "48273": 5,
    "48275": 19,
    "48277": 30,
    "48279": 59,
    "48281": 20,
    "48283": 6,
    "48285": 6,
    "48287": 10,
    "48289": 14,
    "48291": 7,
    "48293": 18,
    "48295": 78,
    "48297": 8,
    "48299": 15,
    "48301": 9,
    "48303": 73,
    "48305": 50,
    "48307": 29,
    "48309": 24,
    "48311": 6,
    "48313": 9,
    "48315": 24,
    "48317": 16,
    "48319": 15,
    "48321": 4,
    "48323": 3,
    "48325": 9,
    "48327": 22,
    "48329": 27,
    "48331": 15,
    "48333": 16,
    "48335": 14,
    "48337": 41,
    "48339": 8,
    "48341": 86,
    "48343": 28,
    "48345": 42,
    "48347": 20,
    "48349": 23,
    "48351": 10,
    "48353": 46,
    "48355": 7,
    "48357": 83,
    "48359": 80,
    "48361": 11,
    "48363": 30,
    "48365": 20,
    "48367": 41,
    "48369": 76,
    "48371": 13,
    "48373": 6,
    "48375": 99,
    "48377": 0,
    "48379": 22,
    "48381": 91,
    "48383": 11,
    "48385": 15,
    "48387": 31,
    "48389": 0,
    "48391": 6,
    "48393": 72,
    "48395": 15,
    "48397": 22,
    "48399": 33,
    "48401": 22,
    "48403": 17,
    "48405": 16,
    "48407": 6,
    "48409": 6,
    "48411": 19,
    "48413": 27,
    "48415": 18,
    "48417": 34,
    "48419": 18,
    "48421": 89,
    "48423": 29,
    "48425": 24,
    "48427": 41,
    "48429": 23,
    "48431": 38,
    "48433": 23,
    "48435": 22,
    "48437": 65,
    "48439": 80,
    "48441": 57,
    "48443": 6,
    "48445": 46,
    "48447": 42,
    "48449": 32,
    "48451": 43,
    "48453": 25,
    "48455": 6,
    "48457": 11,
    "48459": 26,
    "48461": 9,
    "48463": 9,
    "48465": 10,
    "48467": 24,
    "48469": 9,
    "48471": 10,
    "48473": 7,
    "48475": 8,
    "48477": 11,
    "48479": 5,
    "48481": 7,
    "48483": 63,
    "48485": 30,
    "48487": 26,
    "48489": 39,
    "48491": 28,
    "48493": 7,
    "48495": 14,
    "48497": 43,
    "48499": 24,
    "48501": 45,
    "48503": 33,
    "48505": 47,
    "48507": 2,
    "49001": 156,
    "49003": 559,
    "49005": 401,
    "49007": 145,
    "49009": 294,
    "49011": 490,
    "49013": 288,
    "49015": 219,
    "49017": 125,
    "49019": 524,
    "49021": 156,
    "49023": 652,
    "49025": 108,
    "49027": 169,
    "49029": 510,
    "49031": 64,
    "49033": 303,
    "49035": 903,
    "49037": 438,
    "49039": 547,
    "49041": 117,
    "49043": 975,
    "49045": 268,
    "49047": 563,
    "49049": 710,
    "49051": 827,
    "49053": 212,
    "49055": 81,
    "49057": 697,
    "50001": 347,
    "50003": 219,
    "50005": 280,
    "50007": 385,
    "50009": 251,
    "50011": 377,
    "50013": 166,
    "50015": 283,
    "50017": 242,
    "50019": 272,
    "50021": 340,
    "50023": 274,
    "50025": 361,
    "50027": 235,
    "51001": 62,
    "51003": 48,
    "51005": 73,
    "51007": 77,
    "51009": 113,
    "51011": 51,
    "51013": 138,
    "51015": 48,
    "51017": 81,
    "51019": 69,
    "51021": 59,
    "51023": 71,
    "51025": 57,
    "51027": 84,
    "51029": 53,
    "51031": 62,
    "51033": 99,
    "51035": 76,
    "51036": 128,
    "51037": 39,
    "51041": 12,
    "51043": 165,
    "51045": 62,
    "51047": 151,
    "51049": 86,
    "51051": 88,
    "51053": 65,
    "51057": 20,
    "51059": 177,
    "51061": 169,
    "51063": 74,
    "51065": 88,
    "51067": 53,
    "51069": 192,
    "51071": 61,
    "51073": 126,
    "51075": 91,
    "51077": 87,
    "51079": 213,
    "51081": 56,
    "51083": 40,
    "51085": 24,
    "51087": 24,
    "51089": 54,
    "51091": 242,
    "51093": 56,
    "51095": 122,
    "51097": 21,
    "51099": 107,
    "51101": 20,
    "51103": 130,
    "51105": 75,
    "51107": 88,
    "51109": 20,
    "51111": 67,
    "51113": 221,
    "51115": 116,
    "51117": 62,
    "51119": 128,
    "51121": 75,
    "51125": 181,
    "51127": 67,
    "51131": 46,
    "51133": 71,
    "51135": 68,
    "51137": 140,
    "51139": 243,
    "51141": 70,
    "51143": 51,
    "51145": 80,
    "51147": 88,
    "51149": 70,
    "51153": 168,
    "51155": 61,
    "51157": 227,
    "51159": 146,
    "51161": 68,
    "51163": 132,
    "51165": 246,
    "51167": 71,
    "51169": 66,
    "51171": 187,
    "51173": 62,
    "51175": 55,
    "51177": 122,
    "51179": 129,
    "51181": 55,
    "51183": 60,
    "51185": 68,
    "51187": 226,
    "51191": 69,
    "51193": 152,
    "51195": 118,
    "51197": 61,
    "51199": 16,
    "51510": 138,
    "51515": 0,
    "51520": 69,
    "51530": 84,
    "51540": 156,
    "51550": 46,
    "51570": 13,
    "51580": 73,
    "51590": 51,
    "51595": 56,
    "51600": 177,
    "51610": 138,
    "51620": 55,
    "51630": 122,
    "51640": 75,
    "51650": 6,
    "51660": 188,
    "51670": 70,
    "51678": 84,
    "51680": 62,
    "51683": 168,
    "51685": 168,
    "51690": 54,
    "51700": 7,
    "51710": 90,
    "51720": 118,
    "51730": 70,
    "51735": 8,
    "51740": 90,
    "51750": 61,
    "51760": 12,
    "51770": 68,
    "51775": 68,
    "51790": 190,
    "51800": 100,
    "51810": 40,
    "51820": 190,
    "51830": 61,
    "51840": 192,
    "53001": 113,
    "53003": 73,
    "53005": 34,
    "53007": 350,
    "53009": 53,
    "53011": 99,
    "53013": 122,
    "53015": 186,
    "53017": 349,
    "53019": 154,
    "53021": 34,
    "53023": 73,
    "53025": 190,
    "53027": 34,
    "53029": 8,
    "53031": 59,
    "53033": 22,
    "53035": 34,
    "53037": 101,
    "53039": 123,
    "53041": 31,
    "53043": 245,
    "53045": 51,
    "53047": 582,
    "53049": 29,
    "53051": 378,
    "53053": 32,
    "53055": 13,
    "53057": 38,
    "53059": 180,
    "53061": 34,
    "53063": 654,
    "53065": 378,
    "53067": 11,
    "53069": 54,
    "53071": 156,
    "53073": 48,
    "53075": 103,
    "53077": 173,
    "54001": 110,
    "54003": 199,
    "54005": 67,
    "54007": 77,
    "54009": 37,
    "54011": 57,
    "54013": 71,
    "54015": 71,
    "54017": 70,
    "54019": 16,
    "54021": 71,
    "54023": 387,
    "54025": 33,
    "54027": 200,
    "54029": 32,
    "54031": 187,
    "54033": 77,
    "54035": 69,
    "54037": 184,
    "54039": 71,
    "54041": 79,
    "54043": 59,
    "54045": 63,
    "54047": 86,
    "54049": 29,
    "54051": 29,
    "54053": 53,
    "54055": 91,
    "54057": 315,
    "54059": 62,
    "54061": 8,
    "54063": 61,
    "54065": 180,
    "54067": 15,
    "54069": 35,
    "54071": 258,
    "54073": 66,
    "54075": 22,
    "54077": 26,
    "54079": 64,
    "54081": 18,
    "54083": 21,
    "54085": 73,
    "54087": 72,
    "54089": 68,
    "54091": 85,
    "54093": 32,
    "54095": 68,
    "54097": 133,
    "54099": 61,
    "54101": 17,
    "54103": 26,
    "54105": 71,
    "54107": 67,
    "54109": 90,
    "55001": 78,
    "55003": 163,
    "55005": 77,
    "55007": 139,
    "55009": 94,
    "55011": 88,
    "55013": 72,
    "55015": 75,
    "55017": 72,
    "55019": 85,
    "55021": 177,
    "55023": 81,
    "55025": 189,
    "55027": 180,
    "55029": 87,
    "55031": 127,
    "55033": 81,
    "55035": 66,
    "55037": 90,
    "55039": 171,
    "55041": 105,
    "55043": 80,
    "55045": 170,
    "55047": 167,
    "55049": 170,
    "55051": 205,
    "55053": 79,
    "55055": 179,
    "55057": 78,
    "55059": 179,
    "55061": 83,
    "55063": 85,
    "55065": 162,
    "55067": 101,
    "55069": 82,
    "55071": 96,
    "55073": 92,
    "55075": 142,
    "55077": 164,
    "55078": 75,
    "55079": 193,
    "55081": 89,
    "55083": 131,
    "55085": 97,
    "55087": 83,
    "55089": 166,
    "55091": 67,
    "55093": 76,
    "55095": 79,
    "55097": 85,
    "55099": 70,
    "55101": 174,
    "55103": 74,
    "55105": 181,
    "55107": 68,
    "55109": 76,
    "55111": 176,
    "55113": 79,
    "55115": 85,
    "55117": 170,
    "55119": 82,
    "55121": 88,
    "55123": 87,
    "55125": 120,
    "55127": 180,
    "55129": 71,
    "55131": 172,
    "55133": 180,
    "55135": 84,
    "55137": 87,
    "55139": 74,
    "55141": 77,
    "56001": 1047,
    "56003": 81,
    "56005": 170,
    "56007": 1348,
    "56009": 154,
    "56011": 256,
    "56013": 782,
    "56015": 96,
    "56017": 157,
    "56019": 204,
    "56021": 549,
    "56023": 529,
    "56025": 336,
    "56027": 58,
    "56029": 267,
    "56031": 224,
    "56033": 225,
    "56035": 550,
    "56037": 182,
    "56039": 358,
    "56041": 24,
    "56043": 150,
    "56045": 210
  },
  {
    "1001": 225,
    "1003": 322,
    "1005": 120,
    "1007": 131,
    "1009": 312,
    "1011": 62,
    "1013": 104,
    "1015": 286,
    "1017": 127,
    "1019": 240,
    "1021": 183,
    "1023": 168,
    "1025": 272,
    "1027": 141,
    "1029": 112,
    "1031": 226,
    "1033": 506,
    "1035": 95,
    "1037": 86,
    "1039": 223,
    "1041": 100,
    "1043": 520,
    "1045": 285,
    "1047": 172,
    "1049": 556,
    "1051": 296,
    "1053": 157,
    "1055": 327,
    "1057": 153,
    "1059": 300,
    "1061": 183,
    "1063": 90,
    "1065": 123,
    "1067": 167,
    "1069": 342,
    "1071": 361,
    "1073": 741,
    "1075": 288,
    "1077": 771,
    "1079": 354,
    "1081": 220,
    "1083": 463,
    "1085": 99,
    "1087": 93,
    "1089": 968,
    "1091": 124,
    "1093": 301,
    "1095": 539,
    "1097": 447,
    "1099": 145,
    "1101": 207,
    "1103": 472,
    "1105": 89,
    "1107": 160,
    "1109": 93,
    "1111": 205,
    "1113": 159,
    "1115": 261,
    "1117": 415,
    "1119": 179,
    "1121": 304,
    "1123": 232,
    "1125": 485,
    "1127": 345,
    "1129": 169,
    "1131": 70,
    "1133": 279,
    "2013": 97,
    "2016": 272,
    "2020": 287,
    "2050": 54,
    "2060": 35,
    "2068": 184,
    "2070": 35,
    "2090": 77,
    "2100": 157,
    "2110": 266,
    "2122": 186,
    "2130": 159,
    "2150": 76,
    "2164": 171,
    "2170": 99,
    "2180": 151,
    "2185": 135,
    "2188": 78,
    "2201": 0,
    "2220": 465,
    "2232": 0,
    "2240": 120,
    "2261": 321,
    "2270": 0,
    "2280": 0,
    "2282": 131,
    "2290": 127,
    "4001": 317,
    "4003": 244,
    "4005": 557,
    "4007": 213,
    "4009": 81,
    "4011": 23,
    "4012": 94,
    "4013": 1095,
    "4015": 367,
    "4017": 435,
    "4019": 689,
    "4021": 352,
    "4023": 98,
    "4025": 446,
    "4027": 137,
    "5001": 217,
    "5003": 250,
    "5005": 370,
    "5007": 543,
    "5009": 274,
    "5011": 163,
    "5013": 136,
    "5015": 231,
    "5017": 226,
    "5019": 319,
    "5021": 149,
    "5023": 219,
    "5025": 165,
    "5027": 183,
    "5029": 320,
    "5031": 267,
    "5033": 417,
    "5035": 154,
    "5037": 85,
    "5039": 203,
    "5041": 124,
    "5043": 207,
    "5045": 431,
    "5047": 423,
    "5049": 197,
    "5051": 449,
    "5053": 200,
    "5055": 149,
    "5057": 195,
    "5059": 355,
    "5061": 260,
    "5063": 301,
    "5065": 244,
    "5067": 243,
    "5069": 338,
    "5071": 317,
    "5073": 147,
    "5075": 157,
    "5077": 40,
    "5079": 118,
    "5081": 164,
    "5083": 216,
    "5085": 443,
    "5087": 288,
    "5089": 208,
    "5091": 226,
    "5093": 243,
    "5095": 149,
    "5097": 243,
    "5099": 130,
    "5101": 206,
    "5103": 231,
    "5105": 191,
    "5107": 61,
    "5109": 213,
    "5111": 180,
    "5113": 315,
    "5115": 321,
    "5117": 179,
    "5119": 917,
    "5121": 160,
    "5123": 108,
    "5125": 428,
    "5127": 191,
    "5129": 189,
    "5131": 528,
    "5133": 189,
    "5135": 197,
    "5137": 147,
    "5139": 237,
    "5141": 252,
    "5143": 459,
    "5145": 432,
    "5147": 129,
    "5149": 300,
    "6001": 221,
    "6003": 119,
    "6005": 102,
    "6007": 69,
    "6009": 58,
    "6011": 45,
    "6013": 211,
    "6015": 22,
    "6017": 281,
    "6019": 289,
    "6021": 44,
    "6023": 75,
    "6025": 66,
    "6027": 299,
    "6029": 241,
    "6031": 94,
    "6033": 18,
    "6035": 141,
    "6037": 472,
    "6039": 84,
    "6041": 194,
    "6043": 74,
    "6045": 20,
    "6047": 75,
    "6049": 84,
    "6051": 199,
    "6053": 94,
    "6055": 148,
    "6057": 199,
    "6059": 306,
    "6061": 220,
    "6063": 150,
    "6065": 671,
    "6067": 109,
    "6069": 24,
    "6071": 783,
    "6073": 756,
    "6075": 84,
    "6077": 75,
    "6079": 105,
    "6081": 232,
    "6083": 227,
    "6085": 280,
    "6087": 213,
    "6089": 146,
    "6091": 126,
    "6093": 209,
    "6095": 80,
    "6097": 214,
    "6099": 54,
    "6101": 82,
    "6103": 85,
    "6105": 20,
    "6107": 149,
    "6109": 77,
    "6111": 265,
    "6113": 52,
    "6115": 68,
    "8001": 423,
    "8003": 167,
    "8005": 529,
    "8007": 62,
    "8009": 419,
    "8011": 181,
    "8013": 584,
    "8014": 195,
    "8015": 118,
    "8017": 557,
    "8019": 164,
    "8021": 96,
    "8023": 263,
    "8025": 116,
    "8027": 328,
    "8029": 82,
    "8031": 298,
    "8033": 53,
    "8035": 508,
    "8037": 66,
    "8039": 460,
    "8041": 1560,
    "8043": 319,
    "8045": 192,
    "8047": 163,
    "8049": 93,
    "8051": 60,
    "8053": 30,
    "8055": 441,
    "8057": 32,
    "8059": 573,
    "8061": 354,
    "8063": 905,
    "8065": 28,
    "8067": 154,
    "8069": 734,
    "8071": 403,
    "8073": 450,
    "8075": 488,
    "8077": 350,
    "8079": 55,
    "8081": 87,
    "8083": 106,
    "8085": 108,
    "8087": 453,
    "8089": 252,
    "8091": 35,
    "8093": 186,
    "8095": 250,
    "8097": 40,
    "8099": 383,
    "8101": 577,
    "8103": 100,
    "8105": 121,
    "8107": 85,
    "8109": 217,
    "8111": 16,
    "8113": 76,
    "8115": 213,
    "8117": 61,
    "8119": 174,
    "8121": 610,
    "8123": 1004,
    "8125": 948,
    "9001": 482,
    "9003": 482,
    "9005": 547,
    "9007": 171,
    "9009": 385,
    "9011": 218,
    "9013": 218,
    "9015": 182,
    "10001": 415,
    "10003": 503,
    "10005": 861,
    "11001": 271,
    "12001": 511,
    "12003": 147,
    "12005": 211,
    "12007": 151,
    "12009": 531,
    "12011": 648,
    "12013": 98,
    "12015": 110,
    "12017": 170,
    "12019": 374,
    "12021": 206,
    "12023": 243,
    "12027": 58,
    "12029": 90,
    "12031": 969,
    "12033": 225,
    "12035": 541,
    "12037": 73,
    "12039": 137,
    "12041": 117,
    "12043": 74,
    "12045": 93,
    "12047": 182,
    "12049": 73,
    "12051": 66,
    "12053": 140,
    "12055": 135,
    "12057": 604,
    "12059": 112,
    "12061": 107,
    "12063": 260,
    "12065": 172,
    "12067": 76,
    "12069": 209,
    "12071": 279,
    "12073": 686,
    "12075": 159,
    "12077": 85,
    "12079": 228,
    "12081": 199,
    "12083": 557,
    "12085": 118,
    "12086": 606,
    "12087": 185,
    "12089": 312,
    "12091": 234,
    "12093": 85,
    "12095": 439,
    "12097": 163,
    "12099": 508,
    "12101": 280,
    "12103": 430,
    "12105": 470,
    "12107": 392,
    "12109": 438,
    "12111": 130,
    "12113": 288,
    "12115": 139,
    "12117": 206,
    "12119": 107,
    "12121": 297,
    "12123": 129,
    "12125": 83,
    "12127": 348,
    "12129": 281,
    "12131": 293,
    "12133": 135,
    "13001": 169,
    "13003": 114,
    "13005": 104,
    "13007": 54,
    "13009": 111,
    "13011": 138,
    "13013": 149,
    "13015": 271,
    "13017": 63,
    "13019": 104,
    "13021": 222,
    "13023": 75,
    "13025": 163,
    "13027": 114,
    "13029": 161,
    "13031": 350,
    "13033": 215,
    "13035": 122,
    "13037": 40,
    "13039": 354,
    "13043": 90,
    "13045": 235,
    "13047": 131,
    "13049": 157,
    "13051": 669,
    "13053": 63,
    "13055": 170,
    "13057": 382,
    "13059": 141,
    "13061": 46,
    "13063": 181,
    "13065": 202,
    "13067": 402,
    "13069": 235,
    "13071": 149,
    "13073": 226,
    "13075": 61,
    "13077": 367,
    "13079": 108,
    "13081": 122,
    "13083": 155,
    "13085": 141,
    "13087": 176,
    "13089": 253,
    "13091": 122,
    "13093": 103,
    "13095": 179,
    "13097": 212,
    "13099": 85,
    "13101": 71,
    "13103": 371,
    "13105": 138,
    "13107": 130,
    "13109": 91,
    "13111": 130,
    "13113": 249,
    "13115": 343,
    "13117": 252,
    "13119": 123,
    "13121": 463,
    "13123": 167,
    "13125": 47,
    "13127": 212,
    "13129": 185,
    "13131": 132,
    "13133": 110,
    "13135": 493,
    "13137": 183,
    "13139": 239,
    "13141": 63,
    "13143": 137,
    "13145": 176,
    "13147": 120,
    "13149": 130,
    "13151": 220,
    "13153": 243,
    "13155": 78,
    "13157": 174,
    "13159": 126,
    "13161": 122,
    "13163": 104,
    "13165": 111,
    "13167": 115,
    "13169": 107,
    "13171": 86,
    "13173": 84,
    "13175": 245,
    "13177": 101,
    "13179": 316,
    "13181": 108,
    "13183": 138,
    "13185": 293,
    "13187": 122,
    "13189": 100,
    "13191": 204,
    "13193": 90,
    "13195": 110,
    "13197": 71,
    "13199": 137,
    "13201": 82,
    "13205": 129,
    "13207": 126,
    "13209": 76,
    "13211": 141,
    "13213": 158,
    "13215": 166,
    "13217": 152,
    "13219": 111,
    "13221": 116,
    "13223": 164,
    "13225": 104,
    "13227": 131,
    "13229": 111,
    "13231": 84,
    "13233": 196,
    "13235": 86,
    "13237": 116,
    "13239": 41,
    "13241": 166,
    "13243": 55,
    "13245": 212,
    "13247": 111,
    "13249": 57,
    "13251": 249,
    "13253": 56,
    "13255": 140,
    "13257": 145,
    "13259": 68,
    "13261": 143,
    "13263": 64,
    "13265": 40,
    "13267": 189,
    "13269": 92,
    "13271": 102,
    "13273": 82,
    "13275": 171,
    "13277": 115,
    "13279": 104,
    "13281": 66,
    "13283": 66,
    "13285": 214,
    "13287": 77,
    "13289": 111,
    "13291": 103,
    "13293": 171,
    "13295": 192,
    "13297": 193,
    "13299": 207,
    "13301": 63,
    "13303": 140,
    "13305": 233,
    "13307": 53,
    "13309": 64,
    "13311": 146,
    "13313": 199,
    "13315": 81,
    "13317": 93,
    "13319": 109,
    "13321": 198,
    "15001": 1446,
    "15003": 2721,
    "15005": 0,
    "15007": 2830,
    "15009": 3009,
    "16001": 84,
    "16003": 15,
    "16005": 146,
    "16007": 37,
    "16009": 60,
    "16011": 147,
    "16013": 38,
    "16015": 35,
    "16017": 79,
    "16019": 104,
    "16021": 52,
    "16023": 108,
    "16025": 10,
    "16027": 66,
    "16029": 43,
    "16031": 95,
    "16033": 18,
    "16035": 101,
    "16037": 21,
    "16039": 57,
    "16041": 19,
    "16043": 49,
    "16045": 29,
    "16047": 39,
    "16049": 129,
    "16051": 77,
    "16053": 43,
    "16055": 125,
    "16057": 68,
    "16059": 108,
    "16061": 39,
    "16063": 41,
    "16065": 44,
    "16067": 37,
    "16069": 93,
    "16071": 19,
    "16073": 69,
    "16075": 29,
    "16077": 75,
    "16079": 45,
    "16081": 23,
    "16083": 87,
    "16085": 27,
    "16087": 30,
    "17001": 292,
    "17003": 160,
    "17005": 132,
    "17007": 124,
    "17009": 88,
    "17011": 285,
    "17013": 82,
    "17015": 208,
    "17017": 109,
    "17019": 365,
    "17021": 185,
    "17023": 128,
    "17025": 202,
    "17027": 209,
    "17029": 219,
    "17031": 1110,
    "17033": 148,
    "17035": 88,
    "17037": 239,
    "17039": 157,
    "17041": 149,
    "17043": 490,
    "17045": 139,
    "17047": 121,
    "17049": 179,
    "17051": 144,
    "17053": 116,
    "17055": 261,
    "17057": 285,
    "17059": 126,
    "17061": 109,
    "17063": 185,
    "17065": 124,
    "17067": 249,
    "17069": 81,
    "17071": 113,
    "17073": 342,
    "17075": 183,
    "17077": 275,
    "17079": 132,
    "17081": 238,
    "17083": 141,
    "17085": 247,
    "17087": 190,
    "17089": 416,
    "17091": 262,
    "17093": 182,
    "17095": 234,
    "17097": 330,
    "17099": 398,
    "17101": 159,
    "17103": 190,
    "17105": 170,
    "17107": 274,
    "17109": 297,
    "17111": 351,
    "17113": 321,
    "17115": 227,
    "17117": 349,
    "17119": 498,
    "17121": 199,
    "17123": 154,
    "17125": 133,
    "17127": 186,
    "17129": 161,
    "17131": 146,
    "17133": 162,
    "17135": 228,
    "17137": 165,
    "17139": 100,
    "17141": 243,
    "17143": 366,
    "17145": 201,
    "17147": 121,
    "17149": 190,
    "17151": 122,
    "17153": 139,
    "17155": 122,
    "17157": 252,
    "17159": 99,
    "17161": 255,
    "17163": 486,
    "17165": 226,
    "17167": 422,
    "17169": 112,
    "17171": 88,
    "17173": 160,
    "17175": 92,
    "17177": 316,
    "17179": 306,
    "17181": 146,
    "17183": 376,
    "17185": 166,
    "17187": 165,
    "17189": 189,
    "17191": 180,
    "17193": 187,
    "17195": 311,
    "17197": 594,
    "17199": 239,
    "17201": 337,
    "17203": 216,
    "18001": 141,
    "18003": 385,
    "18005": 161,
    "18007": 105,
    "18009": 82,
    "18011": 219,
    "18013": 104,
    "18015": 126,
    "18017": 182,
    "18019": 217,
    "18021": 105,
    "18023": 150,
    "18025": 224,
    "18027": 146,
    "18029": 129,
    "18031": 136,
    "18033": 112,
    "18035": 211,
    "18037": 226,
    "18039": 299,
    "18041": 94,
    "18043": 161,
    "18045": 115,
    "18047": 100,
    "18049": 149,
    "18051": 233,
    "18053": 213,
    "18055": 152,
    "18057": 327,
    "18059": 167,
    "18061": 227,
    "18063": 364,
    "18065": 162,
    "18067": 157,
    "18069": 245,
    "18071": 146,
    "18073": 106,
    "18075": 81,
    "18077": 113,
    "18079": 85,
    "18081": 271,
    "18083": 260,
    "18085": 311,
    "18087": 128,
    "18089": 317,
    "18091": 237,
    "18093": 159,
    "18095": 270,
    "18097": 566,
    "18099": 161,
    "18101": 70,
    "18103": 234,
    "18105": 194,
    "18107": 155,
    "18109": 247,
    "18111": 101,
    "18113": 193,
    "18115": 57,
    "18117": 143,
    "18119": 130,
    "18121": 128,
    "18123": 108,
    "18125": 144,
    "18127": 211,
    "18129": 185,
    "18131": 102,
    "18133": 203,
    "18135": 127,
    "18137": 176,
    "18139": 120,
    "18141": 312,
    "18143": 85,
    "18145": 176,
    "18147": 214,
    "18149": 130,
    "18151": 177,
    "18153": 101,
    "18155": 84,
    "18157": 289,
    "18159": 81,
    "18161": 76,
    "18163": 275,
    "18165": 113,
    "18167": 231,
    "18169": 143,
    "18171": 86,
    "18173": 214,
    "18175": 143,
    "18177": 228,
    "18179": 136,
    "18181": 144,
    "18183": 191,
    "19001": 281,
    "19003": 196,
    "19005": 179,
    "19007": 217,
    "19009": 208,
    "19011": 476,
    "19013": 445,
    "19015": 406,
    "19017": 240,
    "19019": 318,
    "19021": 210,
    "19023": 324,
    "19025": 283,
    "19027": 336,
    "19029": 383,
    "19031": 215,
    "19033": 382,
    "19035": 209,
    "19037": 173,
    "19039": 218,
    "19041": 291,
    "19043": 245,
    "19045": 269,
    "19047": 304,
    "19049": 619,
    "19051": 169,
    "19053": 196,
    "19055": 250,
    "19057": 241,
    "19059": 256,
    "19061": 356,
    "19063": 250,
    "19065": 234,
    "19067": 248,
    "19069": 247,
    "19071": 170,
    "19073": 238,
    "19075": 206,
    "19077": 376,
    "19079": 308,
    "19081": 214,
    "19083": 315,
    "19085": 301,
    "19087": 166,
    "19089": 162,
    "19091": 203,
    "19093": 163,
    "19095": 199,
    "19097": 173,
    "19099": 375,
    "19101": 168,
    "19103": 334,
    "19105": 277,
    "19107": 131,
    "19109": 339,
    "19111": 253,
    "19113": 656,
    "19115": 110,
    "19117": 163,
    "19119": 212,
    "19121": 265,
    "19123": 230,
    "19125": 414,
    "19127": 320,
    "19129": 180,
    "19131": 161,
    "19133": 195,
    "19135": 131,
    "19137": 146,
    "19139": 249,
    "19141": 238,
    "19143": 148,
    "19145": 205,
    "19147": 217,
    "19149": 322,
    "19151": 243,
    "19153": 1274,
    "19155": 268,
    "19157": 244,
    "19159": 205,
    "19161": 197,
    "19163": 494,
    "19165": 199,
    "19167": 327,
    "19169": 701,
    "19171": 240,
    "19173": 315,
    "19175": 262,
    "19177": 168,
    "19179": 314,
    "19181": 498,
    "19183": 197,
    "19185": 178,
    "19187": 477,
    "19189": 235,
    "19191": 277,
    "19193": 512,
    "19195": 202,
    "19197": 227,
    "20001": 237,
    "20003": 225,
    "20005": 147,
    "20007": 549,
    "20009": 644,
    "20011": 259,
    "20013": 273,
    "20015": 1105,
    "20017": 191,
    "20019": 311,
    "20021": 341,
    "20023": 524,
    "20025": 527,
    "20027": 301,
    "20029": 397,
    "20031": 298,
    "20033": 452,
    "20035": 890,
    "20037": 332,
    "20039": 361,
    "20041": 472,
    "20043": 103,
    "20045": 531,
    "20047": 377,
    "20049": 179,
    "20051": 612,
    "20053": 399,
    "20055": 920,
    "20057": 1242,
    "20059": 358,
    "20061": 231,
    "20063": 458,
    "20065": 399,
    "20067": 419,
    "20069": 620,
    "20071": 318,
    "20073": 291,
    "20075": 449,
    "20077": 452,
    "20079": 332,
    "20081": 302,
    "20083": 505,
    "20085": 292,
    "20087": 516,
    "20089": 317,
    "20091": 653,
    "20093": 502,
    "20095": 517,
    "20097": 433,
    "20099": 336,
    "20101": 372,
    "20103": 409,
    "20105": 382,
    "20107": 167,
    "20109": 522,
    "20111": 460,
    "20113": 568,
    "20115": 351,
    "20117": 359,
    "20119": 529,
    "20121": 202,
    "20123": 311,
    "20125": 434,
    "20127": 302,
    "20129": 428,
    "20131": 322,
    "20133": 247,
    "20135": 543,
    "20137": 391,
    "20139": 524,
    "20141": 301,
    "20143": 413,
    "20145": 557,
    "20147": 358,
    "20149": 473,
    "20151": 692,
    "20153": 532,
    "20155": 909,
    "20157": 382,
    "20159": 389,
    "20161": 383,
    "20163": 313,
    "20165": 504,
    "20167": 626,
    "20169": 353,
    "20171": 492,
    "20173": 1653,
    "20175": 495,
    "20177": 723,
    "20179": 366,
    "20181": 874,
    "20183": 269,
    "20185": 503,
    "20187": 441,
    "20189": 337,
    "20191": 691,
    "20193": 551,
    "20195": 429,
    "20197": 355,
    "20199": 399,
    "20201": 349,
    "20203": 277,
    "20205": 244,
    "20207": 169,
    "20209": 154,
    "21001": 138,
    "21003": 132,
    "21005": 96,
    "21007": 184,
    "21009": 194,
    "21011": 170,
    "21013": 182,
    "21015": 194,
    "21017": 97,
    "21019": 149,
    "21021": 80,
    "21023": 85,
    "21025": 333,
    "21027": 194,
    "21029": 166,
    "21031": 114,
    "21033": 119,
    "21035": 294,
    "21037": 134,
    "21039": 149,
    "21041": 86,
    "21043": 121,
    "21045": 136,
    "21047": 348,
    "21049": 101,
    "21051": 176,
    "21053": 97,
    "21055": 99,
    "21057": 84,
    "21059": 313,
    "21061": 125,
    "21063": 94,
    "21065": 253,
    "21067": 252,
    "21069": 150,
    "21071": 249,
    "21073": 138,
    "21075": 127,
    "21077": 74,
    "21079": 90,
    "21081": 109,
    "21083": 250,
    "21085": 156,
    "21087": 124,
    "21089": 167,
    "21091": 88,
    "21093": 249,
    "21095": 183,
    "21097": 95,
    "21099": 161,
    "21101": 194,
    "21103": 122,
    "21105": 126,
    "21107": 230,
    "21109": 185,
    "21111": 566,
    "21113": 95,
    "21115": 216,
    "21117": 132,
    "21119": 117,
    "21121": 146,
    "21123": 105,
    "21125": 351,
    "21127": 139,
    "21129": 204,
    "21131": 236,
    "21133": 160,
    "21135": 84,
    "21137": 98,
    "21139": 162,
    "21141": 168,
    "21143": 94,
    "21145": 294,
    "21147": 212,
    "21149": 119,
    "21151": 209,
    "21153": 177,
    "21155": 104,
    "21157": 256,
    "21159": 136,
    "21161": 103,
    "21163": 142,
    "21165": 135,
    "21167": 105,
    "21169": 110,
    "21171": 102,
    "21173": 173,
    "21175": 247,
    "21177": 192,
    "21179": 176,
    "21181": 52,
    "21183": 179,
    "21185": 166,
    "21187": 127,
    "21189": 132,
    "21191": 105,
    "21193": 230,
    "21195": 439,
    "21197": 192,
    "21199": 445,
    "21201": 38,
    "21203": 172,
    "21205": 157,
    "21207": 125,
    "21209": 142,
    "21211": 163,
    "21213": 102,
    "21215": 83,
    "21217": 196,
    "21219": 161,
    "21221": 213,
    "21223": 90,
    "21225": 119,
    "21227": 286,
    "21229": 88,
    "21231": 188,
    "21233": 142,
    "21235": 251,
    "21237": 184,
    "21239": 99,
    "22001": 133,
    "22003": 157,
    "22005": 80,
    "22007": 35,
    "22009": 145,
    "22011": 191,
    "22013": 210,
    "22015": 410,
    "22017": 765,
    "22019": 413,
    "22021": 100,
    "22023": 134,
    "22025": 159,
    "22027": 185,
    "22029": 156,
    "22031": 234,
    "22033": 233,
    "22035": 128,
    "22037": 70,
    "22039": 105,
    "22041": 212,
    "22043": 153,
    "22045": 111,
    "22047": 95,
    "22049": 137,
    "22051": 198,
    "22053": 130,
    "22055": 147,
    "22057": 127,
    "22059": 102,
    "22061": 229,
    "22063": 177,
    "22065": 130,
    "22067": 232,
    "22069": 245,
    "22071": 118,
    "22073": 327,
    "22075": 92,
    "22077": 108,
    "22079": 281,
    "22081": 122,
    "22083": 176,
    "22085": 161,
    "22087": 75,
    "22089": 109,
    "22091": 53,
    "22093": 40,
    "22095": 52,
    "22097": 178,
    "22099": 80,
    "22101": 105,
    "22103": 291,
    "22105": 209,
    "22107": 132,
    "22109": 146,
    "22111": 252,
    "22113": 130,
    "22115": 173,
    "22117": 146,
    "22119": 277,
    "22121": 42,
    "22123": 143,
    "22125": 56,
    "22127": 155,
    "23001": 192,
    "23003": 706,
    "23005": 493,
    "23007": 239,
    "23009": 225,
    "23011": 255,
    "23013": 97,
    "23015": 134,
    "23017": 364,
    "23019": 447,
    "23021": 260,
    "23023": 118,
    "23025": 354,
    "23027": 175,
    "23029": 280,
    "23031": 467,
    "24001": 226,
    "24003": 572,
    "24005": 604,
    "24009": 275,
    "24011": 260,
    "24013": 301,
    "24015": 473,
    "24017": 426,
    "24019": 130,
    "24021": 496,
    "24023": 151,
    "24025": 399,
    "24027": 258,
    "24029": 421,
    "24031": 662,
    "24033": 492,
    "24035": 465,
    "24037": 343,
    "24039": 96,
    "24041": 299,
    "24043": 339,
    "24045": 176,
    "24047": 172,
    "24510": 165,
    "25001": 349,
    "25003": 578,
    "25005": 505,
    "25007": 136,
    "25009": 560,
    "25011": 501,
    "25013": 626,
    "25015": 456,
    "25017": 869,
    "25019": 171,
    "25021": 929,
    "25023": 647,
    "25025": 258,
    "25027": 808,
    "26001": 91,
    "26003": 122,
    "26005": 198,
    "26007": 80,
    "26009": 92,
    "26011": 73,
    "26013": 113,
    "26015": 140,
    "26017": 221,
    "26019": 41,
    "26021": 239,
    "26023": 216,
    "26025": 185,
    "26027": 165,
    "26029": 61,
    "26031": 55,
    "26033": 51,
    "26035": 81,
    "26037": 124,
    "26039": 63,
    "26041": 184,
    "26043": 171,
    "26045": 136,
    "26047": 64,
    "26049": 501,
    "26051": 70,
    "26053": 171,
    "26055": 85,
    "26057": 86,
    "26059": 192,
    "26061": 198,
    "26063": 219,
    "26065": 153,
    "26067": 101,
    "26069": 94,
    "26071": 123,
    "26073": 110,
    "26075": 166,
    "26077": 182,
    "26079": 48,
    "26081": 217,
    "26083": 54,
    "26085": 53,
    "26087": 266,
    "26089": 81,
    "26091": 353,
    "26093": 300,
    "26095": 69,
    "26097": 33,
    "26099": 479,
    "26101": 75,
    "26103": 326,
    "26105": 77,
    "26107": 73,
    "26109": 182,
    "26111": 201,
    "26113": 53,
    "26115": 317,
    "26117": 113,
    "26119": 69,
    "26121": 139,
    "26123": 97,
    "26125": 699,
    "26127": 74,
    "26129": 103,
    "26131": 126,
    "26133": 57,
    "26135": 70,
    "26137": 90,
    "26139": 173,
    "26141": 58,
    "26143": 106,
    "26145": 320,
    "26147": 301,
    "26149": 212,
    "26151": 179,
    "26153": 90,
    "26155": 179,
    "26157": 241,
    "26159": 142,
    "26161": 555,
    "26163": 554,
    "26165": 73,
    "27001": 178,
    "27003": 346,
    "27005": 340,
    "27007": 389,
    "27009": 136,
    "27011": 157,
    "27013": 251,
    "27015": 170,
    "27017": 141,
    "27019": 314,
    "27021": 319,
    "27023": 153,
    "27025": 124,
    "27027": 277,
    "27029": 163,
    "27031": 41,
    "27033": 184,
    "27035": 324,
    "27037": 409,
    "27039": 198,
    "27041": 222,
    "27043": 186,
    "27045": 283,
    "27047": 220,
    "27049": 239,
    "27051": 201,
    "27053": 757,
    "27055": 162,
    "27057": 221,
    "27059": 164,
    "27061": 338,
    "27063": 193,
    "27065": 125,
    "27067": 255,
    "27069": 251,
    "27071": 132,
    "27073": 218,
    "27075": 98,
    "27077": 150,
    "27079": 137,
    "27081": 158,
    "27083": 265,
    "27085": 438,
    "27087": 146,
    "27089": 275,
    "27091": 197,
    "27093": 240,
    "27095": 163,
    "27097": 212,
    "27099": 229,
    "27101": 141,
    "27103": 158,
    "27105": 256,
    "27107": 227,
    "27109": 458,
    "27111": 652,
    "27113": 123,
    "27115": 186,
    "27117": 160,
    "27119": 590,
    "27121": 183,
    "27123": 273,
    "27125": 144,
    "27127": 208,
    "27129": 245,
    "27131": 233,
    "27133": 188,
    "27135": 293,
    "27137": 639,
    "27139": 331,
    "27141": 230,
    "27143": 177,
    "27145": 528,
    "27147": 126,
    "27149": 165,
    "27151": 152,
    "27153": 180,
    "27155": 125,
    "27157": 215,
    "27159": 211,
    "27161": 153,
    "27163": 257,
    "27165": 127,
    "27167": 228,
    "27169": 276,
    "27171": 469,
    "27173": 138,
    "28001": 212,
    "28003": 142,
    "28005": 101,
    "28007": 248,
    "28009": 47,
    "28011": 301,
    "28013": 124,
    "28015": 216,
    "28017": 133,
    "28019": 127,
    "28021": 151,
    "28023": 279,
    "28025": 151,
    "28027": 114,
    "28029": 351,
    "28031": 227,
    "28033": 233,
    "28035": 411,
    "28037": 155,
    "28039": 83,
    "28041": 103,
    "28043": 221,
    "28045": 155,
    "28047": 221,
    "28049": 623,
    "28051": 204,
    "28053": 104,
    "28055": 92,
    "28057": 163,
    "28059": 157,
    "28061": 301,
    "28063": 149,
    "28065": 230,
    "28067": 488,
    "28069": 183,
    "28071": 141,
    "28073": 315,
    "28075": 430,
    "28077": 249,
    "28079": 266,
    "28081": 354,
    "28083": 209,
    "28085": 318,
    "28087": 329,
    "28089": 421,
    "28091": 252,
    "28093": 116,
    "28095": 205,
    "28097": 151,
    "28099": 337,
    "28101": 315,
    "28103": 191,
    "28105": 202,
    "28107": 151,
    "28109": 181,
    "28111": 109,
    "28113": 182,
    "28115": 173,
    "28117": 121,
    "28119": 38,
    "28121": 620,
    "28123": 308,
    "28125": 99,
    "28127": 316,
    "28129": 337,
    "28131": 92,
    "28133": 225,
    "28135": 107,
    "28137": 94,
    "28139": 110,
    "28141": 162,
    "28143": 85,
    "28145": 134,
    "28147": 96,
    "28149": 391,
    "28151": 262,
    "28153": 125,
    "28155": 173,
    "28157": 50,
    "28159": 182,
    "28161": 87,
    "28163": 306,
    "29001": 149,
    "29003": 138,
    "29005": 219,
    "29007": 150,
    "29009": 438,
    "29011": 278,
    "29013": 205,
    "29015": 246,
    "29017": 204,
    "29019": 417,
    "29021": 215,
    "29023": 276,
    "29025": 129,
    "29027": 259,
    "29029": 323,
    "29031": 331,
    "29033": 127,
    "29035": 158,
    "29037": 424,
    "29039": 211,
    "29041": 121,
    "29043": 445,
    "29045": 177,
    "29047": 488,
    "29049": 197,
    "29051": 178,
    "29053": 152,
    "29055": 181,
    "29057": 213,
    "29059": 229,
    "29061": 216,
    "29063": 158,
    "29065": 171,
    "29067": 343,
    "29069": 215,
    "29071": 406,
    "29073": 193,
    "29075": 118,
    "29077": 1068,
    "29079": 223,
    "29081": 181,
    "29083": 179,
    "29085": 173,
    "29087": 121,
    "29089": 106,
    "29091": 403,
    "29093": 118,
    "29095": 757,
    "29097": 483,
    "29099": 350,
    "29101": 355,
    "29103": 92,
    "29105": 345,
    "29107": 206,
    "29109": 317,
    "29111": 167,
    "29113": 211,
    "29115": 139,
    "29117": 142,
    "29119": 254,
    "29121": 178,
    "29123": 82,
    "29125": 123,
    "29127": 159,
    "29129": 116,
    "29131": 223,
    "29133": 160,
    "29135": 130,
    "29137": 119,
    "29139": 165,
    "29141": 260,
    "29143": 160,
    "29145": 395,
    "29147": 291,
    "29149": 181,
    "29151": 129,
    "29153": 290,
    "29155": 140,
    "29157": 153,
    "29159": 239,
    "29161": 258,
    "29163": 172,
    "29165": 366,
    "29167": 407,
    "29169": 291,
    "29171": 86,
    "29173": 121,
    "29175": 132,
    "29177": 137,
    "29179": 99,
    "29181": 183,
    "29183": 482,
    "29185": 219,
    "29186": 122,
    "29187": 183,
    "29189": 758,
    "29195": 131,
    "29197": 45,
    "29199": 166,
    "29201": 249,
    "29203": 224,
    "29205": 94,
    "29207": 262,
    "29209": 346,
    "29211": 122,
    "29213": 349,
    "29215": 299,
    "29217": 315,
    "29219": 159,
    "29221": 213,
    "29223": 188,
    "29225": 372,
    "29227": 88,
    "29229": 323,
    "29510": 147,
    "30001": 102,
    "30003": 350,
    "30005": 244,
    "30007": 82,
    "30009": 155,
    "30011": 378,
    "30013": 521,
    "30015": 325,
    "30017": 324,
    "30019": 236,
    "30021": 413,
    "30023": 70,
    "30025": 279,
    "30027": 381,
    "30029": 198,
    "30031": 155,
    "30033": 522,
    "30035": 878,
    "30037": 171,
    "30039": 95,
    "30041": 331,
    "30043": 73,
    "30045": 244,
    "30047": 147,
    "30049": 569,
    "30051": 155,
    "30053": 70,
    "30055": 373,
    "30057": 141,
    "30059": 71,
    "30061": 40,
    "30063": 255,
    "30065": 267,
    "30067": 229,
    "30069": 163,
    "30071": 558,
    "30073": 662,
    "30075": 396,
    "30077": 117,
    "30079": 261,
    "30081": 156,
    "30083": 360,
    "30085": 459,
    "30087": 465,
    "30089": 114,
    "30091": 289,
    "30093": 84,
    "30095": 320,
    "30097": 264,
    "30099": 511,
    "30101": 229,
    "30103": 124,
    "30105": 881,
    "30107": 293,
    "30109": 191,
    "30111": 612,
    "31001": 474,
    "31003": 267,
    "31005": 204,
    "31007": 165,
    "31009": 238,
    "31011": 213,
    "31013": 338,
    "31015": 170,
    "31017": 312,
    "31019": 426,
    "31021": 174,
    "31023": 207,
    "31025": 307,
    "31027": 249,
    "31029": 342,
    "31031": 1001,
    "31033": 496,
    "31035": 326,
    "31037": 149,
    "31039": 177,
    "31041": 815,
    "31043": 145,
    "31045": 298,
    "31047": 460,
    "31049": 282,
    "31051": 227,
    "31053": 318,
    "31055": 500,
    "31057": 374,
    "31059": 272,
    "31061": 200,
    "31063": 384,
    "31065": 358,
    "31067": 316,
    "31069": 370,
    "31071": 195,
    "31073": 186,
    "31075": 201,
    "31077": 152,
    "31079": 383,
    "31081": 268,
    "31083": 195,
    "31085": 250,
    "31087": 299,
    "31089": 581,
    "31091": 250,
    "31093": 239,
    "31095": 313,
    "31097": 131,
    "31099": 199,
    "31101": 491,
    "31103": 182,
    "31105": 300,
    "31107": 324,
    "31109": 479,
    "31111": 1170,
    "31113": 229,
    "31115": 177,
    "31117": 218,
    "31119": 220,
    "31121": 190,
    "31123": 300,
    "31125": 156,
    "31127": 184,
    "31129": 200,
    "31131": 257,
    "31133": 101,
    "31135": 338,
    "31137": 287,
    "31139": 149,
    "31141": 290,
    "31143": 187,
    "31145": 329,
    "31147": 173,
    "31149": 271,
    "31151": 351,
    "31153": 312,
    "31155": 310,
    "31157": 430,
    "31159": 222,
    "31161": 543,
    "31163": 192,
    "31165": 215,
    "31167": 161,
    "31169": 329,
    "31171": 206,
    "31173": 162,
    "31175": 253,
    "31177": 187,
    "31179": 122,
    "31181": 218,
    "31183": 172,
    "31185": 308,
    "32001": 148,
    "32003": 666,
    "32005": 759,
    "32007": 235,
    "32009": 109,
    "32011": 47,
    "32013": 78,
    "32015": 51,
    "32017": 94,
    "32019": 919,
    "32021": 127,
    "32023": 337,
    "32027": 111,
    "32029": 666,
    "32031": 987,
    "32033": 70,
    "32510": 743,
    "33001": 222,
    "33003": 302,
    "33005": 336,
    "33007": 239,
    "33009": 476,
    "33011": 281,
    "33013": 299,
    "33015": 458,
    "33017": 225,
    "33019": 165,
    "34001": 632,
    "34003": 372,
    "34005": 745,
    "34007": 394,
    "34009": 633,
    "34011": 391,
    "34013": 173,
    "34015": 412,
    "34017": 130,
    "34019": 379,
    "34021": 363,
    "34023": 389,
    "34025": 698,
    "34027": 388,
    "34029": 797,
    "34031": 212,
    "34033": 267,
    "34035": 349,
    "34037": 392,
    "34039": 143,
    "34041": 342,
    "35001": 387,
    "35003": 87,
    "35005": 321,
    "35006": 85,
    "35007": 393,
    "35009": 384,
    "35011": 212,
    "35013": 239,
    "35015": 675,
    "35017": 91,
    "35019": 171,
    "35021": 112,
    "35023": 39,
    "35025": 501,
    "35027": 360,
    "35028": 51,
    "35029": 64,
    "35031": 65,
    "35033": 225,
    "35035": 186,
    "35037": 399,
    "35039": 91,
    "35041": 337,
    "35043": 272,
    "35045": 59,
    "35047": 444,
    "35049": 363,
    "35051": 68,
    "35053": 206,
    "35055": 65,
    "35057": 436,
    "35059": 411,
    "35061": 216,
    "36001": 489,
    "36003": 215,
    "36005": 80,
    "36007": 449,
    "36009": 317,
    "36011": 317,
    "36013": 389,
    "36015": 158,
    "36017": 291,
    "36019": 280,
    "36021": 503,
    "36023": 174,
    "36025": 242,
    "36027": 562,
    "36029": 399,
    "36031": 272,
    "36033": 278,
    "36035": 253,
    "36037": 161,
    "36039": 250,
    "36041": 124,
    "36043": 484,
    "36045": 210,
    "36047": 109,
    "36049": 199,
    "36051": 176,
    "36053": 210,
    "36055": 284,
    "36057": 251,
    "36059": 303,
    "36061": 88,
    "36063": 240,
    "36065": 561,
    "36067": 382,
    "36069": 197,
    "36071": 365,
    "36073": 128,
    "36075": 335,
    "36077": 329,
    "36079": 154,
    "36081": 194,
    "36083": 491,
    "36085": 112,
    "36087": 162,
    "36089": 365,
    "36091": 599,
    "36093": 274,
    "36095": 213,
    "36097": 96,
    "36099": 106,
    "36101": 311,
    "36103": 622,
    "36105": 265,
    "36107": 207,
    "36109": 213,
    "36111": 477,
    "36113": 258,
    "36115": 344,
    "36117": 229,
    "36119": 371,
    "36121": 164,
    "36123": 87,
    "37001": 233,
    "37003": 165,
    "37005": 145,
    "37007": 184,
    "37009": 254,
    "37011": 140,
    "37013": 233,
    "37015": 94,
    "37017": 374,
    "37019": 262,
    "37021": 397,
    "37023": 393,
    "37025": 259,
    "37027": 239,
    "37029": 74,
    "37031": 194,
    "37033": 250,
    "37035": 368,
    "37037": 234,
    "37039": 169,
    "37041": 80,
    "37043": 87,
    "37045": 366,
    "37047": 348,
    "37049": 292,
    "37051": 299,
    "37053": 111,
    "37055": 143,
    "37057": 268,
    "37059": 167,
    "37061": 280,
    "37063": 246,
    "37065": 161,
    "37067": 304,
    "37069": 207,
    "37071": 323,
    "37073": 92,
    "37075": 125,
    "37077": 172,
    "37079": 114,
    "37081": 384,
    "37083": 214,
    "37085": 263,
    "37087": 147,
    "37089": 287,
    "37091": 84,
    "37093": 137,
    "37095": 94,
    "37097": 377,
    "37099": 226,
    "37101": 415,
    "37103": 125,
    "37105": 146,
    "37107": 204,
    "37109": 236,
    "37111": 294,
    "37113": 189,
    "37115": 191,
    "37117": 116,
    "37119": 515,
    "37121": 105,
    "37123": 162,
    "37125": 275,
    "37127": 232,
    "37129": 286,
    "37131": 136,
    "37133": 290,
    "37135": 231,
    "37137": 91,
    "37139": 109,
    "37141": 215,
    "37143": 91,
    "37145": 211,
    "37147": 285,
    "37149": 162,
    "37151": 350,
    "37153": 143,
    "37155": 406,
    "37157": 477,
    "37159": 331,
    "37161": 334,
    "37163": 294,
    "37165": 130,
    "37167": 187,
    "37169": 341,
    "37171": 448,
    "37173": 112,
    "37175": 183,
    "37177": 50,
    "37179": 298,
    "37181": 131,
    "37183": 661,
    "37185": 124,
    "37187": 83,
    "37189": 243,
    "37191": 257,
    "37193": 401,
    "37195": 167,
    "37197": 226,
    "37199": 99,
    "38001": 216,
    "38003": 347,
    "38005": 359,
    "38007": 151,
    "38009": 173,
    "38011": 241,
    "38013": 143,
    "38015": 396,
    "38017": 621,
    "38019": 277,
    "38021": 186,
    "38023": 122,
    "38025": 215,
    "38027": 204,
    "38029": 205,
    "38031": 132,
    "38033": 187,
    "38035": 592,
    "38037": 203,
    "38039": 190,
    "38041": 207,
    "38043": 174,
    "38045": 168,
    "38047": 132,
    "38049": 208,
    "38051": 174,
    "38053": 259,
    "38055": 339,
    "38057": 202,
    "38059": 499,
    "38061": 242,
    "38063": 265,
    "38065": 134,
    "38067": 294,
    "38069": 125,
    "38071": 308,
    "38073": 222,
    "38075": 115,
    "38077": 411,
    "38079": 102,
    "38081": 263,
    "38083": 91,
    "38085": 158,
    "38087": 151,
    "38089": 275,
    "38091": 226,
    "38093": 274,
    "38095": 195,
    "38097": 250,
    "38099": 343,
    "38101": 332,
    "38103": 152,
    "38105": 289,
    "39001": 192,
    "39003": 166,
    "39005": 275,
    "39007": 322,
    "39009": 200,
    "39011": 213,
    "39013": 208,
    "39015": 207,
    "39017": 301,
    "39019": 218,
    "39021": 154,
    "39023": 251,
    "39025": 299,
    "39027": 266,
    "39029": 341,
    "39031": 207,
    "39033": 228,
    "39035": 564,
    "39037": 226,
    "39039": 134,
    "39041": 198,
    "39043": 269,
    "39045": 255,
    "39047": 160,
    "39049": 475,
    "39051": 132,
    "39053": 163,
    "39055": 272,
    "39057": 294,
    "39059": 200,
    "39061": 432,
    "39063": 262,
    "39065": 123,
    "39067": 160,
    "39069": 145,
    "39071": 203,
    "39073": 140,
    "39075": 234,
    "39077": 302,
    "39079": 149,
    "39081": 207,
    "39083": 256,
    "39085": 253,
    "39087": 194,
    "39089": 272,
    "39091": 167,
    "39093": 455,
    "39095": 378,
    "39097": 136,
    "39099": 271,
    "39101": 229,
    "39103": 335,
    "39105": 129,
    "39107": 159,
    "39109": 192,
    "39111": 114,
    "39113": 426,
    "39115": 110,
    "39117": 178,
    "39119": 228,
    "39121": 93,
    "39123": 271,
    "39125": 140,
    "39127": 178,
    "39129": 147,
    "39131": 145,
    "39133": 317,
    "39135": 167,
    "39137": 177,
    "39139": 352,
    "39141": 201,
    "39143": 259,
    "39145": 278,
    "39147": 306,
    "39149": 176,
    "39151": 431,
    "39153": 434,
    "39155": 420,
    "39157": 305,
    "39159": 130,
    "39161": 190,
    "39163": 98,
    "39165": 336,
    "39167": 200,
    "39169": 323,
    "39171": 103,
    "39173": 346,
    "39175": 156,
    "40001": 249,
    "40003": 377,
    "40005": 193,
    "40007": 733,
    "40009": 410,
    "40011": 282,
    "40013": 265,
    "40015": 634,
    "40017": 543,
    "40019": 370,
    "40021": 366,
    "40023": 213,
    "40025": 457,
    "40027": 642,
    "40029": 116,
    "40031": 670,
    "40033": 243,
    "40035": 305,
    "40037": 522,
    "40039": 401,
    "40041": 340,
    "40043": 365,
    "40045": 333,
    "40047": 615,
    "40049": 312,
    "40051": 514,
    "40053": 308,
    "40055": 280,
    "40057": 289,
    "40059": 353,
    "40061": 245,
    "40063": 195,
    "40065": 540,
    "40067": 259,
    "40069": 187,
    "40071": 607,
    "40073": 355,
    "40075": 549,
    "40077": 246,
    "40079": 681,
    "40081": 325,
    "40083": 341,
    "40085": 166,
    "40087": 331,
    "40089": 389,
    "40091": 378,
    "40093": 283,
    "40095": 142,
    "40097": 410,
    "40099": 182,
    "40101": 490,
    "40103": 236,
    "40105": 235,
    "40107": 317,
    "40109": 960,
    "40111": 352,
    "40113": 776,
    "40115": 262,
    "40117": 338,
    "40119": 374,
    "40121": 440,
    "40123": 321,
    "40125": 299,
    "40127": 314,
    "40129": 359,
    "40131": 424,
    "40133": 212,
    "40135": 399,
    "40137": 517,
    "40139": 843,
    "40141": 432,
    "40143": 1111,
    "40145": 357,
    "40147": 361,
    "40149": 424,
    "40151": 453,
    "40153": 553,
    "41001": 33,
    "41003": 136,
    "41005": 158,
    "41007": 534,
    "41009": 277,
    "41011": 555,
    "41013": 79,
    "41015": 954,
    "41017": 216,
    "41019": 569,
    "41021": 41,
    "41023": 65,
    "41025": 25,
    "41027": 64,
    "41029": 156,
    "41031": 99,
    "41033": 92,
    "41035": 164,
    "41037": 192,
    "41039": 528,
    "41041": 457,
    "41043": 90,
    "41045": 55,
    "41047": 94,
    "41049": 109,
    "41051": 151,
    "41053": 141,
    "41055": 30,
    "41057": 536,
    "41059": 242,
    "41061": 223,
    "41063": 84,
    "41065": 58,
    "41067": 288,
    "41069": 62,
    "41071": 249,
    "42001": 211,
    "42003": 877,
    "42005": 268,
    "42007": 395,
    "42009": 140,
    "42011": 591,
    "42013": 151,
    "42015": 241,
    "42017": 384,
    "42019": 374,
    "42021": 254,
    "42023": 60,
    "42025": 297,
    "42027": 297,
    "42029": 396,
    "42031": 206,
    "42033": 261,
    "42035": 215,
    "42037": 171,
    "42039": 437,
    "42041": 237,
    "42043": 267,
    "42045": 376,
    "42047": 149,
    "42049": 424,
    "42051": 350,
    "42053": 97,
    "42055": 251,
    "42057": 60,
    "42059": 157,
    "42061": 175,
    "42063": 301,
    "42065": 289,
    "42067": 91,
    "42069": 172,
    "42071": 459,
    "42073": 259,
    "42075": 219,
    "42077": 421,
    "42079": 224,
    "42081": 333,
    "42083": 208,
    "42085": 407,
    "42087": 131,
    "42089": 374,
    "42091": 398,
    "42093": 82,
    "42095": 449,
    "42097": 173,
    "42099": 170,
    "42101": 364,
    "42103": 149,
    "42105": 151,
    "42107": 194,
    "42109": 104,
    "42111": 206,
    "42113": 81,
    "42115": 230,
    "42117": 179,
    "42119": 94,
    "42121": 307,
    "42123": 226,
    "42125": 471,
    "42127": 165,
    "42129": 716,
    "42131": 85,
    "42133": 454,
    "44001": 113,
    "44003": 242,
    "44005": 144,
    "44007": 343,
    "44009": 193,
    "45001": 179,
    "45003": 530,
    "45005": 182,
    "45007": 557,
    "45009": 179,
    "45011": 229,
    "45013": 530,
    "45015": 639,
    "45017": 202,
    "45019": 798,
    "45021": 269,
    "45023": 211,
    "45025": 269,
    "45027": 280,
    "45029": 727,
    "45031": 358,
    "45033": 183,
    "45035": 522,
    "45037": 207,
    "45039": 272,
    "45041": 390,
    "45043": 224,
    "45045": 752,
    "45047": 253,
    "45049": 264,
    "45051": 577,
    "45053": 369,
    "45055": 312,
    "45057": 254,
    "45059": 371,
    "45061": 163,
    "45063": 731,
    "45065": 144,
    "45067": 208,
    "45069": 209,
    "45071": 317,
    "45073": 438,
    "45075": 494,
    "45077": 376,
    "45079": 705,
    "45081": 221,
    "45083": 667,
    "45085": 384,
    "45087": 235,
    "45089": 186,
    "45091": 387,
    "46003": 192,
    "46005": 355,
    "46007": 278,
    "46009": 234,
    "46011": 235,
    "46013": 487,
    "46015": 226,
    "46017": 127,
    "46019": 501,
    "46021": 195,
    "46023": 309,
    "46025": 257,
    "46027": 202,
    "46029": 238,
    "46031": 464,
    "46033": 731,
    "46035": 260,
    "46037": 281,
    "46039": 139,
    "46041": 341,
    "46043": 133,
    "46045": 330,
    "46047": 413,
    "46049": 238,
    "46051": 177,
    "46053": 254,
    "46055": 406,
    "46057": 207,
    "46059": 377,
    "46061": 147,
    "46063": 622,
    "46065": 283,
    "46067": 216,
    "46069": 195,
    "46071": 458,
    "46073": 152,
    "46075": 216,
    "46077": 228,
    "46079": 232,
    "46081": 509,
    "46083": 231,
    "46085": 391,
    "46087": 226,
    "46089": 258,
    "46091": 219,
    "46093": 1291,
    "46095": 219,
    "46097": 156,
    "46099": 533,
    "46101": 164,
    "46103": 1639,
    "46105": 563,
    "46107": 168,
    "46109": 197,
    "46111": 164,
    "46113": 48,
    "46115": 296,
    "46117": 295,
    "46119": 216,
    "46121": 374,
    "46123": 392,
    "46125": 224,
    "46127": 210,
    "46129": 263,
    "46135": 281,
    "46137": 424,
    "47001": 231,
    "47003": 190,
    "47005": 148,
    "47007": 172,
    "47009": 340,
    "47011": 292,
    "47013": 190,
    "47015": 96,
    "47017": 178,
    "47019": 129,
    "47021": 166,
    "47023": 112,
    "47025": 188,
    "47027": 136,
    "47029": 203,
    "47031": 249,
    "47033": 79,
    "47035": 165,
    "47037": 869,
    "47039": 117,
    "47041": 133,
    "47043": 294,
    "47045": 115,
    "47047": 173,
    "47049": 196,
    "47051": 245,
    "47053": 207,
    "47055": 183,
    "47057": 180,
    "47059": 325,
    "47061": 112,
    "47063": 174,
    "47065": 425,
    "47067": 95,
    "47069": 167,
    "47071": 136,
    "47073": 201,
    "47075": 91,
    "47077": 181,
    "47079": 169,
    "47081": 233,
    "47083": 102,
    "47085": 168,
    "47087": 138,
    "47089": 212,
    "47091": 94,
    "47093": 427,
    "47095": 59,
    "47097": 120,
    "47099": 358,
    "47101": 118,
    "47103": 247,
    "47105": 227,
    "47107": 298,
    "47109": 138,
    "47111": 147,
    "47113": 235,
    "47115": 234,
    "47117": 136,
    "47119": 312,
    "47121": 143,
    "47123": 339,
    "47125": 310,
    "47127": 118,
    "47129": 215,
    "47131": 132,
    "47133": 173,
    "47135": 122,
    "47137": 71,
    "47139": 198,
    "47141": 309,
    "47143": 215,
    "47145": 257,
    "47147": 277,
    "47149": 475,
    "47151": 160,
    "47153": 155,
    "47155": 341,
    "47157": 498,
    "47159": 161,
    "47161": 172,
    "47163": 276,
    "47165": 437,
    "47167": 180,
    "47169": 74,
    "47171": 86,
    "47173": 158,
    "47175": 64,
    "47177": 151,
    "47179": 198,
    "47181": 168,
    "47183": 155,
    "47185": 142,
    "47187": 422,
    "47189": 560,
    "48001": 266,
    "48003": 146,
    "48005": 243,
    "48007": 53,
    "48009": 362,
    "48011": 309,
    "48013": 94,
    "48015": 104,
    "48017": 203,
    "48019": 86,
    "48021": 137,
    "48023": 186,
    "48025": 99,
    "48027": 384,
    "48029": 388,
    "48031": 67,
    "48033": 107,
    "48035": 201,
    "48037": 375,
    "48039": 262,
    "48041": 165,
    "48043": 288,
    "48045": 199,
    "48047": 59,
    "48049": 309,
    "48051": 130,
    "48053": 173,
    "48055": 89,
    "48057": 45,
    "48059": 225,
    "48061": 199,
    "48063": 105,
    "48065": 558,
    "48067": 240,
    "48069": 259,
    "48071": 94,
    "48073": 248,
    "48075": 254,
    "48077": 356,
    "48079": 179,
    "48081": 161,
    "48083": 226,
    "48085": 622,
    "48087": 227,
    "48089": 120,
    "48091": 113,
    "48093": 195,
    "48095": 141,
    "48097": 340,
    "48099": 195,
    "48101": 217,
    "48103": 65,
    "48105": 101,
    "48107": 227,
    "48109": 781,
    "48111": 221,
    "48113": 715,
    "48115": 162,
    "48117": 426,
    "48119": 88,
    "48121": 721,
    "48123": 57,
    "48125": 177,
    "48127": 57,
    "48129": 415,
    "48131": 101,
    "48133": 220,
    "48135": 310,
    "48137": 84,
    "48139": 350,
    "48141": 215,
    "48143": 208,
    "48145": 108,
    "48147": 244,
    "48149": 85,
    "48151": 187,
    "48153": 278,
    "48155": 132,
    "48157": 217,
    "48159": 106,
    "48161": 95,
    "48163": 87,
    "48165": 264,
    "48167": 265,
    "48169": 246,
    "48171": 134,
    "48173": 158,
    "48175": 82,
    "48177": 62,
    "48179": 559,
    "48181": 433,
    "48183": 289,
    "48185": 79,
    "48187": 91,
    "48189": 348,
    "48191": 262,
    "48193": 164,
    "48195": 285,
    "48197": 258,
    "48199": 115,
    "48201": 861,
    "48203": 326,
    "48205": 350,
    "48207": 280,
    "48209": 129,
    "48211": 260,
    "48213": 221,
    "48215": 233,
    "48217": 248,
    "48219": 372,
    "48221": 195,
    "48223": 212,
    "48225": 197,
    "48227": 241,
    "48229": 74,
    "48231": 265,
    "48233": 537,
    "48235": 95,
    "48237": 199,
    "48239": 69,
    "48241": 188,
    "48243": 101,
    "48245": 196,
    "48247": 54,
    "48249": 108,
    "48251": 322,
    "48253": 346,
    "48255": 37,
    "48257": 213,
    "48259": 83,
    "48261": 37,
    "48263": 143,
    "48265": 136,
    "48267": 130,
    "48269": 139,
    "48271": 58,
    "48273": 87,
    "48275": 231,
    "48277": 274,
    "48279": 308,
    "48281": 129,
    "48283": 74,
    "48285": 83,
    "48287": 91,
    "48289": 134,
    "48291": 144,
    "48293": 152,
    "48295": 360,
    "48297": 96,
    "48299": 152,
    "48301": 36,
    "48303": 686,
    "48305": 268,
    "48307": 242,
    "48309": 431,
    "48311": 40,
    "48313": 99,
    "48315": 105,
    "48317": 143,
    "48319": 136,
    "48321": 72,
    "48323": 73,
    "48325": 135,
    "48327": 112,
    "48329": 378,
    "48331": 119,
    "48333": 109,
    "48335": 219,
    "48337": 320,
    "48339": 290,
    "48341": 444,
    "48343": 110,
    "48345": 200,
    "48347": 236,
    "48349": 239,
    "48351": 125,
    "48353": 250,
    "48355": 304,
    "48357": 368,
    "48359": 285,
    "48361": 142,
    "48363": 305,
    "48365": 165,
    "48367": 432,
    "48369": 266,
    "48371": 464,
    "48373": 158,
    "48375": 1009,
    "48377": 90,
    "48379": 83,
    "48381": 938,
    "48383": 130,
    "48385": 87,
    "48387": 179,
    "48389": 164,
    "48391": 62,
    "48393": 226,
    "48395": 105,
    "48397": 89,
    "48399": 252,
    "48401": 271,
    "48403": 102,
    "48405": 96,
    "48407": 108,
    "48409": 109,
    "48411": 111,
    "48413": 90,
    "48415": 279,
    "48417": 144,
    "48419": 186,
    "48421": 172,
    "48423": 481,
    "48425": 77,
    "48427": 95,
    "48429": 159,
    "48431": 95,
    "48433": 126,
    "48435": 58,
    "48437": 257,
    "48439": 1210,
    "48441": 512,
    "48443": 106,
    "48445": 226,
    "48447": 186,
    "48449": 123,
    "48451": 561,
    "48453": 424,
    "48455": 117,
    "48457": 139,
    "48459": 208,
    "48461": 113,
    "48463": 131,
    "48465": 212,
    "48467": 187,
    "48469": 135,
    "48471": 129,
    "48473": 71,
    "48475": 105,
    "48477": 112,
    "48479": 164,
    "48481": 175,
    "48483": 362,
    "48485": 556,
    "48487": 306,
    "48489": 72,
    "48491": 300,
    "48493": 95,
    "48495": 98,
    "48497": 442,
    "48499": 213,
    "48501": 184,
    "48503": 291,
    "48505": 94,
    "48507": 53,
    "49001": 82,
    "49003": 377,
    "49005": 90,
    "49007": 44,
    "49009": 28,
    "49011": 181,
    "49013": 70,
    "49015": 64,
    "49017": 47,
    "49019": 81,
    "49021": 73,
    "49023": 202,
    "49025": 49,
    "49027": 104,
    "49029": 61,
    "49031": 4,
    "49033": 45,
    "49035": 490,
    "49037": 97,
    "49039": 78,
    "49041": 49,
    "49043": 137,
    "49045": 583,
    "49047": 69,
    "49049": 371,
    "49051": 107,
    "49053": 165,
    "49055": 19,
    "49057": 194,
    "50001": 286,
    "50003": 178,
    "50005": 226,
    "50007": 433,
    "50009": 97,
    "50011": 222,
    "50013": 91,
    "50015": 145,
    "50017": 146,
    "50019": 178,
    "50021": 316,
    "50023": 220,
    "50025": 200,
    "50027": 197,
    "51001": 133,
    "51003": 376,
    "51005": 132,
    "51007": 128,
    "51009": 242,
    "51011": 113,
    "51013": 171,
    "51015": 184,
    "51017": 122,
    "51019": 442,
    "51021": 93,
    "51023": 190,
    "51025": 133,
    "51027": 96,
    "51029": 265,
    "51031": 338,
    "51033": 152,
    "51035": 267,
    "51036": 68,
    "51037": 208,
    "51041": 265,
    "51043": 191,
    "51045": 86,
    "51047": 232,
    "51049": 90,
    "51051": 94,
    "51053": 129,
    "51057": 101,
    "51059": 567,
    "51061": 364,
    "51063": 167,
    "51065": 96,
    "51067": 514,
    "51069": 265,
    "51071": 188,
    "51073": 114,
    "51075": 114,
    "51077": 211,
    "51079": 107,
    "51081": 65,
    "51083": 431,
    "51085": 193,
    "51087": 267,
    "51089": 349,
    "51091": 61,
    "51093": 144,
    "51095": 127,
    "51097": 84,
    "51099": 159,
    "51101": 103,
    "51103": 88,
    "51105": 177,
    "51107": 528,
    "51109": 173,
    "51111": 93,
    "51113": 160,
    "51115": 70,
    "51117": 191,
    "51119": 95,
    "51121": 337,
    "51125": 198,
    "51127": 98,
    "51131": 80,
    "51133": 71,
    "51135": 107,
    "51137": 209,
    "51139": 170,
    "51141": 298,
    "51143": 549,
    "51145": 108,
    "51147": 114,
    "51149": 166,
    "51153": 309,
    "51155": 216,
    "51157": 139,
    "51159": 132,
    "51161": 277,
    "51163": 227,
    "51165": 237,
    "51167": 137,
    "51169": 159,
    "51171": 225,
    "51173": 185,
    "51175": 142,
    "51177": 293,
    "51179": 223,
    "51181": 82,
    "51183": 115,
    "51185": 234,
    "51187": 168,
    "51191": 193,
    "51193": 117,
    "51195": 150,
    "51197": 192,
    "51199": 119,
    "51510": 115,
    "51515": 31,
    "51520": 55,
    "51530": 54,
    "51540": 86,
    "51550": 184,
    "51570": 41,
    "51580": 52,
    "51590": 108,
    "51595": 39,
    "51600": 92,
    "51610": 81,
    "51620": 54,
    "51630": 78,
    "51640": 102,
    "51650": 100,
    "51660": 48,
    "51670": 54,
    "51678": 52,
    "51680": 130,
    "51683": 89,
    "51685": 46,
    "51690": 79,
    "51700": 109,
    "51710": 180,
    "51720": 31,
    "51730": 51,
    "51735": 7,
    "51740": 136,
    "51750": 62,
    "51760": 74,
    "51770": 129,
    "51775": 89,
    "51790": 55,
    "51800": 174,
    "51810": 209,
    "51820": 53,
    "51830": 62,
    "51840": 83,
    "53001": 87,
    "53003": 56,
    "53005": 153,
    "53007": 91,
    "53009": 106,
    "53011": 80,
    "53013": 66,
    "53015": 130,
    "53017": 99,
    "53019": 42,
    "53021": 131,
    "53023": 41,
    "53025": 130,
    "53027": 86,
    "53029": 80,
    "53031": 177,
    "53033": 83,
    "53035": 70,
    "53037": 37,
    "53039": 140,
    "53041": 36,
    "53043": 124,
    "53045": 41,
    "53047": 161,
    "53049": 266,
    "53051": 79,
    "53053": 47,
    "53055": 93,
    "53057": 33,
    "53059": 47,
    "53061": 75,
    "53063": 242,
    "53065": 81,
    "53067": 43,
    "53069": 277,
    "53071": 198,
    "53073": 111,
    "53075": 83,
    "53077": 105,
    "54001": 100,
    "54003": 256,
    "54005": 154,
    "54007": 115,
    "54009": 116,
    "54011": 201,
    "54013": 84,
    "54015": 86,
    "54017": 89,
    "54019": 133,
    "54021": 86,
    "54023": 117,
    "54025": 218,
    "54027": 186,
    "54029": 143,
    "54031": 135,
    "54033": 211,
    "54035": 166,
    "54037": 227,
    "54039": 475,
    "54041": 116,
    "54043": 156,
    "54045": 136,
    "54047": 147,
    "54049": 134,
    "54051": 163,
    "54053": 158,
    "54055": 176,
    "54057": 116,
    "54059": 150,
    "54061": 148,
    "54063": 102,
    "54065": 153,
    "54067": 88,
    "54069": 150,
    "54071": 81,
    "54073": 66,
    "54075": 49,
    "54077": 177,
    "54079": 192,
    "54081": 183,
    "54083": 99,
    "54085": 107,
    "54087": 114,
    "54089": 105,
    "54091": 107,
    "54093": 73,
    "54095": 79,
    "54097": 106,
    "54099": 187,
    "54101": 81,
    "54103": 95,
    "54105": 63,
    "54107": 179,
    "54109": 155,
    "55001": 208,
    "55003": 115,
    "55005": 253,
    "55007": 151,
    "55009": 221,
    "55011": 206,
    "55013": 192,
    "55015": 199,
    "55017": 212,
    "55019": 285,
    "55021": 296,
    "55023": 186,
    "55025": 657,
    "55027": 350,
    "55029": 181,
    "55031": 169,
    "55033": 224,
    "55035": 174,
    "55037": 65,
    "55039": 261,
    "55041": 131,
    "55043": 453,
    "55045": 250,
    "55047": 146,
    "55049": 235,
    "55051": 72,
    "55053": 225,
    "55055": 378,
    "55057": 213,
    "55059": 246,
    "55061": 94,
    "55063": 354,
    "55065": 199,
    "55067": 156,
    "55069": 195,
    "55071": 178,
    "55073": 372,
    "55075": 183,
    "55077": 165,
    "55078": 67,
    "55079": 326,
    "55081": 322,
    "55083": 142,
    "55085": 251,
    "55087": 289,
    "55089": 165,
    "55091": 74,
    "55093": 201,
    "55095": 204,
    "55097": 218,
    "55099": 220,
    "55101": 301,
    "55103": 141,
    "55105": 438,
    "55107": 124,
    "55109": 231,
    "55111": 295,
    "55113": 207,
    "55115": 170,
    "55117": 206,
    "55119": 194,
    "55121": 291,
    "55123": 283,
    "55125": 207,
    "55127": 368,
    "55129": 133,
    "55131": 281,
    "55133": 463,
    "55135": 252,
    "55137": 176,
    "55139": 254,
    "55141": 212,
    "56001": 3621,
    "56003": 132,
    "56005": 760,
    "56007": 1776,
    "56009": 242,
    "56011": 608,
    "56013": 640,
    "56015": 330,
    "56017": 177,
    "56019": 235,
    "56021": 2764,
    "56023": 79,
    "56025": 506,
    "56027": 167,
    "56029": 340,
    "56031": 771,
    "56033": 303,
    "56035": 108,
    "56037": 335,
    "56039": 63,
    "56041": 33,
    "56043": 75,
    "56045": 332
  },
  {
    "1001": 28,
    "1003": 100,
    "1005": 7,
    "1007": 17,
    "1009": 37,
    "1011": 8,
    "1013": 14,
    "1015": 26,
    "1017": 18,
    "1019": 21,
    "1021": 11,
    "1023": 37,
    "1025": 35,
    "1027": 19,
    "1029": 9,
    "1031": 27,
    "1033": 74,
    "1035": 12,
    "1037": 3,
    "1039": 17,
    "1041": 17,
    "1043": 63,
    "1045": 31,
    "1047": 15,
    "1049": 56,
    "1051": 43,
    "1053": 34,
    "1055": 29,
    "1057": 11,
    "1059": 26,
    "1061": 40,
    "1063": 13,
    "1065": 18,
    "1067": 9,
    "1069": 49,
    "1071": 43,
    "1073": 120,
    "1075": 59,
    "1077": 136,
    "1079": 50,
    "1081": 20,
    "1083": 71,
    "1085": 16,
    "1087": 10,
    "1089": 177,
    "1091": 13,
    "1093": 25,
    "1095": 65,
    "1097": 135,
    "1099": 19,
    "1101": 40,
    "1103": 90,
    "1105": 10,
    "1107": 20,
    "1109": 13,
    "1111": 24,
    "1113": 16,
    "1115": 27,
    "1117": 52,
    "1119": 22,
    "1121": 34,
    "1123": 17,
    "1125": 54,
    "1127": 31,
    "1129": 22,
    "1131": 9,
    "1133": 16,
    "2013": 1,
    "2016": 4,
    "2020": 9,
    "2050": 33,
    "2060": 11,
    "2068": 20,
    "2070": 11,
    "2090": 33,
    "2100": 1,
    "2110": 7,
    "2122": 29,
    "2130": 1,
    "2150": 12,
    "2164": 12,
    "2170": 7,
    "2180": 50,
    "2185": 27,
    "2188": 24,
    "2201": 1,
    "2220": 13,
    "2232": 0,
    "2240": 17,
    "2261": 13,
    "2270": 0,
    "2280": 0,
    "2282": 4,
    "2290": 56,
    "4001": 76,
    "4003": 167,
    "4005": 196,
    "4007": 113,
    "4009": 40,
    "4011": 24,
    "4012": 64,
    "4013": 284,
    "4015": 424,
    "4017": 100,
    "4019": 408,
    "4021": 96,
    "4023": 67,
    "4025": 201,
    "4027": 26,
    "5001": 46,
    "5003": 46,
    "5005": 36,
    "5007": 97,
    "5009": 36,
    "5011": 34,
    "5013": 46,
    "5015": 42,
    "5017": 71,
    "5019": 100,
    "5021": 31,
    "5023": 34,
    "5025": 34,
    "5027": 35,
    "5029": 47,
    "5031": 72,
    "5033": 107,
    "5035": 26,
    "5037": 12,
    "5039": 31,
    "5041": 33,
    "5043": 47,
    "5045": 71,
    "5047": 65,
    "5049": 31,
    "5051": 56,
    "5053": 36,
    "5055": 41,
    "5057": 45,
    "5059": 57,
    "5061": 25,
    "5063": 76,
    "5065": 36,
    "5067": 68,
    "5069": 62,
    "5071": 43,
    "5073": 34,
    "5075": 41,
    "5077": 9,
    "5079": 28,
    "5081": 28,
    "5083": 25,
    "5085": 71,
    "5087": 54,
    "5089": 31,
    "5091": 39,
    "5093": 32,
    "5095": 65,
    "5097": 46,
    "5099": 33,
    "5101": 31,
    "5103": 80,
    "5105": 73,
    "5107": 13,
    "5109": 33,
    "5111": 36,
    "5113": 51,
    "5115": 39,
    "5117": 59,
    "5119": 190,
    "5121": 42,
    "5123": 17,
    "5125": 90,
    "5127": 42,
    "5129": 34,
    "5131": 105,
    "5133": 28,
    "5135": 61,
    "5137": 38,
    "5139": 39,
    "5141": 31,
    "5143": 98,
    "5145": 145,
    "5147": 241,
    "5149": 81,
    "6001": 92,
    "6003": 9,
    "6005": 37,
    "6007": 40,
    "6009": 22,
    "6011": 17,
    "6013": 48,
    "6015": 8,
    "6017": 55,
    "6019": 134,
    "6021": 15,
    "6023": 12,
    "6025": 26,
    "6027": 152,
    "6029": 226,
    "6031": 22,
    "6033": 14,
    "6035": 11,
    "6037": 160,
    "6039": 41,
    "6041": 84,
    "6043": 67,
    "6045": 13,
    "6047": 46,
    "6049": 10,
    "6051": 28,
    "6053": 78,
    "6055": 47,
    "6057": 40,
    "6059": 90,
    "6061": 47,
    "6063": 18,
    "6065": 282,
    "6067": 61,
    "6069": 15,
    "6071": 691,
    "6073": 350,
    "6075": 58,
    "6077": 19,
    "6079": 20,
    "6081": 76,
    "6083": 54,
    "6085": 122,
    "6087": 92,
    "6089": 31,
    "6091": 7,
    "6093": 37,
    "6095": 25,
    "6097": 174,
    "6099": 12,
    "6101": 22,
    "6103": 31,
    "6105": 4,
    "6107": 80,
    "6109": 31,
    "6111": 67,
    "6113": 18,
    "6115": 21,
    "8001": 22,
    "8003": 6,
    "8005": 39,
    "8007": 8,
    "8009": 9,
    "8011": 14,
    "8013": 34,
    "8014": 2,
    "8015": 13,
    "8017": 23,
    "8019": 7,
    "8021": 4,
    "8023": 12,
    "8025": 5,
    "8027": 23,
    "8029": 15,
    "8031": 23,
    "8033": 6,
    "8035": 44,
    "8037": 40,
    "8039": 21,
    "8041": 151,
    "8043": 49,
    "8045": 82,
    "8047": 2,
    "8049": 2,
    "8051": 28,
    "8053": 17,
    "8055": 35,
    "8057": 1,
    "8059": 40,
    "8061": 8,
    "8063": 33,
    "8065": 0,
    "8067": 79,
    "8069": 54,
    "8071": 17,
    "8073": 15,
    "8075": 18,
    "8077": 96,
    "8079": 2,
    "8081": 14,
    "8083": 15,
    "8085": 46,
    "8087": 37,
    "8089": 24,
    "8091": 34,
    "8093": 9,
    "8095": 12,
    "8097": 35,
    "8099": 26,
    "8101": 57,
    "8103": 49,
    "8105": 6,
    "8107": 23,
    "8109": 6,
    "8111": 6,
    "8113": 52,
    "8115": 8,
    "8117": 1,
    "8119": 24,
    "8121": 26,
    "8123": 55,
    "8125": 39,
    "9001": 148,
    "9003": 114,
    "9005": 127,
    "9007": 47,
    "9009": 141,
    "9011": 111,
    "9013": 15,
    "9015": 20,
    "10001": 80,
    "10003": 231,
    "10005": 214,
    "11001": 185,
    "12001": 30,
    "12003": 11,
    "12005": 73,
    "12007": 12,
    "12009": 26,
    "12011": 61,
    "12013": 11,
    "12015": 14,
    "12017": 26,
    "12019": 13,
    "12021": 34,
    "12023": 14,
    "12027": 38,
    "12029": 17,
    "12031": 126,
    "12033": 59,
    "12035": 46,
    "12037": 23,
    "12039": 9,
    "12041": 4,
    "12043": 14,
    "12045": 35,
    "12047": 10,
    "12049": 24,
    "12051": 5,
    "12053": 26,
    "12055": 13,
    "12057": 71,
    "12059": 79,
    "12061": 18,
    "12063": 80,
    "12065": 8,
    "12067": 15,
    "12069": 6,
    "12071": 31,
    "12073": 72,
    "12075": 10,
    "12077": 4,
    "12079": 12,
    "12081": 43,
    "12083": 27,
    "12085": 14,
    "12086": 103,
    "12087": 47,
    "12089": 26,
    "12091": 52,
    "12093": 5,
    "12095": 8,
    "12097": 16,
    "12099": 51,
    "12101": 55,
    "12103": 57,
    "12105": 38,
    "12107": 16,
    "12109": 47,
    "12111": 17,
    "12113": 52,
    "12115": 37,
    "12117": 9,
    "12119": 6,
    "12121": 16,
    "12123": 22,
    "12125": 7,
    "12127": 20,
    "12129": 31,
    "12131": 119,
    "12133": 45,
    "13001": 10,
    "13003": 6,
    "13005": 8,
    "13007": 8,
    "13009": 10,
    "13011": 12,
    "13013": 12,
    "13015": 22,
    "13017": 5,
    "13019": 4,
    "13021": 18,
    "13023": 7,
    "13025": 8,
    "13027": 9,
    "13029": 12,
    "13031": 17,
    "13033": 8,
    "13035": 5,
    "13037": 3,
    "13039": 16,
    "13043": 3,
    "13045": 29,
    "13047": 16,
    "13049": 4,
    "13051": 150,
    "13053": 6,
    "13055": 23,
    "13057": 29,
    "13059": 10,
    "13061": 1,
    "13063": 14,
    "13065": 3,
    "13067": 48,
    "13069": 11,
    "13071": 10,
    "13073": 26,
    "13075": 5,
    "13077": 30,
    "13079": 11,
    "13081": 22,
    "13083": 15,
    "13085": 15,
    "13087": 12,
    "13089": 56,
    "13091": 10,
    "13093": 15,
    "13095": 26,
    "13097": 21,
    "13099": 4,
    "13101": 4,
    "13103": 7,
    "13105": 19,
    "13107": 7,
    "13109": 6,
    "13111": 15,
    "13113": 21,
    "13115": 32,
    "13117": 32,
    "13119": 10,
    "13121": 81,
    "13123": 29,
    "13125": 1,
    "13127": 14,
    "13129": 33,
    "13131": 7,
    "13133": 7,
    "13135": 40,
    "13137": 31,
    "13139": 17,
    "13141": 2,
    "13143": 15,
    "13145": 12,
    "13147": 14,
    "13149": 11,
    "13151": 7,
    "13153": 17,
    "13155": 6,
    "13157": 11,
    "13159": 4,
    "13161": 5,
    "13163": 2,
    "13165": 5,
    "13167": 8,
    "13169": 11,
    "13171": 9,
    "13173": 0,
    "13175": 13,
    "13177": 16,
    "13179": 21,
    "13181": 3,
    "13183": 5,
    "13185": 16,
    "13187": 10,
    "13189": 3,
    "13191": 26,
    "13193": 6,
    "13195": 6,
    "13197": 5,
    "13199": 7,
    "13201": 5,
    "13205": 9,
    "13207": 8,
    "13209": 8,
    "13211": 10,
    "13213": 21,
    "13215": 20,
    "13217": 10,
    "13219": 4,
    "13221": 5,
    "13223": 16,
    "13225": 10,
    "13227": 15,
    "13229": 6,
    "13231": 13,
    "13233": 18,
    "13235": 13,
    "13237": 13,
    "13239": 2,
    "13241": 26,
    "13243": 3,
    "13245": 27,
    "13247": 10,
    "13249": 3,
    "13251": 9,
    "13253": 6,
    "13255": 11,
    "13257": 14,
    "13259": 3,
    "13261": 13,
    "13263": 8,
    "13265": 6,
    "13267": 18,
    "13269": 10,
    "13271": 12,
    "13273": 5,
    "13275": 12,
    "13277": 9,
    "13279": 10,
    "13281": 7,
    "13283": 6,
    "13285": 10,
    "13287": 2,
    "13289": 3,
    "13291": 12,
    "13293": 24,
    "13295": 16,
    "13297": 12,
    "13299": 10,
    "13301": 2,
    "13303": 6,
    "13305": 7,
    "13307": 6,
    "13309": 7,
    "13311": 21,
    "13313": 26,
    "13315": 6,
    "13317": 8,
    "13319": 6,
    "13321": 22,
    "15001": 188,
    "15003": 195,
    "15005": 0,
    "15007": 181,
    "15009": 155,
    "16001": 18,
    "16003": 8,
    "16005": 56,
    "16007": 9,
    "16009": 39,
    "16011": 14,
    "16013": 21,
    "16015": 25,
    "16017": 27,
    "16019": 13,
    "16021": 26,
    "16023": 9,
    "16025": 4,
    "16027": 9,
    "16029": 10,
    "16031": 20,
    "16033": 8,
    "16035": 13,
    "16037": 13,
    "16039": 19,
    "16041": 6,
    "16043": 14,
    "16045": 12,
    "16047": 4,
    "16049": 14,
    "16051": 9,
    "16053": 4,
    "16055": 58,
    "16057": 41,
    "16059": 23,
    "16061": 2,
    "16063": 4,
    "16065": 16,
    "16067": 4,
    "16069": 18,
    "16071": 15,
    "16073": 26,
    "16075": 7,
    "16077": 22,
    "16079": 38,
    "16081": 5,
    "16083": 11,
    "16085": 14,
    "16087": 21,
    "17001": 31,
    "17003": 185,
    "17005": 18,
    "17007": 25,
    "17009": 17,
    "17011": 17,
    "17013": 26,
    "17015": 40,
    "17017": 32,
    "17019": 54,
    "17021": 46,
    "17023": 39,
    "17025": 53,
    "17027": 19,
    "17029": 47,
    "17031": 213,
    "17033": 47,
    "17035": 33,
    "17037": 36,
    "17039": 18,
    "17041": 31,
    "17043": 84,
    "17045": 38,
    "17047": 25,
    "17049": 58,
    "17051": 24,
    "17053": 26,
    "17055": 95,
    "17057": 57,
    "17059": 138,
    "17061": 15,
    "17063": 33,
    "17065": 32,
    "17067": 81,
    "17069": 49,
    "17071": 44,
    "17073": 54,
    "17075": 44,
    "17077": 166,
    "17079": 47,
    "17081": 35,
    "17083": 33,
    "17085": 49,
    "17087": 23,
    "17089": 61,
    "17091": 38,
    "17093": 23,
    "17095": 41,
    "17097": 64,
    "17099": 63,
    "17101": 41,
    "17103": 23,
    "17105": 33,
    "17107": 40,
    "17109": 62,
    "17111": 33,
    "17113": 29,
    "17115": 34,
    "17117": 26,
    "17119": 37,
    "17121": 25,
    "17123": 29,
    "17125": 26,
    "17127": 104,
    "17129": 24,
    "17131": 41,
    "17133": 28,
    "17135": 18,
    "17137": 39,
    "17139": 28,
    "17141": 37,
    "17143": 38,
    "17145": 44,
    "17147": 22,
    "17149": 25,
    "17151": 61,
    "17153": 108,
    "17155": 13,
    "17157": 27,
    "17159": 35,
    "17161": 81,
    "17163": 44,
    "17165": 51,
    "17167": 52,
    "17169": 42,
    "17171": 39,
    "17173": 48,
    "17175": 22,
    "17177": 46,
    "17179": 35,
    "17181": 58,
    "17183": 56,
    "17185": 92,
    "17187": 23,
    "17189": 14,
    "17191": 75,
    "17193": 172,
    "17195": 51,
    "17197": 102,
    "17199": 53,
    "17201": 61,
    "17203": 38,
    "18001": 13,
    "18003": 34,
    "18005": 51,
    "18007": 22,
    "18009": 7,
    "18011": 48,
    "18013": 24,
    "18015": 48,
    "18017": 23,
    "18019": 80,
    "18021": 42,
    "18023": 35,
    "18025": 62,
    "18027": 106,
    "18029": 73,
    "18031": 27,
    "18033": 7,
    "18035": 64,
    "18037": 73,
    "18039": 8,
    "18041": 50,
    "18043": 46,
    "18045": 104,
    "18047": 47,
    "18049": 12,
    "18051": 234,
    "18053": 16,
    "18055": 111,
    "18057": 68,
    "18059": 27,
    "18061": 61,
    "18063": 48,
    "18065": 25,
    "18067": 27,
    "18069": 24,
    "18071": 126,
    "18073": 22,
    "18075": 16,
    "18077": 111,
    "18079": 39,
    "18081": 56,
    "18083": 194,
    "18085": 14,
    "18087": 4,
    "18089": 64,
    "18091": 10,
    "18093": 84,
    "18095": 64,
    "18097": 111,
    "18099": 9,
    "18101": 44,
    "18103": 21,
    "18105": 43,
    "18107": 38,
    "18109": 84,
    "18111": 21,
    "18113": 3,
    "18115": 29,
    "18117": 40,
    "18119": 100,
    "18121": 126,
    "18123": 77,
    "18125": 124,
    "18127": 41,
    "18129": 196,
    "18131": 4,
    "18133": 56,
    "18135": 44,
    "18137": 104,
    "18139": 27,
    "18141": 15,
    "18143": 21,
    "18145": 43,
    "18147": 73,
    "18149": 3,
    "18151": 9,
    "18153": 113,
    "18155": 44,
    "18157": 132,
    "18159": 21,
    "18161": 43,
    "18163": 98,
    "18165": 125,
    "18167": 124,
    "18169": 19,
    "18171": 92,
    "18173": 121,
    "18175": 53,
    "18177": 70,
    "18179": 11,
    "18181": 23,
    "18183": 16,
    "19001": 37,
    "19003": 38,
    "19005": 52,
    "19007": 63,
    "19009": 33,
    "19011": 36,
    "19013": 173,
    "19015": 53,
    "19017": 54,
    "19019": 78,
    "19021": 56,
    "19023": 113,
    "19025": 60,
    "19027": 59,
    "19029": 46,
    "19031": 30,
    "19033": 75,
    "19035": 55,
    "19037": 32,
    "19039": 61,
    "19041": 114,
    "19043": 144,
    "19045": 73,
    "19047": 31,
    "19049": 164,
    "19051": 30,
    "19053": 60,
    "19055": 41,
    "19057": 73,
    "19059": 71,
    "19061": 66,
    "19063": 74,
    "19065": 64,
    "19067": 56,
    "19069": 61,
    "19071": 78,
    "19073": 60,
    "19075": 51,
    "19077": 76,
    "19079": 71,
    "19081": 38,
    "19083": 55,
    "19085": 25,
    "19087": 26,
    "19089": 29,
    "19091": 74,
    "19093": 19,
    "19095": 64,
    "19097": 39,
    "19099": 55,
    "19101": 17,
    "19103": 62,
    "19105": 51,
    "19107": 37,
    "19109": 78,
    "19111": 67,
    "19113": 71,
    "19115": 69,
    "19117": 105,
    "19119": 58,
    "19121": 51,
    "19123": 137,
    "19125": 132,
    "19127": 81,
    "19129": 23,
    "19131": 38,
    "19133": 18,
    "19135": 63,
    "19137": 27,
    "19139": 63,
    "19141": 46,
    "19143": 8,
    "19145": 23,
    "19147": 53,
    "19149": 91,
    "19151": 42,
    "19153": 262,
    "19155": 36,
    "19157": 34,
    "19159": 31,
    "19161": 49,
    "19163": 114,
    "19165": 5,
    "19167": 91,
    "19169": 122,
    "19171": 49,
    "19173": 34,
    "19175": 38,
    "19177": 33,
    "19179": 106,
    "19181": 129,
    "19183": 54,
    "19185": 86,
    "19187": 137,
    "19189": 37,
    "19191": 54,
    "19193": 59,
    "19195": 43,
    "19197": 59,
    "20001": 46,
    "20003": 61,
    "20005": 55,
    "20007": 20,
    "20009": 45,
    "20011": 74,
    "20013": 28,
    "20015": 111,
    "20017": 23,
    "20019": 29,
    "20021": 145,
    "20023": 27,
    "20025": 9,
    "20027": 32,
    "20029": 21,
    "20031": 31,
    "20033": 13,
    "20035": 54,
    "20037": 76,
    "20039": 12,
    "20041": 45,
    "20043": 17,
    "20045": 50,
    "20047": 10,
    "20049": 30,
    "20051": 43,
    "20053": 23,
    "20055": 10,
    "20057": 43,
    "20059": 55,
    "20061": 33,
    "20063": 38,
    "20065": 21,
    "20067": 8,
    "20069": 11,
    "20071": 15,
    "20073": 41,
    "20075": 7,
    "20077": 34,
    "20079": 30,
    "20081": 4,
    "20083": 15,
    "20085": 30,
    "20087": 54,
    "20089": 10,
    "20091": 101,
    "20093": 12,
    "20095": 26,
    "20097": 8,
    "20099": 51,
    "20101": 7,
    "20103": 125,
    "20105": 20,
    "20107": 51,
    "20109": 56,
    "20111": 66,
    "20113": 55,
    "20115": 33,
    "20117": 36,
    "20119": 14,
    "20121": 51,
    "20123": 18,
    "20125": 62,
    "20127": 40,
    "20129": 9,
    "20131": 32,
    "20133": 31,
    "20135": 15,
    "20137": 11,
    "20139": 60,
    "20141": 17,
    "20143": 36,
    "20145": 16,
    "20147": 16,
    "20149": 34,
    "20151": 20,
    "20153": 22,
    "20155": 48,
    "20157": 24,
    "20159": 34,
    "20161": 44,
    "20163": 19,
    "20165": 21,
    "20167": 24,
    "20169": 32,
    "20171": 7,
    "20173": 170,
    "20175": 10,
    "20177": 95,
    "20179": 8,
    "20181": 39,
    "20183": 15,
    "20185": 13,
    "20187": 17,
    "20189": 10,
    "20191": 57,
    "20193": 14,
    "20195": 11,
    "20197": 43,
    "20199": 15,
    "20201": 18,
    "20203": 14,
    "20205": 40,
    "20207": 23,
    "20209": 48,
    "21001": 21,
    "21003": 33,
    "21005": 31,
    "21007": 77,
    "21009": 31,
    "21011": 46,
    "21013": 66,
    "21015": 57,
    "21017": 80,
    "21019": 67,
    "21021": 18,
    "21023": 31,
    "21025": 103,
    "21027": 36,
    "21029": 39,
    "21031": 127,
    "21033": 26,
    "21035": 60,
    "21037": 53,
    "21039": 53,
    "21041": 47,
    "21043": 62,
    "21045": 19,
    "21047": 66,
    "21049": 32,
    "21051": 46,
    "21053": 13,
    "21055": 53,
    "21057": 13,
    "21059": 93,
    "21061": 44,
    "21063": 32,
    "21065": 110,
    "21067": 49,
    "21069": 58,
    "21071": 140,
    "21073": 50,
    "21075": 53,
    "21077": 50,
    "21079": 22,
    "21081": 41,
    "21083": 56,
    "21085": 28,
    "21087": 17,
    "21089": 52,
    "21091": 24,
    "21093": 54,
    "21095": 51,
    "21097": 34,
    "21099": 35,
    "21101": 76,
    "21103": 26,
    "21105": 53,
    "21107": 42,
    "21109": 35,
    "21111": 190,
    "21113": 27,
    "21115": 61,
    "21117": 63,
    "21119": 33,
    "21121": 74,
    "21123": 17,
    "21125": 55,
    "21127": 43,
    "21129": 54,
    "21131": 59,
    "21133": 78,
    "21135": 69,
    "21137": 27,
    "21139": 61,
    "21141": 42,
    "21143": 27,
    "21145": 118,
    "21147": 36,
    "21149": 54,
    "21151": 70,
    "21153": 55,
    "21155": 28,
    "21157": 48,
    "21159": 52,
    "21161": 46,
    "21163": 22,
    "21165": 43,
    "21167": 22,
    "21169": 15,
    "21171": 13,
    "21173": 63,
    "21175": 56,
    "21177": 107,
    "21179": 75,
    "21181": 52,
    "21183": 86,
    "21185": 49,
    "21187": 55,
    "21189": 43,
    "21191": 50,
    "21193": 74,
    "21195": 146,
    "21197": 101,
    "21199": 68,
    "21201": 11,
    "21203": 49,
    "21205": 59,
    "21207": 17,
    "21209": 53,
    "21211": 26,
    "21213": 41,
    "21215": 32,
    "21217": 37,
    "21219": 45,
    "21221": 35,
    "21223": 35,
    "21225": 94,
    "21227": 79,
    "21229": 15,
    "21231": 28,
    "21233": 30,
    "21235": 136,
    "21237": 33,
    "21239": 20,
    "22001": 29,
    "22003": 13,
    "22005": 20,
    "22007": 8,
    "22009": 21,
    "22011": 34,
    "22013": 30,
    "22015": 101,
    "22017": 195,
    "22019": 92,
    "22021": 19,
    "22023": 24,
    "22025": 22,
    "22027": 23,
    "22029": 29,
    "22031": 44,
    "22033": 31,
    "22035": 25,
    "22037": 10,
    "22039": 15,
    "22041": 36,
    "22043": 32,
    "22045": 36,
    "22047": 12,
    "22049": 17,
    "22051": 76,
    "22053": 28,
    "22055": 42,
    "22057": 41,
    "22059": 19,
    "22061": 28,
    "22063": 23,
    "22065": 24,
    "22067": 43,
    "22069": 75,
    "22071": 64,
    "22073": 96,
    "22075": 31,
    "22077": 18,
    "22079": 36,
    "22081": 26,
    "22083": 43,
    "22085": 45,
    "22087": 38,
    "22089": 38,
    "22091": 5,
    "22093": 19,
    "22095": 24,
    "22097": 35,
    "22099": 30,
    "22101": 37,
    "22103": 85,
    "22105": 29,
    "22107": 27,
    "22109": 37,
    "22111": 36,
    "22113": 38,
    "22115": 28,
    "22117": 17,
    "22119": 61,
    "22121": 6,
    "22123": 29,
    "22125": 10,
    "22127": 37,
    "23001": 46,
    "23003": 140,
    "23005": 144,
    "23007": 57,
    "23009": 50,
    "23011": 81,
    "23013": 43,
    "23015": 33,
    "23017": 116,
    "23019": 78,
    "23021": 86,
    "23023": 30,
    "23025": 121,
    "23027": 63,
    "23029": 52,
    "23031": 104,
    "24001": 70,
    "24003": 231,
    "24005": 343,
    "24009": 53,
    "24011": 33,
    "24013": 111,
    "24015": 80,
    "24017": 64,
    "24019": 27,
    "24021": 203,
    "24023": 62,
    "24025": 137,
    "24027": 129,
    "24029": 35,
    "24031": 234,
    "24033": 130,
    "24035": 50,
    "24037": 189,
    "24039": 17,
    "24041": 31,
    "24043": 87,
    "24045": 22,
    "24047": 35,
    "24510": 76,
    "25001": 77,
    "25003": 125,
    "25005": 122,
    "25007": 22,
    "25009": 148,
    "25011": 61,
    "25013": 105,
    "25015": 50,
    "25017": 183,
    "25019": 31,
    "25021": 218,
    "25023": 120,
    "25025": 80,
    "25027": 122,
    "26001": 5,
    "26003": 5,
    "26005": 20,
    "26007": 1,
    "26009": 1,
    "26011": 13,
    "26013": 9,
    "26015": 15,
    "26017": 14,
    "26019": 1,
    "26021": 22,
    "26023": 0,
    "26025": 13,
    "26027": 12,
    "26029": 1,
    "26031": 3,
    "26033": 5,
    "26035": 8,
    "26037": 12,
    "26039": 1,
    "26041": 10,
    "26043": 13,
    "26045": 11,
    "26047": 1,
    "26049": 30,
    "26051": 10,
    "26053": 14,
    "26055": 7,
    "26057": 11,
    "26059": 6,
    "26061": 13,
    "26063": 9,
    "26065": 12,
    "26067": 7,
    "26069": 3,
    "26071": 9,
    "26073": 14,
    "26075": 11,
    "26077": 13,
    "26079": 2,
    "26081": 24,
    "26083": 5,
    "26085": 8,
    "26087": 15,
    "26089": 2,
    "26091": 33,
    "26093": 18,
    "26095": 0,
    "26097": 5,
    "26099": 40,
    "26101": 8,
    "26103": 30,
    "26105": 13,
    "26107": 13,
    "26109": 4,
    "26111": 15,
    "26113": 3,
    "26115": 17,
    "26117": 10,
    "26119": 1,
    "26121": 13,
    "26123": 11,
    "26125": 24,
    "26127": 9,
    "26129": 3,
    "26131": 5,
    "26133": 12,
    "26135": 3,
    "26137": 1,
    "26139": 20,
    "26141": 0,
    "26143": 2,
    "26145": 37,
    "26147": 10,
    "26149": 6,
    "26151": 7,
    "26153": 1,
    "26155": 14,
    "26157": 18,
    "26159": 10,
    "26161": 32,
    "26163": 67,
    "26165": 11,
    "27001": 29,
    "27003": 18,
    "27005": 27,
    "27007": 16,
    "27009": 12,
    "27011": 11,
    "27013": 37,
    "27015": 17,
    "27017": 26,
    "27019": 31,
    "27021": 3,
    "27023": 13,
    "27025": 6,
    "27027": 47,
    "27029": 11,
    "27031": 12,
    "27033": 32,
    "27035": 22,
    "27037": 30,
    "27039": 24,
    "27041": 10,
    "27043": 25,
    "27045": 41,
    "27047": 24,
    "27049": 28,
    "27051": 19,
    "27053": 50,
    "27055": 38,
    "27057": 9,
    "27059": 6,
    "27061": 13,
    "27063": 37,
    "27065": 11,
    "27067": 15,
    "27069": 44,
    "27071": 4,
    "27073": 14,
    "27075": 10,
    "27077": 16,
    "27079": 21,
    "27081": 15,
    "27083": 36,
    "27085": 26,
    "27087": 17,
    "27089": 37,
    "27091": 21,
    "27093": 11,
    "27095": 13,
    "27097": 16,
    "27099": 63,
    "27101": 25,
    "27103": 19,
    "27105": 26,
    "27107": 25,
    "27109": 42,
    "27111": 42,
    "27113": 13,
    "27115": 22,
    "27117": 51,
    "27119": 53,
    "27121": 16,
    "27123": 21,
    "27125": 19,
    "27127": 25,
    "27129": 22,
    "27131": 22,
    "27133": 45,
    "27135": 21,
    "27137": 54,
    "27139": 31,
    "27141": 6,
    "27143": 20,
    "27145": 21,
    "27147": 22,
    "27149": 8,
    "27151": 13,
    "27153": 13,
    "27155": 11,
    "27157": 55,
    "27159": 14,
    "27161": 22,
    "27163": 13,
    "27165": 17,
    "27167": 56,
    "27169": 66,
    "27171": 20,
    "27173": 13,
    "28001": 38,
    "28003": 33,
    "28005": 6,
    "28007": 24,
    "28009": 6,
    "28011": 44,
    "28013": 18,
    "28015": 21,
    "28017": 6,
    "28019": 12,
    "28021": 17,
    "28023": 32,
    "28025": 11,
    "28027": 22,
    "28029": 29,
    "28031": 37,
    "28033": 65,
    "28035": 106,
    "28037": 25,
    "28039": 29,
    "28041": 28,
    "28043": 52,
    "28045": 45,
    "28047": 64,
    "28049": 135,
    "28051": 18,
    "28053": 18,
    "28055": 10,
    "28057": 12,
    "28059": 38,
    "28061": 32,
    "28063": 17,
    "28065": 31,
    "28067": 110,
    "28069": 13,
    "28071": 22,
    "28073": 69,
    "28075": 68,
    "28077": 29,
    "28079": 23,
    "28081": 45,
    "28083": 34,
    "28085": 41,
    "28087": 41,
    "28089": 82,
    "28091": 67,
    "28093": 19,
    "28095": 18,
    "28097": 21,
    "28099": 34,
    "28101": 41,
    "28103": 15,
    "28105": 22,
    "28107": 26,
    "28109": 20,
    "28111": 25,
    "28113": 13,
    "28115": 21,
    "28117": 20,
    "28119": 5,
    "28121": 136,
    "28123": 41,
    "28125": 17,
    "28127": 25,
    "28129": 22,
    "28131": 27,
    "28133": 35,
    "28135": 14,
    "28137": 23,
    "28139": 19,
    "28141": 15,
    "28143": 13,
    "28145": 26,
    "28147": 8,
    "28149": 60,
    "28151": 51,
    "28153": 27,
    "28155": 16,
    "28157": 10,
    "28159": 15,
    "28161": 8,
    "28163": 43,
    "29001": 43,
    "29003": 22,
    "29005": 43,
    "29007": 34,
    "29009": 170,
    "29011": 114,
    "29013": 23,
    "29015": 103,
    "29017": 50,
    "29019": 73,
    "29021": 113,
    "29023": 96,
    "29025": 18,
    "29027": 39,
    "29029": 91,
    "29031": 150,
    "29033": 71,
    "29035": 40,
    "29037": 53,
    "29039": 41,
    "29041": 117,
    "29043": 110,
    "29045": 70,
    "29047": 119,
    "29049": 19,
    "29051": 37,
    "29053": 150,
    "29055": 35,
    "29057": 49,
    "29059": 106,
    "29061": 53,
    "29063": 19,
    "29065": 70,
    "29067": 196,
    "29069": 33,
    "29071": 45,
    "29073": 30,
    "29075": 17,
    "29077": 255,
    "29079": 34,
    "29081": 12,
    "29083": 174,
    "29085": 55,
    "29087": 19,
    "29089": 94,
    "29091": 205,
    "29093": 22,
    "29095": 190,
    "29097": 153,
    "29099": 47,
    "29101": 133,
    "29103": 27,
    "29105": 127,
    "29107": 101,
    "29109": 113,
    "29111": 40,
    "29113": 45,
    "29115": 20,
    "29117": 75,
    "29119": 153,
    "29121": 38,
    "29123": 19,
    "29125": 77,
    "29127": 35,
    "29129": 8,
    "29131": 95,
    "29133": 41,
    "29135": 33,
    "29137": 28,
    "29139": 31,
    "29141": 104,
    "29143": 56,
    "29145": 171,
    "29147": 57,
    "29149": 62,
    "29151": 35,
    "29153": 148,
    "29155": 15,
    "29157": 72,
    "29159": 33,
    "29161": 87,
    "29163": 27,
    "29165": 104,
    "29167": 147,
    "29169": 80,
    "29171": 17,
    "29173": 28,
    "29175": 15,
    "29177": 52,
    "29179": 24,
    "29181": 68,
    "29183": 51,
    "29185": 52,
    "29186": 20,
    "29187": 26,
    "29189": 63,
    "29195": 143,
    "29197": 14,
    "29199": 28,
    "29201": 65,
    "29203": 95,
    "29205": 26,
    "29207": 46,
    "29209": 96,
    "29211": 11,
    "29213": 103,
    "29215": 103,
    "29217": 93,
    "29219": 24,
    "29221": 22,
    "29223": 106,
    "29225": 161,
    "29227": 3,
    "29229": 158,
    "29510": 29,
    "30001": 11,
    "30003": 21,
    "30005": 16,
    "30007": 4,
    "30009": 17,
    "30011": 9,
    "30013": 19,
    "30015": 7,
    "30017": 27,
    "30019": 17,
    "30021": 28,
    "30023": 18,
    "30025": 15,
    "30027": 9,
    "30029": 39,
    "30031": 13,
    "30033": 30,
    "30035": 10,
    "30037": 11,
    "30039": 21,
    "30041": 6,
    "30043": 5,
    "30045": 4,
    "30047": 20,
    "30049": 33,
    "30051": 1,
    "30053": 16,
    "30055": 22,
    "30057": 8,
    "30059": 4,
    "30061": 6,
    "30063": 28,
    "30065": 32,
    "30067": 8,
    "30069": 20,
    "30071": 52,
    "30073": 10,
    "30075": 26,
    "30077": 19,
    "30079": 22,
    "30081": 28,
    "30083": 31,
    "30085": 45,
    "30087": 27,
    "30089": 24,
    "30091": 15,
    "30093": 18,
    "30095": 12,
    "30097": 9,
    "30099": 6,
    "30101": 7,
    "30103": 10,
    "30105": 98,
    "30107": 14,
    "30109": 18,
    "30111": 35,
    "31001": 18,
    "31003": 20,
    "31005": 2,
    "31007": 8,
    "31009": 1,
    "31011": 26,
    "31013": 4,
    "31015": 9,
    "31017": 5,
    "31019": 20,
    "31021": 15,
    "31023": 26,
    "31025": 62,
    "31027": 19,
    "31029": 8,
    "31031": 11,
    "31033": 35,
    "31035": 11,
    "31037": 20,
    "31039": 33,
    "31041": 30,
    "31043": 19,
    "31045": 7,
    "31047": 17,
    "31049": 7,
    "31051": 21,
    "31053": 58,
    "31055": 46,
    "31057": 9,
    "31059": 12,
    "31061": 7,
    "31063": 19,
    "31065": 11,
    "31067": 32,
    "31069": 7,
    "31071": 3,
    "31073": 5,
    "31075": 2,
    "31077": 6,
    "31079": 24,
    "31081": 15,
    "31083": 5,
    "31085": 20,
    "31087": 10,
    "31089": 16,
    "31091": 1,
    "31093": 15,
    "31095": 37,
    "31097": 10,
    "31099": 9,
    "31101": 12,
    "31103": 5,
    "31105": 32,
    "31107": 35,
    "31109": 44,
    "31111": 46,
    "31113": 4,
    "31115": 2,
    "31117": 1,
    "31119": 30,
    "31121": 14,
    "31123": 20,
    "31125": 8,
    "31127": 62,
    "31129": 8,
    "31131": 58,
    "31133": 10,
    "31135": 10,
    "31137": 11,
    "31139": 15,
    "31141": 43,
    "31143": 17,
    "31145": 14,
    "31147": 62,
    "31149": 3,
    "31151": 69,
    "31153": 33,
    "31155": 66,
    "31157": 25,
    "31159": 23,
    "31161": 7,
    "31163": 8,
    "31165": 6,
    "31167": 22,
    "31169": 16,
    "31171": 2,
    "31173": 19,
    "31175": 5,
    "31177": 24,
    "31179": 10,
    "31181": 10,
    "31183": 4,
    "31185": 18,
    "32001": 7,
    "32003": 318,
    "32005": 26,
    "32007": 64,
    "32009": 18,
    "32011": 30,
    "32013": 9,
    "32015": 11,
    "32017": 65,
    "32019": 32,
    "32021": 11,
    "32023": 55,
    "32027": 5,
    "32029": 13,
    "32031": 45,
    "32033": 23,
    "32510": 8,
    "33001": 30,
    "33003": 80,
    "33005": 32,
    "33007": 94,
    "33009": 205,
    "33011": 55,
    "33013": 83,
    "33015": 98,
    "33017": 22,
    "33019": 31,
    "34001": 185,
    "34003": 266,
    "34005": 164,
    "34007": 165,
    "34009": 239,
    "34011": 89,
    "34013": 108,
    "34015": 131,
    "34017": 110,
    "34019": 93,
    "34021": 111,
    "34023": 132,
    "34025": 274,
    "34027": 124,
    "34029": 228,
    "34031": 142,
    "34033": 89,
    "34035": 180,
    "34037": 50,
    "34039": 120,
    "34041": 55,
    "35001": 73,
    "35003": 38,
    "35005": 41,
    "35006": 28,
    "35007": 26,
    "35009": 20,
    "35011": 16,
    "35013": 70,
    "35015": 189,
    "35017": 59,
    "35019": 20,
    "35021": 5,
    "35023": 7,
    "35025": 86,
    "35027": 42,
    "35028": 13,
    "35029": 29,
    "35031": 51,
    "35033": 6,
    "35035": 44,
    "35037": 20,
    "35039": 37,
    "35041": 29,
    "35043": 78,
    "35045": 36,
    "35047": 27,
    "35049": 75,
    "35051": 54,
    "35053": 39,
    "35055": 8,
    "35057": 18,
    "35059": 26,
    "35061": 19,
    "36001": 134,
    "36003": 58,
    "36005": 69,
    "36007": 166,
    "36009": 77,
    "36011": 41,
    "36013": 89,
    "36015": 55,
    "36017": 110,
    "36019": 76,
    "36021": 83,
    "36023": 60,
    "36025": 106,
    "36027": 70,
    "36029": 140,
    "36031": 106,
    "36033": 49,
    "36035": 35,
    "36037": 35,
    "36039": 100,
    "36041": 31,
    "36043": 189,
    "36045": 26,
    "36047": 68,
    "36049": 33,
    "36051": 42,
    "36053": 44,
    "36055": 78,
    "36057": 116,
    "36059": 175,
    "36061": 72,
    "36063": 32,
    "36065": 106,
    "36067": 45,
    "36069": 45,
    "36071": 98,
    "36073": 18,
    "36075": 34,
    "36077": 55,
    "36079": 24,
    "36081": 139,
    "36083": 92,
    "36085": 66,
    "36087": 90,
    "36089": 29,
    "36091": 111,
    "36093": 72,
    "36095": 89,
    "36097": 17,
    "36099": 16,
    "36101": 88,
    "36103": 286,
    "36105": 72,
    "36107": 80,
    "36109": 26,
    "36111": 169,
    "36113": 59,
    "36115": 90,
    "36117": 37,
    "36119": 181,
    "36121": 37,
    "36123": 39,
    "37001": 39,
    "37003": 9,
    "37005": 24,
    "37007": 39,
    "37009": 70,
    "37011": 34,
    "37013": 32,
    "37015": 24,
    "37017": 50,
    "37019": 95,
    "37021": 47,
    "37023": 54,
    "37025": 70,
    "37027": 60,
    "37029": 14,
    "37031": 36,
    "37033": 30,
    "37035": 25,
    "37037": 27,
    "37039": 15,
    "37041": 7,
    "37043": 6,
    "37045": 13,
    "37047": 39,
    "37049": 26,
    "37051": 55,
    "37053": 19,
    "37055": 18,
    "37057": 52,
    "37059": 12,
    "37061": 33,
    "37063": 59,
    "37065": 37,
    "37067": 44,
    "37069": 23,
    "37071": 22,
    "37073": 14,
    "37075": 11,
    "37077": 18,
    "37079": 26,
    "37081": 90,
    "37083": 36,
    "37085": 26,
    "37087": 32,
    "37089": 88,
    "37091": 16,
    "37093": 26,
    "37095": 6,
    "37097": 23,
    "37099": 43,
    "37101": 49,
    "37103": 17,
    "37105": 22,
    "37107": 36,
    "37109": 25,
    "37111": 36,
    "37113": 35,
    "37115": 39,
    "37117": 20,
    "37119": 103,
    "37121": 27,
    "37123": 36,
    "37125": 35,
    "37127": 31,
    "37129": 157,
    "37131": 18,
    "37133": 36,
    "37135": 34,
    "37137": 18,
    "37139": 16,
    "37141": 82,
    "37143": 10,
    "37145": 20,
    "37147": 48,
    "37149": 23,
    "37151": 51,
    "37153": 21,
    "37155": 30,
    "37157": 79,
    "37159": 34,
    "37161": 27,
    "37163": 26,
    "37165": 20,
    "37167": 68,
    "37169": 20,
    "37171": 58,
    "37173": 28,
    "37175": 76,
    "37177": 4,
    "37179": 72,
    "37181": 9,
    "37183": 149,
    "37185": 19,
    "37187": 9,
    "37189": 110,
    "37191": 35,
    "37193": 62,
    "37195": 29,
    "37197": 22,
    "37199": 26,
    "38001": 4,
    "38003": 30,
    "38005": 63,
    "38007": 6,
    "38009": 16,
    "38011": 4,
    "38013": 2,
    "38015": 29,
    "38017": 69,
    "38019": 23,
    "38021": 12,
    "38023": 2,
    "38025": 12,
    "38027": 25,
    "38029": 7,
    "38031": 6,
    "38033": 5,
    "38035": 62,
    "38037": 9,
    "38039": 20,
    "38041": 7,
    "38043": 7,
    "38045": 10,
    "38047": 6,
    "38049": 16,
    "38051": 4,
    "38053": 7,
    "38055": 12,
    "38057": 11,
    "38059": 19,
    "38061": 15,
    "38063": 57,
    "38065": 10,
    "38067": 44,
    "38069": 4,
    "38071": 60,
    "38073": 41,
    "38075": 11,
    "38077": 78,
    "38079": 12,
    "38081": 44,
    "38083": 1,
    "38085": 13,
    "38087": 1,
    "38089": 6,
    "38091": 26,
    "38093": 21,
    "38095": 22,
    "38097": 31,
    "38099": 51,
    "38101": 24,
    "38103": 12,
    "38105": 11,
    "39001": 90,
    "39003": 11,
    "39005": 40,
    "39007": 43,
    "39009": 71,
    "39011": 66,
    "39013": 116,
    "39015": 78,
    "39017": 86,
    "39019": 51,
    "39021": 32,
    "39023": 68,
    "39025": 116,
    "39027": 47,
    "39029": 70,
    "39031": 88,
    "39033": 35,
    "39035": 81,
    "39037": 74,
    "39039": 15,
    "39041": 54,
    "39043": 62,
    "39045": 52,
    "39047": 37,
    "39049": 129,
    "39051": 12,
    "39053": 71,
    "39055": 27,
    "39057": 60,
    "39059": 62,
    "39061": 199,
    "39063": 43,
    "39065": 41,
    "39067": 42,
    "39069": 17,
    "39071": 66,
    "39073": 73,
    "39075": 40,
    "39077": 32,
    "39079": 39,
    "39081": 41,
    "39083": 27,
    "39085": 39,
    "39087": 64,
    "39089": 67,
    "39091": 63,
    "39093": 68,
    "39095": 45,
    "39097": 25,
    "39099": 32,
    "39101": 55,
    "39103": 39,
    "39105": 65,
    "39107": 84,
    "39109": 61,
    "39111": 54,
    "39113": 86,
    "39115": 27,
    "39117": 24,
    "39119": 65,
    "39121": 65,
    "39123": 22,
    "39125": 20,
    "39127": 45,
    "39129": 55,
    "39131": 56,
    "39133": 26,
    "39135": 55,
    "39137": 17,
    "39139": 48,
    "39141": 70,
    "39143": 40,
    "39145": 110,
    "39147": 28,
    "39149": 59,
    "39151": 63,
    "39153": 47,
    "39155": 57,
    "39157": 85,
    "39159": 46,
    "39161": 18,
    "39163": 62,
    "39165": 93,
    "39167": 93,
    "39169": 25,
    "39171": 6,
    "39173": 32,
    "39175": 30,
    "40001": 72,
    "40003": 27,
    "40005": 26,
    "40007": 20,
    "40009": 15,
    "40011": 14,
    "40013": 26,
    "40015": 46,
    "40017": 43,
    "40019": 29,
    "40021": 116,
    "40023": 29,
    "40025": 12,
    "40027": 76,
    "40029": 16,
    "40031": 68,
    "40033": 18,
    "40035": 38,
    "40037": 70,
    "40039": 13,
    "40041": 38,
    "40043": 9,
    "40045": 14,
    "40047": 29,
    "40049": 26,
    "40051": 31,
    "40053": 40,
    "40055": 11,
    "40057": 5,
    "40059": 8,
    "40061": 41,
    "40063": 8,
    "40065": 24,
    "40067": 30,
    "40069": 33,
    "40071": 78,
    "40073": 24,
    "40075": 39,
    "40077": 47,
    "40079": 151,
    "40081": 18,
    "40083": 14,
    "40085": 3,
    "40087": 27,
    "40089": 79,
    "40091": 47,
    "40093": 22,
    "40095": 11,
    "40097": 55,
    "40099": 53,
    "40101": 80,
    "40103": 17,
    "40105": 52,
    "40107": 40,
    "40109": 142,
    "40111": 96,
    "40113": 67,
    "40115": 135,
    "40117": 35,
    "40119": 23,
    "40121": 78,
    "40123": 29,
    "40125": 36,
    "40127": 55,
    "40129": 9,
    "40131": 65,
    "40133": 22,
    "40135": 59,
    "40137": 49,
    "40139": 14,
    "40141": 17,
    "40143": 239,
    "40145": 63,
    "40147": 40,
    "40149": 10,
    "40151": 19,
    "40153": 24,
    "41001": 16,
    "41003": 40,
    "41005": 64,
    "41007": 48,
    "41009": 51,
    "41011": 100,
    "41013": 5,
    "41015": 62,
    "41017": 12,
    "41019": 60,
    "41021": 2,
    "41023": 10,
    "41025": 8,
    "41027": 15,
    "41029": 21,
    "41031": 0,
    "41033": 20,
    "41035": 9,
    "41037": 4,
    "41039": 62,
    "41041": 52,
    "41043": 22,
    "41045": 24,
    "41047": 32,
    "41049": 6,
    "41051": 40,
    "41053": 37,
    "41055": 1,
    "41057": 92,
    "41059": 16,
    "41061": 9,
    "41063": 18,
    "41065": 1,
    "41067": 50,
    "41069": 10,
    "41071": 24,
    "42001": 47,
    "42003": 408,
    "42005": 63,
    "42007": 122,
    "42009": 49,
    "42011": 155,
    "42013": 44,
    "42015": 146,
    "42017": 121,
    "42019": 78,
    "42021": 38,
    "42023": 12,
    "42025": 59,
    "42027": 33,
    "42029": 168,
    "42031": 50,
    "42033": 46,
    "42035": 37,
    "42037": 42,
    "42039": 73,
    "42041": 77,
    "42043": 70,
    "42045": 165,
    "42047": 14,
    "42049": 72,
    "42051": 128,
    "42053": 16,
    "42055": 54,
    "42057": 17,
    "42059": 77,
    "42061": 60,
    "42063": 74,
    "42065": 90,
    "42067": 19,
    "42069": 49,
    "42071": 112,
    "42073": 74,
    "42075": 66,
    "42077": 97,
    "42079": 89,
    "42081": 60,
    "42083": 32,
    "42085": 80,
    "42087": 14,
    "42089": 61,
    "42091": 176,
    "42093": 24,
    "42095": 99,
    "42097": 40,
    "42099": 39,
    "42101": 213,
    "42103": 22,
    "42105": 20,
    "42107": 50,
    "42109": 34,
    "42111": 57,
    "42113": 29,
    "42115": 64,
    "42117": 40,
    "42119": 38,
    "42121": 73,
    "42123": 32,
    "42125": 155,
    "42127": 40,
    "42129": 227,
    "42131": 53,
    "42133": 117,
    "44001": 25,
    "44003": 50,
    "44005": 20,
    "44007": 108,
    "44009": 36,
    "45001": 14,
    "45003": 17,
    "45005": 12,
    "45007": 52,
    "45009": 7,
    "45011": 8,
    "45013": 91,
    "45015": 66,
    "45017": 8,
    "45019": 348,
    "45021": 10,
    "45023": 12,
    "45025": 32,
    "45027": 17,
    "45029": 33,
    "45031": 27,
    "45033": 10,
    "45035": 54,
    "45037": 3,
    "45039": 4,
    "45041": 43,
    "45043": 47,
    "45045": 111,
    "45047": 20,
    "45049": 15,
    "45051": 91,
    "45053": 20,
    "45055": 16,
    "45057": 50,
    "45059": 28,
    "45061": 2,
    "45063": 63,
    "45065": 4,
    "45067": 28,
    "45069": 13,
    "45071": 9,
    "45073": 27,
    "45075": 27,
    "45077": 40,
    "45079": 168,
    "45081": 6,
    "45083": 66,
    "45085": 17,
    "45087": 16,
    "45089": 22,
    "45091": 33,
    "46003": 8,
    "46005": 39,
    "46007": 7,
    "46009": 46,
    "46011": 50,
    "46013": 120,
    "46015": 17,
    "46017": 13,
    "46019": 20,
    "46021": 9,
    "46023": 34,
    "46025": 19,
    "46027": 45,
    "46029": 29,
    "46031": 36,
    "46033": 31,
    "46035": 58,
    "46037": 30,
    "46039": 12,
    "46041": 27,
    "46043": 13,
    "46045": 24,
    "46047": 26,
    "46049": 13,
    "46051": 23,
    "46053": 9,
    "46055": 23,
    "46057": 42,
    "46059": 32,
    "46061": 36,
    "46063": 17,
    "46065": 25,
    "46067": 46,
    "46069": 16,
    "46071": 22,
    "46073": 5,
    "46075": 14,
    "46077": 11,
    "46079": 15,
    "46081": 21,
    "46083": 68,
    "46085": 25,
    "46087": 16,
    "46089": 11,
    "46091": 24,
    "46093": 34,
    "46095": 11,
    "46097": 7,
    "46099": 113,
    "46101": 33,
    "46103": 60,
    "46105": 26,
    "46107": 14,
    "46109": 28,
    "46111": 38,
    "46113": 0,
    "46115": 73,
    "46117": 23,
    "46119": 10,
    "46121": 12,
    "46123": 19,
    "46125": 34,
    "46127": 89,
    "46129": 14,
    "46135": 49,
    "46137": 32,
    "47001": 28,
    "47003": 38,
    "47005": 40,
    "47007": 40,
    "47009": 32,
    "47011": 26,
    "47013": 22,
    "47015": 25,
    "47017": 31,
    "47019": 33,
    "47021": 33,
    "47023": 22,
    "47025": 21,
    "47027": 21,
    "47029": 23,
    "47031": 34,
    "47033": 32,
    "47035": 37,
    "47037": 113,
    "47039": 41,
    "47041": 20,
    "47043": 38,
    "47045": 26,
    "47047": 30,
    "47049": 33,
    "47051": 41,
    "47053": 44,
    "47055": 38,
    "47057": 11,
    "47059": 29,
    "47061": 17,
    "47063": 14,
    "47065": 53,
    "47067": 10,
    "47069": 22,
    "47071": 30,
    "47073": 17,
    "47075": 24,
    "47077": 27,
    "47079": 18,
    "47081": 25,
    "47083": 25,
    "47085": 21,
    "47087": 17,
    "47089": 11,
    "47091": 19,
    "47093": 45,
    "47095": 13,
    "47097": 23,
    "47099": 84,
    "47101": 23,
    "47103": 53,
    "47105": 24,
    "47107": 36,
    "47109": 23,
    "47111": 34,
    "47113": 64,
    "47115": 21,
    "47117": 32,
    "47119": 44,
    "47121": 21,
    "47123": 31,
    "47125": 48,
    "47127": 22,
    "47129": 30,
    "47131": 33,
    "47133": 26,
    "47135": 27,
    "47137": 6,
    "47139": 14,
    "47141": 54,
    "47143": 31,
    "47145": 33,
    "47147": 25,
    "47149": 56,
    "47151": 23,
    "47153": 17,
    "47155": 38,
    "47157": 156,
    "47159": 27,
    "47161": 34,
    "47163": 32,
    "47165": 56,
    "47167": 43,
    "47169": 17,
    "47171": 18,
    "47173": 14,
    "47175": 17,
    "47177": 20,
    "47179": 28,
    "47181": 45,
    "47183": 24,
    "47185": 20,
    "47187": 63,
    "47189": 76,
    "48001": 46,
    "48003": 40,
    "48005": 94,
    "48007": 46,
    "48009": 26,
    "48011": 16,
    "48013": 73,
    "48015": 33,
    "48017": 22,
    "48019": 115,
    "48021": 98,
    "48023": 20,
    "48025": 57,
    "48027": 142,
    "48029": 321,
    "48031": 73,
    "48033": 21,
    "48035": 54,
    "48037": 73,
    "48039": 69,
    "48041": 45,
    "48043": 67,
    "48045": 14,
    "48047": 17,
    "48049": 61,
    "48051": 16,
    "48053": 82,
    "48055": 91,
    "48057": 43,
    "48059": 26,
    "48061": 85,
    "48063": 13,
    "48065": 15,
    "48067": 28,
    "48069": 27,
    "48071": 43,
    "48073": 54,
    "48075": 10,
    "48077": 24,
    "48079": 7,
    "48081": 17,
    "48083": 30,
    "48085": 84,
    "48087": 6,
    "48089": 25,
    "48091": 125,
    "48093": 48,
    "48095": 9,
    "48097": 66,
    "48099": 60,
    "48101": 6,
    "48103": 16,
    "48105": 34,
    "48107": 15,
    "48109": 11,
    "48111": 1,
    "48113": 209,
    "48115": 40,
    "48117": 15,
    "48119": 23,
    "48121": 128,
    "48123": 115,
    "48125": 11,
    "48127": 50,
    "48129": 20,
    "48131": 34,
    "48133": 48,
    "48135": 126,
    "48137": 84,
    "48139": 85,
    "48141": 120,
    "48143": 39,
    "48145": 36,
    "48147": 64,
    "48149": 79,
    "48151": 27,
    "48153": 18,
    "48155": 8,
    "48157": 47,
    "48159": 21,
    "48161": 40,
    "48163": 78,
    "48165": 60,
    "48167": 107,
    "48169": 20,
    "48171": 87,
    "48173": 25,
    "48175": 38,
    "48177": 93,
    "48179": 12,
    "48181": 86,
    "48183": 75,
    "48185": 39,
    "48187": 97,
    "48189": 29,
    "48191": 13,
    "48193": 38,
    "48195": 9,
    "48197": 8,
    "48199": 34,
    "48201": 166,
    "48203": 66,
    "48205": 8,
    "48207": 28,
    "48209": 116,
    "48211": 8,
    "48213": 52,
    "48215": 67,
    "48217": 51,
    "48219": 37,
    "48221": 56,
    "48223": 55,
    "48225": 32,
    "48227": 66,
    "48229": 18,
    "48231": 84,
    "48233": 24,
    "48235": 19,
    "48237": 29,
    "48239": 26,
    "48241": 30,
    "48243": 23,
    "48245": 86,
    "48247": 16,
    "48249": 67,
    "48251": 105,
    "48253": 33,
    "48255": 85,
    "48257": 65,
    "48259": 80,
    "48261": 5,
    "48263": 8,
    "48265": 95,
    "48267": 40,
    "48269": 4,
    "48271": 59,
    "48273": 68,
    "48275": 23,
    "48277": 42,
    "48279": 15,
    "48281": 29,
    "48283": 34,
    "48285": 107,
    "48287": 51,
    "48289": 29,
    "48291": 50,
    "48293": 78,
    "48295": 11,
    "48297": 56,
    "48299": 86,
    "48301": 12,
    "48303": 57,
    "48305": 34,
    "48307": 40,
    "48309": 93,
    "48311": 27,
    "48313": 24,
    "48315": 7,
    "48317": 26,
    "48319": 29,
    "48321": 30,
    "48323": 52,
    "48325": 98,
    "48327": 28,
    "48329": 158,
    "48331": 61,
    "48333": 28,
    "48335": 47,
    "48337": 30,
    "48339": 60,
    "48341": 17,
    "48343": 12,
    "48345": 3,
    "48347": 49,
    "48349": 79,
    "48351": 21,
    "48353": 27,
    "48355": 217,
    "48357": 18,
    "48359": 6,
    "48361": 66,
    "48363": 59,
    "48365": 28,
    "48367": 66,
    "48369": 11,
    "48371": 102,
    "48373": 40,
    "48375": 65,
    "48377": 20,
    "48379": 20,
    "48381": 88,
    "48383": 28,
    "48385": 90,
    "48387": 50,
    "48389": 44,
    "48391": 52,
    "48393": 5,
    "48395": 28,
    "48397": 24,
    "48399": 29,
    "48401": 45,
    "48403": 29,
    "48405": 14,
    "48407": 43,
    "48409": 100,
    "48411": 28,
    "48413": 22,
    "48415": 48,
    "48417": 10,
    "48419": 39,
    "48421": 2,
    "48423": 115,
    "48425": 19,
    "48427": 48,
    "48429": 26,
    "48431": 16,
    "48433": 4,
    "48435": 36,
    "48437": 15,
    "48439": 239,
    "48441": 69,
    "48443": 32,
    "48445": 15,
    "48447": 16,
    "48449": 23,
    "48451": 92,
    "48453": 210,
    "48455": 28,
    "48457": 24,
    "48459": 32,
    "48461": 37,
    "48463": 147,
    "48465": 140,
    "48467": 45,
    "48469": 58,
    "48471": 39,
    "48473": 22,
    "48475": 16,
    "48477": 36,
    "48479": 88,
    "48481": 28,
    "48483": 15,
    "48485": 34,
    "48487": 18,
    "48489": 33,
    "48491": 141,
    "48493": 69,
    "48495": 20,
    "48497": 69,
    "48499": 62,
    "48501": 13,
    "48503": 39,
    "48505": 32,
    "48507": 54,
    "49001": 3,
    "49003": 7,
    "49005": 19,
    "49007": 15,
    "49009": 13,
    "49011": 13,
    "49013": 18,
    "49015": 39,
    "49017": 90,
    "49019": 75,
    "49021": 36,
    "49023": 10,
    "49025": 152,
    "49027": 10,
    "49029": 8,
    "49031": 9,
    "49033": 2,
    "49035": 32,
    "49037": 65,
    "49039": 18,
    "49041": 15,
    "49043": 9,
    "49045": 14,
    "49047": 21,
    "49049": 34,
    "49051": 7,
    "49053": 204,
    "49055": 107,
    "49057": 22,
    "50001": 68,
    "50003": 53,
    "50005": 43,
    "50007": 71,
    "50009": 19,
    "50011": 55,
    "50013": 13,
    "50015": 49,
    "50017": 30,
    "50019": 47,
    "50021": 64,
    "50023": 64,
    "50025": 69,
    "50027": 53,
    "51001": 31,
    "51003": 131,
    "51005": 32,
    "51007": 8,
    "51009": 41,
    "51011": 29,
    "51013": 46,
    "51015": 100,
    "51017": 34,
    "51019": 65,
    "51021": 20,
    "51023": 57,
    "51025": 9,
    "51027": 39,
    "51029": 53,
    "51031": 63,
    "51033": 13,
    "51035": 67,
    "51036": 12,
    "51037": 58,
    "51041": 25,
    "51043": 49,
    "51045": 16,
    "51047": 110,
    "51049": 9,
    "51051": 33,
    "51053": 13,
    "51057": 11,
    "51059": 293,
    "51061": 98,
    "51063": 19,
    "51065": 7,
    "51067": 91,
    "51069": 112,
    "51071": 60,
    "51073": 26,
    "51075": 5,
    "51077": 36,
    "51079": 89,
    "51081": 7,
    "51083": 141,
    "51085": 23,
    "51087": 32,
    "51089": 60,
    "51091": 18,
    "51093": 19,
    "51095": 17,
    "51097": 14,
    "51099": 15,
    "51101": 15,
    "51103": 26,
    "51105": 17,
    "51107": 135,
    "51109": 12,
    "51111": 15,
    "51113": 81,
    "51115": 27,
    "51117": 22,
    "51119": 22,
    "51121": 81,
    "51125": 72,
    "51127": 17,
    "51131": 20,
    "51133": 18,
    "51135": 9,
    "51137": 76,
    "51139": 54,
    "51141": 54,
    "51143": 89,
    "51145": 13,
    "51147": 9,
    "51149": 15,
    "51153": 164,
    "51155": 61,
    "51157": 56,
    "51159": 25,
    "51161": 73,
    "51163": 66,
    "51165": 109,
    "51167": 27,
    "51169": 31,
    "51171": 153,
    "51173": 43,
    "51175": 19,
    "51177": 49,
    "51179": 91,
    "51181": 18,
    "51183": 16,
    "51185": 92,
    "51187": 78,
    "51191": 30,
    "51193": 23,
    "51195": 28,
    "51197": 56,
    "51199": 18,
    "51510": 47,
    "51515": 2,
    "51520": 11,
    "51530": 12,
    "51540": 19,
    "51550": 33,
    "51570": 7,
    "51580": 7,
    "51590": 52,
    "51595": 9,
    "51600": 24,
    "51610": 29,
    "51620": 9,
    "51630": 18,
    "51640": 26,
    "51650": 25,
    "51660": 28,
    "51670": 6,
    "51678": 16,
    "51680": 32,
    "51683": 20,
    "51685": 10,
    "51690": 18,
    "51700": 28,
    "51710": 69,
    "51720": 13,
    "51730": 9,
    "51735": 6,
    "51740": 56,
    "51750": 8,
    "51760": 15,
    "51770": 63,
    "51775": 29,
    "51790": 19,
    "51800": 29,
    "51810": 49,
    "51820": 20,
    "51830": 6,
    "51840": 13,
    "53001": 7,
    "53003": 9,
    "53005": 11,
    "53007": 83,
    "53009": 3,
    "53011": 15,
    "53013": 3,
    "53015": 34,
    "53017": 8,
    "53019": 30,
    "53021": 5,
    "53023": 4,
    "53025": 10,
    "53027": 8,
    "53029": 5,
    "53031": 7,
    "53033": 11,
    "53035": 5,
    "53037": 21,
    "53039": 7,
    "53041": 5,
    "53043": 13,
    "53045": 4,
    "53047": 96,
    "53049": 30,
    "53051": 22,
    "53053": 6,
    "53055": 2,
    "53057": 9,
    "53059": 3,
    "53061": 16,
    "53063": 35,
    "53065": 20,
    "53067": 2,
    "53069": 58,
    "53071": 15,
    "53073": 9,
    "53075": 27,
    "53077": 51,
    "54001": 36,
    "54003": 94,
    "54005": 37,
    "54007": 39,
    "54009": 38,
    "54011": 63,
    "54013": 34,
    "54015": 29,
    "54017": 32,
    "54019": 29,
    "54021": 41,
    "54023": 45,
    "54025": 64,
    "54027": 61,
    "54029": 28,
    "54031": 44,
    "54033": 68,
    "54035": 52,
    "54037": 54,
    "54039": 90,
    "54041": 39,
    "54043": 50,
    "54045": 46,
    "54047": 35,
    "54049": 74,
    "54051": 74,
    "54053": 42,
    "54055": 62,
    "54057": 39,
    "54059": 40,
    "54061": 65,
    "54063": 36,
    "54065": 57,
    "54067": 31,
    "54069": 40,
    "54071": 34,
    "54073": 23,
    "54075": 32,
    "54077": 67,
    "54079": 51,
    "54081": 34,
    "54083": 48,
    "54085": 34,
    "54087": 46,
    "54089": 23,
    "54091": 32,
    "54093": 35,
    "54095": 51,
    "54097": 43,
    "54099": 47,
    "54101": 36,
    "54103": 40,
    "54105": 17,
    "54107": 43,
    "54109": 26,
    "55001": 13,
    "55003": 24,
    "55005": 10,
    "55007": 33,
    "55009": 16,
    "55011": 34,
    "55013": 4,
    "55015": 10,
    "55017": 17,
    "55019": 28,
    "55021": 42,
    "55023": 97,
    "55025": 69,
    "55027": 28,
    "55029": 2,
    "55031": 18,
    "55033": 15,
    "55035": 16,
    "55037": 8,
    "55039": 18,
    "55041": 4,
    "55043": 101,
    "55045": 52,
    "55047": 10,
    "55049": 18,
    "55051": 9,
    "55053": 52,
    "55055": 40,
    "55057": 23,
    "55059": 50,
    "55061": 2,
    "55063": 59,
    "55065": 38,
    "55067": 6,
    "55069": 11,
    "55071": 18,
    "55073": 25,
    "55075": 16,
    "55077": 12,
    "55078": 3,
    "55079": 47,
    "55081": 25,
    "55083": 9,
    "55085": 12,
    "55087": 17,
    "55089": 26,
    "55091": 13,
    "55093": 16,
    "55095": 10,
    "55097": 14,
    "55099": 8,
    "55101": 42,
    "55103": 42,
    "55105": 60,
    "55107": 10,
    "55109": 17,
    "55111": 59,
    "55113": 13,
    "55115": 8,
    "55117": 22,
    "55119": 12,
    "55121": 72,
    "55123": 122,
    "55125": 7,
    "55127": 25,
    "55129": 1,
    "55131": 18,
    "55133": 49,
    "55135": 9,
    "55137": 10,
    "55139": 17,
    "55141": 20,
    "56001": 9,
    "56003": 27,
    "56005": 24,
    "56007": 6,
    "56009": 4,
    "56011": 18,
    "56013": 52,
    "56015": 19,
    "56017": 9,
    "56019": 35,
    "56021": 69,
    "56023": 16,
    "56025": 28,
    "56027": 4,
    "56029": 21,
    "56031": 18,
    "56033": 23,
    "56035": 11,
    "56037": 9,
    "56039": 11,
    "56041": 1,
    "56043": 13,
    "56045": 16
  },
  {
    "1001": 0,
    "1003": 0,
    "1005": 0,
    "1007": 0,
    "1009": 0,
    "1011": 0,
    "1013": 0,
    "1015": 0,
    "1017": 0,
    "1019": 0,
    "1021": 0,
    "1023": 0,
    "1025": 0,
    "1027": 0,
    "1029": 0,
    "1031": 0,
    "1033": 3,
    "1035": 0,
    "1037": 0,
    "1039": 0,
    "1041": 0,
    "1043": 0,
    "1045": 0,
    "1047": 0,
    "1049": 2,
    "1051": 0,
    "1053": 0,
    "1055": 0,
    "1057": 0,
    "1059": 2,
    "1061": 0,
    "1063": 0,
    "1065": 0,
    "1067": 0,
    "1069": 0,
    "1071": 0,
    "1073": 0,
    "1075": 0,
    "1077": 1,
    "1079": 1,
    "1081": 0,
    "1083": 0,
    "1085": 0,
    "1087": 0,
    "1089": 0,
    "1091": 0,
    "1093": 0,
    "1095": 0,
    "1097": 0,
    "1099": 1,
    "1101": 0,
    "1103": 0,
    "1105": 0,
    "1107": 0,
    "1109": 0,
    "1111": 0,
    "1113": 0,
    "1115": 0,
    "1117": 0,
    "1119": 0,
    "1121": 0,
    "1123": 0,
    "1125": 0,
    "1127": 0,
    "1129": 0,
    "1131": 0,
    "1133": 0,
    "2013": 1,
    "2016": 0,
    "2020": 1,
    "2050": 1,
    "2060": 0,
    "2068": 4,
    "2070": 0,
    "2090": 14,
    "2100": 1,
    "2110": 2,
    "2122": 3,
    "2130": 1,
    "2150": 1,
    "2164": 1,
    "2170": 2,
    "2180": 0,
    "2185": 0,
    "2188": 0,
    "2201": 0,
    "2220": 4,
    "2232": 0,
    "2240": 3,
    "2261": 3,
    "2270": 0,
    "2280": 0,
    "2282": 0,
    "2290": 15,
    "4001": 11,
    "4003": 24,
    "4005": 68,
    "4007": 21,
    "4009": 18,
    "4011": 11,
    "4012": 0,
    "4013": 0,
    "4015": 4,
    "4017": 35,
    "4019": 23,
    "4021": 7,
    "4023": 15,
    "4025": 22,
    "4027": 0,
    "5001": 0,
    "5003": 1,
    "5005": 5,
    "5007": 1,
    "5009": 1,
    "5011": 6,
    "5013": 3,
    "5015": 2,
    "5017": 0,
    "5019": 8,
    "5021": 0,
    "5023": 0,
    "5025": 1,
    "5027": 3,
    "5029": 3,
    "5031": 0,
    "5033": 2,
    "5035": 0,
    "5037": 0,
    "5039": 5,
    "5041": 0,
    "5043": 5,
    "5045": 4,
    "5047": 1,
    "5049": 2,
    "5051": 6,
    "5053": 2,
    "5055": 1,
    "5057": 0,
    "5059": 5,
    "5061": 3,
    "5063": 3,
    "5065": 4,
    "5067": 1,
    "5069": 2,
    "5071": 4,
    "5073": 2,
    "5075": 1,
    "5077": 0,
    "5079": 0,
    "5081": 2,
    "5083": 1,
    "5085": 1,
    "5087": 0,
    "5089": 2,
    "5091": 4,
    "5093": 0,
    "5095": 1,
    "5097": 8,
    "5099": 1,
    "5101": 2,
    "5103": 2,
    "5105": 4,
    "5107": 0,
    "5109": 5,
    "5111": 0,
    "5113": 8,
    "5115": 1,
    "5117": 0,
    "5119": 8,
    "5121": 0,
    "5123": 0,
    "5125": 5,
    "5127": 0,
    "5129": 13,
    "5131": 3,
    "5133": 1,
    "5135": 7,
    "5137": 2,
    "5139": 0,
    "5141": 4,
    "5143": 1,
    "5145": 2,
    "5147": 1,
    "5149": 1,
    "6001": 7,
    "6003": 18,
    "6005": 24,
    "6007": 21,
    "6009": 24,
    "6011": 22,
    "6013": 7,
    "6015": 2,
    "6017": 28,
    "6019": 13,
    "6021": 13,
    "6023": 2,
    "6025": 0,
    "6027": 3,
    "6029": 27,
    "6031": 0,
    "6033": 13,
    "6035": 5,
    "6037": 53,
    "6039": 7,
    "6041": 17,
    "6043": 23,
    "6045": 2,
    "6047": 4,
    "6049": 19,
    "6051": 5,
    "6053": 10,
    "6055": 15,
    "6057": 33,
    "6059": 30,
    "6061": 27,
    "6063": 8,
    "6065": 175,
    "6067": 8,
    "6069": 0,
    "6071": 182,
    "6073": 168,
    "6075": 2,
    "6077": 7,
    "6079": 5,
    "6081": 6,
    "6083": 30,
    "6085": 10,
    "6087": 4,
    "6089": 42,
    "6091": 16,
    "6093": 69,
    "6095": 9,
    "6097": 17,
    "6099": 1,
    "6101": 10,
    "6103": 27,
    "6105": 5,
    "6107": 28,
    "6109": 24,
    "6111": 30,
    "6113": 3,
    "6115": 31,
    "8001": 0,
    "8003": 13,
    "8005": 0,
    "8007": 33,
    "8009": 7,
    "8011": 4,
    "8013": 1,
    "8014": 0,
    "8015": 6,
    "8017": 1,
    "8019": 2,
    "8021": 4,
    "8023": 18,
    "8025": 3,
    "8027": 26,
    "8029": 23,
    "8031": 0,
    "8033": 44,
    "8035": 2,
    "8037": 16,
    "8039": 0,
    "8041": 19,
    "8043": 32,
    "8045": 61,
    "8047": 2,
    "8049": 0,
    "8051": 16,
    "8053": 29,
    "8055": 31,
    "8057": 0,
    "8059": 4,
    "8061": 1,
    "8063": 0,
    "8065": 1,
    "8067": 48,
    "8069": 3,
    "8071": 22,
    "8073": 0,
    "8075": 1,
    "8077": 60,
    "8079": 4,
    "8081": 64,
    "8083": 46,
    "8085": 39,
    "8087": 0,
    "8089": 7,
    "8091": 14,
    "8093": 2,
    "8095": 1,
    "8097": 8,
    "8099": 3,
    "8101": 15,
    "8103": 71,
    "8105": 10,
    "8107": 53,
    "8109": 10,
    "8111": 26,
    "8113": 63,
    "8115": 0,
    "8117": 0,
    "8119": 13,
    "8121": 0,
    "8123": 1,
    "8125": 2,
    "9001": 0,
    "9003": 0,
    "9005": 1,
    "9007": 0,
    "9009": 0,
    "9011": 0,
    "9013": 0,
    "9015": 0,
    "10001": 3,
    "10003": 4,
    "10005": 10,
    "11001": 0,
    "12001": 11,
    "12003": 14,
    "12005": 8,
    "12007": 4,
    "12009": 2,
    "12011": 8,
    "12013": 1,
    "12015": 5,
    "12017": 2,
    "12019": 12,
    "12021": 20,
    "12023": 7,
    "12027": 1,
    "12029": 1,
    "12031": 9,
    "12033": 1,
    "12035": 17,
    "12037": 4,
    "12039": 1,
    "12041": 3,
    "12043": 9,
    "12045": 5,
    "12047": 3,
    "12049": 0,
    "12051": 7,
    "12053": 1,
    "12055": 2,
    "12057": 2,
    "12059": 0,
    "12061": 0,
    "12063": 0,
    "12065": 0,
    "12067": 5,
    "12069": 0,
    "12071": 14,
    "12073": 2,
    "12075": 1,
    "12077": 7,
    "12079": 1,
    "12081": 2,
    "12083": 17,
    "12085": 0,
    "12086": 13,
    "12087": 0,
    "12089": 15,
    "12091": 0,
    "12093": 1,
    "12095": 1,
    "12097": 0,
    "12099": 6,
    "12101": 0,
    "12103": 4,
    "12105": 15,
    "12107": 35,
    "12109": 12,
    "12111": 1,
    "12113": 0,
    "12115": 7,
    "12117": 1,
    "12119": 1,
    "12121": 1,
    "12123": 3,
    "12125": 5,
    "12127": 3,
    "12129": 5,
    "12131": 2,
    "12133": 0,
    "13001": 1,
    "13003": 2,
    "13005": 1,
    "13007": 0,
    "13009": 0,
    "13011": 0,
    "13013": 0,
    "13015": 0,
    "13017": 0,
    "13019": 0,
    "13021": 0,
    "13023": 0,
    "13025": 6,
    "13027": 0,
    "13029": 0,
    "13031": 0,
    "13033": 0,
    "13035": 0,
    "13037": 0,
    "13039": 4,
    "13043": 1,
    "13045": 0,
    "13047": 0,
    "13049": 2,
    "13051": 0,
    "13053": 0,
    "13055": 11,
    "13057": 0,
    "13059": 0,
    "13061": 0,
    "13063": 0,
    "13065": 2,
    "13067": 0,
    "13069": 1,
    "13071": 0,
    "13073": 0,
    "13075": 0,
    "13077": 0,
    "13079": 0,
    "13081": 0,
    "13083": 0,
    "13085": 0,
    "13087": 0,
    "13089": 0,
    "13091": 0,
    "13093": 0,
    "13095": 0,
    "13097": 1,
    "13099": 0,
    "13101": 0,
    "13103": 1,
    "13105": 0,
    "13107": 0,
    "13109": 0,
    "13111": 25,
    "13113": 0,
    "13115": 5,
    "13117": 2,
    "13119": 0,
    "13121": 0,
    "13123": 9,
    "13125": 0,
    "13127": 0,
    "13129": 3,
    "13131": 0,
    "13133": 0,
    "13135": 0,
    "13137": 0,
    "13139": 0,
    "13141": 0,
    "13143": 0,
    "13145": 0,
    "13147": 0,
    "13149": 0,
    "13151": 0,
    "13153": 0,
    "13155": 0,
    "13157": 0,
    "13159": 5,
    "13161": 0,
    "13163": 0,
    "13165": 0,
    "13167": 0,
    "13169": 1,
    "13171": 0,
    "13173": 0,
    "13175": 0,
    "13177": 0,
    "13179": 2,
    "13181": 0,
    "13183": 4,
    "13185": 0,
    "13187": 12,
    "13189": 0,
    "13191": 0,
    "13193": 0,
    "13195": 0,
    "13197": 0,
    "13199": 0,
    "13201": 0,
    "13205": 0,
    "13207": 0,
    "13209": 0,
    "13211": 0,
    "13213": 20,
    "13215": 0,
    "13217": 0,
    "13219": 0,
    "13221": 0,
    "13223": 0,
    "13225": 0,
    "13227": 0,
    "13229": 0,
    "13231": 0,
    "13233": 0,
    "13235": 0,
    "13237": 6,
    "13239": 0,
    "13241": 1,
    "13243": 0,
    "13245": 0,
    "13247": 0,
    "13249": 0,
    "13251": 0,
    "13253": 0,
    "13255": 1,
    "13257": 0,
    "13259": 0,
    "13261": 0,
    "13263": 0,
    "13265": 0,
    "13267": 0,
    "13269": 0,
    "13271": 0,
    "13273": 0,
    "13275": 0,
    "13277": 0,
    "13279": 0,
    "13281": 11,
    "13283": 0,
    "13285": 0,
    "13287": 0,
    "13289": 0,
    "13291": 18,
    "13293": 0,
    "13295": 11,
    "13297": 0,
    "13299": 0,
    "13301": 0,
    "13303": 0,
    "13305": 2,
    "13307": 0,
    "13309": 0,
    "13311": 4,
    "13313": 2,
    "13315": 0,
    "13317": 0,
    "13319": 0,
    "13321": 0,
    "15001": 88,
    "15003": 74,
    "15005": 0,
    "15007": 26,
    "15009": 58,
    "16001": 6,
    "16003": 0,
    "16005": 8,
    "16007": 0,
    "16009": 33,
    "16011": 12,
    "16013": 8,
    "16015": 1,
    "16017": 22,
    "16019": 6,
    "16021": 21,
    "16023": 5,
    "16025": 0,
    "16027": 2,
    "16029": 3,
    "16031": 6,
    "16033": 5,
    "16035": 1,
    "16037": 5,
    "16039": 8,
    "16041": 3,
    "16043": 19,
    "16045": 3,
    "16047": 2,
    "16049": 2,
    "16051": 4,
    "16053": 1,
    "16055": 56,
    "16057": 31,
    "16059": 2,
    "16061": 5,
    "16063": 6,
    "16065": 4,
    "16067": 2,
    "16069": 13,
    "16071": 8,
    "16073": 8,
    "16075": 1,
    "16077": 10,
    "16079": 32,
    "16081": 0,
    "16083": 2,
    "16085": 0,
    "16087": 0,
    "17001": 0,
    "17003": 0,
    "17005": 0,
    "17007": 0,
    "17009": 0,
    "17011": 0,
    "17013": 0,
    "17015": 0,
    "17017": 0,
    "17019": 0,
    "17021": 0,
    "17023": 0,
    "17025": 0,
    "17027": 0,
    "17029": 0,
    "17031": 1,
    "17033": 0,
    "17035": 0,
    "17037": 0,
    "17039": 0,
    "17041": 0,
    "17043": 1,
    "17045": 0,
    "17047": 0,
    "17049": 0,
    "17051": 0,
    "17053": 0,
    "17055": 1,
    "17057": 0,
    "17059": 0,
    "17061": 0,
    "17063": 1,
    "17065": 0,
    "17067": 0,
    "17069": 1,
    "17071": 0,
    "17073": 1,
    "17075": 0,
    "17077": 1,
    "17079": 0,
    "17081": 0,
    "17083": 0,
    "17085": 0,
    "17087": 0,
    "17089": 0,
    "17091": 0,
    "17093": 0,
    "17095": 0,
    "17097": 2,
    "17099": 0,
    "17101": 0,
    "17103": 0,
    "17105": 0,
    "17107": 0,
    "17109": 0,
    "17111": 0,
    "17113": 0,
    "17115": 0,
    "17117": 0,
    "17119": 0,
    "17121": 0,
    "17123": 0,
    "17125": 0,
    "17127": 0,
    "17129": 0,
    "17131": 0,
    "17133": 0,
    "17135": 0,
    "17137": 0,
    "17139": 0,
    "17141": 0,
    "17143": 0,
    "17145": 0,
    "17147": 0,
    "17149": 0,
    "17151": 0,
    "17153": 0,
    "17155": 0,
    "17157": 0,
    "17159": 0,
    "17161": 0,
    "17163": 0,
    "17165": 2,
    "17167": 1,
    "17169": 0,
    "17171": 0,
    "17173": 0,
    "17175": 0,
    "17177": 0,
    "17179": 0,
    "17181": 0,
    "17183": 0,
    "17185": 0,
    "17187": 0,
    "17189": 0,
    "17191": 1,
    "17193": 0,
    "17195": 0,
    "17197": 2,
    "17199": 0,
    "17201": 0,
    "17203": 0,
    "18001": 0,
    "18003": 0,
    "18005": 0,
    "18007": 0,
    "18009": 0,
    "18011": 0,
    "18013": 0,
    "18015": 0,
    "18017": 0,
    "18019": 0,
    "18021": 0,
    "18023": 0,
    "18025": 0,
    "18027": 0,
    "18029": 0,
    "18031": 0,
    "18033": 0,
    "18035": 0,
    "18037": 0,
    "18039": 0,
    "18041": 0,
    "18043": 0,
    "18045": 0,
    "18047": 0,
    "18049": 0,
    "18051": 0,
    "18053": 0,
    "18055": 0,
    "18057": 0,
    "18059": 0,
    "18061": 0,
    "18063": 0,
    "18065": 0,
    "18067": 0,
    "18069": 0,
    "18071": 0,
    "18073": 1,
    "18075": 0,
    "18077": 0,
    "18079": 0,
    "18081": 0,
    "18083": 0,
    "18085": 0,
    "18087": 0,
    "18089": 0,
    "18091": 0,
    "18093": 0,
    "18095": 0,
    "18097": 0,
    "18099": 0,
    "18101": 0,
    "18103": 0,
    "18105": 0,
    "18107": 0,
    "18109": 0,
    "18111": 0,
    "18113": 0,
    "18115": 0,
    "18117": 0,
    "18119": 0,
    "18121": 0,
    "18123": 0,
    "18125": 2,
    "18127": 0,
    "18129": 0,
    "18131": 0,
    "18133": 0,
    "18135": 0,
    "18137": 0,
    "18139": 0,
    "18141": 0,
    "18143": 0,
    "18145": 0,
    "18147": 0,
    "18149": 0,
    "18151": 0,
    "18153": 0,
    "18155": 0,
    "18157": 0,
    "18159": 0,
    "18161": 0,
    "18163": 0,
    "18165": 0,
    "18167": 0,
    "18169": 0,
    "18171": 0,
    "18173": 0,
    "18175": 0,
    "18177": 0,
    "18179": 0,
    "18181": 0,
    "18183": 0,
    "19001": 0,
    "19003": 0,
    "19005": 0,
    "19007": 0,
    "19009": 0,
    "19011": 0,
    "19013": 0,
    "19015": 0,
    "19017": 0,
    "19019": 0,
    "19021": 3,
    "19023": 0,
    "19025": 0,
    "19027": 0,
    "19029": 0,
    "19031": 0,
    "19033": 0,
    "19035": 0,
    "19037": 0,
    "19039": 1,
    "19041": 2,
    "19043": 0,
    "19045": 0,
    "19047": 0,
    "19049": 0,
    "19051": 0,
    "19053": 0,
    "19055": 0,
    "19057": 0,
    "19059": 1,
    "19061": 0,
    "19063": 0,
    "19065": 0,
    "19067": 0,
    "19069": 0,
    "19071": 0,
    "19073": 0,
    "19075": 0,
    "19077": 0,
    "19079": 0,
    "19081": 0,
    "19083": 0,
    "19085": 0,
    "19087": 0,
    "19089": 0,
    "19091": 0,
    "19093": 0,
    "19095": 0,
    "19097": 0,
    "19099": 0,
    "19101": 0,
    "19103": 0,
    "19105": 0,
    "19107": 0,
    "19109": 0,
    "19111": 0,
    "19113": 0,
    "19115": 0,
    "19117": 0,
    "19119": 1,
    "19121": 0,
    "19123": 0,
    "19125": 0,
    "19127": 0,
    "19129": 0,
    "19131": 0,
    "19133": 0,
    "19135": 0,
    "19137": 0,
    "19139": 0,
    "19141": 3,
    "19143": 2,
    "19145": 0,
    "19147": 0,
    "19149": 0,
    "19151": 0,
    "19153": 0,
    "19155": 1,
    "19157": 1,
    "19159": 0,
    "19161": 0,
    "19163": 1,
    "19165": 0,
    "19167": 1,
    "19169": 0,
    "19171": 0,
    "19173": 0,
    "19175": 0,
    "19177": 0,
    "19179": 0,
    "19181": 0,
    "19183": 0,
    "19185": 0,
    "19187": 0,
    "19189": 0,
    "19191": 0,
    "19193": 0,
    "19195": 0,
    "19197": 0,
    "20001": 0,
    "20003": 0,
    "20005": 0,
    "20007": 1,
    "20009": 0,
    "20011": 1,
    "20013": 0,
    "20015": 1,
    "20017": 0,
    "20019": 0,
    "20021": 3,
    "20023": 2,
    "20025": 1,
    "20027": 0,
    "20029": 0,
    "20031": 0,
    "20033": 2,
    "20035": 0,
    "20037": 0,
    "20039": 0,
    "20041": 0,
    "20043": 0,
    "20045": 0,
    "20047": 0,
    "20049": 0,
    "20051": 0,
    "20053": 1,
    "20055": 0,
    "20057": 1,
    "20059": 0,
    "20061": 0,
    "20063": 0,
    "20065": 0,
    "20067": 0,
    "20069": 0,
    "20071": 0,
    "20073": 0,
    "20075": 0,
    "20077": 0,
    "20079": 1,
    "20081": 1,
    "20083": 1,
    "20085": 0,
    "20087": 0,
    "20089": 0,
    "20091": 0,
    "20093": 1,
    "20095": 1,
    "20097": 0,
    "20099": 0,
    "20101": 2,
    "20103": 0,
    "20105": 1,
    "20107": 0,
    "20109": 0,
    "20111": 0,
    "20113": 0,
    "20115": 0,
    "20117": 0,
    "20119": 0,
    "20121": 0,
    "20123": 0,
    "20125": 0,
    "20127": 0,
    "20129": 1,
    "20131": 0,
    "20133": 0,
    "20135": 1,
    "20137": 0,
    "20139": 0,
    "20141": 0,
    "20143": 0,
    "20145": 0,
    "20147": 0,
    "20149": 0,
    "20151": 0,
    "20153": 1,
    "20155": 4,
    "20157": 0,
    "20159": 1,
    "20161": 0,
    "20163": 2,
    "20165": 0,
    "20167": 1,
    "20169": 0,
    "20171": 1,
    "20173": 0,
    "20175": 1,
    "20177": 1,
    "20179": 0,
    "20181": 2,
    "20183": 1,
    "20185": 0,
    "20187": 2,
    "20189": 1,
    "20191": 0,
    "20193": 0,
    "20195": 0,
    "20197": 0,
    "20199": 1,
    "20201": 0,
    "20203": 0,
    "20205": 0,
    "20207": 0,
    "20209": 0,
    "21001": 0,
    "21003": 0,
    "21005": 0,
    "21007": 1,
    "21009": 0,
    "21011": 0,
    "21013": 2,
    "21015": 0,
    "21017": 0,
    "21019": 0,
    "21021": 0,
    "21023": 0,
    "21025": 1,
    "21027": 0,
    "21029": 0,
    "21031": 0,
    "21033": 1,
    "21035": 1,
    "21037": 0,
    "21039": 1,
    "21041": 0,
    "21043": 0,
    "21045": 0,
    "21047": 2,
    "21049": 0,
    "21051": 0,
    "21053": 0,
    "21055": 1,
    "21057": 0,
    "21059": 1,
    "21061": 0,
    "21063": 0,
    "21065": 0,
    "21067": 0,
    "21069": 0,
    "21071": 0,
    "21073": 0,
    "21075": 1,
    "21077": 0,
    "21079": 0,
    "21081": 0,
    "21083": 1,
    "21085": 0,
    "21087": 0,
    "21089": 0,
    "21091": 0,
    "21093": 0,
    "21095": 1,
    "21097": 0,
    "21099": 0,
    "21101": 1,
    "21103": 0,
    "21105": 1,
    "21107": 2,
    "21109": 0,
    "21111": 0,
    "21113": 0,
    "21115": 0,
    "21117": 0,
    "21119": 1,
    "21121": 0,
    "21123": 0,
    "21125": 0,
    "21127": 0,
    "21129": 0,
    "21131": 0,
    "21133": 1,
    "21135": 0,
    "21137": 0,
    "21139": 2,
    "21141": 0,
    "21143": 4,
    "21145": 3,
    "21147": 0,
    "21149": 2,
    "21151": 0,
    "21153": 0,
    "21155": 0,
    "21157": 2,
    "21159": 0,
    "21161": 0,
    "21163": 0,
    "21165": 0,
    "21167": 0,
    "21169": 0,
    "21171": 0,
    "21173": 0,
    "21175": 0,
    "21177": 2,
    "21179": 0,
    "21181": 0,
    "21183": 0,
    "21185": 0,
    "21187": 0,
    "21189": 0,
    "21191": 0,
    "21193": 1,
    "21195": 1,
    "21197": 1,
    "21199": 0,
    "21201": 0,
    "21203": 0,
    "21205": 0,
    "21207": 0,
    "21209": 0,
    "21211": 0,
    "21213": 0,
    "21215": 0,
    "21217": 0,
    "21219": 1,
    "21221": 4,
    "21223": 0,
    "21225": 1,
    "21227": 0,
    "21229": 0,
    "21231": 0,
    "21233": 1,
    "21235": 0,
    "21237": 0,
    "21239": 0,
    "22001": 0,
    "22003": 0,
    "22005": 0,
    "22007": 0,
    "22009": 0,
    "22011": 0,
    "22013": 2,
    "22015": 0,
    "22017": 4,
    "22019": 2,
    "22021": 0,
    "22023": 1,
    "22025": 0,
    "22027": 0,
    "22029": 0,
    "22031": 2,
    "22033": 0,
    "22035": 0,
    "22037": 0,
    "22039": 0,
    "22041": 0,
    "22043": 0,
    "22045": 0,
    "22047": 0,
    "22049": 0,
    "22051": 0,
    "22053": 0,
    "22055": 0,
    "22057": 0,
    "22059": 0,
    "22061": 0,
    "22063": 0,
    "22065": 0,
    "22067": 0,
    "22069": 4,
    "22071": 0,
    "22073": 0,
    "22075": 0,
    "22077": 0,
    "22079": 0,
    "22081": 1,
    "22083": 0,
    "22085": 0,
    "22087": 0,
    "22089": 0,
    "22091": 0,
    "22093": 0,
    "22095": 0,
    "22097": 0,
    "22099": 0,
    "22101": 0,
    "22103": 0,
    "22105": 0,
    "22107": 0,
    "22109": 0,
    "22111": 0,
    "22113": 0,
    "22115": 1,
    "22117": 0,
    "22119": 1,
    "22121": 0,
    "22123": 0,
    "22125": 0,
    "22127": 1,
    "23001": 0,
    "23003": 0,
    "23005": 0,
    "23007": 0,
    "23009": 0,
    "23011": 0,
    "23013": 0,
    "23015": 0,
    "23017": 0,
    "23019": 0,
    "23021": 0,
    "23023": 0,
    "23025": 0,
    "23027": 0,
    "23029": 0,
    "23031": 0,
    "24001": 3,
    "24003": 2,
    "24005": 0,
    "24009": 0,
    "24011": 2,
    "24013": 0,
    "24015": 8,
    "24017": 0,
    "24019": 0,
    "24021": 0,
    "24023": 0,
    "24025": 1,
    "24027": 0,
    "24029": 4,
    "24031": 0,
    "24033": 1,
    "24035": 4,
    "24037": 0,
    "24039": 0,
    "24041": 2,
    "24043": 1,
    "24045": 0,
    "24047": 0,
    "24510": 0,
    "25001": 1,
    "25003": 1,
    "25005": 0,
    "25007": 0,
    "25009": 0,
    "25011": 0,
    "25013": 2,
    "25015": 0,
    "25017": 0,
    "25019": 0,
    "25021": 1,
    "25023": 0,
    "25025": 0,
    "25027": 1,
    "26001": 0,
    "26003": 0,
    "26005": 0,
    "26007": 0,
    "26009": 0,
    "26011": 0,
    "26013": 2,
    "26015": 0,
    "26017": 0,
    "26019": 0,
    "26021": 0,
    "26023": 0,
    "26025": 0,
    "26027": 0,
    "26029": 0,
    "26031": 0,
    "26033": 0,
    "26035": 0,
    "26037": 0,
    "26039": 2,
    "26041": 1,
    "26043": 0,
    "26045": 0,
    "26047": 0,
    "26049": 0,
    "26051": 0,
    "26053": 0,
    "26055": 0,
    "26057": 0,
    "26059": 0,
    "26061": 0,
    "26063": 0,
    "26065": 0,
    "26067": 0,
    "26069": 1,
    "26071": 0,
    "26073": 0,
    "26075": 0,
    "26077": 0,
    "26079": 1,
    "26081": 0,
    "26083": 0,
    "26085": 0,
    "26087": 0,
    "26089": 0,
    "26091": 0,
    "26093": 0,
    "26095": 2,
    "26097": 0,
    "26099": 2,
    "26101": 0,
    "26103": 7,
    "26105": 0,
    "26107": 0,
    "26109": 0,
    "26111": 0,
    "26113": 0,
    "26115": 0,
    "26117": 0,
    "26119": 0,
    "26121": 0,
    "26123": 0,
    "26125": 0,
    "26127": 0,
    "26129": 0,
    "26131": 1,
    "26133": 0,
    "26135": 2,
    "26137": 0,
    "26139": 0,
    "26141": 0,
    "26143": 1,
    "26145": 0,
    "26147": 0,
    "26149": 0,
    "26151": 0,
    "26153": 1,
    "26155": 0,
    "26157": 1,
    "26159": 0,
    "26161": 0,
    "26163": 0,
    "26165": 0,
    "27001": 0,
    "27003": 0,
    "27005": 0,
    "27007": 0,
    "27009": 0,
    "27011": 0,
    "27013": 0,
    "27015": 0,
    "27017": 0,
    "27019": 0,
    "27021": 0,
    "27023": 0,
    "27025": 0,
    "27027": 0,
    "27029": 0,
    "27031": 3,
    "27033": 1,
    "27035": 0,
    "27037": 0,
    "27039": 1,
    "27041": 0,
    "27043": 0,
    "27045": 0,
    "27047": 0,
    "27049": 0,
    "27051": 0,
    "27053": 0,
    "27055": 0,
    "27057": 0,
    "27059": 0,
    "27061": 1,
    "27063": 0,
    "27065": 0,
    "27067": 0,
    "27069": 1,
    "27071": 0,
    "27073": 0,
    "27075": 3,
    "27077": 0,
    "27079": 0,
    "27081": 0,
    "27083": 0,
    "27085": 0,
    "27087": 0,
    "27089": 1,
    "27091": 0,
    "27093": 0,
    "27095": 0,
    "27097": 0,
    "27099": 2,
    "27101": 0,
    "27103": 0,
    "27105": 0,
    "27107": 0,
    "27109": 2,
    "27111": 0,
    "27113": 0,
    "27115": 0,
    "27117": 0,
    "27119": 0,
    "27121": 0,
    "27123": 0,
    "27125": 0,
    "27127": 0,
    "27129": 0,
    "27131": 0,
    "27133": 0,
    "27135": 1,
    "27137": 1,
    "27139": 0,
    "27141": 0,
    "27143": 0,
    "27145": 0,
    "27147": 0,
    "27149": 0,
    "27151": 0,
    "27153": 1,
    "27155": 0,
    "27157": 0,
    "27159": 0,
    "27161": 0,
    "27163": 0,
    "27165": 0,
    "27167": 0,
    "27169": 0,
    "27171": 0,
    "27173": 0,
    "28001": 0,
    "28003": 0,
    "28005": 0,
    "28007": 0,
    "28009": 0,
    "28011": 0,
    "28013": 0,
    "28015": 0,
    "28017": 0,
    "28019": 0,
    "28021": 0,
    "28023": 0,
    "28025": 0,
    "28027": 0,
    "28029": 0,
    "28031": 0,
    "28033": 0,
    "28035": 0,
    "28037": 0,
    "28039": 0,
    "28041": 0,
    "28043": 0,
    "28045": 0,
    "28047": 0,
    "28049": 0,
    "28051": 0,
    "28053": 0,
    "28055": 0,
    "28057": 0,
    "28059": 0,
    "28061": 0,
    "28063": 0,
    "28065": 0,
    "28067": 0,
    "28069": 0,
    "28071": 0,
    "28073": 0,
    "28075": 0,
    "28077": 0,
    "28079": 0,
    "28081": 0,
    "28083": 0,
    "28085": 0,
    "28087": 0,
    "28089": 0,
    "28091": 0,
    "28093": 0,
    "28095": 0,
    "28097": 0,
    "28099": 0,
    "28101": 0,
    "28103": 0,
    "28105": 0,
    "28107": 0,
    "28109": 0,
    "28111": 0,
    "28113": 0,
    "28115": 0,
    "28117": 0,
    "28119": 0,
    "28121": 0,
    "28123": 0,
    "28125": 0,
    "28127": 0,
    "28129": 0,
    "28131": 0,
    "28133": 0,
    "28135": 0,
    "28137": 0,
    "28139": 0,
    "28141": 0,
    "28143": 0,
    "28145": 1,
    "28147": 0,
    "28149": 0,
    "28151": 0,
    "28153": 0,
    "28155": 0,
    "28157": 0,
    "28159": 0,
    "28161": 0,
    "28163": 0,
    "29001": 0,
    "29003": 0,
    "29005": 0,
    "29007": 0,
    "29009": 1,
    "29011": 2,
    "29013": 0,
    "29015": 2,
    "29017": 0,
    "29019": 0,
    "29021": 0,
    "29023": 2,
    "29025": 0,
    "29027": 0,
    "29029": 3,
    "29031": 0,
    "29033": 0,
    "29035": 4,
    "29037": 0,
    "29039": 0,
    "29041": 0,
    "29043": 2,
    "29045": 1,
    "29047": 0,
    "29049": 0,
    "29051": 0,
    "29053": 0,
    "29055": 0,
    "29057": 0,
    "29059": 3,
    "29061": 0,
    "29063": 0,
    "29065": 2,
    "29067": 0,
    "29069": 0,
    "29071": 0,
    "29073": 0,
    "29075": 0,
    "29077": 2,
    "29079": 0,
    "29081": 0,
    "29083": 0,
    "29085": 4,
    "29087": 0,
    "29089": 0,
    "29091": 2,
    "29093": 0,
    "29095": 0,
    "29097": 1,
    "29099": 0,
    "29101": 0,
    "29103": 0,
    "29105": 3,
    "29107": 0,
    "29109": 4,
    "29111": 0,
    "29113": 0,
    "29115": 0,
    "29117": 0,
    "29119": 0,
    "29121": 0,
    "29123": 0,
    "29125": 0,
    "29127": 0,
    "29129": 0,
    "29131": 1,
    "29133": 0,
    "29135": 0,
    "29137": 0,
    "29139": 0,
    "29141": 2,
    "29143": 0,
    "29145": 1,
    "29147": 0,
    "29149": 0,
    "29151": 0,
    "29153": 4,
    "29155": 0,
    "29157": 0,
    "29159": 0,
    "29161": 1,
    "29163": 0,
    "29165": 0,
    "29167": 3,
    "29169": 2,
    "29171": 0,
    "29173": 0,
    "29175": 0,
    "29177": 0,
    "29179": 0,
    "29181": 4,
    "29183": 0,
    "29185": 2,
    "29186": 0,
    "29187": 0,
    "29189": 0,
    "29195": 0,
    "29197": 0,
    "29199": 0,
    "29201": 0,
    "29203": 1,
    "29205": 0,
    "29207": 0,
    "29209": 3,
    "29211": 0,
    "29213": 4,
    "29215": 1,
    "29217": 1,
    "29219": 0,
    "29221": 0,
    "29223": 3,
    "29225": 2,
    "29227": 0,
    "29229": 1,
    "29510": 0,
    "30001": 7,
    "30003": 8,
    "30005": 1,
    "30007": 0,
    "30009": 10,
    "30011": 2,
    "30013": 3,
    "30015": 2,
    "30017": 2,
    "30019": 0,
    "30021": 3,
    "30023": 0,
    "30025": 0,
    "30027": 0,
    "30029": 3,
    "30031": 20,
    "30033": 9,
    "30035": 1,
    "30037": 0,
    "30039": 3,
    "30041": 0,
    "30043": 3,
    "30045": 4,
    "30047": 2,
    "30049": 16,
    "30051": 0,
    "30053": 1,
    "30055": 1,
    "30057": 0,
    "30059": 1,
    "30061": 4,
    "30063": 9,
    "30065": 4,
    "30067": 29,
    "30069": 5,
    "30071": 7,
    "30073": 1,
    "30075": 3,
    "30077": 1,
    "30079": 2,
    "30081": 6,
    "30083": 0,
    "30085": 6,
    "30087": 10,
    "30089": 4,
    "30091": 1,
    "30093": 0,
    "30095": 17,
    "30097": 11,
    "30099": 10,
    "30101": 0,
    "30103": 0,
    "30105": 7,
    "30107": 0,
    "30109": 1,
    "30111": 4,
    "31001": 0,
    "31003": 0,
    "31005": 2,
    "31007": 0,
    "31009": 2,
    "31011": 1,
    "31013": 0,
    "31015": 0,
    "31017": 1,
    "31019": 0,
    "31021": 0,
    "31023": 0,
    "31025": 0,
    "31027": 0,
    "31029": 0,
    "31031": 2,
    "31033": 0,
    "31035": 0,
    "31037": 0,
    "31039": 0,
    "31041": 0,
    "31043": 0,
    "31045": 1,
    "31047": 0,
    "31049": 0,
    "31051": 0,
    "31053": 0,
    "31055": 1,
    "31057": 0,
    "31059": 1,
    "31061": 0,
    "31063": 0,
    "31065": 1,
    "31067": 0,
    "31069": 0,
    "31071": 0,
    "31073": 0,
    "31075": 0,
    "31077": 0,
    "31079": 0,
    "31081": 0,
    "31083": 0,
    "31085": 0,
    "31087": 2,
    "31089": 0,
    "31091": 0,
    "31093": 0,
    "31095": 0,
    "31097": 0,
    "31099": 0,
    "31101": 3,
    "31103": 1,
    "31105": 1,
    "31107": 0,
    "31109": 2,
    "31111": 1,
    "31113": 1,
    "31115": 0,
    "31117": 2,
    "31119": 0,
    "31121": 0,
    "31123": 0,
    "31125": 0,
    "31127": 0,
    "31129": 0,
    "31131": 0,
    "31133": 0,
    "31135": 1,
    "31137": 0,
    "31139": 1,
    "31141": 0,
    "31143": 0,
    "31145": 2,
    "31147": 0,
    "31149": 0,
    "31151": 0,
    "31153": 0,
    "31155": 0,
    "31157": 0,
    "31159": 1,
    "31161": 2,
    "31163": 1,
    "31165": 0,
    "31167": 1,
    "31169": 0,
    "31171": 0,
    "31173": 0,
    "31175": 1,
    "31177": 0,
    "31179": 0,
    "31181": 0,
    "31183": 0,
    "31185": 0,
    "32001": 5,
    "32003": 7,
    "32005": 10,
    "32007": 6,
    "32009": 0,
    "32011": 1,
    "32013": 2,
    "32015": 1,
    "32017": 1,
    "32019": 14,
    "32021": 0,
    "32023": 2,
    "32027": 5,
    "32029": 9,
    "32031": 15,
    "32033": 1,
    "32510": 9,
    "33001": 0,
    "33003": 0,
    "33005": 0,
    "33007": 0,
    "33009": 0,
    "33011": 0,
    "33013": 0,
    "33015": 0,
    "33017": 0,
    "33019": 0,
    "34001": 10,
    "34003": 0,
    "34005": 29,
    "34007": 11,
    "34009": 4,
    "34011": 9,
    "34013": 0,
    "34015": 8,
    "34017": 1,
    "34019": 6,
    "34021": 6,
    "34023": 18,
    "34025": 10,
    "34027": 8,
    "34029": 26,
    "34031": 0,
    "34033": 4,
    "34035": 3,
    "34037": 12,
    "34039": 0,
    "34041": 7,
    "35001": 7,
    "35003": 7,
    "35005": 0,
    "35006": 0,
    "35007": 4,
    "35009": 3,
    "35011": 0,
    "35013": 0,
    "35015": 0,
    "35017": 0,
    "35019": 2,
    "35021": 0,
    "35023": 0,
    "35025": 2,
    "35027": 10,
    "35028": 8,
    "35029": 0,
    "35031": 0,
    "35033": 5,
    "35035": 0,
    "35037": 2,
    "35039": 18,
    "35041": 2,
    "35043": 15,
    "35045": 4,
    "35047": 9,
    "35049": 12,
    "35051": 0,
    "35053": 8,
    "35055": 10,
    "35057": 7,
    "35059": 2,
    "35061": 6,
    "36001": 2,
    "36003": 0,
    "36005": 0,
    "36007": 0,
    "36009": 0,
    "36011": 0,
    "36013": 0,
    "36015": 0,
    "36017": 0,
    "36019": 0,
    "36021": 2,
    "36023": 0,
    "36025": 0,
    "36027": 2,
    "36029": 0,
    "36031": 0,
    "36033": 0,
    "36035": 1,
    "36037": 0,
    "36039": 2,
    "36041": 1,
    "36043": 2,
    "36045": 1,
    "36047": 0,
    "36049": 0,
    "36051": 0,
    "36053": 0,
    "36055": 0,
    "36057": 1,
    "36059": 0,
    "36061": 0,
    "36063": 0,
    "36065": 0,
    "36067": 0,
    "36069": 0,
    "36071": 0,
    "36073": 0,
    "36075": 0,
    "36077": 0,
    "36079": 0,
    "36081": 0,
    "36083": 3,
    "36085": 0,
    "36087": 0,
    "36089": 0,
    "36091": 2,
    "36093": 3,
    "36095": 1,
    "36097": 0,
    "36099": 0,
    "36101": 0,
    "36103": 1,
    "36105": 0,
    "36107": 0,
    "36109": 0,
    "36111": 3,
    "36113": 1,
    "36115": 2,
    "36117": 0,
    "36119": 0,
    "36121": 0,
    "36123": 0,
    "37001": 0,
    "37003": 0,
    "37005": 0,
    "37007": 0,
    "37009": 0,
    "37011": 0,
    "37013": 0,
    "37015": 0,
    "37017": 3,
    "37019": 2,
    "37021": 0,
    "37023": 0,
    "37025": 0,
    "37027": 0,
    "37029": 0,
    "37031": 0,
    "37033": 0,
    "37035": 0,
    "37037": 0,
    "37039": 0,
    "37041": 0,
    "37043": 0,
    "37045": 0,
    "37047": 0,
    "37049": 0,
    "37051": 0,
    "37053": 0,
    "37055": 0,
    "37057": 0,
    "37059": 0,
    "37061": 0,
    "37063": 0,
    "37065": 0,
    "37067": 0,
    "37069": 0,
    "37071": 0,
    "37073": 0,
    "37075": 1,
    "37077": 0,
    "37079": 0,
    "37081": 0,
    "37083": 0,
    "37085": 0,
    "37087": 1,
    "37089": 0,
    "37091": 0,
    "37093": 0,
    "37095": 0,
    "37097": 0,
    "37099": 1,
    "37101": 0,
    "37103": 0,
    "37105": 0,
    "37107": 0,
    "37109": 0,
    "37111": 2,
    "37113": 1,
    "37115": 0,
    "37117": 0,
    "37119": 0,
    "37121": 1,
    "37123": 0,
    "37125": 0,
    "37127": 0,
    "37129": 1,
    "37131": 0,
    "37133": 0,
    "37135": 0,
    "37137": 0,
    "37139": 0,
    "37141": 5,
    "37143": 0,
    "37145": 0,
    "37147": 0,
    "37149": 1,
    "37151": 0,
    "37153": 0,
    "37155": 2,
    "37157": 1,
    "37159": 0,
    "37161": 2,
    "37163": 0,
    "37165": 0,
    "37167": 0,
    "37169": 0,
    "37171": 0,
    "37173": 2,
    "37175": 0,
    "37177": 0,
    "37179": 0,
    "37181": 0,
    "37183": 1,
    "37185": 0,
    "37187": 0,
    "37189": 1,
    "37191": 0,
    "37193": 0,
    "37195": 0,
    "37197": 0,
    "37199": 1,
    "38001": 3,
    "38003": 0,
    "38005": 0,
    "38007": 1,
    "38009": 0,
    "38011": 1,
    "38013": 0,
    "38015": 5,
    "38017": 0,
    "38019": 1,
    "38021": 0,
    "38023": 0,
    "38025": 1,
    "38027": 0,
    "38029": 1,
    "38031": 0,
    "38033": 1,
    "38035": 1,
    "38037": 2,
    "38039": 0,
    "38041": 2,
    "38043": 0,
    "38045": 0,
    "38047": 0,
    "38049": 0,
    "38051": 0,
    "38053": 1,
    "38055": 0,
    "38057": 0,
    "38059": 1,
    "38061": 0,
    "38063": 0,
    "38065": 1,
    "38067": 0,
    "38069": 0,
    "38071": 0,
    "38073": 0,
    "38075": 0,
    "38077": 0,
    "38079": 0,
    "38081": 0,
    "38083": 0,
    "38085": 4,
    "38087": 3,
    "38089": 2,
    "38091": 0,
    "38093": 1,
    "38095": 0,
    "38097": 0,
    "38099": 0,
    "38101": 1,
    "38103": 0,
    "38105": 1,
    "39001": 0,
    "39003": 0,
    "39005": 0,
    "39007": 0,
    "39009": 0,
    "39011": 0,
    "39013": 0,
    "39015": 0,
    "39017": 0,
    "39019": 0,
    "39021": 0,
    "39023": 0,
    "39025": 0,
    "39027": 0,
    "39029": 0,
    "39031": 0,
    "39033": 0,
    "39035": 0,
    "39037": 0,
    "39039": 0,
    "39041": 0,
    "39043": 0,
    "39045": 0,
    "39047": 0,
    "39049": 0,
    "39051": 0,
    "39053": 0,
    "39055": 0,
    "39057": 0,
    "39059": 0,
    "39061": 0,
    "39063": 0,
    "39065": 0,
    "39067": 0,
    "39069": 0,
    "39071": 0,
    "39073": 0,
    "39075": 0,
    "39077": 0,
    "39079": 0,
    "39081": 0,
    "39083": 0,
    "39085": 0,
    "39087": 0,
    "39089": 0,
    "39091": 0,
    "39093": 0,
    "39095": 0,
    "39097": 0,
    "39099": 0,
    "39101": 0,
    "39103": 0,
    "39105": 0,
    "39107": 0,
    "39109": 0,
    "39111": 0,
    "39113": 0,
    "39115": 0,
    "39117": 0,
    "39119": 0,
    "39121": 0,
    "39123": 0,
    "39125": 0,
    "39127": 0,
    "39129": 0,
    "39131": 0,
    "39133": 0,
    "39135": 0,
    "39137": 0,
    "39139": 0,
    "39141": 0,
    "39143": 0,
    "39145": 0,
    "39147": 0,
    "39149": 0,
    "39151": 0,
    "39153": 0,
    "39155": 0,
    "39157": 0,
    "39159": 0,
    "39161": 0,
    "39163": 0,
    "39165": 0,
    "39167": 0,
    "39169": 0,
    "39171": 0,
    "39173": 0,
    "39175": 0,
    "40001": 9,
    "40003": 1,
    "40005": 13,
    "40007": 9,
    "40009": 3,
    "40011": 0,
    "40013": 0,
    "40015": 2,
    "40017": 1,
    "40019": 3,
    "40021": 9,
    "40023": 4,
    "40025": 2,
    "40027": 2,
    "40029": 4,
    "40031": 2,
    "40033": 1,
    "40035": 0,
    "40037": 18,
    "40039": 3,
    "40041": 4,
    "40043": 2,
    "40045": 0,
    "40047": 0,
    "40049": 4,
    "40051": 3,
    "40053": 0,
    "40055": 1,
    "40057": 0,
    "40059": 4,
    "40061": 10,
    "40063": 3,
    "40065": 1,
    "40067": 1,
    "40069": 0,
    "40071": 1,
    "40073": 0,
    "40075": 1,
    "40077": 13,
    "40079": 9,
    "40081": 2,
    "40083": 5,
    "40085": 1,
    "40087": 0,
    "40089": 1,
    "40091": 6,
    "40093": 0,
    "40095": 0,
    "40097": 4,
    "40099": 4,
    "40101": 10,
    "40103": 1,
    "40105": 2,
    "40107": 8,
    "40109": 2,
    "40111": 8,
    "40113": 11,
    "40115": 1,
    "40117": 6,
    "40119": 2,
    "40121": 18,
    "40123": 0,
    "40125": 4,
    "40127": 13,
    "40129": 5,
    "40131": 2,
    "40133": 4,
    "40135": 5,
    "40137": 4,
    "40139": 14,
    "40141": 0,
    "40143": 7,
    "40145": 7,
    "40147": 2,
    "40149": 0,
    "40151": 3,
    "40153": 5,
    "41001": 4,
    "41003": 0,
    "41005": 10,
    "41007": 0,
    "41009": 0,
    "41011": 34,
    "41013": 39,
    "41015": 65,
    "41017": 62,
    "41019": 62,
    "41021": 15,
    "41023": 57,
    "41025": 0,
    "41027": 10,
    "41029": 66,
    "41031": 75,
    "41033": 75,
    "41035": 59,
    "41037": 36,
    "41039": 17,
    "41041": 0,
    "41043": 10,
    "41045": 5,
    "41047": 11,
    "41049": 32,
    "41051": 11,
    "41053": 0,
    "41055": 13,
    "41057": 0,
    "41059": 34,
    "41061": 41,
    "41063": 30,
    "41065": 46,
    "41067": 0,
    "41069": 55,
    "41071": 0,
    "42001": 0,
    "42003": 0,
    "42005": 0,
    "42007": 0,
    "42009": 0,
    "42011": 10,
    "42013": 0,
    "42015": 0,
    "42017": 0,
    "42019": 0,
    "42021": 0,
    "42023": 0,
    "42025": 15,
    "42027": 0,
    "42029": 2,
    "42031": 0,
    "42033": 0,
    "42035": 0,
    "42037": 0,
    "42039": 0,
    "42041": 0,
    "42043": 0,
    "42045": 3,
    "42047": 0,
    "42049": 0,
    "42051": 0,
    "42053": 0,
    "42055": 0,
    "42057": 0,
    "42059": 0,
    "42061": 0,
    "42063": 0,
    "42065": 0,
    "42067": 0,
    "42069": 0,
    "42071": 0,
    "42073": 0,
    "42075": 0,
    "42077": 7,
    "42079": 0,
    "42081": 0,
    "42083": 0,
    "42085": 0,
    "42087": 0,
    "42089": 11,
    "42091": 1,
    "42093": 0,
    "42095": 19,
    "42097": 0,
    "42099": 0,
    "42101": 1,
    "42103": 0,
    "42105": 0,
    "42107": 0,
    "42109": 0,
    "42111": 0,
    "42113": 0,
    "42115": 0,
    "42117": 0,
    "42119": 0,
    "42121": 0,
    "42123": 0,
    "42125": 0,
    "42127": 0,
    "42129": 0,
    "42131": 0,
    "42133": 0,
    "44001": 0,
    "44003": 0,
    "44005": 0,
    "44007": 0,
    "44009": 0,
    "45001": 0,
    "45003": 0,
    "45005": 0,
    "45007": 0,
    "45009": 0,
    "45011": 0,
    "45013": 2,
    "45015": 2,
    "45017": 0,
    "45019": 1,
    "45021": 0,
    "45023": 0,
    "45025": 0,
    "45027": 0,
    "45029": 1,
    "45031": 0,
    "45033": 0,
    "45035": 2,
    "45037": 0,
    "45039": 0,
    "45041": 0,
    "45043": 2,
    "45045": 0,
    "45047": 0,
    "45049": 0,
    "45051": 0,
    "45053": 2,
    "45055": 0,
    "45057": 0,
    "45059": 0,
    "45061": 0,
    "45063": 0,
    "45065": 0,
    "45067": 0,
    "45069": 0,
    "45071": 0,
    "45073": 0,
    "45075": 0,
    "45077": 1,
    "45079": 0,
    "45081": 0,
    "45083": 0,
    "45085": 0,
    "45087": 0,
    "45089": 0,
    "45091": 0,
    "46003": 0,
    "46005": 1,
    "46007": 3,
    "46009": 0,
    "46011": 0,
    "46013": 5,
    "46015": 0,
    "46017": 0,
    "46019": 1,
    "46021": 1,
    "46023": 1,
    "46025": 0,
    "46027": 0,
    "46029": 0,
    "46031": 3,
    "46033": 2,
    "46035": 0,
    "46037": 0,
    "46039": 0,
    "46041": 0,
    "46043": 1,
    "46045": 1,
    "46047": 3,
    "46049": 0,
    "46051": 1,
    "46053": 2,
    "46055": 1,
    "46057": 0,
    "46059": 0,
    "46061": 0,
    "46063": 4,
    "46065": 0,
    "46067": 0,
    "46069": 0,
    "46071": 2,
    "46073": 0,
    "46075": 1,
    "46077": 0,
    "46079": 0,
    "46081": 2,
    "46083": 0,
    "46085": 3,
    "46087": 0,
    "46089": 1,
    "46091": 0,
    "46093": 2,
    "46095": 0,
    "46097": 0,
    "46099": 1,
    "46101": 1,
    "46103": 2,
    "46105": 2,
    "46107": 1,
    "46109": 0,
    "46111": 1,
    "46113": 0,
    "46115": 0,
    "46117": 1,
    "46119": 0,
    "46121": 1,
    "46123": 1,
    "46125": 0,
    "46127": 0,
    "46129": 0,
    "46135": 1,
    "46137": 1,
    "47001": 0,
    "47003": 0,
    "47005": 0,
    "47007": 0,
    "47009": 0,
    "47011": 0,
    "47013": 0,
    "47015": 0,
    "47017": 0,
    "47019": 0,
    "47021": 0,
    "47023": 0,
    "47025": 0,
    "47027": 0,
    "47029": 0,
    "47031": 0,
    "47033": 0,
    "47035": 0,
    "47037": 0,
    "47039": 0,
    "47041": 0,
    "47043": 0,
    "47045": 0,
    "47047": 0,
    "47049": 0,
    "47051": 0,
    "47053": 0,
    "47055": 0,
    "47057": 0,
    "47059": 0,
    "47061": 0,
    "47063": 0,
    "47065": 0,
    "47067": 0,
    "47069": 0,
    "47071": 0,
    "47073": 0,
    "47075": 0,
    "47077": 0,
    "47079": 0,
    "47081": 0,
    "47083": 0,
    "47085": 0,
    "47087": 0,
    "47089": 0,
    "47091": 0,
    "47093": 0,
    "47095": 0,
    "47097": 0,
    "47099": 0,
    "47101": 0,
    "47103": 0,
    "47105": 0,
    "47107": 0,
    "47109": 0,
    "47111": 0,
    "47113": 0,
    "47115": 0,
    "47117": 0,
    "47119": 0,
    "47121": 0,
    "47123": 0,
    "47125": 0,
    "47127": 0,
    "47129": 0,
    "47131": 0,
    "47133": 0,
    "47135": 1,
    "47137": 0,
    "47139": 0,
    "47141": 0,
    "47143": 0,
    "47145": 0,
    "47147": 0,
    "47149": 0,
    "47151": 0,
    "47153": 0,
    "47155": 0,
    "47157": 1,
    "47159": 0,
    "47161": 0,
    "47163": 0,
    "47165": 0,
    "47167": 0,
    "47169": 0,
    "47171": 0,
    "47173": 0,
    "47175": 0,
    "47177": 0,
    "47179": 0,
    "47181": 0,
    "47183": 0,
    "47185": 0,
    "47187": 0,
    "47189": 0,
    "48001": 10,
    "48003": 5,
    "48005": 0,
    "48007": 6,
    "48009": 1,
    "48011": 22,
    "48013": 3,
    "48015": 0,
    "48017": 9,
    "48019": 0,
    "48021": 2,
    "48023": 1,
    "48025": 2,
    "48027": 8,
    "48029": 2,
    "48031": 1,
    "48033": 0,
    "48035": 2,
    "48037": 5,
    "48039": 0,
    "48041": 0,
    "48043": 0,
    "48045": 1,
    "48047": 16,
    "48049": 5,
    "48051": 0,
    "48053": 3,
    "48055": 1,
    "48057": 4,
    "48059": 7,
    "48061": 0,
    "48063": 0,
    "48065": 27,
    "48067": 1,
    "48069": 3,
    "48071": 0,
    "48073": 3,
    "48075": 3,
    "48077": 2,
    "48079": 6,
    "48081": 5,
    "48083": 3,
    "48085": 4,
    "48087": 7,
    "48089": 0,
    "48091": 0,
    "48093": 1,
    "48095": 2,
    "48097": 3,
    "48099": 15,
    "48101": 5,
    "48103": 1,
    "48105": 15,
    "48107": 3,
    "48109": 0,
    "48111": 14,
    "48113": 3,
    "48115": 0,
    "48117": 15,
    "48119": 0,
    "48121": 4,
    "48123": 1,
    "48125": 5,
    "48127": 1,
    "48129": 16,
    "48131": 13,
    "48133": 13,
    "48135": 2,
    "48137": 1,
    "48139": 5,
    "48141": 0,
    "48143": 3,
    "48145": 0,
    "48147": 0,
    "48149": 2,
    "48151": 2,
    "48153": 4,
    "48155": 1,
    "48157": 0,
    "48159": 3,
    "48161": 1,
    "48163": 0,
    "48165": 0,
    "48167": 0,
    "48169": 12,
    "48171": 1,
    "48173": 1,
    "48175": 2,
    "48177": 1,
    "48179": 15,
    "48181": 6,
    "48183": 2,
    "48185": 1,
    "48187": 0,
    "48189": 7,
    "48191": 0,
    "48193": 2,
    "48195": 5,
    "48197": 0,
    "48199": 5,
    "48201": 0,
    "48203": 4,
    "48205": 24,
    "48207": 5,
    "48209": 2,
    "48211": 15,
    "48213": 8,
    "48215": 14,
    "48217": 2,
    "48219": 15,
    "48221": 5,
    "48223": 2,
    "48225": 0,
    "48227": 2,
    "48229": 0,
    "48231": 9,
    "48233": 31,
    "48235": 7,
    "48237": 11,
    "48239": 0,
    "48241": 1,
    "48243": 0,
    "48245": 1,
    "48247": 7,
    "48249": 15,
    "48251": 8,
    "48253": 4,
    "48255": 2,
    "48257": 3,
    "48259": 1,
    "48261": 5,
    "48263": 3,
    "48265": 1,
    "48267": 5,
    "48269": 6,
    "48271": 0,
    "48273": 12,
    "48275": 0,
    "48277": 2,
    "48279": 8,
    "48281": 9,
    "48283": 6,
    "48285": 0,
    "48287": 0,
    "48289": 3,
    "48291": 0,
    "48293": 2,
    "48295": 23,
    "48297": 5,
    "48299": 1,
    "48301": 0,
    "48303": 9,
    "48305": 1,
    "48307": 3,
    "48309": 3,
    "48311": 0,
    "48313": 0,
    "48315": 1,
    "48317": 0,
    "48319": 6,
    "48321": 0,
    "48323": 0,
    "48325": 0,
    "48327": 8,
    "48329": 3,
    "48331": 2,
    "48333": 2,
    "48335": 1,
    "48337": 5,
    "48339": 0,
    "48341": 12,
    "48343": 0,
    "48345": 8,
    "48347": 1,
    "48349": 7,
    "48351": 0,
    "48353": 7,
    "48355": 9,
    "48357": 9,
    "48359": 16,
    "48361": 0,
    "48363": 15,
    "48365": 1,
    "48367": 9,
    "48369": 0,
    "48371": 1,
    "48373": 0,
    "48375": 42,
    "48377": 0,
    "48379": 0,
    "48381": 26,
    "48383": 1,
    "48385": 0,
    "48387": 2,
    "48389": 0,
    "48391": 0,
    "48393": 8,
    "48395": 3,
    "48397": 0,
    "48399": 1,
    "48401": 6,
    "48403": 0,
    "48405": 0,
    "48407": 0,
    "48409": 9,
    "48411": 6,
    "48413": 5,
    "48415": 1,
    "48417": 5,
    "48419": 0,
    "48421": 7,
    "48423": 3,
    "48425": 1,
    "48427": 7,
    "48429": 8,
    "48431": 6,
    "48433": 5,
    "48435": 10,
    "48437": 6,
    "48439": 8,
    "48441": 9,
    "48443": 1,
    "48445": 5,
    "48447": 5,
    "48449": 1,
    "48451": 10,
    "48453": 3,
    "48455": 0,
    "48457": 3,
    "48459": 4,
    "48461": 0,
    "48463": 0,
    "48465": 6,
    "48467": 2,
    "48469": 1,
    "48471": 0,
    "48473": 0,
    "48475": 0,
    "48477": 0,
    "48479": 4,
    "48481": 0,
    "48483": 29,
    "48485": 2,
    "48487": 1,
    "48489": 2,
    "48491": 2,
    "48493": 0,
    "48495": 1,
    "48497": 12,
    "48499": 0,
    "48501": 6,
    "48503": 3,
    "48505": 7,
    "48507": 0,
    "49001": 6,
    "49003": 4,
    "49005": 0,
    "49007": 6,
    "49009": 7,
    "49011": 3,
    "49013": 10,
    "49015": 9,
    "49017": 3,
    "49019": 26,
    "49021": 6,
    "49023": 13,
    "49025": 3,
    "49027": 3,
    "49029": 1,
    "49031": 3,
    "49033": 0,
    "49035": 18,
    "49037": 18,
    "49039": 17,
    "49041": 4,
    "49043": 12,
    "49045": 10,
    "49047": 20,
    "49049": 17,
    "49051": 19,
    "49053": 8,
    "49055": 3,
    "49057": 4,
    "50001": 0,
    "50003": 1,
    "50005": 0,
    "50007": 0,
    "50009": 0,
    "50011": 0,
    "50013": 0,
    "50015": 0,
    "50017": 0,
    "50019": 0,
    "50021": 0,
    "50023": 0,
    "50025": 1,
    "50027": 0,
    "51001": 0,
    "51003": 1,
    "51005": 3,
    "51007": 0,
    "51009": 0,
    "51011": 0,
    "51013": 0,
    "51015": 1,
    "51017": 1,
    "51019": 0,
    "51021": 0,
    "51023": 0,
    "51025": 0,
    "51027": 0,
    "51029": 0,
    "51031": 0,
    "51033": 0,
    "51035": 1,
    "51036": 0,
    "51037": 0,
    "51041": 0,
    "51043": 3,
    "51045": 1,
    "51047": 0,
    "51049": 0,
    "51051": 0,
    "51053": 0,
    "51057": 0,
    "51059": 0,
    "51061": 0,
    "51063": 0,
    "51065": 0,
    "51067": 0,
    "51069": 0,
    "51071": 0,
    "51073": 2,
    "51075": 0,
    "51077": 0,
    "51079": 1,
    "51081": 0,
    "51083": 0,
    "51085": 0,
    "51087": 0,
    "51089": 0,
    "51091": 0,
    "51093": 0,
    "51095": 0,
    "51097": 0,
    "51099": 0,
    "51101": 0,
    "51103": 0,
    "51105": 0,
    "51107": 0,
    "51109": 0,
    "51111": 0,
    "51113": 2,
    "51115": 0,
    "51117": 0,
    "51119": 0,
    "51121": 0,
    "51125": 5,
    "51127": 0,
    "51131": 0,
    "51133": 0,
    "51135": 0,
    "51137": 0,
    "51139": 3,
    "51141": 1,
    "51143": 2,
    "51145": 0,
    "51147": 0,
    "51149": 0,
    "51153": 0,
    "51155": 0,
    "51157": 1,
    "51159": 0,
    "51161": 0,
    "51163": 1,
    "51165": 6,
    "51167": 0,
    "51169": 0,
    "51171": 3,
    "51173": 0,
    "51175": 0,
    "51177": 0,
    "51179": 0,
    "51181": 0,
    "51183": 0,
    "51185": 0,
    "51187": 1,
    "51191": 0,
    "51193": 0,
    "51195": 0,
    "51197": 0,
    "51199": 0,
    "51510": 0,
    "51515": 0,
    "51520": 0,
    "51530": 1,
    "51540": 1,
    "51550": 0,
    "51570": 0,
    "51580": 3,
    "51590": 2,
    "51595": 0,
    "51600": 0,
    "51610": 0,
    "51620": 0,
    "51630": 0,
    "51640": 1,
    "51650": 0,
    "51660": 3,
    "51670": 0,
    "51678": 1,
    "51680": 0,
    "51683": 0,
    "51685": 0,
    "51690": 0,
    "51700": 0,
    "51710": 0,
    "51720": 0,
    "51730": 0,
    "51735": 0,
    "51740": 0,
    "51750": 0,
    "51760": 0,
    "51770": 0,
    "51775": 0,
    "51790": 0,
    "51800": 0,
    "51810": 0,
    "51820": 0,
    "51830": 0,
    "51840": 0,
    "53001": 43,
    "53003": 6,
    "53005": 28,
    "53007": 87,
    "53009": 0,
    "53011": 0,
    "53013": 9,
    "53015": 1,
    "53017": 94,
    "53019": 25,
    "53021": 25,
    "53023": 6,
    "53025": 66,
    "53027": 1,
    "53029": 0,
    "53031": 1,
    "53033": 1,
    "53035": 1,
    "53037": 24,
    "53039": 47,
    "53041": 1,
    "53043": 30,
    "53045": 2,
    "53047": 148,
    "53049": 1,
    "53051": 25,
    "53053": 0,
    "53055": 0,
    "53057": 1,
    "53059": 1,
    "53061": 1,
    "53063": 48,
    "53065": 28,
    "53067": 1,
    "53069": 0,
    "53071": 36,
    "53073": 1,
    "53075": 10,
    "53077": 47,
    "54001": 0,
    "54003": 0,
    "54005": 4,
    "54007": 0,
    "54009": 0,
    "54011": 0,
    "54013": 0,
    "54015": 1,
    "54017": 0,
    "54019": 2,
    "54021": 0,
    "54023": 0,
    "54025": 0,
    "54027": 0,
    "54029": 0,
    "54031": 0,
    "54033": 0,
    "54035": 0,
    "54037": 0,
    "54039": 3,
    "54041": 0,
    "54043": 1,
    "54045": 3,
    "54047": 3,
    "54049": 0,
    "54051": 0,
    "54053": 0,
    "54055": 0,
    "54057": 0,
    "54059": 3,
    "54061": 0,
    "54063": 0,
    "54065": 0,
    "54067": 1,
    "54069": 0,
    "54071": 1,
    "54073": 0,
    "54075": 0,
    "54077": 0,
    "54079": 0,
    "54081": 3,
    "54083": 0,
    "54085": 0,
    "54087": 1,
    "54089": 0,
    "54091": 0,
    "54093": 0,
    "54095": 0,
    "54097": 0,
    "54099": 1,
    "54101": 0,
    "54103": 0,
    "54105": 0,
    "54107": 0,
    "54109": 3,
    "55001": 3,
    "55003": 0,
    "55005": 0,
    "55007": 0,
    "55009": 0,
    "55011": 0,
    "55013": 0,
    "55015": 0,
    "55017": 0,
    "55019": 1,
    "55021": 0,
    "55023": 0,
    "55025": 0,
    "55027": 1,
    "55029": 0,
    "55031": 0,
    "55033": 0,
    "55035": 0,
    "55037": 0,
    "55039": 0,
    "55041": 0,
    "55043": 0,
    "55045": 0,
    "55047": 0,
    "55049": 0,
    "55051": 0,
    "55053": 2,
    "55055": 0,
    "55057": 3,
    "55059": 0,
    "55061": 0,
    "55063": 3,
    "55065": 0,
    "55067": 0,
    "55069": 0,
    "55071": 0,
    "55073": 0,
    "55075": 0,
    "55077": 0,
    "55078": 0,
    "55079": 0,
    "55081": 6,
    "55083": 0,
    "55085": 0,
    "55087": 0,
    "55089": 0,
    "55091": 0,
    "55093": 0,
    "55095": 0,
    "55097": 0,
    "55099": 0,
    "55101": 0,
    "55103": 0,
    "55105": 0,
    "55107": 0,
    "55109": 0,
    "55111": 0,
    "55113": 1,
    "55115": 0,
    "55117": 0,
    "55119": 0,
    "55121": 1,
    "55123": 1,
    "55125": 0,
    "55127": 0,
    "55129": 0,
    "55131": 0,
    "55133": 0,
    "55135": 0,
    "55137": 0,
    "55139": 0,
    "55141": 0,
    "56001": 4,
    "56003": 6,
    "56005": 2,
    "56007": 2,
    "56009": 0,
    "56011": 3,
    "56013": 38,
    "56015": 0,
    "56017": 9,
    "56019": 8,
    "56021": 2,
    "56023": 22,
    "56025": 12,
    "56027": 0,
    "56029": 35,
    "56031": 2,
    "56033": 4,
    "56035": 25,
    "56037": 7,
    "56039": 31,
    "56041": 2,
    "56043": 6,
    "56045": 1
  },
  {
    "1001": 5,
    "1003": 0,
    "1005": 8,
    "1007": 5,
    "1009": 4,
    "1011": 4,
    "1013": 2,
    "1015": 11,
    "1017": 5,
    "1019": 4,
    "1021": 6,
    "1023": 2,
    "1025": 3,
    "1027": 4,
    "1029": 5,
    "1031": 0,
    "1033": 53,
    "1035": 2,
    "1037": 4,
    "1039": 2,
    "1041": 2,
    "1043": 12,
    "1045": 2,
    "1047": 6,
    "1049": 9,
    "1051": 5,
    "1053": 4,
    "1055": 5,
    "1057": 6,
    "1059": 21,
    "1061": 0,
    "1063": 7,
    "1065": 6,
    "1067": 2,
    "1069": 2,
    "1071": 11,
    "1073": 47,
    "1075": 6,
    "1077": 35,
    "1079": 21,
    "1081": 5,
    "1083": 22,
    "1085": 5,
    "1087": 5,
    "1089": 124,
    "1091": 7,
    "1093": 6,
    "1095": 10,
    "1097": 0,
    "1099": 3,
    "1101": 66,
    "1103": 19,
    "1105": 6,
    "1107": 6,
    "1109": 4,
    "1111": 4,
    "1113": 4,
    "1115": 4,
    "1117": 7,
    "1119": 7,
    "1121": 8,
    "1123": 6,
    "1125": 22,
    "1127": 4,
    "1129": 2,
    "1131": 2,
    "1133": 4,
    "2013": 0,
    "2016": 0,
    "2020": 0,
    "2050": 0,
    "2060": 0,
    "2068": 0,
    "2070": 0,
    "2090": 0,
    "2100": 11,
    "2110": 11,
    "2122": 0,
    "2130": 0,
    "2150": 0,
    "2164": 0,
    "2170": 0,
    "2180": 0,
    "2185": 0,
    "2188": 0,
    "2201": 0,
    "2220": 14,
    "2232": 0,
    "2240": 0,
    "2261": 0,
    "2270": 0,
    "2280": 0,
    "2282": 0,
    "2290": 0,
    "4001": 9,
    "4003": 14,
    "4005": 16,
    "4007": 1,
    "4009": 12,
    "4011": 6,
    "4012": 0,
    "4013": 1,
    "4015": 8,
    "4017": 8,
    "4019": 46,
    "4021": 27,
    "4023": 12,
    "4025": 7,
    "4027": 0,
    "5001": 10,
    "5003": 4,
    "5005": 7,
    "5007": 7,
    "5009": 8,
    "5011": 11,
    "5013": 10,
    "5015": 4,
    "5017": 4,
    "5019": 11,
    "5021": 32,
    "5023": 8,
    "5025": 10,
    "5027": 22,
    "5029": 11,
    "5031": 39,
    "5033": 26,
    "5035": 37,
    "5037": 44,
    "5039": 11,
    "5041": 10,
    "5043": 10,
    "5045": 9,
    "5047": 23,
    "5049": 7,
    "5051": 11,
    "5053": 10,
    "5055": 31,
    "5057": 19,
    "5059": 10,
    "5061": 19,
    "5063": 9,
    "5065": 7,
    "5067": 8,
    "5069": 12,
    "5071": 10,
    "5073": 18,
    "5075": 34,
    "5077": 38,
    "5079": 11,
    "5081": 18,
    "5083": 10,
    "5085": 13,
    "5087": 4,
    "5089": 7,
    "5091": 17,
    "5093": 37,
    "5095": 10,
    "5097": 9,
    "5099": 20,
    "5101": 9,
    "5103": 10,
    "5105": 11,
    "5107": 37,
    "5109": 10,
    "5111": 43,
    "5113": 9,
    "5115": 11,
    "5117": 10,
    "5119": 16,
    "5121": 32,
    "5123": 42,
    "5125": 9,
    "5127": 9,
    "5129": 8,
    "5131": 39,
    "5133": 19,
    "5135": 7,
    "5137": 8,
    "5139": 22,
    "5141": 8,
    "5143": 11,
    "5145": 11,
    "5147": 10,
    "5149": 11,
    "6001": 10,
    "6003": 0,
    "6005": 72,
    "6007": 14,
    "6009": 39,
    "6011": 17,
    "6013": 10,
    "6015": 0,
    "6017": 35,
    "6019": 0,
    "6021": 15,
    "6023": 0,
    "6025": 0,
    "6027": 14,
    "6029": 0,
    "6031": 0,
    "6033": 5,
    "6035": 0,
    "6037": 20,
    "6039": 0,
    "6041": 5,
    "6043": 0,
    "6045": 0,
    "6047": 0,
    "6049": 2,
    "6051": 0,
    "6053": 3,
    "6055": 4,
    "6057": 14,
    "6059": 17,
    "6061": 35,
    "6063": 0,
    "6065": 60,
    "6067": 38,
    "6069": 2,
    "6071": 34,
    "6073": 79,
    "6075": 3,
    "6077": 42,
    "6079": 7,
    "6081": 6,
    "6083": 8,
    "6085": 9,
    "6087": 4,
    "6089": 35,
    "6091": 0,
    "6093": 6,
    "6095": 38,
    "6097": 5,
    "6099": 37,
    "6101": 45,
    "6103": 33,
    "6105": 0,
    "6107": 0,
    "6109": 39,
    "6111": 17,
    "6113": 33,
    "6115": 14,
    "8001": 5,
    "8003": 0,
    "8005": 5,
    "8007": 0,
    "8009": 0,
    "8011": 0,
    "8013": 0,
    "8014": 5,
    "8015": 0,
    "8017": 0,
    "8019": 0,
    "8021": 0,
    "8023": 0,
    "8025": 0,
    "8027": 0,
    "8029": 0,
    "8031": 5,
    "8033": 0,
    "8035": 5,
    "8037": 0,
    "8039": 0,
    "8041": 0,
    "8043": 0,
    "8045": 0,
    "8047": 0,
    "8049": 0,
    "8051": 0,
    "8053": 0,
    "8055": 0,
    "8057": 0,
    "8059": 0,
    "8061": 0,
    "8063": 0,
    "8065": 0,
    "8067": 0,
    "8069": 0,
    "8071": 0,
    "8073": 0,
    "8075": 0,
    "8077": 0,
    "8079": 0,
    "8081": 0,
    "8083": 0,
    "8085": 0,
    "8087": 0,
    "8089": 0,
    "8091": 0,
    "8093": 0,
    "8095": 0,
    "8097": 0,
    "8099": 0,
    "8101": 0,
    "8103": 0,
    "8105": 0,
    "8107": 0,
    "8109": 0,
    "8111": 0,
    "8113": 0,
    "8115": 0,
    "8117": 0,
    "8119": 0,
    "8121": 0,
    "8123": 0,
    "8125": 0,
    "9001": 12,
    "9003": 25,
    "9005": 36,
    "9007": 10,
    "9009": 13,
    "9011": 6,
    "9013": 0,
    "9015": 5,
    "10001": 74,
    "10003": 82,
    "10005": 127,
    "11001": 56,
    "12001": 0,
    "12003": 0,
    "12005": 3,
    "12007": 0,
    "12009": 1,
    "12011": 6,
    "12013": 0,
    "12015": 0,
    "12017": 0,
    "12019": 0,
    "12021": 0,
    "12023": 0,
    "12027": 0,
    "12029": 3,
    "12031": 1,
    "12033": 0,
    "12035": 0,
    "12037": 3,
    "12039": 0,
    "12041": 0,
    "12043": 1,
    "12045": 0,
    "12047": 0,
    "12049": 0,
    "12051": 0,
    "12053": 0,
    "12055": 0,
    "12057": 0,
    "12059": 0,
    "12061": 0,
    "12063": 6,
    "12065": 0,
    "12067": 0,
    "12069": 0,
    "12071": 3,
    "12073": 3,
    "12075": 0,
    "12077": 0,
    "12079": 0,
    "12081": 0,
    "12083": 0,
    "12085": 1,
    "12086": 10,
    "12087": 0,
    "12089": 0,
    "12091": 0,
    "12093": 0,
    "12095": 2,
    "12097": 0,
    "12099": 5,
    "12101": 0,
    "12103": 0,
    "12105": 1,
    "12107": 0,
    "12109": 0,
    "12111": 1,
    "12113": 0,
    "12115": 0,
    "12117": 0,
    "12119": 0,
    "12121": 0,
    "12123": 2,
    "12125": 0,
    "12127": 1,
    "12129": 0,
    "12131": 0,
    "12133": 0,
    "13001": 0,
    "13003": 0,
    "13005": 0,
    "13007": 0,
    "13009": 11,
    "13011": 11,
    "13013": 12,
    "13015": 11,
    "13017": 0,
    "13019": 0,
    "13021": 11,
    "13023": 12,
    "13025": 0,
    "13027": 0,
    "13029": 10,
    "13031": 4,
    "13033": 1,
    "13035": 12,
    "13037": 0,
    "13039": 0,
    "13043": 6,
    "13045": 12,
    "13047": 11,
    "13049": 0,
    "13051": 36,
    "13053": 11,
    "13055": 11,
    "13057": 11,
    "13059": 11,
    "13061": 0,
    "13063": 11,
    "13065": 0,
    "13067": 11,
    "13069": 0,
    "13071": 0,
    "13073": 0,
    "13075": 0,
    "13077": 12,
    "13079": 11,
    "13081": 11,
    "13083": 11,
    "13085": 11,
    "13087": 0,
    "13089": 11,
    "13091": 11,
    "13093": 11,
    "13095": 1,
    "13097": 11,
    "13099": 0,
    "13101": 0,
    "13103": 5,
    "13105": 3,
    "13107": 11,
    "13109": 5,
    "13111": 11,
    "13113": 11,
    "13115": 11,
    "13117": 11,
    "13119": 2,
    "13121": 22,
    "13123": 11,
    "13125": 11,
    "13127": 0,
    "13129": 11,
    "13131": 0,
    "13133": 11,
    "13135": 11,
    "13137": 0,
    "13139": 11,
    "13141": 11,
    "13143": 11,
    "13145": 11,
    "13147": 3,
    "13149": 11,
    "13151": 12,
    "13153": 11,
    "13155": 0,
    "13157": 12,
    "13159": 11,
    "13161": 0,
    "13163": 11,
    "13165": 5,
    "13167": 11,
    "13169": 11,
    "13171": 12,
    "13173": 0,
    "13175": 11,
    "13177": 0,
    "13179": 20,
    "13181": 0,
    "13183": 7,
    "13185": 2,
    "13187": 11,
    "13189": 0,
    "13191": 15,
    "13193": 11,
    "13195": 11,
    "13197": 11,
    "13199": 11,
    "13201": 0,
    "13205": 0,
    "13207": 11,
    "13209": 11,
    "13211": 11,
    "13213": 11,
    "13215": 42,
    "13217": 12,
    "13219": 11,
    "13221": 11,
    "13223": 11,
    "13225": 11,
    "13227": 11,
    "13229": 0,
    "13231": 12,
    "13233": 11,
    "13235": 11,
    "13237": 11,
    "13239": 1,
    "13241": 0,
    "13243": 0,
    "13245": 0,
    "13247": 13,
    "13249": 11,
    "13251": 5,
    "13253": 0,
    "13255": 12,
    "13257": 2,
    "13259": 10,
    "13261": 12,
    "13263": 12,
    "13265": 11,
    "13267": 5,
    "13269": 11,
    "13271": 11,
    "13273": 0,
    "13275": 0,
    "13277": 0,
    "13279": 11,
    "13281": 11,
    "13283": 11,
    "13285": 11,
    "13287": 0,
    "13289": 12,
    "13291": 11,
    "13293": 12,
    "13295": 12,
    "13297": 24,
    "13299": 0,
    "13301": 11,
    "13303": 11,
    "13305": 0,
    "13307": 11,
    "13309": 11,
    "13311": 11,
    "13313": 11,
    "13315": 11,
    "13317": 11,
    "13319": 11,
    "13321": 0,
    "15001": 0,
    "15003": 0,
    "15005": 0,
    "15007": 0,
    "15009": 0,
    "16001": 0,
    "16003": 0,
    "16005": 0,
    "16007": 0,
    "16009": 0,
    "16011": 0,
    "16013": 0,
    "16015": 0,
    "16017": 0,
    "16019": 0,
    "16021": 0,
    "16023": 0,
    "16025": 0,
    "16027": 0,
    "16029": 0,
    "16031": 0,
    "16033": 0,
    "16035": 2,
    "16037": 0,
    "16039": 0,
    "16041": 0,
    "16043": 0,
    "16045": 0,
    "16047": 0,
    "16049": 2,
    "16051": 0,
    "16053": 0,
    "16055": 0,
    "16057": 0,
    "16059": 0,
    "16061": 0,
    "16063": 0,
    "16065": 0,
    "16067": 0,
    "16069": 0,
    "16071": 0,
    "16073": 0,
    "16075": 0,
    "16077": 0,
    "16079": 0,
    "16081": 0,
    "16083": 0,
    "16085": 0,
    "16087": 0,
    "17001": 40,
    "17003": 59,
    "17005": 44,
    "17007": 1,
    "17009": 38,
    "17011": 5,
    "17013": 45,
    "17015": 4,
    "17017": 12,
    "17019": 11,
    "17021": 11,
    "17023": 11,
    "17025": 11,
    "17027": 47,
    "17029": 11,
    "17031": 57,
    "17033": 12,
    "17035": 11,
    "17037": 1,
    "17039": 11,
    "17041": 11,
    "17043": 4,
    "17045": 11,
    "17047": 48,
    "17049": 12,
    "17051": 45,
    "17053": 1,
    "17055": 55,
    "17057": 11,
    "17059": 54,
    "17061": 44,
    "17063": 2,
    "17065": 54,
    "17067": 5,
    "17069": 54,
    "17071": 5,
    "17073": 5,
    "17075": 1,
    "17077": 55,
    "17079": 11,
    "17081": 52,
    "17083": 45,
    "17085": 4,
    "17087": 55,
    "17089": 3,
    "17091": 1,
    "17093": 3,
    "17095": 11,
    "17097": 3,
    "17099": 4,
    "17101": 11,
    "17103": 2,
    "17105": 4,
    "17107": 11,
    "17109": 5,
    "17111": 3,
    "17113": 14,
    "17115": 11,
    "17117": 44,
    "17119": 64,
    "17121": 45,
    "17123": 11,
    "17125": 11,
    "17127": 56,
    "17129": 12,
    "17131": 5,
    "17133": 57,
    "17135": 44,
    "17137": 13,
    "17139": 11,
    "17141": 1,
    "17143": 11,
    "17145": 52,
    "17147": 11,
    "17149": 40,
    "17151": 54,
    "17153": 57,
    "17155": 5,
    "17157": 48,
    "17159": 12,
    "17161": 6,
    "17163": 65,
    "17165": 56,
    "17167": 13,
    "17169": 12,
    "17171": 12,
    "17173": 11,
    "17175": 11,
    "17177": 4,
    "17179": 11,
    "17181": 56,
    "17183": 11,
    "17185": 47,
    "17187": 5,
    "17189": 50,
    "17191": 49,
    "17193": 52,
    "17195": 4,
    "17197": 11,
    "17199": 55,
    "17201": 3,
    "17203": 11,
    "18001": 0,
    "18003": 0,
    "18005": 2,
    "18007": 1,
    "18009": 0,
    "18011": 3,
    "18013": 1,
    "18015": 2,
    "18017": 3,
    "18019": 1,
    "18021": 1,
    "18023": 1,
    "18025": 0,
    "18027": 1,
    "18029": 4,
    "18031": 1,
    "18033": 0,
    "18035": 1,
    "18037": 0,
    "18039": 0,
    "18041": 3,
    "18043": 0,
    "18045": 1,
    "18047": 4,
    "18049": 0,
    "18051": 42,
    "18053": 0,
    "18055": 1,
    "18057": 1,
    "18059": 1,
    "18061": 0,
    "18063": 1,
    "18065": 1,
    "18067": 1,
    "18069": 0,
    "18071": 1,
    "18073": 1,
    "18075": 0,
    "18077": 0,
    "18079": 1,
    "18081": 1,
    "18083": 1,
    "18085": 0,
    "18087": 0,
    "18089": 1,
    "18091": 0,
    "18093": 1,
    "18095": 1,
    "18097": 2,
    "18099": 0,
    "18101": 1,
    "18103": 1,
    "18105": 1,
    "18107": 1,
    "18109": 1,
    "18111": 1,
    "18113": 0,
    "18115": 4,
    "18117": 0,
    "18119": 1,
    "18121": 1,
    "18123": 1,
    "18125": 40,
    "18127": 1,
    "18129": 44,
    "18131": 0,
    "18133": 1,
    "18135": 1,
    "18137": 4,
    "18139": 1,
    "18141": 2,
    "18143": 0,
    "18145": 1,
    "18147": 44,
    "18149": 0,
    "18151": 0,
    "18153": 1,
    "18155": 4,
    "18157": 1,
    "18159": 1,
    "18161": 3,
    "18163": 46,
    "18165": 1,
    "18167": 1,
    "18169": 0,
    "18171": 1,
    "18173": 45,
    "18175": 0,
    "18177": 3,
    "18179": 0,
    "18181": 0,
    "18183": 0,
    "19001": 3,
    "19003": 3,
    "19005": 9,
    "19007": 3,
    "19009": 3,
    "19011": 4,
    "19013": 2,
    "19015": 3,
    "19017": 2,
    "19019": 4,
    "19021": 9,
    "19023": 2,
    "19025": 3,
    "19027": 3,
    "19029": 3,
    "19031": 4,
    "19033": 3,
    "19035": 9,
    "19037": 8,
    "19039": 3,
    "19041": 9,
    "19043": 11,
    "19045": 4,
    "19047": 3,
    "19049": 3,
    "19051": 3,
    "19053": 3,
    "19055": 4,
    "19057": 6,
    "19059": 9,
    "19061": 4,
    "19063": 3,
    "19065": 9,
    "19067": 9,
    "19069": 3,
    "19071": 19,
    "19073": 3,
    "19075": 2,
    "19077": 3,
    "19079": 3,
    "19081": 3,
    "19083": 3,
    "19085": 15,
    "19087": 5,
    "19089": 8,
    "19091": 3,
    "19093": 10,
    "19095": 5,
    "19097": 4,
    "19099": 3,
    "19101": 5,
    "19103": 5,
    "19105": 4,
    "19107": 5,
    "19109": 3,
    "19111": 4,
    "19113": 4,
    "19115": 5,
    "19117": 3,
    "19119": 10,
    "19121": 3,
    "19123": 3,
    "19125": 3,
    "19127": 3,
    "19129": 19,
    "19131": 8,
    "19133": 10,
    "19135": 3,
    "19137": 19,
    "19139": 5,
    "19141": 9,
    "19143": 9,
    "19145": 20,
    "19147": 3,
    "19149": 10,
    "19151": 3,
    "19153": 5,
    "19155": 17,
    "19157": 3,
    "19159": 3,
    "19161": 3,
    "19163": 5,
    "19165": 12,
    "19167": 10,
    "19169": 3,
    "19171": 3,
    "19173": 3,
    "19175": 3,
    "19177": 5,
    "19179": 3,
    "19181": 3,
    "19183": 5,
    "19185": 3,
    "19187": 3,
    "19189": 3,
    "19191": 9,
    "19193": 11,
    "19195": 3,
    "19197": 3,
    "20001": 12,
    "20003": 22,
    "20005": 13,
    "20007": 0,
    "20009": 8,
    "20011": 9,
    "20013": 17,
    "20015": 14,
    "20017": 10,
    "20019": 13,
    "20021": 9,
    "20023": 0,
    "20025": 0,
    "20027": 17,
    "20029": 14,
    "20031": 21,
    "20033": 0,
    "20035": 12,
    "20037": 7,
    "20039": 0,
    "20041": 18,
    "20043": 13,
    "20045": 22,
    "20047": 0,
    "20049": 13,
    "20051": 0,
    "20053": 8,
    "20055": 0,
    "20057": 2,
    "20059": 21,
    "20061": 20,
    "20063": 0,
    "20065": 0,
    "20067": 0,
    "20069": 0,
    "20071": 0,
    "20073": 11,
    "20075": 0,
    "20077": 9,
    "20079": 11,
    "20081": 0,
    "20083": 0,
    "20085": 20,
    "20087": 23,
    "20089": 1,
    "20091": 18,
    "20093": 0,
    "20095": 9,
    "20097": 0,
    "20099": 13,
    "20101": 0,
    "20103": 18,
    "20105": 8,
    "20107": 15,
    "20109": 1,
    "20111": 21,
    "20113": 9,
    "20115": 10,
    "20117": 16,
    "20119": 0,
    "20121": 15,
    "20123": 1,
    "20125": 13,
    "20127": 21,
    "20129": 0,
    "20131": 17,
    "20133": 13,
    "20135": 0,
    "20137": 0,
    "20139": 21,
    "20141": 1,
    "20143": 18,
    "20145": 0,
    "20147": 1,
    "20149": 20,
    "20151": 0,
    "20153": 0,
    "20155": 10,
    "20157": 15,
    "20159": 8,
    "20161": 20,
    "20163": 1,
    "20165": 0,
    "20167": 7,
    "20169": 10,
    "20171": 0,
    "20173": 16,
    "20175": 0,
    "20177": 24,
    "20179": 0,
    "20181": 0,
    "20183": 1,
    "20185": 0,
    "20187": 0,
    "20189": 0,
    "20191": 12,
    "20193": 0,
    "20195": 0,
    "20197": 22,
    "20199": 0,
    "20201": 15,
    "20203": 0,
    "20205": 13,
    "20207": 11,
    "20209": 18,
    "21001": 0,
    "21003": 0,
    "21005": 0,
    "21007": 56,
    "21009": 0,
    "21011": 2,
    "21013": 1,
    "21015": 5,
    "21017": 0,
    "21019": 22,
    "21021": 0,
    "21023": 4,
    "21025": 4,
    "21027": 0,
    "21029": 0,
    "21031": 0,
    "21033": 47,
    "21035": 49,
    "21037": 5,
    "21039": 56,
    "21041": 4,
    "21043": 20,
    "21045": 0,
    "21047": 45,
    "21049": 0,
    "21051": 6,
    "21053": 0,
    "21055": 52,
    "21057": 0,
    "21059": 51,
    "21061": 0,
    "21063": 8,
    "21065": 7,
    "21067": 1,
    "21069": 6,
    "21071": 8,
    "21073": 0,
    "21075": 56,
    "21077": 4,
    "21079": 0,
    "21081": 4,
    "21083": 54,
    "21085": 0,
    "21087": 0,
    "21089": 20,
    "21091": 0,
    "21093": 0,
    "21095": 2,
    "21097": 0,
    "21099": 0,
    "21101": 51,
    "21103": 0,
    "21105": 56,
    "21107": 45,
    "21109": 1,
    "21111": 3,
    "21113": 0,
    "21115": 4,
    "21117": 5,
    "21119": 10,
    "21121": 7,
    "21123": 0,
    "21125": 6,
    "21127": 20,
    "21129": 7,
    "21131": 3,
    "21133": 2,
    "21135": 4,
    "21137": 0,
    "21139": 52,
    "21141": 0,
    "21143": 47,
    "21145": 55,
    "21147": 3,
    "21149": 45,
    "21151": 0,
    "21153": 2,
    "21155": 0,
    "21157": 50,
    "21159": 4,
    "21161": 4,
    "21163": 0,
    "21165": 2,
    "21167": 0,
    "21169": 0,
    "21171": 0,
    "21173": 7,
    "21175": 6,
    "21177": 44,
    "21179": 0,
    "21181": 0,
    "21183": 0,
    "21185": 0,
    "21187": 4,
    "21189": 7,
    "21191": 4,
    "21193": 10,
    "21195": 2,
    "21197": 6,
    "21199": 7,
    "21201": 4,
    "21203": 5,
    "21205": 8,
    "21207": 0,
    "21209": 0,
    "21211": 0,
    "21213": 0,
    "21215": 0,
    "21217": 0,
    "21219": 44,
    "21221": 45,
    "21223": 0,
    "21225": 52,
    "21227": 1,
    "21229": 0,
    "21231": 7,
    "21233": 47,
    "21235": 6,
    "21237": 5,
    "21239": 0,
    "22001": 2,
    "22003": 2,
    "22005": 0,
    "22007": 0,
    "22009": 2,
    "22011": 2,
    "22013": 21,
    "22015": 36,
    "22017": 32,
    "22019": 2,
    "22021": 21,
    "22023": 0,
    "22025": 4,
    "22027": 22,
    "22029": 4,
    "22031": 21,
    "22033": 0,
    "22035": 4,
    "22037": 0,
    "22039": 2,
    "22041": 4,
    "22043": 21,
    "22045": 3,
    "22047": 0,
    "22049": 21,
    "22051": 2,
    "22053": 2,
    "22055": 3,
    "22057": 0,
    "22059": 21,
    "22061": 22,
    "22063": 0,
    "22065": 4,
    "22067": 4,
    "22069": 21,
    "22071": 3,
    "22073": 24,
    "22075": 1,
    "22077": 0,
    "22079": 3,
    "22081": 20,
    "22083": 4,
    "22085": 19,
    "22087": 0,
    "22089": 0,
    "22091": 0,
    "22093": 0,
    "22095": 0,
    "22097": 2,
    "22099": 4,
    "22101": 2,
    "22103": 0,
    "22105": 0,
    "22107": 4,
    "22109": 2,
    "22111": 21,
    "22113": 2,
    "22115": 2,
    "22117": 0,
    "22119": 20,
    "22121": 0,
    "22123": 4,
    "22125": 0,
    "22127": 21,
    "23001": 2,
    "23003": 8,
    "23005": 4,
    "23007": 4,
    "23009": 7,
    "23011": 2,
    "23013": 2,
    "23015": 2,
    "23017": 4,
    "23019": 11,
    "23021": 7,
    "23023": 2,
    "23025": 6,
    "23027": 4,
    "23029": 9,
    "23031": 4,
    "24001": 7,
    "24003": 110,
    "24005": 177,
    "24009": 48,
    "24011": 75,
    "24013": 34,
    "24015": 154,
    "24017": 112,
    "24019": 4,
    "24021": 39,
    "24023": 0,
    "24025": 12,
    "24027": 13,
    "24029": 150,
    "24031": 17,
    "24033": 61,
    "24035": 150,
    "24037": 102,
    "24039": 3,
    "24041": 75,
    "24043": 35,
    "24045": 3,
    "24047": 6,
    "24510": 69,
    "25001": 2,
    "25003": 18,
    "25005": 5,
    "25007": 1,
    "25009": 6,
    "25011": 2,
    "25013": 4,
    "25015": 0,
    "25017": 4,
    "25019": 0,
    "25021": 49,
    "25023": 3,
    "25025": 21,
    "25027": 11,
    "26001": 2,
    "26003": 1,
    "26005": 0,
    "26007": 2,
    "26009": 2,
    "26011": 2,
    "26013": 1,
    "26015": 0,
    "26017": 13,
    "26019": 2,
    "26021": 0,
    "26023": 0,
    "26025": 0,
    "26027": 0,
    "26029": 0,
    "26031": 2,
    "26033": 0,
    "26035": 0,
    "26037": 1,
    "26039": 2,
    "26041": 0,
    "26043": 1,
    "26045": 0,
    "26047": 2,
    "26049": 13,
    "26051": 2,
    "26053": 1,
    "26055": 2,
    "26057": 1,
    "26059": 0,
    "26061": 2,
    "26063": 12,
    "26065": 0,
    "26067": 0,
    "26069": 2,
    "26071": 1,
    "26073": 1,
    "26075": 0,
    "26077": 0,
    "26079": 2,
    "26081": 1,
    "26083": 1,
    "26085": 0,
    "26087": 13,
    "26089": 2,
    "26091": 14,
    "26093": 14,
    "26095": 0,
    "26097": 0,
    "26099": 15,
    "26101": 2,
    "26103": 1,
    "26105": 0,
    "26107": 0,
    "26109": 1,
    "26111": 13,
    "26113": 2,
    "26115": 14,
    "26117": 0,
    "26119": 2,
    "26121": 0,
    "26123": 1,
    "26125": 17,
    "26127": 0,
    "26129": 2,
    "26131": 1,
    "26133": 0,
    "26135": 2,
    "26137": 2,
    "26139": 0,
    "26141": 2,
    "26143": 2,
    "26145": 13,
    "26147": 13,
    "26149": 0,
    "26151": 12,
    "26153": 0,
    "26155": 13,
    "26157": 13,
    "26159": 0,
    "26161": 14,
    "26163": 16,
    "26165": 2,
    "27001": 4,
    "27003": 9,
    "27005": 6,
    "27007": 2,
    "27009": 7,
    "27011": 3,
    "27013": 9,
    "27015": 9,
    "27017": 3,
    "27019": 9,
    "27021": 3,
    "27023": 9,
    "27025": 8,
    "27027": 2,
    "27029": 3,
    "27031": 0,
    "27033": 7,
    "27035": 2,
    "27037": 9,
    "27039": 9,
    "27041": 7,
    "27043": 9,
    "27045": 8,
    "27047": 9,
    "27049": 9,
    "27051": 3,
    "27053": 12,
    "27055": 9,
    "27057": 2,
    "27059": 8,
    "27061": 1,
    "27063": 7,
    "27065": 7,
    "27067": 9,
    "27069": 1,
    "27071": 0,
    "27073": 9,
    "27075": 1,
    "27077": 1,
    "27079": 9,
    "27081": 7,
    "27083": 7,
    "27085": 9,
    "27087": 3,
    "27089": 2,
    "27091": 9,
    "27093": 9,
    "27095": 7,
    "27097": 7,
    "27099": 8,
    "27101": 7,
    "27103": 9,
    "27105": 7,
    "27107": 2,
    "27109": 10,
    "27111": 6,
    "27113": 1,
    "27115": 2,
    "27117": 7,
    "27119": 4,
    "27121": 8,
    "27123": 10,
    "27125": 2,
    "27127": 9,
    "27129": 9,
    "27131": 9,
    "27133": 7,
    "27135": 1,
    "27137": 4,
    "27139": 9,
    "27141": 8,
    "27143": 9,
    "27145": 8,
    "27147": 9,
    "27149": 8,
    "27151": 9,
    "27153": 7,
    "27155": 3,
    "27157": 9,
    "27159": 2,
    "27161": 9,
    "27163": 9,
    "27165": 9,
    "27167": 2,
    "27169": 9,
    "27171": 9,
    "27173": 9,
    "28001": 5,
    "28003": 20,
    "28005": 0,
    "28007": 5,
    "28009": 22,
    "28011": 5,
    "28013": 21,
    "28015": 5,
    "28017": 20,
    "28019": 5,
    "28021": 5,
    "28023": 5,
    "28025": 5,
    "28027": 36,
    "28029": 7,
    "28031": 5,
    "28033": 34,
    "28035": 4,
    "28037": 4,
    "28039": 2,
    "28041": 2,
    "28043": 5,
    "28045": 0,
    "28047": 1,
    "28049": 7,
    "28051": 5,
    "28053": 5,
    "28055": 5,
    "28057": 22,
    "28059": 3,
    "28061": 5,
    "28063": 4,
    "28065": 5,
    "28067": 6,
    "28069": 5,
    "28071": 23,
    "28073": 4,
    "28075": 5,
    "28077": 4,
    "28079": 5,
    "28081": 24,
    "28083": 6,
    "28085": 4,
    "28087": 5,
    "28089": 6,
    "28091": 4,
    "28093": 24,
    "28095": 21,
    "28097": 5,
    "28099": 5,
    "28101": 5,
    "28103": 5,
    "28105": 5,
    "28107": 31,
    "28109": 0,
    "28111": 2,
    "28113": 0,
    "28115": 21,
    "28117": 20,
    "28119": 29,
    "28121": 5,
    "28123": 5,
    "28125": 5,
    "28127": 5,
    "28129": 5,
    "28131": 2,
    "28133": 6,
    "28135": 29,
    "28137": 29,
    "28139": 21,
    "28141": 21,
    "28143": 30,
    "28145": 20,
    "28147": 0,
    "28149": 5,
    "28151": 7,
    "28153": 2,
    "28155": 5,
    "28157": 0,
    "28159": 5,
    "28161": 24,
    "28163": 6,
    "29001": 13,
    "29003": 14,
    "29005": 14,
    "29007": 47,
    "29009": 9,
    "29011": 9,
    "29013": 16,
    "29015": 9,
    "29017": 54,
    "29019": 54,
    "29021": 15,
    "29023": 63,
    "29025": 15,
    "29027": 54,
    "29029": 9,
    "29031": 57,
    "29033": 15,
    "29035": 55,
    "29037": 17,
    "29039": 9,
    "29041": 15,
    "29043": 9,
    "29045": 4,
    "29047": 21,
    "29049": 15,
    "29051": 50,
    "29053": 14,
    "29055": 53,
    "29057": 9,
    "29059": 9,
    "29061": 13,
    "29063": 14,
    "29065": 9,
    "29067": 9,
    "29069": 32,
    "29071": 57,
    "29073": 52,
    "29075": 14,
    "29077": 13,
    "29079": 13,
    "29081": 14,
    "29083": 15,
    "29085": 9,
    "29087": 14,
    "29089": 14,
    "29091": 10,
    "29093": 49,
    "29095": 31,
    "29097": 11,
    "29099": 60,
    "29101": 15,
    "29103": 38,
    "29105": 9,
    "29107": 15,
    "29109": 10,
    "29111": 39,
    "29113": 52,
    "29115": 13,
    "29117": 13,
    "29119": 9,
    "29121": 13,
    "29123": 48,
    "29125": 9,
    "29127": 41,
    "29129": 13,
    "29131": 9,
    "29133": 58,
    "29135": 50,
    "29137": 41,
    "29139": 53,
    "29141": 9,
    "29143": 62,
    "29145": 9,
    "29147": 14,
    "29149": 9,
    "29151": 50,
    "29153": 9,
    "29155": 31,
    "29157": 52,
    "29159": 15,
    "29161": 9,
    "29163": 41,
    "29165": 22,
    "29167": 9,
    "29169": 9,
    "29171": 13,
    "29173": 40,
    "29175": 14,
    "29177": 14,
    "29179": 47,
    "29181": 60,
    "29183": 73,
    "29185": 9,
    "29186": 51,
    "29187": 53,
    "29189": 89,
    "29195": 14,
    "29197": 13,
    "29199": 4,
    "29201": 60,
    "29203": 9,
    "29205": 39,
    "29207": 61,
    "29209": 9,
    "29211": 13,
    "29213": 9,
    "29215": 9,
    "29217": 10,
    "29219": 51,
    "29221": 50,
    "29223": 55,
    "29225": 9,
    "29227": 13,
    "29229": 9,
    "29510": 100,
    "30001": 0,
    "30003": 1,
    "30005": 0,
    "30007": 0,
    "30009": 0,
    "30011": 0,
    "30013": 0,
    "30015": 0,
    "30017": 0,
    "30019": 3,
    "30021": 5,
    "30023": 0,
    "30025": 0,
    "30027": 0,
    "30029": 3,
    "30031": 0,
    "30033": 4,
    "30035": 0,
    "30037": 0,
    "30039": 1,
    "30041": 0,
    "30043": 0,
    "30045": 0,
    "30047": 3,
    "30049": 0,
    "30051": 0,
    "30053": 1,
    "30055": 3,
    "30057": 0,
    "30059": 0,
    "30061": 1,
    "30063": 3,
    "30065": 0,
    "30067": 0,
    "30069": 2,
    "30071": 7,
    "30073": 0,
    "30075": 0,
    "30077": 1,
    "30079": 3,
    "30081": 1,
    "30083": 3,
    "30085": 5,
    "30087": 0,
    "30089": 3,
    "30091": 2,
    "30093": 0,
    "30095": 0,
    "30097": 0,
    "30099": 0,
    "30101": 0,
    "30103": 0,
    "30105": 5,
    "30107": 0,
    "30109": 3,
    "30111": 0,
    "31001": 1,
    "31003": 8,
    "31005": 0,
    "31007": 0,
    "31009": 1,
    "31011": 8,
    "31013": 0,
    "31015": 1,
    "31017": 1,
    "31019": 1,
    "31021": 17,
    "31023": 17,
    "31025": 21,
    "31027": 8,
    "31029": 1,
    "31031": 1,
    "31033": 0,
    "31035": 2,
    "31037": 12,
    "31039": 11,
    "31041": 1,
    "31043": 10,
    "31045": 0,
    "31047": 2,
    "31049": 0,
    "31051": 12,
    "31053": 18,
    "31055": 19,
    "31057": 0,
    "31059": 2,
    "31061": 1,
    "31063": 1,
    "31065": 1,
    "31067": 20,
    "31069": 0,
    "31071": 1,
    "31073": 1,
    "31075": 0,
    "31077": 1,
    "31079": 2,
    "31081": 2,
    "31083": 1,
    "31085": 1,
    "31087": 0,
    "31089": 1,
    "31091": 0,
    "31093": 1,
    "31095": 19,
    "31097": 19,
    "31099": 1,
    "31101": 0,
    "31103": 1,
    "31105": 0,
    "31107": 8,
    "31109": 18,
    "31111": 1,
    "31113": 1,
    "31115": 1,
    "31117": 0,
    "31119": 9,
    "31121": 1,
    "31123": 0,
    "31125": 1,
    "31127": 19,
    "31129": 1,
    "31131": 19,
    "31133": 19,
    "31135": 0,
    "31137": 1,
    "31139": 8,
    "31141": 11,
    "31143": 2,
    "31145": 0,
    "31147": 19,
    "31149": 1,
    "31151": 17,
    "31153": 19,
    "31155": 17,
    "31157": 0,
    "31159": 16,
    "31161": 0,
    "31163": 1,
    "31165": 0,
    "31167": 9,
    "31169": 1,
    "31171": 1,
    "31173": 9,
    "31175": 1,
    "31177": 17,
    "31179": 9,
    "31181": 1,
    "31183": 1,
    "31185": 2,
    "32001": 2,
    "32003": 145,
    "32005": 2,
    "32007": 0,
    "32009": 0,
    "32011": 0,
    "32013": 0,
    "32015": 0,
    "32017": 0,
    "32019": 5,
    "32021": 1,
    "32023": 0,
    "32027": 2,
    "32029": 2,
    "32031": 4,
    "32033": 0,
    "32510": 2,
    "33001": 2,
    "33003": 4,
    "33005": 0,
    "33007": 4,
    "33009": 4,
    "33011": 3,
    "33013": 2,
    "33015": 4,
    "33017": 2,
    "33019": 2,
    "34001": 129,
    "34003": 6,
    "34005": 123,
    "34007": 87,
    "34009": 117,
    "34011": 84,
    "34013": 10,
    "34015": 85,
    "34017": 6,
    "34019": 71,
    "34021": 84,
    "34023": 78,
    "34025": 133,
    "34027": 65,
    "34029": 137,
    "34031": 14,
    "34033": 82,
    "34035": 77,
    "34037": 51,
    "34039": 13,
    "34041": 54,
    "35001": 5,
    "35003": 1,
    "35005": 2,
    "35006": 2,
    "35007": 1,
    "35009": 1,
    "35011": 0,
    "35013": 0,
    "35015": 0,
    "35017": 0,
    "35019": 0,
    "35021": 0,
    "35023": 0,
    "35025": 0,
    "35027": 1,
    "35028": 0,
    "35029": 0,
    "35031": 2,
    "35033": 1,
    "35035": 0,
    "35037": 1,
    "35039": 1,
    "35041": 2,
    "35043": 5,
    "35045": 3,
    "35047": 2,
    "35049": 1,
    "35051": 0,
    "35053": 2,
    "35055": 0,
    "35057": 6,
    "35059": 1,
    "35061": 6,
    "36001": 38,
    "36003": 0,
    "36005": 9,
    "36007": 5,
    "36009": 0,
    "36011": 4,
    "36013": 0,
    "36015": 4,
    "36017": 4,
    "36019": 6,
    "36021": 39,
    "36023": 4,
    "36025": 4,
    "36027": 52,
    "36029": 1,
    "36031": 6,
    "36033": 6,
    "36035": 18,
    "36037": 0,
    "36039": 33,
    "36041": 6,
    "36043": 22,
    "36045": 0,
    "36047": 8,
    "36049": 0,
    "36051": 0,
    "36053": 4,
    "36055": 0,
    "36057": 15,
    "36059": 8,
    "36061": 11,
    "36063": 0,
    "36065": 8,
    "36067": 5,
    "36069": 0,
    "36071": 11,
    "36073": 0,
    "36075": 0,
    "36077": 4,
    "36079": 10,
    "36081": 16,
    "36083": 34,
    "36085": 9,
    "36087": 7,
    "36089": 14,
    "36091": 41,
    "36093": 35,
    "36095": 9,
    "36097": 4,
    "36099": 4,
    "36101": 4,
    "36103": 26,
    "36105": 4,
    "36107": 4,
    "36109": 4,
    "36111": 39,
    "36113": 19,
    "36115": 25,
    "36117": 0,
    "36119": 14,
    "36121": 0,
    "36123": 4,
    "37001": 1,
    "37003": 2,
    "37005": 1,
    "37007": 1,
    "37009": 0,
    "37011": 0,
    "37013": 0,
    "37015": 3,
    "37017": 4,
    "37019": 10,
    "37021": 0,
    "37023": 0,
    "37025": 3,
    "37027": 0,
    "37029": 3,
    "37031": 0,
    "37033": 0,
    "37035": 2,
    "37037": 1,
    "37039": 0,
    "37041": 4,
    "37043": 0,
    "37045": 2,
    "37047": 5,
    "37049": 0,
    "37051": 2,
    "37053": 6,
    "37055": 0,
    "37057": 1,
    "37059": 2,
    "37061": 0,
    "37063": 1,
    "37065": 2,
    "37067": 1,
    "37069": 1,
    "37071": 2,
    "37073": 3,
    "37075": 0,
    "37077": 1,
    "37079": 0,
    "37081": 2,
    "37083": 1,
    "37085": 2,
    "37087": 0,
    "37089": 0,
    "37091": 3,
    "37093": 1,
    "37095": 0,
    "37097": 2,
    "37099": 0,
    "37101": 2,
    "37103": 0,
    "37105": 1,
    "37107": 0,
    "37109": 3,
    "37111": 0,
    "37113": 0,
    "37115": 0,
    "37117": 0,
    "37119": 4,
    "37121": 0,
    "37123": 1,
    "37125": 1,
    "37127": 1,
    "37129": 10,
    "37131": 3,
    "37133": 0,
    "37135": 1,
    "37137": 0,
    "37139": 3,
    "37141": 7,
    "37143": 3,
    "37145": 2,
    "37147": 2,
    "37149": 0,
    "37151": 1,
    "37153": 1,
    "37155": 5,
    "37157": 0,
    "37159": 2,
    "37161": 0,
    "37163": 1,
    "37165": 2,
    "37167": 1,
    "37169": 0,
    "37171": 0,
    "37173": 0,
    "37175": 0,
    "37177": 0,
    "37179": 3,
    "37181": 1,
    "37183": 2,
    "37185": 1,
    "37187": 0,
    "37189": 0,
    "37191": 1,
    "37193": 0,
    "37195": 1,
    "37197": 1,
    "37199": 0,
    "38001": 1,
    "38003": 3,
    "38005": 1,
    "38007": 1,
    "38009": 1,
    "38011": 1,
    "38013": 1,
    "38015": 4,
    "38017": 3,
    "38019": 1,
    "38021": 2,
    "38023": 1,
    "38025": 1,
    "38027": 2,
    "38029": 1,
    "38031": 2,
    "38033": 1,
    "38035": 2,
    "38037": 1,
    "38039": 3,
    "38041": 1,
    "38043": 1,
    "38045": 2,
    "38047": 2,
    "38049": 1,
    "38051": 2,
    "38053": 1,
    "38055": 1,
    "38057": 1,
    "38059": 1,
    "38061": 1,
    "38063": 2,
    "38065": 1,
    "38067": 1,
    "38069": 1,
    "38071": 1,
    "38073": 3,
    "38075": 1,
    "38077": 3,
    "38079": 1,
    "38081": 3,
    "38083": 1,
    "38085": 1,
    "38087": 1,
    "38089": 1,
    "38091": 3,
    "38093": 2,
    "38095": 1,
    "38097": 3,
    "38099": 2,
    "38101": 1,
    "38103": 1,
    "38105": 1,
    "39001": 4,
    "39003": 0,
    "39005": 2,
    "39007": 2,
    "39009": 18,
    "39011": 3,
    "39013": 0,
    "39015": 4,
    "39017": 5,
    "39019": 0,
    "39021": 3,
    "39023": 3,
    "39025": 5,
    "39027": 4,
    "39029": 0,
    "39031": 0,
    "39033": 2,
    "39035": 2,
    "39037": 3,
    "39039": 0,
    "39041": 3,
    "39043": 2,
    "39045": 3,
    "39047": 3,
    "39049": 3,
    "39051": 1,
    "39053": 19,
    "39055": 2,
    "39057": 3,
    "39059": 0,
    "39061": 5,
    "39063": 2,
    "39065": 3,
    "39067": 0,
    "39069": 2,
    "39071": 4,
    "39073": 3,
    "39075": 2,
    "39077": 2,
    "39079": 18,
    "39081": 0,
    "39083": 2,
    "39085": 2,
    "39087": 19,
    "39089": 3,
    "39091": 3,
    "39093": 2,
    "39095": 2,
    "39097": 3,
    "39099": 2,
    "39101": 2,
    "39103": 2,
    "39105": 18,
    "39107": 3,
    "39109": 3,
    "39111": 0,
    "39113": 5,
    "39115": 18,
    "39117": 2,
    "39119": 0,
    "39121": 0,
    "39123": 2,
    "39125": 0,
    "39127": 18,
    "39129": 3,
    "39131": 4,
    "39133": 2,
    "39135": 3,
    "39137": 0,
    "39139": 2,
    "39141": 3,
    "39143": 2,
    "39145": 4,
    "39147": 2,
    "39149": 3,
    "39151": 2,
    "39153": 2,
    "39155": 2,
    "39157": 0,
    "39159": 3,
    "39161": 0,
    "39163": 18,
    "39165": 5,
    "39167": 19,
    "39169": 2,
    "39171": 0,
    "39173": 2,
    "39175": 2,
    "40001": 12,
    "40003": 3,
    "40005": 3,
    "40007": 0,
    "40009": 3,
    "40011": 3,
    "40013": 3,
    "40015": 4,
    "40017": 5,
    "40019": 6,
    "40021": 17,
    "40023": 17,
    "40025": 0,
    "40027": 6,
    "40029": 3,
    "40031": 5,
    "40033": 4,
    "40035": 25,
    "40037": 27,
    "40039": 3,
    "40041": 16,
    "40043": 3,
    "40045": 3,
    "40047": 3,
    "40049": 4,
    "40051": 4,
    "40053": 3,
    "40055": 3,
    "40057": 3,
    "40059": 3,
    "40061": 24,
    "40063": 3,
    "40065": 6,
    "40067": 3,
    "40069": 3,
    "40071": 4,
    "40073": 3,
    "40075": 5,
    "40077": 18,
    "40079": 22,
    "40081": 4,
    "40083": 6,
    "40085": 3,
    "40087": 4,
    "40089": 19,
    "40091": 25,
    "40093": 3,
    "40095": 4,
    "40097": 23,
    "40099": 4,
    "40101": 26,
    "40103": 3,
    "40105": 24,
    "40107": 25,
    "40109": 40,
    "40111": 24,
    "40113": 28,
    "40115": 20,
    "40117": 27,
    "40119": 5,
    "40121": 32,
    "40123": 3,
    "40125": 4,
    "40127": 15,
    "40129": 3,
    "40131": 26,
    "40133": 5,
    "40135": 25,
    "40137": 5,
    "40139": 0,
    "40141": 4,
    "40143": 56,
    "40145": 27,
    "40147": 27,
    "40149": 3,
    "40151": 3,
    "40153": 4,
    "41001": 0,
    "41003": 6,
    "41005": 25,
    "41007": 4,
    "41009": 16,
    "41011": 1,
    "41013": 2,
    "41015": 2,
    "41017": 2,
    "41019": 3,
    "41021": 4,
    "41023": 5,
    "41025": 0,
    "41027": 2,
    "41029": 4,
    "41031": 4,
    "41033": 3,
    "41035": 3,
    "41037": 0,
    "41039": 11,
    "41041": 3,
    "41043": 7,
    "41045": 0,
    "41047": 12,
    "41049": 9,
    "41051": 16,
    "41053": 11,
    "41055": 3,
    "41057": 4,
    "41059": 8,
    "41061": 8,
    "41063": 4,
    "41065": 5,
    "41067": 14,
    "41069": 5,
    "41071": 10,
    "42001": 8,
    "42003": 0,
    "42005": 0,
    "42007": 0,
    "42009": 2,
    "42011": 65,
    "42013": 2,
    "42015": 4,
    "42017": 16,
    "42019": 0,
    "42021": 0,
    "42023": 0,
    "42025": 35,
    "42027": 2,
    "42029": 15,
    "42031": 0,
    "42033": 0,
    "42035": 3,
    "42037": 3,
    "42039": 1,
    "42041": 8,
    "42043": 9,
    "42045": 89,
    "42047": 0,
    "42049": 2,
    "42051": 0,
    "42053": 0,
    "42055": 5,
    "42057": 2,
    "42059": 0,
    "42061": 2,
    "42063": 0,
    "42065": 0,
    "42067": 3,
    "42069": 4,
    "42071": 9,
    "42073": 0,
    "42075": 9,
    "42077": 66,
    "42079": 5,
    "42081": 3,
    "42083": 0,
    "42085": 0,
    "42087": 3,
    "42089": 35,
    "42091": 15,
    "42093": 3,
    "42095": 63,
    "42097": 3,
    "42099": 6,
    "42101": 122,
    "42103": 4,
    "42105": 0,
    "42107": 3,
    "42109": 3,
    "42111": 0,
    "42113": 0,
    "42115": 4,
    "42117": 0,
    "42119": 3,
    "42121": 0,
    "42123": 0,
    "42125": 0,
    "42127": 7,
    "42129": 0,
    "42131": 4,
    "42133": 9,
    "44001": 0,
    "44003": 21,
    "44005": 2,
    "44007": 8,
    "44009": 3,
    "45001": 3,
    "45003": 0,
    "45005": 6,
    "45007": 6,
    "45009": 0,
    "45011": 0,
    "45013": 40,
    "45015": 10,
    "45017": 0,
    "45019": 23,
    "45021": 2,
    "45023": 4,
    "45025": 1,
    "45027": 2,
    "45029": 13,
    "45031": 5,
    "45033": 3,
    "45035": 7,
    "45037": 0,
    "45039": 1,
    "45041": 4,
    "45043": 7,
    "45045": 4,
    "45047": 3,
    "45049": 5,
    "45051": 3,
    "45053": 7,
    "45055": 1,
    "45057": 0,
    "45059": 3,
    "45061": 0,
    "45063": 0,
    "45065": 0,
    "45067": 4,
    "45069": 4,
    "45071": 0,
    "45073": 3,
    "45075": 0,
    "45077": 2,
    "45079": 2,
    "45081": 0,
    "45083": 3,
    "45085": 0,
    "45087": 4,
    "45089": 4,
    "45091": 5,
    "46003": 11,
    "46005": 10,
    "46007": 1,
    "46009": 10,
    "46011": 6,
    "46013": 5,
    "46015": 11,
    "46017": 4,
    "46019": 1,
    "46021": 4,
    "46023": 11,
    "46025": 4,
    "46027": 10,
    "46029": 3,
    "46031": 4,
    "46033": 2,
    "46035": 11,
    "46037": 5,
    "46039": 3,
    "46041": 4,
    "46043": 11,
    "46045": 4,
    "46047": 2,
    "46049": 4,
    "46051": 3,
    "46053": 10,
    "46055": 1,
    "46057": 3,
    "46059": 4,
    "46061": 10,
    "46063": 1,
    "46065": 4,
    "46067": 10,
    "46069": 4,
    "46071": 1,
    "46073": 11,
    "46075": 4,
    "46077": 7,
    "46079": 7,
    "46081": 1,
    "46083": 9,
    "46085": 4,
    "46087": 8,
    "46089": 4,
    "46091": 5,
    "46093": 3,
    "46095": 1,
    "46097": 8,
    "46099": 9,
    "46101": 6,
    "46103": 2,
    "46105": 1,
    "46107": 4,
    "46109": 3,
    "46111": 11,
    "46113": 0,
    "46115": 5,
    "46117": 4,
    "46119": 4,
    "46121": 1,
    "46123": 1,
    "46125": 9,
    "46127": 10,
    "46129": 4,
    "46135": 10,
    "46137": 1,
    "47001": 0,
    "47003": 1,
    "47005": 7,
    "47007": 0,
    "47009": 1,
    "47011": 0,
    "47013": 0,
    "47015": 0,
    "47017": 20,
    "47019": 0,
    "47021": 1,
    "47023": 22,
    "47025": 0,
    "47027": 0,
    "47029": 0,
    "47031": 1,
    "47033": 26,
    "47035": 0,
    "47037": 2,
    "47039": 20,
    "47041": 0,
    "47043": 1,
    "47045": 28,
    "47047": 25,
    "47049": 0,
    "47051": 7,
    "47053": 23,
    "47055": 1,
    "47057": 0,
    "47059": 0,
    "47061": 0,
    "47063": 0,
    "47065": 1,
    "47067": 0,
    "47069": 24,
    "47071": 21,
    "47073": 0,
    "47075": 26,
    "47077": 20,
    "47079": 19,
    "47081": 1,
    "47083": 1,
    "47085": 1,
    "47087": 0,
    "47089": 0,
    "47091": 0,
    "47093": 2,
    "47095": 29,
    "47097": 32,
    "47099": 1,
    "47101": 1,
    "47103": 12,
    "47105": 0,
    "47107": 0,
    "47109": 21,
    "47111": 0,
    "47113": 28,
    "47115": 0,
    "47117": 1,
    "47119": 1,
    "47121": 0,
    "47123": 0,
    "47125": 1,
    "47127": 10,
    "47129": 0,
    "47131": 27,
    "47133": 0,
    "47135": 1,
    "47137": 0,
    "47139": 0,
    "47141": 0,
    "47143": 0,
    "47145": 0,
    "47147": 1,
    "47149": 3,
    "47151": 0,
    "47153": 0,
    "47155": 0,
    "47157": 48,
    "47159": 0,
    "47161": 1,
    "47163": 1,
    "47165": 1,
    "47167": 34,
    "47169": 0,
    "47171": 0,
    "47173": 0,
    "47175": 0,
    "47177": 0,
    "47179": 0,
    "47181": 1,
    "47183": 21,
    "47185": 0,
    "47187": 1,
    "47189": 2,
    "48001": 6,
    "48003": 0,
    "48005": 24,
    "48007": 1,
    "48009": 1,
    "48011": 1,
    "48013": 1,
    "48015": 6,
    "48017": 1,
    "48019": 1,
    "48021": 1,
    "48023": 1,
    "48025": 1,
    "48027": 8,
    "48029": 5,
    "48031": 2,
    "48033": 0,
    "48035": 5,
    "48037": 18,
    "48039": 6,
    "48041": 6,
    "48043": 0,
    "48045": 2,
    "48047": 0,
    "48049": 0,
    "48051": 6,
    "48053": 2,
    "48055": 1,
    "48057": 0,
    "48059": 0,
    "48061": 5,
    "48063": 15,
    "48065": 0,
    "48067": 18,
    "48069": 1,
    "48071": 7,
    "48073": 16,
    "48075": 1,
    "48077": 1,
    "48079": 0,
    "48081": 0,
    "48083": 0,
    "48085": 11,
    "48087": 0,
    "48089": 6,
    "48091": 3,
    "48093": 5,
    "48095": 0,
    "48097": 6,
    "48099": 6,
    "48101": 1,
    "48103": 0,
    "48105": 0,
    "48107": 2,
    "48109": 0,
    "48111": 0,
    "48113": 31,
    "48115": 0,
    "48117": 0,
    "48119": 6,
    "48121": 9,
    "48123": 0,
    "48125": 1,
    "48127": 3,
    "48129": 0,
    "48131": 2,
    "48133": 5,
    "48135": 0,
    "48137": 1,
    "48139": 6,
    "48141": 0,
    "48143": 5,
    "48145": 6,
    "48147": 7,
    "48149": 0,
    "48151": 0,
    "48153": 1,
    "48155": 1,
    "48157": 8,
    "48159": 15,
    "48161": 6,
    "48163": 1,
    "48165": 0,
    "48167": 7,
    "48169": 2,
    "48171": 1,
    "48173": 0,
    "48175": 1,
    "48177": 0,
    "48179": 0,
    "48181": 6,
    "48183": 18,
    "48185": 6,
    "48187": 3,
    "48189": 1,
    "48191": 2,
    "48193": 5,
    "48195": 0,
    "48197": 1,
    "48199": 2,
    "48201": 66,
    "48203": 20,
    "48205": 0,
    "48207": 4,
    "48209": 1,
    "48211": 0,
    "48213": 6,
    "48215": 4,
    "48217": 7,
    "48219": 2,
    "48221": 6,
    "48223": 6,
    "48225": 7,
    "48227": 0,
    "48229": 0,
    "48231": 8,
    "48233": 0,
    "48235": 0,
    "48237": 7,
    "48239": 6,
    "48241": 0,
    "48243": 0,
    "48245": 2,
    "48247": 0,
    "48249": 1,
    "48251": 9,
    "48253": 0,
    "48255": 0,
    "48257": 7,
    "48259": 1,
    "48261": 0,
    "48263": 1,
    "48265": 2,
    "48267": 0,
    "48269": 1,
    "48271": 0,
    "48273": 2,
    "48275": 1,
    "48277": 7,
    "48279": 1,
    "48281": 5,
    "48283": 1,
    "48285": 0,
    "48287": 1,
    "48289": 5,
    "48291": 6,
    "48293": 6,
    "48295": 0,
    "48297": 1,
    "48299": 1,
    "48301": 0,
    "48303": 2,
    "48305": 0,
    "48307": 0,
    "48309": 7,
    "48311": 1,
    "48313": 6,
    "48315": 18,
    "48317": 0,
    "48319": 0,
    "48321": 6,
    "48323": 4,
    "48325": 1,
    "48327": 0,
    "48329": 0,
    "48331": 5,
    "48333": 5,
    "48335": 0,
    "48337": 7,
    "48339": 8,
    "48341": 0,
    "48343": 15,
    "48345": 2,
    "48347": 19,
    "48349": 7,
    "48351": 0,
    "48353": 0,
    "48355": 5,
    "48357": 0,
    "48359": 0,
    "48361": 2,
    "48363": 6,
    "48365": 21,
    "48367": 7,
    "48369": 1,
    "48371": 0,
    "48373": 6,
    "48375": 0,
    "48377": 0,
    "48379": 6,
    "48381": 3,
    "48383": 0,
    "48385": 1,
    "48387": 15,
    "48389": 0,
    "48391": 1,
    "48393": 0,
    "48395": 5,
    "48397": 7,
    "48399": 0,
    "48401": 18,
    "48403": 21,
    "48405": 21,
    "48407": 6,
    "48409": 1,
    "48411": 0,
    "48413": 0,
    "48415": 0,
    "48417": 0,
    "48419": 21,
    "48421": 0,
    "48423": 18,
    "48425": 6,
    "48427": 4,
    "48429": 5,
    "48431": 0,
    "48433": 1,
    "48435": 0,
    "48437": 1,
    "48439": 16,
    "48441": 0,
    "48443": 0,
    "48445": 2,
    "48447": 4,
    "48449": 15,
    "48451": 0,
    "48453": 14,
    "48455": 6,
    "48457": 2,
    "48459": 16,
    "48461": 0,
    "48463": 2,
    "48465": 2,
    "48467": 6,
    "48469": 2,
    "48471": 6,
    "48473": 6,
    "48475": 0,
    "48477": 6,
    "48479": 1,
    "48481": 6,
    "48483": 0,
    "48485": 6,
    "48487": 2,
    "48489": 0,
    "48491": 2,
    "48493": 0,
    "48495": 0,
    "48497": 6,
    "48499": 17,
    "48501": 0,
    "48503": 6,
    "48505": 4,
    "48507": 0,
    "49001": 0,
    "49003": 0,
    "49005": 0,
    "49007": 0,
    "49009": 0,
    "49011": 0,
    "49013": 0,
    "49015": 1,
    "49017": 4,
    "49019": 0,
    "49021": 0,
    "49023": 0,
    "49025": 3,
    "49027": 0,
    "49029": 0,
    "49031": 0,
    "49033": 0,
    "49035": 0,
    "49037": 1,
    "49039": 0,
    "49041": 1,
    "49043": 0,
    "49045": 0,
    "49047": 0,
    "49049": 0,
    "49051": 0,
    "49053": 2,
    "49055": 1,
    "49057": 0,
    "50001": 9,
    "50003": 10,
    "50005": 7,
    "50007": 11,
    "50009": 3,
    "50011": 7,
    "50013": 4,
    "50015": 4,
    "50017": 5,
    "50019": 3,
    "50021": 9,
    "50023": 7,
    "50025": 14,
    "50027": 5,
    "51001": 3,
    "51003": 0,
    "51005": 0,
    "51007": 3,
    "51009": 0,
    "51011": 0,
    "51013": 53,
    "51015": 0,
    "51017": 0,
    "51019": 1,
    "51021": 0,
    "51023": 0,
    "51025": 3,
    "51027": 15,
    "51029": 0,
    "51031": 0,
    "51033": 3,
    "51035": 0,
    "51036": 6,
    "51037": 0,
    "51041": 0,
    "51043": 31,
    "51045": 0,
    "51047": 48,
    "51049": 3,
    "51051": 15,
    "51053": 3,
    "51057": 0,
    "51059": 51,
    "51061": 29,
    "51063": 0,
    "51065": 3,
    "51067": 2,
    "51069": 29,
    "51071": 0,
    "51073": 6,
    "51075": 3,
    "51077": 0,
    "51079": 33,
    "51081": 3,
    "51083": 1,
    "51085": 0,
    "51087": 0,
    "51089": 1,
    "51091": 0,
    "51093": 3,
    "51095": 6,
    "51097": 0,
    "51099": 57,
    "51101": 0,
    "51103": 6,
    "51105": 0,
    "51107": 8,
    "51109": 0,
    "51111": 3,
    "51113": 29,
    "51115": 6,
    "51117": 3,
    "51119": 6,
    "51121": 0,
    "51125": 30,
    "51127": 2,
    "51131": 3,
    "51133": 3,
    "51135": 3,
    "51137": 46,
    "51139": 25,
    "51141": 0,
    "51143": 1,
    "51145": 3,
    "51147": 3,
    "51149": 3,
    "51153": 58,
    "51155": 0,
    "51157": 31,
    "51159": 6,
    "51161": 1,
    "51163": 0,
    "51165": 23,
    "51167": 0,
    "51169": 0,
    "51171": 26,
    "51173": 0,
    "51175": 3,
    "51177": 59,
    "51179": 59,
    "51181": 3,
    "51183": 3,
    "51185": 0,
    "51187": 28,
    "51191": 0,
    "51193": 6,
    "51195": 0,
    "51197": 0,
    "51199": 0,
    "51510": 53,
    "51515": 0,
    "51520": 0,
    "51530": 0,
    "51540": 37,
    "51550": 3,
    "51570": 1,
    "51580": 0,
    "51590": 1,
    "51595": 3,
    "51600": 51,
    "51610": 53,
    "51620": 3,
    "51630": 59,
    "51640": 0,
    "51650": 0,
    "51660": 23,
    "51670": 3,
    "51678": 0,
    "51680": 0,
    "51683": 58,
    "51685": 58,
    "51690": 1,
    "51700": 0,
    "51710": 6,
    "51720": 0,
    "51730": 3,
    "51735": 0,
    "51740": 6,
    "51750": 0,
    "51760": 0,
    "51770": 1,
    "51775": 1,
    "51790": 25,
    "51800": 6,
    "51810": 3,
    "51820": 25,
    "51830": 3,
    "51840": 29,
    "53001": 0,
    "53003": 0,
    "53005": 5,
    "53007": 0,
    "53009": 0,
    "53011": 9,
    "53013": 7,
    "53015": 6,
    "53017": 0,
    "53019": 0,
    "53021": 5,
    "53023": 0,
    "53025": 0,
    "53027": 0,
    "53029": 0,
    "53031": 0,
    "53033": 1,
    "53035": 0,
    "53037": 4,
    "53039": 9,
    "53041": 1,
    "53043": 0,
    "53045": 0,
    "53047": 0,
    "53049": 2,
    "53051": 0,
    "53053": 1,
    "53055": 0,
    "53057": 0,
    "53059": 3,
    "53061": 0,
    "53063": 0,
    "53065": 0,
    "53067": 1,
    "53069": 4,
    "53071": 12,
    "53073": 2,
    "53075": 0,
    "53077": 9,
    "54001": 19,
    "54003": 31,
    "54005": 20,
    "54007": 20,
    "54009": 0,
    "54011": 21,
    "54013": 19,
    "54015": 20,
    "54017": 19,
    "54019": 0,
    "54021": 19,
    "54023": 4,
    "54025": 0,
    "54027": 20,
    "54029": 0,
    "54031": 19,
    "54033": 19,
    "54035": 20,
    "54037": 31,
    "54039": 20,
    "54041": 19,
    "54043": 21,
    "54045": 20,
    "54047": 19,
    "54049": 0,
    "54051": 0,
    "54053": 21,
    "54055": 0,
    "54057": 6,
    "54059": 20,
    "54061": 0,
    "54063": 0,
    "54065": 30,
    "54067": 0,
    "54069": 0,
    "54071": 0,
    "54073": 19,
    "54075": 0,
    "54077": 0,
    "54079": 21,
    "54081": 0,
    "54083": 0,
    "54085": 19,
    "54087": 20,
    "54089": 0,
    "54091": 19,
    "54093": 0,
    "54095": 20,
    "54097": 17,
    "54099": 21,
    "54101": 0,
    "54103": 0,
    "54105": 19,
    "54107": 19,
    "54109": 20,
    "55001": 8,
    "55003": 2,
    "55005": 8,
    "55007": 2,
    "55009": 16,
    "55011": 9,
    "55013": 2,
    "55015": 3,
    "55017": 8,
    "55019": 7,
    "55021": 31,
    "55023": 12,
    "55025": 37,
    "55027": 30,
    "55029": 3,
    "55031": 2,
    "55033": 8,
    "55035": 8,
    "55037": 1,
    "55039": 32,
    "55041": 1,
    "55043": 9,
    "55045": 36,
    "55047": 27,
    "55049": 33,
    "55051": 3,
    "55053": 8,
    "55055": 33,
    "55057": 8,
    "55059": 38,
    "55061": 2,
    "55063": 10,
    "55065": 35,
    "55067": 1,
    "55069": 1,
    "55071": 5,
    "55073": 14,
    "55075": 2,
    "55077": 27,
    "55078": 1,
    "55079": 47,
    "55081": 8,
    "55083": 2,
    "55085": 3,
    "55087": 5,
    "55089": 28,
    "55091": 8,
    "55093": 8,
    "55095": 8,
    "55097": 7,
    "55099": 2,
    "55101": 36,
    "55103": 8,
    "55105": 42,
    "55107": 7,
    "55109": 8,
    "55111": 31,
    "55113": 2,
    "55115": 2,
    "55117": 30,
    "55119": 7,
    "55121": 10,
    "55123": 9,
    "55125": 1,
    "55127": 35,
    "55129": 2,
    "55131": 31,
    "55133": 33,
    "55135": 5,
    "55137": 4,
    "55139": 10,
    "55141": 6,
    "56001": 0,
    "56003": 0,
    "56005": 0,
    "56007": 0,
    "56009": 0,
    "56011": 0,
    "56013": 0,
    "56015": 0,
    "56017": 0,
    "56019": 0,
    "56021": 0,
    "56023": 0,
    "56025": 0,
    "56027": 0,
    "56029": 0,
    "56031": 0,
    "56033": 0,
    "56035": 0,
    "56037": 0,
    "56039": 0,
    "56041": 0,
    "56043": 0,
    "56045": 0
  },
  {
    "1001": 36,
    "1003": 0,
    "1005": 49,
    "1007": 34,
    "1009": 29,
    "1011": 49,
    "1013": 2,
    "1015": 40,
    "1017": 62,
    "1019": 36,
    "1021": 38,
    "1023": 3,
    "1025": 3,
    "1027": 53,
    "1029": 47,
    "1031": 32,
    "1033": 23,
    "1035": 2,
    "1037": 52,
    "1039": 2,
    "1041": 2,
    "1043": 27,
    "1045": 33,
    "1047": 28,
    "1049": 33,
    "1051": 59,
    "1053": 2,
    "1055": 29,
    "1057": 30,
    "1059": 23,
    "1061": 29,
    "1063": 21,
    "1065": 28,
    "1067": 35,
    "1069": 31,
    "1071": 33,
    "1073": 35,
    "1075": 26,
    "1077": 25,
    "1079": 28,
    "1081": 61,
    "1083": 28,
    "1085": 41,
    "1087": 63,
    "1089": 36,
    "1091": 22,
    "1093": 30,
    "1095": 28,
    "1097": 0,
    "1099": 2,
    "1101": 58,
    "1103": 28,
    "1105": 29,
    "1107": 25,
    "1109": 44,
    "1111": 60,
    "1113": 54,
    "1115": 32,
    "1117": 38,
    "1119": 21,
    "1121": 43,
    "1123": 61,
    "1125": 33,
    "1127": 32,
    "1129": 3,
    "1131": 2,
    "1133": 28,
    "2013": 0,
    "2016": 0,
    "2020": 0,
    "2050": 0,
    "2060": 0,
    "2068": 0,
    "2070": 0,
    "2090": 0,
    "2100": 2,
    "2110": 2,
    "2122": 0,
    "2130": 0,
    "2150": 0,
    "2164": 0,
    "2170": 0,
    "2180": 0,
    "2185": 0,
    "2188": 0,
    "2201": 0,
    "2220": 0,
    "2232": 0,
    "2240": 0,
    "2261": 0,
    "2270": 0,
    "2280": 0,
    "2282": 0,
    "2290": 0,
    "4001": 0,
    "4003": 121,
    "4005": 7,
    "4007": 0,
    "4009": 120,
    "4011": 61,
    "4012": 0,
    "4013": 0,
    "4015": 0,
    "4017": 0,
    "4019": 130,
    "4021": 110,
    "4023": 66,
    "4025": 0,
    "4027": 0,
    "5001": 18,
    "5003": 10,
    "5005": 15,
    "5007": 23,
    "5009": 17,
    "5011": 24,
    "5013": 26,
    "5015": 25,
    "5017": 9,
    "5019": 22,
    "5021": 20,
    "5023": 15,
    "5025": 17,
    "5027": 24,
    "5029": 15,
    "5031": 18,
    "5033": 32,
    "5035": 16,
    "5037": 17,
    "5039": 23,
    "5041": 22,
    "5043": 23,
    "5045": 15,
    "5047": 30,
    "5049": 10,
    "5051": 21,
    "5053": 17,
    "5055": 20,
    "5057": 29,
    "5059": 21,
    "5061": 32,
    "5063": 13,
    "5065": 13,
    "5067": 12,
    "5069": 21,
    "5071": 13,
    "5073": 27,
    "5075": 20,
    "5077": 20,
    "5079": 16,
    "5081": 31,
    "5083": 16,
    "5085": 19,
    "5087": 29,
    "5089": 15,
    "5091": 31,
    "5093": 19,
    "5095": 16,
    "5097": 20,
    "5099": 22,
    "5101": 17,
    "5103": 26,
    "5105": 16,
    "5107": 23,
    "5109": 25,
    "5111": 18,
    "5113": 23,
    "5115": 15,
    "5117": 15,
    "5119": 18,
    "5121": 21,
    "5123": 17,
    "5125": 18,
    "5127": 21,
    "5129": 16,
    "5131": 32,
    "5133": 33,
    "5135": 15,
    "5137": 17,
    "5139": 26,
    "5141": 15,
    "5143": 29,
    "5145": 16,
    "5147": 12,
    "5149": 19,
    "6001": 0,
    "6003": 10,
    "6005": 70,
    "6007": 12,
    "6009": 52,
    "6011": 26,
    "6013": 0,
    "6015": 0,
    "6017": 45,
    "6019": 1,
    "6021": 17,
    "6023": 0,
    "6025": 0,
    "6027": 0,
    "6029": 0,
    "6031": 0,
    "6033": 15,
    "6035": 2,
    "6037": 0,
    "6039": 0,
    "6041": 0,
    "6043": 1,
    "6045": 0,
    "6047": 0,
    "6049": 0,
    "6051": 0,
    "6053": 0,
    "6055": 0,
    "6057": 38,
    "6059": 26,
    "6061": 45,
    "6063": 2,
    "6065": 104,
    "6067": 32,
    "6069": 0,
    "6071": 78,
    "6073": 131,
    "6075": 0,
    "6077": 39,
    "6079": 0,
    "6081": 0,
    "6083": 0,
    "6085": 0,
    "6087": 0,
    "6089": 26,
    "6091": 11,
    "6093": 0,
    "6095": 32,
    "6097": 0,
    "6099": 25,
    "6101": 29,
    "6103": 24,
    "6105": 0,
    "6107": 0,
    "6109": 52,
    "6111": 0,
    "6113": 18,
    "6115": 38,
    "8001": 5,
    "8003": 3,
    "8005": 8,
    "8007": 224,
    "8009": 0,
    "8011": 0,
    "8013": 7,
    "8014": 5,
    "8015": 5,
    "8017": 41,
    "8019": 4,
    "8021": 3,
    "8023": 5,
    "8025": 0,
    "8027": 5,
    "8029": 411,
    "8031": 3,
    "8033": 337,
    "8035": 9,
    "8037": 289,
    "8039": 7,
    "8041": 1,
    "8043": 6,
    "8045": 793,
    "8047": 4,
    "8049": 4,
    "8051": 420,
    "8053": 224,
    "8055": 7,
    "8057": 3,
    "8059": 6,
    "8061": 0,
    "8063": 21,
    "8065": 3,
    "8067": 232,
    "8069": 6,
    "8071": 2,
    "8073": 4,
    "8075": 2,
    "8077": 703,
    "8079": 3,
    "8081": 409,
    "8083": 234,
    "8085": 627,
    "8087": 2,
    "8089": 0,
    "8091": 215,
    "8093": 4,
    "8095": 2,
    "8097": 193,
    "8099": 0,
    "8101": 2,
    "8103": 408,
    "8105": 6,
    "8107": 392,
    "8109": 7,
    "8111": 113,
    "8113": 552,
    "8115": 2,
    "8117": 2,
    "8119": 1,
    "8121": 2,
    "8123": 6,
    "8125": 21,
    "9001": 6,
    "9003": 9,
    "9005": 2,
    "9007": 6,
    "9009": 6,
    "9011": 6,
    "9013": 9,
    "9015": 7,
    "10001": 53,
    "10003": 49,
    "10005": 105,
    "11001": 11,
    "12001": 0,
    "12003": 0,
    "12005": 38,
    "12007": 1,
    "12009": 0,
    "12011": 43,
    "12013": 17,
    "12015": 0,
    "12017": 0,
    "12019": 2,
    "12021": 64,
    "12023": 0,
    "12027": 0,
    "12029": 15,
    "12031": 1,
    "12033": 0,
    "12035": 0,
    "12037": 22,
    "12039": 21,
    "12041": 0,
    "12043": 38,
    "12045": 43,
    "12047": 0,
    "12049": 0,
    "12051": 37,
    "12053": 0,
    "12055": 0,
    "12057": 0,
    "12059": 25,
    "12061": 0,
    "12063": 56,
    "12065": 28,
    "12067": 12,
    "12069": 0,
    "12071": 0,
    "12073": 20,
    "12075": 0,
    "12077": 15,
    "12079": 20,
    "12081": 0,
    "12083": 0,
    "12085": 0,
    "12086": 54,
    "12087": 9,
    "12089": 1,
    "12091": 0,
    "12093": 0,
    "12095": 0,
    "12097": 0,
    "12099": 63,
    "12101": 0,
    "12103": 0,
    "12105": 0,
    "12107": 0,
    "12109": 1,
    "12111": 0,
    "12113": 0,
    "12115": 0,
    "12117": 0,
    "12119": 0,
    "12121": 0,
    "12123": 20,
    "12125": 1,
    "12127": 0,
    "12129": 27,
    "12131": 55,
    "12133": 22,
    "13001": 0,
    "13003": 0,
    "13005": 1,
    "13007": 36,
    "13009": 29,
    "13011": 32,
    "13013": 32,
    "13015": 33,
    "13017": 30,
    "13019": 27,
    "13021": 27,
    "13023": 24,
    "13025": 0,
    "13027": 26,
    "13029": 46,
    "13031": 23,
    "13033": 0,
    "13035": 29,
    "13037": 31,
    "13039": 2,
    "13043": 23,
    "13045": 34,
    "13047": 30,
    "13049": 0,
    "13051": 69,
    "13053": 22,
    "13055": 30,
    "13057": 33,
    "13059": 31,
    "13061": 35,
    "13063": 29,
    "13065": 0,
    "13067": 33,
    "13069": 0,
    "13071": 31,
    "13073": 0,
    "13075": 26,
    "13077": 30,
    "13079": 25,
    "13081": 25,
    "13083": 30,
    "13085": 33,
    "13087": 62,
    "13089": 31,
    "13091": 23,
    "13093": 26,
    "13095": 31,
    "13097": 33,
    "13099": 38,
    "13101": 0,
    "13103": 23,
    "13105": 39,
    "13107": 24,
    "13109": 23,
    "13111": 33,
    "13113": 30,
    "13115": 31,
    "13117": 32,
    "13119": 39,
    "13121": 62,
    "13123": 34,
    "13125": 24,
    "13127": 0,
    "13129": 33,
    "13131": 31,
    "13133": 30,
    "13135": 33,
    "13137": 40,
    "13139": 34,
    "13141": 27,
    "13143": 32,
    "13145": 29,
    "13147": 39,
    "13149": 31,
    "13151": 30,
    "13153": 26,
    "13155": 28,
    "13157": 35,
    "13159": 28,
    "13161": 0,
    "13163": 24,
    "13165": 20,
    "13167": 24,
    "13169": 27,
    "13171": 28,
    "13173": 24,
    "13175": 26,
    "13177": 32,
    "13179": 69,
    "13181": 0,
    "13183": 23,
    "13185": 26,
    "13187": 33,
    "13189": 0,
    "13191": 69,
    "13193": 25,
    "13195": 32,
    "13197": 25,
    "13199": 30,
    "13201": 34,
    "13205": 35,
    "13207": 29,
    "13209": 22,
    "13211": 30,
    "13213": 33,
    "13215": 26,
    "13217": 30,
    "13219": 33,
    "13221": 29,
    "13223": 33,
    "13225": 26,
    "13227": 33,
    "13229": 0,
    "13231": 28,
    "13233": 32,
    "13235": 23,
    "13237": 28,
    "13239": 33,
    "13241": 40,
    "13243": 34,
    "13245": 0,
    "13247": 30,
    "13249": 24,
    "13251": 23,
    "13253": 32,
    "13255": 30,
    "13257": 42,
    "13259": 21,
    "13261": 25,
    "13263": 27,
    "13265": 27,
    "13267": 23,
    "13269": 24,
    "13271": 24,
    "13273": 31,
    "13275": 31,
    "13277": 29,
    "13279": 21,
    "13281": 33,
    "13283": 24,
    "13285": 29,
    "13287": 29,
    "13289": 28,
    "13291": 33,
    "13293": 28,
    "13295": 30,
    "13297": 62,
    "13299": 0,
    "13301": 27,
    "13303": 27,
    "13305": 0,
    "13307": 24,
    "13309": 24,
    "13311": 34,
    "13313": 31,
    "13315": 23,
    "13317": 29,
    "13319": 28,
    "13321": 30,
    "15001": 307,
    "15003": 127,
    "15005": 0,
    "15007": 116,
    "15009": 366,
    "16001": 0,
    "16003": 0,
    "16005": 0,
    "16007": 0,
    "16009": 0,
    "16011": 0,
    "16013": 0,
    "16015": 0,
    "16017": 0,
    "16019": 0,
    "16021": 0,
    "16023": 0,
    "16025": 0,
    "16027": 0,
    "16029": 0,
    "16031": 0,
    "16033": 0,
    "16035": 0,
    "16037": 0,
    "16039": 0,
    "16041": 0,
    "16043": 0,
    "16045": 0,
    "16047": 0,
    "16049": 0,
    "16051": 0,
    "16053": 0,
    "16055": 0,
    "16057": 0,
    "16059": 0,
    "16061": 0,
    "16063": 0,
    "16065": 0,
    "16067": 0,
    "16069": 0,
    "16071": 0,
    "16073": 0,
    "16075": 0,
    "16077": 0,
    "16079": 0,
    "16081": 0,
    "16083": 0,
    "16085": 0,
    "16087": 0,
    "17001": 6,
    "17003": 29,
    "17005": 4,
    "17007": 9,
    "17009": 5,
    "17011": 15,
    "17013": 10,
    "17015": 14,
    "17017": 5,
    "17019": 3,
    "17021": 3,
    "17023": 4,
    "17025": 6,
    "17027": 3,
    "17029": 3,
    "17031": 9,
    "17033": 6,
    "17035": 4,
    "17037": 9,
    "17039": 6,
    "17041": 3,
    "17043": 9,
    "17045": 3,
    "17047": 21,
    "17049": 4,
    "17051": 4,
    "17053": 2,
    "17055": 23,
    "17057": 4,
    "17059": 25,
    "17061": 6,
    "17063": 9,
    "17065": 24,
    "17067": 16,
    "17069": 28,
    "17071": 17,
    "17073": 15,
    "17075": 1,
    "17077": 21,
    "17079": 6,
    "17081": 19,
    "17083": 10,
    "17085": 13,
    "17087": 27,
    "17089": 9,
    "17091": 4,
    "17093": 9,
    "17095": 4,
    "17097": 9,
    "17099": 9,
    "17101": 6,
    "17103": 10,
    "17105": 10,
    "17107": 8,
    "17109": 15,
    "17111": 9,
    "17113": 7,
    "17115": 7,
    "17117": 6,
    "17119": 4,
    "17121": 3,
    "17123": 7,
    "17125": 5,
    "17127": 29,
    "17129": 4,
    "17131": 15,
    "17133": 4,
    "17135": 5,
    "17137": 3,
    "17139": 3,
    "17141": 10,
    "17143": 7,
    "17145": 21,
    "17147": 7,
    "17149": 6,
    "17151": 29,
    "17153": 29,
    "17155": 15,
    "17157": 4,
    "17159": 6,
    "17161": 15,
    "17163": 4,
    "17165": 24,
    "17167": 3,
    "17169": 3,
    "17171": 3,
    "17173": 3,
    "17175": 7,
    "17177": 13,
    "17179": 8,
    "17181": 27,
    "17183": 3,
    "17185": 21,
    "17187": 17,
    "17189": 4,
    "17191": 19,
    "17193": 24,
    "17195": 15,
    "17197": 9,
    "17199": 24,
    "17201": 10,
    "17203": 7,
    "18001": 0,
    "18003": 0,
    "18005": 10,
    "18007": 0,
    "18009": 0,
    "18011": 5,
    "18013": 10,
    "18015": 3,
    "18017": 0,
    "18019": 0,
    "18021": 6,
    "18023": 4,
    "18025": 0,
    "18027": 7,
    "18029": 0,
    "18031": 8,
    "18033": 0,
    "18035": 4,
    "18037": 0,
    "18039": 0,
    "18041": 0,
    "18043": 0,
    "18045": 3,
    "18047": 0,
    "18049": 0,
    "18051": 20,
    "18053": 0,
    "18055": 7,
    "18057": 5,
    "18059": 6,
    "18061": 0,
    "18063": 8,
    "18065": 5,
    "18067": 3,
    "18069": 0,
    "18071": 9,
    "18073": 0,
    "18075": 0,
    "18077": 0,
    "18079": 7,
    "18081": 9,
    "18083": 6,
    "18085": 0,
    "18087": 0,
    "18089": 0,
    "18091": 0,
    "18093": 9,
    "18095": 5,
    "18097": 6,
    "18099": 0,
    "18101": 8,
    "18103": 0,
    "18105": 10,
    "18107": 5,
    "18109": 8,
    "18111": 0,
    "18113": 0,
    "18115": 0,
    "18117": 0,
    "18119": 8,
    "18121": 6,
    "18123": 0,
    "18125": 20,
    "18127": 0,
    "18129": 21,
    "18131": 0,
    "18133": 8,
    "18135": 4,
    "18137": 0,
    "18139": 7,
    "18141": 0,
    "18143": 0,
    "18145": 8,
    "18147": 21,
    "18149": 0,
    "18151": 0,
    "18153": 6,
    "18155": 0,
    "18157": 5,
    "18159": 4,
    "18161": 0,
    "18163": 21,
    "18165": 5,
    "18167": 6,
    "18169": 0,
    "18171": 3,
    "18173": 21,
    "18175": 0,
    "18177": 0,
    "18179": 0,
    "18181": 0,
    "18183": 0,
    "19001": 12,
    "19003": 10,
    "19005": 6,
    "19007": 17,
    "19009": 10,
    "19011": 10,
    "19013": 7,
    "19015": 9,
    "19017": 6,
    "19019": 4,
    "19021": 15,
    "19023": 6,
    "19025": 8,
    "19027": 9,
    "19029": 10,
    "19031": 15,
    "19033": 6,
    "19035": 15,
    "19037": 5,
    "19039": 16,
    "19041": 15,
    "19043": 5,
    "19045": 15,
    "19047": 9,
    "19049": 10,
    "19051": 17,
    "19053": 19,
    "19055": 8,
    "19057": 17,
    "19059": 15,
    "19061": 12,
    "19063": 7,
    "19065": 5,
    "19067": 10,
    "19069": 7,
    "19071": 10,
    "19073": 9,
    "19075": 6,
    "19077": 10,
    "19079": 7,
    "19081": 7,
    "19083": 7,
    "19085": 10,
    "19087": 17,
    "19089": 10,
    "19091": 7,
    "19093": 15,
    "19095": 16,
    "19097": 13,
    "19099": 10,
    "19101": 17,
    "19103": 15,
    "19105": 15,
    "19107": 18,
    "19109": 7,
    "19111": 16,
    "19113": 13,
    "19115": 17,
    "19117": 16,
    "19119": 15,
    "19121": 13,
    "19123": 13,
    "19125": 15,
    "19127": 9,
    "19129": 10,
    "19131": 10,
    "19133": 10,
    "19135": 17,
    "19137": 4,
    "19139": 15,
    "19141": 15,
    "19143": 15,
    "19145": 4,
    "19147": 7,
    "19149": 15,
    "19151": 8,
    "19153": 10,
    "19155": 10,
    "19157": 10,
    "19159": 16,
    "19161": 9,
    "19163": 15,
    "19165": 10,
    "19167": 15,
    "19169": 9,
    "19171": 9,
    "19173": 10,
    "19175": 13,
    "19177": 17,
    "19179": 17,
    "19181": 13,
    "19183": 17,
    "19185": 15,
    "19187": 7,
    "19189": 6,
    "19191": 6,
    "19193": 15,
    "19195": 6,
    "19197": 7,
    "20001": 20,
    "20003": 11,
    "20005": 13,
    "20007": 3,
    "20009": 30,
    "20011": 21,
    "20013": 10,
    "20015": 32,
    "20017": 28,
    "20019": 22,
    "20021": 20,
    "20023": 35,
    "20025": 2,
    "20027": 12,
    "20029": 11,
    "20031": 11,
    "20033": 2,
    "20035": 28,
    "20037": 20,
    "20039": 30,
    "20041": 11,
    "20043": 11,
    "20045": 11,
    "20047": 3,
    "20049": 23,
    "20051": 3,
    "20053": 30,
    "20055": 3,
    "20057": 3,
    "20059": 11,
    "20061": 11,
    "20063": 30,
    "20065": 30,
    "20067": 3,
    "20069": 3,
    "20071": 40,
    "20073": 25,
    "20075": 3,
    "20077": 33,
    "20079": 31,
    "20081": 3,
    "20083": 3,
    "20085": 10,
    "20087": 11,
    "20089": 23,
    "20091": 13,
    "20093": 3,
    "20095": 33,
    "20097": 3,
    "20099": 17,
    "20101": 3,
    "20103": 13,
    "20105": 20,
    "20107": 12,
    "20109": 40,
    "20111": 11,
    "20113": 28,
    "20115": 30,
    "20117": 10,
    "20119": 3,
    "20121": 13,
    "20123": 22,
    "20125": 20,
    "20127": 11,
    "20129": 3,
    "20131": 10,
    "20133": 17,
    "20135": 3,
    "20137": 30,
    "20139": 11,
    "20141": 23,
    "20143": 11,
    "20145": 2,
    "20147": 27,
    "20149": 10,
    "20151": 2,
    "20153": 31,
    "20155": 32,
    "20157": 10,
    "20159": 30,
    "20161": 11,
    "20163": 27,
    "20165": 3,
    "20167": 23,
    "20169": 24,
    "20171": 3,
    "20173": 34,
    "20175": 2,
    "20177": 11,
    "20179": 30,
    "20181": 40,
    "20183": 24,
    "20185": 3,
    "20187": 3,
    "20189": 2,
    "20191": 32,
    "20193": 40,
    "20195": 3,
    "20197": 11,
    "20199": 40,
    "20201": 10,
    "20203": 40,
    "20205": 21,
    "20207": 19,
    "20209": 12,
    "21001": 0,
    "21003": 0,
    "21005": 0,
    "21007": 30,
    "21009": 0,
    "21011": 2,
    "21013": 2,
    "21015": 0,
    "21017": 0,
    "21019": 16,
    "21021": 0,
    "21023": 0,
    "21025": 2,
    "21027": 0,
    "21029": 0,
    "21031": 0,
    "21033": 31,
    "21035": 34,
    "21037": 0,
    "21039": 31,
    "21041": 0,
    "21043": 16,
    "21045": 0,
    "21047": 29,
    "21049": 0,
    "21051": 2,
    "21053": 0,
    "21055": 30,
    "21057": 0,
    "21059": 28,
    "21061": 0,
    "21063": 2,
    "21065": 2,
    "21067": 0,
    "21069": 2,
    "21071": 2,
    "21073": 0,
    "21075": 32,
    "21077": 0,
    "21079": 0,
    "21081": 0,
    "21083": 32,
    "21085": 0,
    "21087": 0,
    "21089": 16,
    "21091": 0,
    "21093": 0,
    "21095": 2,
    "21097": 0,
    "21099": 0,
    "21101": 30,
    "21103": 0,
    "21105": 32,
    "21107": 31,
    "21109": 2,
    "21111": 0,
    "21113": 0,
    "21115": 2,
    "21117": 0,
    "21119": 2,
    "21121": 2,
    "21123": 0,
    "21125": 2,
    "21127": 16,
    "21129": 2,
    "21131": 2,
    "21133": 2,
    "21135": 0,
    "21137": 0,
    "21139": 31,
    "21141": 0,
    "21143": 31,
    "21145": 31,
    "21147": 2,
    "21149": 28,
    "21151": 0,
    "21153": 2,
    "21155": 0,
    "21157": 32,
    "21159": 2,
    "21161": 0,
    "21163": 0,
    "21165": 2,
    "21167": 0,
    "21169": 0,
    "21171": 0,
    "21173": 2,
    "21175": 2,
    "21177": 28,
    "21179": 0,
    "21181": 0,
    "21183": 0,
    "21185": 0,
    "21187": 0,
    "21189": 2,
    "21191": 0,
    "21193": 2,
    "21195": 2,
    "21197": 2,
    "21199": 2,
    "21201": 0,
    "21203": 2,
    "21205": 2,
    "21207": 0,
    "21209": 0,
    "21211": 0,
    "21213": 0,
    "21215": 0,
    "21217": 0,
    "21219": 28,
    "21221": 33,
    "21223": 0,
    "21225": 30,
    "21227": 0,
    "21229": 0,
    "21231": 2,
    "21233": 30,
    "21235": 2,
    "21237": 2,
    "21239": 0,
    "22001": 7,
    "22003": 7,
    "22005": 3,
    "22007": 3,
    "22009": 4,
    "22011": 7,
    "22013": 34,
    "22015": 38,
    "22017": 39,
    "22019": 7,
    "22021": 26,
    "22023": 0,
    "22025": 10,
    "22027": 31,
    "22029": 10,
    "22031": 34,
    "22033": 4,
    "22035": 10,
    "22037": 4,
    "22039": 7,
    "22041": 11,
    "22043": 24,
    "22045": 4,
    "22047": 3,
    "22049": 28,
    "22051": 4,
    "22053": 7,
    "22055": 4,
    "22057": 6,
    "22059": 24,
    "22061": 32,
    "22063": 4,
    "22065": 10,
    "22067": 12,
    "22069": 29,
    "22071": 2,
    "22073": 29,
    "22075": 4,
    "22077": 4,
    "22079": 7,
    "22081": 30,
    "22083": 11,
    "22085": 29,
    "22087": 4,
    "22089": 3,
    "22091": 4,
    "22093": 3,
    "22095": 3,
    "22097": 4,
    "22099": 6,
    "22101": 3,
    "22103": 4,
    "22105": 0,
    "22107": 9,
    "22109": 6,
    "22111": 33,
    "22113": 4,
    "22115": 6,
    "22117": 4,
    "22119": 33,
    "22121": 4,
    "22123": 11,
    "22125": 4,
    "22127": 26,
    "23001": 9,
    "23003": 0,
    "23005": 18,
    "23007": 18,
    "23009": 4,
    "23011": 9,
    "23013": 9,
    "23015": 9,
    "23017": 18,
    "23019": 4,
    "23021": 1,
    "23023": 9,
    "23025": 18,
    "23027": 18,
    "23029": 4,
    "23031": 18,
    "24001": 0,
    "24003": 24,
    "24005": 28,
    "24009": 12,
    "24011": 60,
    "24013": 7,
    "24015": 104,
    "24017": 24,
    "24019": 1,
    "24021": 12,
    "24023": 2,
    "24025": 0,
    "24027": 0,
    "24029": 122,
    "24031": 0,
    "24033": 11,
    "24035": 124,
    "24037": 24,
    "24039": 1,
    "24041": 59,
    "24043": 12,
    "24045": 1,
    "24047": 0,
    "24510": 9,
    "25001": 6,
    "25003": 2,
    "25005": 14,
    "25007": 4,
    "25009": 17,
    "25011": 16,
    "25013": 18,
    "25015": 18,
    "25017": 30,
    "25019": 2,
    "25021": 34,
    "25023": 23,
    "25025": 11,
    "25027": 22,
    "26001": 0,
    "26003": 0,
    "26005": 0,
    "26007": 0,
    "26009": 1,
    "26011": 0,
    "26013": 0,
    "26015": 0,
    "26017": 2,
    "26019": 0,
    "26021": 0,
    "26023": 0,
    "26025": 0,
    "26027": 0,
    "26029": 0,
    "26031": 2,
    "26033": 0,
    "26035": 0,
    "26037": 0,
    "26039": 0,
    "26041": 0,
    "26043": 0,
    "26045": 0,
    "26047": 2,
    "26049": 2,
    "26051": 0,
    "26053": 0,
    "26055": 1,
    "26057": 0,
    "26059": 0,
    "26061": 0,
    "26063": 2,
    "26065": 0,
    "26067": 0,
    "26069": 0,
    "26071": 0,
    "26073": 0,
    "26075": 0,
    "26077": 0,
    "26079": 1,
    "26081": 0,
    "26083": 0,
    "26085": 0,
    "26087": 2,
    "26089": 1,
    "26091": 2,
    "26093": 2,
    "26095": 0,
    "26097": 0,
    "26099": 2,
    "26101": 0,
    "26103": 0,
    "26105": 0,
    "26107": 0,
    "26109": 0,
    "26111": 2,
    "26113": 1,
    "26115": 2,
    "26117": 0,
    "26119": 0,
    "26121": 0,
    "26123": 0,
    "26125": 2,
    "26127": 0,
    "26129": 0,
    "26131": 0,
    "26133": 0,
    "26135": 0,
    "26137": 1,
    "26139": 0,
    "26141": 0,
    "26143": 0,
    "26145": 2,
    "26147": 2,
    "26149": 0,
    "26151": 2,
    "26153": 0,
    "26155": 2,
    "26157": 2,
    "26159": 0,
    "26161": 2,
    "26163": 2,
    "26165": 1,
    "27001": 32,
    "27003": 0,
    "27005": 17,
    "27007": 34,
    "27009": 0,
    "27011": 8,
    "27013": 0,
    "27015": 0,
    "27017": 21,
    "27019": 0,
    "27021": 40,
    "27023": 0,
    "27025": 0,
    "27027": 8,
    "27029": 28,
    "27031": 57,
    "27033": 16,
    "27035": 19,
    "27037": 0,
    "27039": 14,
    "27041": 0,
    "27043": 0,
    "27045": 11,
    "27047": 0,
    "27049": 0,
    "27051": 5,
    "27053": 0,
    "27055": 8,
    "27057": 12,
    "27059": 0,
    "27061": 36,
    "27063": 15,
    "27065": 0,
    "27067": 0,
    "27069": 7,
    "27071": 26,
    "27073": 0,
    "27075": 52,
    "27077": 18,
    "27079": 0,
    "27081": 16,
    "27083": 16,
    "27085": 0,
    "27087": 16,
    "27089": 26,
    "27091": 0,
    "27093": 0,
    "27095": 0,
    "27097": 0,
    "27099": 16,
    "27101": 16,
    "27103": 0,
    "27105": 15,
    "27107": 8,
    "27109": 8,
    "27111": 11,
    "27113": 16,
    "27115": 19,
    "27117": 16,
    "27119": 25,
    "27121": 0,
    "27123": 0,
    "27125": 16,
    "27127": 0,
    "27129": 0,
    "27131": 0,
    "27133": 16,
    "27135": 13,
    "27137": 102,
    "27139": 0,
    "27141": 0,
    "27143": 0,
    "27145": 0,
    "27147": 0,
    "27149": 0,
    "27151": 0,
    "27153": 0,
    "27155": 8,
    "27157": 10,
    "27159": 15,
    "27161": 0,
    "27163": 0,
    "27165": 0,
    "27167": 3,
    "27169": 8,
    "27171": 0,
    "27173": 0,
    "28001": 4,
    "28003": 9,
    "28005": 0,
    "28007": 12,
    "28009": 12,
    "28011": 8,
    "28013": 13,
    "28015": 12,
    "28017": 19,
    "28019": 11,
    "28021": 11,
    "28023": 11,
    "28025": 14,
    "28027": 22,
    "28029": 11,
    "28031": 8,
    "28033": 15,
    "28035": 7,
    "28037": 7,
    "28039": 2,
    "28041": 2,
    "28043": 11,
    "28045": 0,
    "28047": 0,
    "28049": 13,
    "28051": 13,
    "28053": 10,
    "28055": 12,
    "28057": 17,
    "28059": 0,
    "28061": 10,
    "28063": 8,
    "28065": 7,
    "28067": 10,
    "28069": 11,
    "28071": 14,
    "28073": 6,
    "28075": 11,
    "28077": 8,
    "28079": 12,
    "28081": 16,
    "28083": 11,
    "28085": 8,
    "28087": 13,
    "28089": 14,
    "28091": 6,
    "28093": 12,
    "28095": 19,
    "28097": 14,
    "28099": 12,
    "28101": 12,
    "28103": 13,
    "28105": 13,
    "28107": 20,
    "28109": 0,
    "28111": 3,
    "28113": 0,
    "28115": 13,
    "28117": 12,
    "28119": 17,
    "28121": 12,
    "28123": 12,
    "28125": 12,
    "28127": 11,
    "28129": 12,
    "28131": 2,
    "28133": 9,
    "28135": 21,
    "28137": 11,
    "28139": 9,
    "28141": 12,
    "28143": 18,
    "28145": 10,
    "28147": 0,
    "28149": 12,
    "28151": 9,
    "28153": 3,
    "28155": 12,
    "28157": 0,
    "28159": 12,
    "28161": 17,
    "28163": 10,
    "29001": 11,
    "29003": 16,
    "29005": 12,
    "29007": 9,
    "29009": 19,
    "29011": 19,
    "29013": 8,
    "29015": 13,
    "29017": 26,
    "29019": 8,
    "29021": 13,
    "29023": 34,
    "29025": 15,
    "29027": 7,
    "29029": 9,
    "29031": 26,
    "29033": 12,
    "29035": 33,
    "29037": 13,
    "29039": 14,
    "29041": 11,
    "29043": 17,
    "29045": 13,
    "29047": 14,
    "29049": 14,
    "29051": 7,
    "29053": 14,
    "29055": 9,
    "29057": 13,
    "29059": 14,
    "29061": 16,
    "29063": 18,
    "29065": 9,
    "29067": 9,
    "29069": 19,
    "29071": 9,
    "29073": 6,
    "29075": 17,
    "29077": 16,
    "29079": 16,
    "29081": 17,
    "29083": 8,
    "29085": 11,
    "29087": 12,
    "29089": 10,
    "29091": 9,
    "29093": 6,
    "29095": 13,
    "29097": 20,
    "29099": 10,
    "29101": 12,
    "29103": 6,
    "29105": 8,
    "29107": 14,
    "29109": 17,
    "29111": 6,
    "29113": 12,
    "29115": 16,
    "29117": 16,
    "29119": 21,
    "29121": 12,
    "29123": 6,
    "29125": 8,
    "29127": 6,
    "29129": 14,
    "29131": 8,
    "29133": 32,
    "29135": 7,
    "29137": 7,
    "29139": 7,
    "29141": 8,
    "29143": 32,
    "29145": 21,
    "29147": 18,
    "29149": 10,
    "29151": 7,
    "29153": 10,
    "29155": 19,
    "29157": 21,
    "29159": 9,
    "29161": 8,
    "29163": 7,
    "29165": 14,
    "29167": 13,
    "29169": 8,
    "29171": 15,
    "29173": 8,
    "29175": 9,
    "29177": 13,
    "29179": 6,
    "29181": 33,
    "29183": 9,
    "29185": 13,
    "29186": 6,
    "29187": 6,
    "29189": 8,
    "29195": 9,
    "29197": 12,
    "29199": 13,
    "29201": 32,
    "29203": 10,
    "29205": 7,
    "29207": 32,
    "29209": 19,
    "29211": 17,
    "29213": 19,
    "29215": 9,
    "29217": 19,
    "29219": 7,
    "29221": 10,
    "29223": 34,
    "29225": 15,
    "29227": 15,
    "29229": 7,
    "29510": 4,
    "30001": 0,
    "30003": 0,
    "30005": 0,
    "30007": 0,
    "30009": 0,
    "30011": 0,
    "30013": 0,
    "30015": 0,
    "30017": 0,
    "30019": 17,
    "30021": 13,
    "30023": 0,
    "30025": 0,
    "30027": 0,
    "30029": 0,
    "30031": 0,
    "30033": 12,
    "30035": 0,
    "30037": 0,
    "30039": 0,
    "30041": 0,
    "30043": 0,
    "30045": 0,
    "30047": 0,
    "30049": 0,
    "30051": 0,
    "30053": 0,
    "30055": 15,
    "30057": 0,
    "30059": 0,
    "30061": 0,
    "30063": 0,
    "30065": 0,
    "30067": 0,
    "30069": 10,
    "30071": 31,
    "30073": 0,
    "30075": 0,
    "30077": 0,
    "30079": 11,
    "30081": 0,
    "30083": 15,
    "30085": 34,
    "30087": 0,
    "30089": 0,
    "30091": 18,
    "30093": 0,
    "30095": 0,
    "30097": 0,
    "30099": 0,
    "30101": 0,
    "30103": 0,
    "30105": 29,
    "30107": 0,
    "30109": 11,
    "30111": 0,
    "31001": 16,
    "31003": 15,
    "31005": 23,
    "31007": 0,
    "31009": 23,
    "31011": 14,
    "31013": 0,
    "31015": 13,
    "31017": 20,
    "31019": 18,
    "31021": 12,
    "31023": 12,
    "31025": 12,
    "31027": 14,
    "31029": 25,
    "31031": 47,
    "31033": 0,
    "31035": 15,
    "31037": 12,
    "31039": 12,
    "31041": 22,
    "31043": 16,
    "31045": 0,
    "31047": 27,
    "31049": 21,
    "31051": 16,
    "31053": 12,
    "31055": 12,
    "31057": 31,
    "31059": 15,
    "31061": 22,
    "31063": 25,
    "31065": 27,
    "31067": 11,
    "31069": 24,
    "31071": 21,
    "31073": 27,
    "31075": 25,
    "31077": 20,
    "31079": 17,
    "31081": 15,
    "31083": 24,
    "31085": 26,
    "31087": 31,
    "31089": 17,
    "31091": 28,
    "31093": 18,
    "31095": 11,
    "31097": 11,
    "31099": 18,
    "31101": 26,
    "31103": 19,
    "31105": 0,
    "31107": 13,
    "31109": 12,
    "31111": 26,
    "31113": 26,
    "31115": 19,
    "31117": 28,
    "31119": 12,
    "31121": 15,
    "31123": 0,
    "31125": 18,
    "31127": 11,
    "31129": 16,
    "31131": 11,
    "31133": 11,
    "31135": 25,
    "31137": 25,
    "31139": 14,
    "31141": 12,
    "31143": 15,
    "31145": 31,
    "31147": 11,
    "31149": 17,
    "31151": 12,
    "31153": 12,
    "31155": 12,
    "31157": 0,
    "31159": 12,
    "31161": 18,
    "31163": 21,
    "31165": 0,
    "31167": 12,
    "31169": 16,
    "31171": 25,
    "31173": 12,
    "31175": 21,
    "31177": 12,
    "31179": 14,
    "31181": 18,
    "31183": 18,
    "31185": 15,
    "32001": 0,
    "32003": 0,
    "32005": 0,
    "32007": 0,
    "32009": 0,
    "32011": 0,
    "32013": 0,
    "32015": 0,
    "32017": 0,
    "32019": 0,
    "32021": 0,
    "32023": 0,
    "32027": 0,
    "32029": 0,
    "32031": 0,
    "32033": 0,
    "32510": 0,
    "33001": 9,
    "33003": 18,
    "33005": 0,
    "33007": 18,
    "33009": 18,
    "33011": 0,
    "33013": 9,
    "33015": 18,
    "33017": 9,
    "33019": 9,
    "34001": 76,
    "34003": 0,
    "34005": 49,
    "34007": 40,
    "34009": 76,
    "34011": 38,
    "34013": 0,
    "34015": 40,
    "34017": 11,
    "34019": 43,
    "34021": 44,
    "34023": 42,
    "34025": 87,
    "34027": 41,
    "34029": 87,
    "34031": 22,
    "34033": 40,
    "34035": 42,
    "34037": 39,
    "34039": 0,
    "34041": 36,
    "35001": 188,
    "35003": 224,
    "35005": 102,
    "35006": 151,
    "35007": 215,
    "35009": 52,
    "35011": 52,
    "35013": 115,
    "35015": 30,
    "35017": 252,
    "35019": 58,
    "35021": 59,
    "35023": 146,
    "35025": 14,
    "35027": 197,
    "35028": 43,
    "35029": 89,
    "35031": 255,
    "35033": 160,
    "35035": 203,
    "35037": 62,
    "35039": 317,
    "35041": 53,
    "35043": 337,
    "35045": 197,
    "35047": 317,
    "35049": 344,
    "35051": 140,
    "35053": 290,
    "35055": 215,
    "35057": 253,
    "35059": 124,
    "35061": 186,
    "36001": 5,
    "36003": 4,
    "36005": 8,
    "36007": 6,
    "36009": 3,
    "36011": 9,
    "36013": 3,
    "36015": 7,
    "36017": 3,
    "36019": 0,
    "36021": 4,
    "36023": 6,
    "36025": 3,
    "36027": 4,
    "36029": 10,
    "36031": 0,
    "36033": 0,
    "36035": 2,
    "36037": 5,
    "36039": 4,
    "36041": 4,
    "36043": 6,
    "36045": 2,
    "36047": 8,
    "36049": 0,
    "36051": 5,
    "36053": 2,
    "36055": 5,
    "36057": 2,
    "36059": 0,
    "36061": 8,
    "36063": 5,
    "36065": 4,
    "36067": 5,
    "36069": 5,
    "36071": 10,
    "36073": 5,
    "36075": 3,
    "36077": 3,
    "36079": 10,
    "36081": 0,
    "36083": 4,
    "36085": 8,
    "36087": 10,
    "36089": 0,
    "36091": 4,
    "36093": 4,
    "36095": 1,
    "36097": 7,
    "36099": 4,
    "36101": 7,
    "36103": 32,
    "36105": 4,
    "36107": 7,
    "36109": 7,
    "36111": 4,
    "36113": 2,
    "36115": 2,
    "36117": 3,
    "36119": 20,
    "36121": 5,
    "36123": 6,
    "37001": 0,
    "37003": 35,
    "37005": 17,
    "37007": 0,
    "37009": 23,
    "37011": 33,
    "37013": 3,
    "37015": 0,
    "37017": 10,
    "37019": 6,
    "37021": 33,
    "37023": 30,
    "37025": 33,
    "37027": 30,
    "37029": 0,
    "37031": 0,
    "37033": 18,
    "37035": 35,
    "37037": 0,
    "37039": 0,
    "37041": 0,
    "37043": 0,
    "37045": 35,
    "37047": 11,
    "37049": 0,
    "37051": 0,
    "37053": 0,
    "37055": 3,
    "37057": 0,
    "37059": 33,
    "37061": 3,
    "37063": 0,
    "37065": 0,
    "37067": 0,
    "37069": 0,
    "37071": 33,
    "37073": 0,
    "37075": 35,
    "37077": 0,
    "37079": 3,
    "37081": 0,
    "37083": 0,
    "37085": 0,
    "37087": 35,
    "37089": 34,
    "37091": 0,
    "37093": 0,
    "37095": 3,
    "37097": 33,
    "37099": 70,
    "37101": 0,
    "37103": 3,
    "37105": 0,
    "37107": 3,
    "37109": 35,
    "37111": 30,
    "37113": 35,
    "37115": 32,
    "37117": 2,
    "37119": 33,
    "37121": 33,
    "37123": 0,
    "37125": 0,
    "37127": 0,
    "37129": 6,
    "37131": 0,
    "37133": 0,
    "37135": 0,
    "37137": 3,
    "37139": 0,
    "37141": 4,
    "37143": 0,
    "37145": 0,
    "37147": 3,
    "37149": 32,
    "37151": 0,
    "37153": 0,
    "37155": 12,
    "37157": 18,
    "37159": 33,
    "37161": 32,
    "37163": 0,
    "37165": 0,
    "37167": 0,
    "37169": 17,
    "37171": 19,
    "37173": 35,
    "37175": 34,
    "37177": 3,
    "37179": 33,
    "37181": 0,
    "37183": 0,
    "37185": 0,
    "37187": 3,
    "37189": 25,
    "37191": 0,
    "37193": 21,
    "37195": 0,
    "37197": 20,
    "37199": 33,
    "38001": 0,
    "38003": 5,
    "38005": 1,
    "38007": 0,
    "38009": 0,
    "38011": 0,
    "38013": 0,
    "38015": 0,
    "38017": 6,
    "38019": 5,
    "38021": 0,
    "38023": 0,
    "38025": 0,
    "38027": 5,
    "38029": 0,
    "38031": 0,
    "38033": 0,
    "38035": 6,
    "38037": 0,
    "38039": 5,
    "38041": 0,
    "38043": 0,
    "38045": 0,
    "38047": 0,
    "38049": 0,
    "38051": 0,
    "38053": 0,
    "38055": 0,
    "38057": 0,
    "38059": 0,
    "38061": 0,
    "38063": 6,
    "38065": 0,
    "38067": 5,
    "38069": 0,
    "38071": 2,
    "38073": 5,
    "38075": 0,
    "38077": 4,
    "38079": 0,
    "38081": 3,
    "38083": 0,
    "38085": 0,
    "38087": 0,
    "38089": 0,
    "38091": 6,
    "38093": 0,
    "38095": 4,
    "38097": 6,
    "38099": 6,
    "38101": 0,
    "38103": 0,
    "38105": 0,
    "39001": 2,
    "39003": 0,
    "39005": 5,
    "39007": 6,
    "39009": 6,
    "39011": 2,
    "39013": 2,
    "39015": 2,
    "39017": 2,
    "39019": 2,
    "39021": 2,
    "39023": 2,
    "39025": 2,
    "39027": 2,
    "39029": 2,
    "39031": 2,
    "39033": 5,
    "39035": 5,
    "39037": 2,
    "39039": 0,
    "39041": 2,
    "39043": 5,
    "39045": 2,
    "39047": 2,
    "39049": 2,
    "39051": 4,
    "39053": 13,
    "39055": 5,
    "39057": 2,
    "39059": 2,
    "39061": 2,
    "39063": 5,
    "39065": 2,
    "39067": 2,
    "39069": 4,
    "39071": 2,
    "39073": 2,
    "39075": 5,
    "39077": 5,
    "39079": 10,
    "39081": 2,
    "39083": 5,
    "39085": 5,
    "39087": 13,
    "39089": 2,
    "39091": 2,
    "39093": 6,
    "39095": 5,
    "39097": 2,
    "39099": 6,
    "39101": 5,
    "39103": 5,
    "39105": 10,
    "39107": 2,
    "39109": 2,
    "39111": 2,
    "39113": 2,
    "39115": 5,
    "39117": 5,
    "39119": 2,
    "39121": 2,
    "39123": 5,
    "39125": 0,
    "39127": 5,
    "39129": 2,
    "39131": 2,
    "39133": 5,
    "39135": 2,
    "39137": 0,
    "39139": 5,
    "39141": 2,
    "39143": 5,
    "39145": 2,
    "39147": 5,
    "39149": 2,
    "39151": 6,
    "39153": 5,
    "39155": 6,
    "39157": 2,
    "39159": 2,
    "39161": 0,
    "39163": 9,
    "39165": 2,
    "39167": 6,
    "39169": 5,
    "39171": 0,
    "39173": 5,
    "39175": 5,
    "40001": 32,
    "40003": 72,
    "40005": 56,
    "40007": 34,
    "40009": 77,
    "40011": 73,
    "40013": 65,
    "40015": 74,
    "40017": 69,
    "40019": 60,
    "40021": 32,
    "40023": 47,
    "40025": 32,
    "40027": 53,
    "40029": 49,
    "40031": 77,
    "40033": 78,
    "40035": 33,
    "40037": 49,
    "40039": 77,
    "40041": 27,
    "40043": 79,
    "40045": 84,
    "40047": 67,
    "40049": 54,
    "40051": 62,
    "40053": 61,
    "40055": 76,
    "40057": 81,
    "40059": 84,
    "40061": 37,
    "40063": 44,
    "40065": 82,
    "40067": 76,
    "40069": 64,
    "40071": 68,
    "40073": 71,
    "40075": 76,
    "40077": 38,
    "40079": 39,
    "40081": 52,
    "40083": 67,
    "40085": 59,
    "40087": 56,
    "40089": 28,
    "40091": 37,
    "40093": 78,
    "40095": 59,
    "40097": 29,
    "40099": 59,
    "40101": 38,
    "40103": 68,
    "40105": 38,
    "40107": 42,
    "40109": 52,
    "40111": 42,
    "40113": 59,
    "40115": 26,
    "40117": 58,
    "40119": 57,
    "40121": 38,
    "40123": 52,
    "40125": 52,
    "40127": 44,
    "40129": 85,
    "40131": 36,
    "40133": 51,
    "40135": 38,
    "40137": 75,
    "40139": 33,
    "40141": 80,
    "40143": 48,
    "40145": 32,
    "40147": 46,
    "40149": 77,
    "40151": 80,
    "40153": 80,
    "41001": 0,
    "41003": 0,
    "41005": 0,
    "41007": 0,
    "41009": 0,
    "41011": 0,
    "41013": 0,
    "41015": 0,
    "41017": 0,
    "41019": 0,
    "41021": 0,
    "41023": 0,
    "41025": 0,
    "41027": 0,
    "41029": 0,
    "41031": 3,
    "41033": 0,
    "41035": 0,
    "41037": 0,
    "41039": 0,
    "41041": 0,
    "41043": 0,
    "41045": 0,
    "41047": 0,
    "41049": 0,
    "41051": 0,
    "41053": 0,
    "41055": 0,
    "41057": 0,
    "41059": 0,
    "41061": 1,
    "41063": 1,
    "41065": 0,
    "41067": 0,
    "41069": 0,
    "41071": 0,
    "42001": 4,
    "42003": 2,
    "42005": 2,
    "42007": 2,
    "42009": 4,
    "42011": 44,
    "42013": 4,
    "42015": 3,
    "42017": 0,
    "42019": 2,
    "42021": 4,
    "42023": 4,
    "42025": 40,
    "42027": 8,
    "42029": 0,
    "42031": 2,
    "42033": 4,
    "42035": 8,
    "42037": 4,
    "42039": 5,
    "42041": 4,
    "42043": 4,
    "42045": 44,
    "42047": 2,
    "42049": 10,
    "42051": 0,
    "42053": 2,
    "42055": 4,
    "42057": 4,
    "42059": 2,
    "42061": 4,
    "42063": 2,
    "42065": 2,
    "42067": 4,
    "42069": 3,
    "42071": 4,
    "42073": 2,
    "42075": 4,
    "42077": 43,
    "42079": 3,
    "42081": 8,
    "42083": 2,
    "42085": 2,
    "42087": 4,
    "42089": 41,
    "42091": 0,
    "42093": 4,
    "42095": 43,
    "42097": 4,
    "42099": 4,
    "42101": 46,
    "42103": 3,
    "42105": 4,
    "42107": 4,
    "42109": 4,
    "42111": 4,
    "42113": 4,
    "42115": 3,
    "42117": 4,
    "42119": 4,
    "42121": 2,
    "42123": 2,
    "42125": 2,
    "42127": 3,
    "42129": 0,
    "42131": 3,
    "42133": 4,
    "44001": 4,
    "44003": 8,
    "44005": 5,
    "44007": 9,
    "44009": 8,
    "45001": 40,
    "45003": 0,
    "45005": 21,
    "45007": 40,
    "45009": 0,
    "45011": 0,
    "45013": 42,
    "45015": 21,
    "45017": 0,
    "45019": 20,
    "45021": 34,
    "45023": 32,
    "45025": 0,
    "45027": 0,
    "45029": 42,
    "45031": 8,
    "45033": 8,
    "45035": 21,
    "45037": 0,
    "45039": 0,
    "45041": 8,
    "45043": 0,
    "45045": 73,
    "45047": 38,
    "45049": 21,
    "45051": 1,
    "45053": 21,
    "45055": 0,
    "45057": 0,
    "45059": 36,
    "45061": 0,
    "45063": 0,
    "45065": 0,
    "45067": 8,
    "45069": 10,
    "45071": 0,
    "45073": 77,
    "45075": 0,
    "45077": 73,
    "45079": 0,
    "45081": 0,
    "45083": 35,
    "45085": 0,
    "45087": 34,
    "45089": 7,
    "45091": 32,
    "46003": 17,
    "46005": 17,
    "46007": 0,
    "46009": 19,
    "46011": 15,
    "46013": 16,
    "46015": 18,
    "46017": 19,
    "46019": 0,
    "46021": 18,
    "46023": 19,
    "46025": 13,
    "46027": 19,
    "46029": 14,
    "46031": 31,
    "46033": 0,
    "46035": 17,
    "46037": 5,
    "46039": 15,
    "46041": 33,
    "46043": 18,
    "46045": 22,
    "46047": 0,
    "46049": 20,
    "46051": 9,
    "46053": 19,
    "46055": 0,
    "46057": 15,
    "46059": 21,
    "46061": 17,
    "46063": 0,
    "46065": 22,
    "46067": 18,
    "46069": 20,
    "46071": 0,
    "46073": 17,
    "46075": 28,
    "46077": 15,
    "46079": 15,
    "46081": 0,
    "46083": 16,
    "46085": 26,
    "46087": 17,
    "46089": 17,
    "46091": 3,
    "46093": 0,
    "46095": 0,
    "46097": 17,
    "46099": 15,
    "46101": 15,
    "46103": 0,
    "46105": 0,
    "46107": 20,
    "46109": 7,
    "46111": 17,
    "46113": 0,
    "46115": 14,
    "46117": 30,
    "46119": 20,
    "46121": 0,
    "46123": 0,
    "46125": 18,
    "46127": 19,
    "46129": 18,
    "46135": 19,
    "46137": 0,
    "47001": 1,
    "47003": 21,
    "47005": 17,
    "47007": 0,
    "47009": 2,
    "47011": 1,
    "47013": 1,
    "47015": 23,
    "47017": 19,
    "47019": 2,
    "47021": 11,
    "47023": 12,
    "47025": 1,
    "47027": 14,
    "47029": 2,
    "47031": 27,
    "47033": 20,
    "47035": 23,
    "47037": 13,
    "47039": 12,
    "47041": 22,
    "47043": 13,
    "47045": 18,
    "47047": 15,
    "47049": 20,
    "47051": 34,
    "47053": 20,
    "47055": 19,
    "47057": 1,
    "47059": 2,
    "47061": 28,
    "47063": 1,
    "47065": 1,
    "47067": 1,
    "47069": 12,
    "47071": 11,
    "47073": 1,
    "47075": 20,
    "47077": 13,
    "47079": 20,
    "47081": 10,
    "47083": 16,
    "47085": 16,
    "47087": 18,
    "47089": 1,
    "47091": 1,
    "47093": 1,
    "47095": 18,
    "47097": 19,
    "47099": 11,
    "47101": 10,
    "47103": 29,
    "47105": 1,
    "47107": 1,
    "47109": 9,
    "47111": 14,
    "47113": 14,
    "47115": 0,
    "47117": 18,
    "47119": 15,
    "47121": 1,
    "47123": 2,
    "47125": 16,
    "47127": 26,
    "47129": 1,
    "47131": 19,
    "47133": 18,
    "47135": 10,
    "47137": 13,
    "47139": 2,
    "47141": 20,
    "47143": 1,
    "47145": 1,
    "47147": 12,
    "47149": 20,
    "47151": 1,
    "47153": 0,
    "47155": 2,
    "47157": 17,
    "47159": 19,
    "47161": 16,
    "47163": 1,
    "47165": 12,
    "47167": 18,
    "47169": 17,
    "47171": 1,
    "47173": 1,
    "47175": 25,
    "47177": 25,
    "47179": 1,
    "47181": 10,
    "47183": 20,
    "47185": 24,
    "47187": 12,
    "47189": 20,
    "48001": 47,
    "48003": 16,
    "48005": 23,
    "48007": 53,
    "48009": 70,
    "48011": 36,
    "48013": 29,
    "48015": 9,
    "48017": 74,
    "48019": 58,
    "48021": 31,
    "48023": 76,
    "48025": 67,
    "48027": 74,
    "48029": 32,
    "48031": 43,
    "48033": 16,
    "48035": 61,
    "48037": 35,
    "48039": 9,
    "48041": 9,
    "48043": 0,
    "48045": 90,
    "48047": 137,
    "48049": 45,
    "48051": 9,
    "48053": 44,
    "48055": 34,
    "48057": 57,
    "48059": 43,
    "48061": 191,
    "48063": 36,
    "48065": 39,
    "48067": 34,
    "48069": 79,
    "48071": 9,
    "48073": 29,
    "48075": 91,
    "48077": 69,
    "48079": 81,
    "48081": 37,
    "48083": 37,
    "48085": 57,
    "48087": 32,
    "48089": 9,
    "48091": 41,
    "48093": 62,
    "48095": 32,
    "48097": 63,
    "48099": 66,
    "48101": 95,
    "48103": 16,
    "48105": 39,
    "48107": 80,
    "48109": 1,
    "48111": 41,
    "48113": 56,
    "48115": 16,
    "48117": 29,
    "48119": 58,
    "48121": 66,
    "48123": 41,
    "48125": 89,
    "48127": 47,
    "48129": 32,
    "48131": 67,
    "48133": 60,
    "48135": 16,
    "48137": 74,
    "48139": 56,
    "48141": 29,
    "48143": 61,
    "48145": 60,
    "48147": 55,
    "48149": 26,
    "48151": 51,
    "48153": 87,
    "48155": 80,
    "48157": 9,
    "48159": 36,
    "48161": 49,
    "48163": 44,
    "48165": 16,
    "48167": 9,
    "48169": 83,
    "48171": 62,
    "48173": 16,
    "48175": 72,
    "48177": 26,
    "48179": 32,
    "48181": 60,
    "48183": 31,
    "48185": 9,
    "48187": 31,
    "48189": 82,
    "48191": 77,
    "48193": 59,
    "48195": 38,
    "48197": 80,
    "48199": 5,
    "48201": 9,
    "48203": 34,
    "48205": 41,
    "48207": 60,
    "48209": 29,
    "48211": 34,
    "48213": 39,
    "48215": 137,
    "48217": 60,
    "48219": 80,
    "48221": 67,
    "48223": 58,
    "48225": 9,
    "48227": 16,
    "48229": 59,
    "48231": 58,
    "48233": 36,
    "48235": 38,
    "48237": 65,
    "48239": 9,
    "48241": 0,
    "48243": 0,
    "48245": 5,
    "48247": 147,
    "48249": 67,
    "48251": 63,
    "48253": 54,
    "48255": 37,
    "48257": 47,
    "48259": 61,
    "48261": 126,
    "48263": 89,
    "48265": 65,
    "48267": 55,
    "48269": 97,
    "48271": 57,
    "48273": 61,
    "48275": 78,
    "48277": 59,
    "48279": 79,
    "48281": 64,
    "48283": 60,
    "48285": 26,
    "48287": 29,
    "48289": 51,
    "48291": 9,
    "48293": 57,
    "48295": 33,
    "48297": 66,
    "48299": 51,
    "48301": 16,
    "48303": 82,
    "48305": 83,
    "48307": 40,
    "48309": 62,
    "48311": 54,
    "48313": 9,
    "48315": 35,
    "48317": 16,
    "48319": 55,
    "48321": 9,
    "48323": 47,
    "48325": 57,
    "48327": 40,
    "48329": 16,
    "48331": 64,
    "48333": 61,
    "48335": 4,
    "48337": 60,
    "48339": 9,
    "48341": 40,
    "48343": 34,
    "48345": 91,
    "48347": 25,
    "48349": 47,
    "48351": 0,
    "48353": 40,
    "48355": 71,
    "48357": 29,
    "48359": 32,
    "48361": 5,
    "48363": 69,
    "48365": 28,
    "48367": 69,
    "48369": 81,
    "48371": 17,
    "48373": 9,
    "48375": 40,
    "48377": 0,
    "48379": 53,
    "48381": 32,
    "48383": 16,
    "48385": 57,
    "48387": 39,
    "48389": 0,
    "48391": 60,
    "48393": 32,
    "48395": 56,
    "48397": 55,
    "48399": 34,
    "48401": 29,
    "48403": 24,
    "48405": 24,
    "48407": 9,
    "48409": 68,
    "48411": 49,
    "48413": 44,
    "48415": 15,
    "48417": 61,
    "48419": 27,
    "48421": 40,
    "48423": 33,
    "48425": 66,
    "48427": 133,
    "48429": 69,
    "48431": 34,
    "48433": 94,
    "48435": 58,
    "48437": 84,
    "48439": 65,
    "48441": 44,
    "48443": 16,
    "48445": 84,
    "48447": 60,
    "48449": 37,
    "48451": 35,
    "48453": 28,
    "48455": 9,
    "48457": 5,
    "48459": 37,
    "48461": 16,
    "48463": 53,
    "48465": 75,
    "48467": 43,
    "48469": 65,
    "48471": 9,
    "48473": 9,
    "48475": 16,
    "48477": 9,
    "48479": 71,
    "48481": 9,
    "48483": 32,
    "48485": 76,
    "48487": 79,
    "48489": 183,
    "48491": 35,
    "48493": 29,
    "48495": 16,
    "48497": 70,
    "48499": 35,
    "48501": 82,
    "48503": 69,
    "48505": 128,
    "48507": 49,
    "49001": 0,
    "49003": 0,
    "49005": 0,
    "49007": 0,
    "49009": 107,
    "49011": 0,
    "49013": 0,
    "49015": 0,
    "49017": 0,
    "49019": 325,
    "49021": 0,
    "49023": 0,
    "49025": 0,
    "49027": 0,
    "49029": 0,
    "49031": 0,
    "49033": 0,
    "49035": 0,
    "49037": 368,
    "49039": 0,
    "49041": 0,
    "49043": 0,
    "49045": 0,
    "49047": 316,
    "49049": 0,
    "49051": 0,
    "49053": 0,
    "49055": 0,
    "49057": 0,
    "50001": 0,
    "50003": 1,
    "50005": 0,
    "50007": 0,
    "50009": 0,
    "50011": 0,
    "50013": 0,
    "50015": 0,
    "50017": 0,
    "50019": 0,
    "50021": 0,
    "50023": 0,
    "50025": 1,
    "50027": 0,
    "51001": 1,
    "51003": 0,
    "51005": 6,
    "51007": 3,
    "51009": 7,
    "51011": 11,
    "51013": 9,
    "51015": 0,
    "51017": 6,
    "51019": 9,
    "51021": 16,
    "51023": 7,
    "51025": 3,
    "51027": 14,
    "51029": 12,
    "51031": 12,
    "51033": 2,
    "51035": 20,
    "51036": 2,
    "51037": 13,
    "51041": 0,
    "51043": 12,
    "51045": 7,
    "51047": 11,
    "51049": 3,
    "51051": 14,
    "51053": 3,
    "51057": 0,
    "51059": 10,
    "51061": 0,
    "51063": 12,
    "51065": 2,
    "51067": 12,
    "51069": 11,
    "51071": 10,
    "51073": 0,
    "51075": 2,
    "51077": 21,
    "51079": 9,
    "51081": 0,
    "51083": 15,
    "51085": 0,
    "51087": 0,
    "51089": 16,
    "51091": 0,
    "51093": 1,
    "51095": 2,
    "51097": 0,
    "51099": 12,
    "51101": 0,
    "51103": 6,
    "51105": 0,
    "51107": 0,
    "51109": 0,
    "51111": 0,
    "51113": 11,
    "51115": 0,
    "51117": 0,
    "51119": 4,
    "51121": 12,
    "51125": 9,
    "51127": 1,
    "51131": 1,
    "51133": 2,
    "51135": 3,
    "51137": 11,
    "51139": 8,
    "51141": 16,
    "51143": 17,
    "51145": 3,
    "51147": 3,
    "51149": 1,
    "51153": 12,
    "51155": 12,
    "51157": 11,
    "51159": 4,
    "51161": 8,
    "51163": 6,
    "51165": 8,
    "51167": 0,
    "51169": 0,
    "51171": 9,
    "51173": 20,
    "51175": 0,
    "51177": 12,
    "51179": 12,
    "51181": 0,
    "51183": 0,
    "51185": 18,
    "51187": 10,
    "51191": 0,
    "51193": 4,
    "51195": 0,
    "51197": 17,
    "51199": 0,
    "51510": 9,
    "51515": 0,
    "51520": 0,
    "51530": 6,
    "51540": 9,
    "51550": 0,
    "51570": 0,
    "51580": 6,
    "51590": 17,
    "51595": 0,
    "51600": 10,
    "51610": 9,
    "51620": 0,
    "51630": 12,
    "51640": 20,
    "51650": 0,
    "51660": 8,
    "51670": 1,
    "51678": 6,
    "51680": 12,
    "51683": 12,
    "51685": 12,
    "51690": 16,
    "51700": 0,
    "51710": 2,
    "51720": 0,
    "51730": 1,
    "51735": 0,
    "51740": 2,
    "51750": 12,
    "51760": 0,
    "51770": 8,
    "51775": 8,
    "51790": 8,
    "51800": 2,
    "51810": 0,
    "51820": 8,
    "51830": 1,
    "51840": 11,
    "53001": 0,
    "53003": 0,
    "53005": 1,
    "53007": 0,
    "53009": 0,
    "53011": 0,
    "53013": 1,
    "53015": 2,
    "53017": 0,
    "53019": 0,
    "53021": 1,
    "53023": 0,
    "53025": 0,
    "53027": 0,
    "53029": 0,
    "53031": 0,
    "53033": 0,
    "53035": 0,
    "53037": 0,
    "53039": 1,
    "53041": 0,
    "53043": 0,
    "53045": 0,
    "53047": 0,
    "53049": 2,
    "53051": 0,
    "53053": 0,
    "53055": 2,
    "53057": 0,
    "53059": 0,
    "53061": 0,
    "53063": 0,
    "53065": 0,
    "53067": 0,
    "53069": 2,
    "53071": 2,
    "53073": 0,
    "53075": 0,
    "53077": 0,
    "54001": 9,
    "54003": 13,
    "54005": 12,
    "54007": 9,
    "54009": 2,
    "54011": 14,
    "54013": 9,
    "54015": 10,
    "54017": 9,
    "54019": 0,
    "54021": 9,
    "54023": 0,
    "54025": 0,
    "54027": 11,
    "54029": 2,
    "54031": 11,
    "54033": 8,
    "54035": 15,
    "54037": 13,
    "54039": 14,
    "54041": 8,
    "54043": 14,
    "54045": 12,
    "54047": 10,
    "54049": 2,
    "54051": 2,
    "54053": 14,
    "54055": 12,
    "54057": 0,
    "54059": 12,
    "54061": 0,
    "54063": 7,
    "54065": 11,
    "54067": 0,
    "54069": 2,
    "54071": 0,
    "54073": 9,
    "54075": 0,
    "54077": 0,
    "54079": 14,
    "54081": 0,
    "54083": 0,
    "54085": 9,
    "54087": 12,
    "54089": 7,
    "54091": 9,
    "54093": 0,
    "54095": 9,
    "54097": 9,
    "54099": 14,
    "54101": 0,
    "54103": 2,
    "54105": 9,
    "54107": 9,
    "54109": 10,
    "55001": 6,
    "55003": 27,
    "55005": 0,
    "55007": 25,
    "55009": 4,
    "55011": 13,
    "55013": 27,
    "55015": 4,
    "55017": 0,
    "55019": 10,
    "55021": 18,
    "55023": 5,
    "55025": 18,
    "55027": 18,
    "55029": 6,
    "55031": 25,
    "55033": 0,
    "55035": 0,
    "55037": 23,
    "55039": 19,
    "55041": 24,
    "55043": 8,
    "55045": 17,
    "55047": 17,
    "55049": 18,
    "55051": 31,
    "55053": 10,
    "55055": 18,
    "55057": 7,
    "55059": 17,
    "55061": 3,
    "55063": 7,
    "55065": 17,
    "55067": 19,
    "55069": 29,
    "55071": 4,
    "55073": 16,
    "55075": 42,
    "55077": 17,
    "55078": 17,
    "55079": 17,
    "55081": 8,
    "55083": 34,
    "55085": 35,
    "55087": 5,
    "55089": 17,
    "55091": 0,
    "55093": 0,
    "55095": 0,
    "55097": 16,
    "55099": 30,
    "55101": 18,
    "55103": 5,
    "55105": 17,
    "55107": 0,
    "55109": 0,
    "55111": 18,
    "55113": 30,
    "55115": 15,
    "55117": 15,
    "55119": 11,
    "55121": 13,
    "55123": 6,
    "55125": 33,
    "55127": 18,
    "55129": 31,
    "55131": 18,
    "55133": 18,
    "55135": 10,
    "55137": 6,
    "55139": 5,
    "55141": 18,
    "56001": 0,
    "56003": 0,
    "56005": 0,
    "56007": 0,
    "56009": 0,
    "56011": 0,
    "56013": 0,
    "56015": 0,
    "56017": 0,
    "56019": 0,
    "56021": 0,
    "56023": 0,
    "56025": 0,
    "56027": 0,
    "56029": 0,
    "56031": 0,
    "56033": 0,
    "56035": 0,
    "56037": 0,
    "56039": 0,
    "56041": 0,
    "56043": 0,
    "56045": 0
  },
  {
    "1001": 8,
    "1003": 20,
    "1005": 8,
    "1007": 7,
    "1009": 4,
    "1011": 8,
    "1013": 10,
    "1015": 5,
    "1017": 6,
    "1019": 5,
    "1021": 7,
    "1023": 11,
    "1025": 13,
    "1027": 6,
    "1029": 6,
    "1031": 10,
    "1033": 5,
    "1035": 11,
    "1037": 7,
    "1039": 12,
    "1041": 10,
    "1043": 6,
    "1045": 9,
    "1047": 8,
    "1049": 5,
    "1051": 7,
    "1053": 11,
    "1055": 5,
    "1057": 4,
    "1059": 4,
    "1061": 13,
    "1063": 7,
    "1065": 7,
    "1067": 9,
    "1069": 9,
    "1071": 4,
    "1073": 8,
    "1075": 5,
    "1077": 5,
    "1079": 4,
    "1081": 6,
    "1083": 4,
    "1085": 8,
    "1087": 8,
    "1089": 4,
    "1091": 8,
    "1093": 5,
    "1095": 4,
    "1097": 21,
    "1099": 11,
    "1101": 8,
    "1103": 4,
    "1105": 8,
    "1107": 7,
    "1109": 8,
    "1111": 6,
    "1113": 7,
    "1115": 6,
    "1117": 6,
    "1119": 8,
    "1121": 7,
    "1123": 6,
    "1125": 7,
    "1127": 4,
    "1129": 12,
    "1131": 7,
    "1133": 5,
    "2013": 0,
    "2016": 0,
    "2020": 0,
    "2050": 0,
    "2060": 0,
    "2068": 0,
    "2070": 0,
    "2090": 0,
    "2100": 0,
    "2110": 0,
    "2122": 0,
    "2130": 0,
    "2150": 0,
    "2164": 0,
    "2170": 0,
    "2180": 0,
    "2185": 0,
    "2188": 0,
    "2201": 0,
    "2220": 0,
    "2232": 0,
    "2240": 0,
    "2261": 0,
    "2270": 0,
    "2280": 0,
    "2282": 0,
    "2290": 0,
    "4001": 1,
    "4003": 1,
    "4005": 1,
    "4007": 1,
    "4009": 1,
    "4011": 1,
    "4012": 1,
    "4013": 1,
    "4015": 1,
    "4017": 1,
    "4019": 1,
    "4021": 1,
    "4023": 1,
    "4025": 1,
    "4027": 1,
    "5001": 1,
    "5003": 2,
    "5005": 1,
    "5007": 1,
    "5009": 1,
    "5011": 2,
    "5013": 2,
    "5015": 1,
    "5017": 2,
    "5019": 2,
    "5021": 1,
    "5023": 1,
    "5025": 2,
    "5027": 1,
    "5029": 2,
    "5031": 1,
    "5033": 1,
    "5035": 1,
    "5037": 1,
    "5039": 2,
    "5041": 1,
    "5043": 2,
    "5045": 1,
    "5047": 1,
    "5049": 1,
    "5051": 2,
    "5053": 2,
    "5055": 1,
    "5057": 1,
    "5059": 2,
    "5061": 1,
    "5063": 1,
    "5065": 1,
    "5067": 1,
    "5069": 1,
    "5071": 1,
    "5073": 1,
    "5075": 1,
    "5077": 1,
    "5079": 2,
    "5081": 1,
    "5083": 1,
    "5085": 1,
    "5087": 1,
    "5089": 1,
    "5091": 1,
    "5093": 1,
    "5095": 1,
    "5097": 2,
    "5099": 1,
    "5101": 1,
    "5103": 1,
    "5105": 2,
    "5107": 1,
    "5109": 1,
    "5111": 1,
    "5113": 1,
    "5115": 1,
    "5117": 2,
    "5119": 1,
    "5121": 1,
    "5123": 1,
    "5125": 2,
    "5127": 1,
    "5129": 1,
    "5131": 1,
    "5133": 1,
    "5135": 1,
    "5137": 1,
    "5139": 1,
    "5141": 2,
    "5143": 1,
    "5145": 1,
    "5147": 1,
    "5149": 1,
    "6001": 1,
    "6003": 1,
    "6005": 1,
    "6007": 1,
    "6009": 1,
    "6011": 1,
    "6013": 1,
    "6015": 1,
    "6017": 1,
    "6019": 1,
    "6021": 1,
    "6023": 1,
    "6025": 1,
    "6027": 1,
    "6029": 1,
    "6031": 1,
    "6033": 1,
    "6035": 1,
    "6037": 1,
    "6039": 1,
    "6041": 1,
    "6043": 1,
    "6045": 1,
    "6047": 1,
    "6049": 1,
    "6051": 1,
    "6053": 1,
    "6055": 1,
    "6057": 1,
    "6059": 1,
    "6061": 1,
    "6063": 1,
    "6065": 1,
    "6067": 1,
    "6069": 1,
    "6071": 1,
    "6073": 1,
    "6075": 1,
    "6077": 1,
    "6079": 1,
    "6081": 1,
    "6083": 1,
    "6085": 1,
    "6087": 1,
    "6089": 1,
    "6091": 1,
    "6093": 1,
    "6095": 1,
    "6097": 1,
    "6099": 1,
    "6101": 1,
    "6103": 1,
    "6105": 1,
    "6107": 1,
    "6109": 1,
    "6111": 1,
    "6113": 1,
    "6115": 1,
    "8001": 0,
    "8003": 0,
    "8005": 0,
    "8007": 0,
    "8009": 0,
    "8011": 0,
    "8013": 0,
    "8014": 0,
    "8015": 0,
    "8017": 0,
    "8019": 0,
    "8021": 0,
    "8023": 0,
    "8025": 0,
    "8027": 0,
    "8029": 0,
    "8031": 0,
    "8033": 0,
    "8035": 0,
    "8037": 0,
    "8039": 0,
    "8041": 0,
    "8043": 0,
    "8045": 0,
    "8047": 0,
    "8049": 0,
    "8051": 0,
    "8053": 0,
    "8055": 0,
    "8057": 0,
    "8059": 0,
    "8061": 0,
    "8063": 0,
    "8065": 0,
    "8067": 0,
    "8069": 0,
    "8071": 0,
    "8073": 0,
    "8075": 0,
    "8077": 0,
    "8079": 0,
    "8081": 0,
    "8083": 0,
    "8085": 0,
    "8087": 0,
    "8089": 0,
    "8091": 0,
    "8093": 0,
    "8095": 0,
    "8097": 0,
    "8099": 0,
    "8101": 0,
    "8103": 0,
    "8105": 0,
    "8107": 0,
    "8109": 0,
    "8111": 0,
    "8113": 0,
    "8115": 0,
    "8117": 0,
    "8119": 0,
    "8121": 0,
    "8123": 0,
    "8125": 0,
    "9001": 7,
    "9003": 7,
    "9005": 7,
    "9007": 7,
    "9009": 7,
    "9011": 7,
    "9013": 7,
    "9015": 7,
    "10001": 6,
    "10003": 7,
    "10005": 6,
    "11001": 6,
    "12001": 7,
    "12003": 8,
    "12005": 17,
    "12007": 7,
    "12009": 15,
    "12011": 17,
    "12013": 12,
    "12015": 11,
    "12017": 10,
    "12019": 9,
    "12021": 17,
    "12023": 8,
    "12027": 9,
    "12029": 11,
    "12031": 12,
    "12033": 16,
    "12035": 13,
    "12037": 18,
    "12039": 12,
    "12041": 7,
    "12043": 14,
    "12045": 16,
    "12047": 7,
    "12049": 9,
    "12051": 12,
    "12053": 10,
    "12055": 13,
    "12057": 11,
    "12059": 11,
    "12061": 14,
    "12063": 11,
    "12065": 12,
    "12067": 7,
    "12069": 10,
    "12071": 13,
    "12073": 11,
    "12075": 10,
    "12077": 12,
    "12079": 8,
    "12081": 12,
    "12083": 10,
    "12085": 17,
    "12086": 10,
    "12087": 19,
    "12089": 10,
    "12091": 16,
    "12093": 11,
    "12095": 11,
    "12097": 12,
    "12099": 17,
    "12101": 11,
    "12103": 11,
    "12105": 11,
    "12107": 9,
    "12109": 12,
    "12111": 16,
    "12113": 16,
    "12115": 12,
    "12117": 11,
    "12119": 8,
    "12121": 10,
    "12123": 12,
    "12125": 7,
    "12127": 13,
    "12129": 15,
    "12131": 14,
    "12133": 11,
    "13001": 6,
    "13003": 6,
    "13005": 6,
    "13007": 5,
    "13009": 3,
    "13011": 5,
    "13013": 4,
    "13015": 4,
    "13017": 5,
    "13019": 5,
    "13021": 4,
    "13023": 5,
    "13025": 6,
    "13027": 5,
    "13029": 6,
    "13031": 6,
    "13033": 5,
    "13035": 4,
    "13037": 5,
    "13039": 7,
    "13043": 7,
    "13045": 5,
    "13047": 4,
    "13049": 5,
    "13051": 6,
    "13053": 4,
    "13055": 4,
    "13057": 5,
    "13059": 3,
    "13061": 0,
    "13063": 5,
    "13065": 5,
    "13067": 5,
    "13069": 6,
    "13071": 5,
    "13073": 3,
    "13075": 5,
    "13077": 4,
    "13079": 5,
    "13081": 5,
    "13083": 5,
    "13085": 5,
    "13087": 5,
    "13089": 5,
    "13091": 5,
    "13093": 5,
    "13095": 5,
    "13097": 4,
    "13099": 5,
    "13101": 6,
    "13103": 5,
    "13105": 5,
    "13107": 7,
    "13109": 7,
    "13111": 5,
    "13113": 4,
    "13115": 4,
    "13117": 5,
    "13119": 4,
    "13121": 5,
    "13123": 5,
    "13125": 4,
    "13127": 7,
    "13129": 4,
    "13131": 5,
    "13133": 4,
    "13135": 4,
    "13137": 5,
    "13139": 4,
    "13141": 5,
    "13143": 4,
    "13145": 6,
    "13147": 4,
    "13149": 5,
    "13151": 3,
    "13153": 5,
    "13155": 5,
    "13157": 3,
    "13159": 4,
    "13161": 6,
    "13163": 4,
    "13165": 6,
    "13167": 5,
    "13169": 5,
    "13171": 4,
    "13173": 4,
    "13175": 5,
    "13177": 4,
    "13179": 6,
    "13181": 3,
    "13183": 6,
    "13185": 4,
    "13187": 5,
    "13189": 3,
    "13191": 7,
    "13193": 5,
    "13195": 4,
    "13197": 4,
    "13199": 4,
    "13201": 5,
    "13205": 4,
    "13207": 4,
    "13209": 5,
    "13211": 3,
    "13213": 4,
    "13215": 4,
    "13217": 3,
    "13219": 3,
    "13221": 3,
    "13223": 4,
    "13225": 5,
    "13227": 5,
    "13229": 6,
    "13231": 6,
    "13233": 4,
    "13235": 5,
    "13237": 5,
    "13239": 0,
    "13241": 6,
    "13243": 5,
    "13245": 3,
    "13247": 4,
    "13249": 5,
    "13251": 6,
    "13253": 4,
    "13255": 5,
    "13257": 4,
    "13259": 5,
    "13261": 5,
    "13263": 5,
    "13265": 4,
    "13267": 7,
    "13269": 4,
    "13271": 5,
    "13273": 4,
    "13275": 5,
    "13277": 5,
    "13279": 7,
    "13281": 5,
    "13283": 6,
    "13285": 4,
    "13287": 5,
    "13289": 5,
    "13291": 5,
    "13293": 6,
    "13295": 4,
    "13297": 3,
    "13299": 6,
    "13301": 3,
    "13303": 5,
    "13305": 6,
    "13307": 5,
    "13309": 5,
    "13311": 5,
    "13313": 4,
    "13315": 5,
    "13317": 5,
    "13319": 5,
    "13321": 5,
    "15001": 3,
    "15003": 2,
    "15005": 1,
    "15007": 3,
    "15009": 3,
    "16001": 0,
    "16003": 1,
    "16005": 1,
    "16007": 1,
    "16009": 1,
    "16011": 1,
    "16013": 1,
    "16015": 1,
    "16017": 1,
    "16019": 1,
    "16021": 1,
    "16023": 1,
    "16025": 1,
    "16027": 1,
    "16029": 1,
    "16031": 1,
    "16033": 1,
    "16035": 1,
    "16037": 1,
    "16039": 1,
    "16041": 1,
    "16043": 1,
    "16045": 1,
    "16047": 1,
    "16049": 1,
    "16051": 1,
    "16053": 1,
    "16055": 1,
    "16057": 1,
    "16059": 1,
    "16061": 1,
    "16063": 1,
    "16065": 1,
    "16067": 1,
    "16069": 1,
    "16071": 1,
    "16073": 1,
    "16075": 1,
    "16077": 1,
    "16079": 1,
    "16081": 1,
    "16083": 1,
    "16085": 1,
    "16087": 1,
    "17001": 1,
    "17003": 1,
    "17005": 1,
    "17007": 1,
    "17009": 1,
    "17011": 1,
    "17013": 1,
    "17015": 1,
    "17017": 1,
    "17019": 1,
    "17021": 1,
    "17023": 1,
    "17025": 1,
    "17027": 1,
    "17029": 1,
    "17031": 1,
    "17033": 1,
    "17035": 1,
    "17037": 1,
    "17039": 1,
    "17041": 1,
    "17043": 1,
    "17045": 1,
    "17047": 1,
    "17049": 1,
    "17051": 1,
    "17053": 1,
    "17055": 1,
    "17057": 1,
    "17059": 1,
    "17061": 1,
    "17063": 1,
    "17065": 1,
    "17067": 1,
    "17069": 1,
    "17071": 1,
    "17073": 1,
    "17075": 1,
    "17077": 1,
    "17079": 1,
    "17081": 1,
    "17083": 1,
    "17085": 1,
    "17087": 1,
    "17089": 1,
    "17091": 1,
    "17093": 1,
    "17095": 1,
    "17097": 1,
    "17099": 0,
    "17101": 1,
    "17103": 1,
    "17105": 1,
    "17107": 1,
    "17109": 1,
    "17111": 1,
    "17113": 1,
    "17115": 1,
    "17117": 1,
    "17119": 1,
    "17121": 1,
    "17123": 1,
    "17125": 1,
    "17127": 1,
    "17129": 1,
    "17131": 1,
    "17133": 1,
    "17135": 1,
    "17137": 1,
    "17139": 1,
    "17141": 1,
    "17143": 1,
    "17145": 1,
    "17147": 1,
    "17149": 1,
    "17151": 1,
    "17153": 1,
    "17155": 1,
    "17157": 1,
    "17159": 1,
    "17161": 1,
    "17163": 1,
    "17165": 1,
    "17167": 1,
    "17169": 1,
    "17171": 1,
    "17173": 1,
    "17175": 1,
    "17177": 1,
    "17179": 1,
    "17181": 1,
    "17183": 1,
    "17185": 1,
    "17187": 1,
    "17189": 1,
    "17191": 1,
    "17193": 0,
    "17195": 1,
    "17197": 0,
    "17199": 1,
    "17201": 1,
    "17203": 1,
    "18001": 1,
    "18003": 1,
    "18005": 1,
    "18007": 1,
    "18009": 1,
    "18011": 1,
    "18013": 1,
    "18015": 1,
    "18017": 1,
    "18019": 1,
    "18021": 1,
    "18023": 1,
    "18025": 1,
    "18027": 1,
    "18029": 1,
    "18031": 1,
    "18033": 1,
    "18035": 1,
    "18037": 1,
    "18039": 1,
    "18041": 1,
    "18043": 1,
    "18045": 1,
    "18047": 1,
    "18049": 1,
    "18051": 1,
    "18053": 1,
    "18055": 1,
    "18057": 1,
    "18059": 1,
    "18061": 1,
    "18063": 1,
    "18065": 1,
    "18067": 1,
    "18069": 1,
    "18071": 1,
    "18073": 1,
    "18075": 1,
    "18077": 1,
    "18079": 1,
    "18081": 1,
    "18083": 1,
    "18085": 1,
    "18087": 1,
    "18089": 1,
    "18091": 1,
    "18093": 1,
    "18095": 1,
    "18097": 1,
    "18099": 1,
    "18101": 1,
    "18103": 1,
    "18105": 1,
    "18107": 1,
    "18109": 1,
    "18111": 1,
    "18113": 1,
    "18115": 1,
    "18117": 1,
    "18119": 1,
    "18121": 1,
    "18123": 1,
    "18125": 1,
    "18127": 1,
    "18129": 1,
    "18131": 1,
    "18133": 1,
    "18135": 1,
    "18137": 1,
    "18139": 1,
    "18141": 1,
    "18143": 1,
    "18145": 1,
    "18147": 1,
    "18149": 1,
    "18151": 1,
    "18153": 1,
    "18155": 1,
    "18157": 1,
    "18159": 1,
    "18161": 1,
    "18163": 1,
    "18165": 1,
    "18167": 1,
    "18169": 1,
    "18171": 1,
    "18173": 1,
    "18175": 1,
    "18177": 1,
    "18179": 1,
    "18181": 1,
    "18183": 1,
    "19001": 1,
    "19003": 1,
    "19005": 1,
    "19007": 1,
    "19009": 1,
    "19011": 1,
    "19013": 1,
    "19015": 1,
    "19017": 1,
    "19019": 1,
    "19021": 1,
    "19023": 1,
    "19025": 1,
    "19027": 1,
    "19029": 1,
    "19031": 1,
    "19033": 1,
    "19035": 1,
    "19037": 1,
    "19039": 1,
    "19041": 0,
    "19043": 1,
    "19045": 1,
    "19047": 1,
    "19049": 1,
    "19051": 1,
    "19053": 1,
    "19055": 1,
    "19057": 1,
    "19059": 1,
    "19061": 1,
    "19063": 1,
    "19065": 1,
    "19067": 1,
    "19069": 1,
    "19071": 1,
    "19073": 1,
    "19075": 1,
    "19077": 1,
    "19079": 1,
    "19081": 1,
    "19083": 1,
    "19085": 1,
    "19087": 1,
    "19089": 1,
    "19091": 1,
    "19093": 1,
    "19095": 1,
    "19097": 1,
    "19099": 1,
    "19101": 1,
    "19103": 1,
    "19105": 1,
    "19107": 1,
    "19109": 1,
    "19111": 1,
    "19113": 1,
    "19115": 1,
    "19117": 1,
    "19119": 1,
    "19121": 1,
    "19123": 1,
    "19125": 1,
    "19127": 1,
    "19129": 1,
    "19131": 1,
    "19133": 1,
    "19135": 1,
    "19137": 1,
    "19139": 1,
    "19141": 1,
    "19143": 1,
    "19145": 1,
    "19147": 1,
    "19149": 1,
    "19151": 1,
    "19153": 1,
    "19155": 1,
    "19157": 1,
    "19159": 1,
    "19161": 1,
    "19163": 1,
    "19165": 1,
    "19167": 1,
    "19169": 1,
    "19171": 1,
    "19173": 1,
    "19175": 1,
    "19177": 1,
    "19179": 1,
    "19181": 1,
    "19183": 1,
    "19185": 1,
    "19187": 1,
    "19189": 1,
    "19191": 1,
    "19193": 1,
    "19195": 1,
    "19197": 1,
    "20001": 1,
    "20003": 1,
    "20005": 1,
    "20007": 1,
    "20009": 1,
    "20011": 1,
    "20013": 1,
    "20015": 1,
    "20017": 1,
    "20019": 1,
    "20021": 1,
    "20023": 1,
    "20025": 1,
    "20027": 1,
    "20029": 1,
    "20031": 1,
    "20033": 1,
    "20035": 1,
    "20037": 1,
    "20039": 1,
    "20041": 1,
    "20043": 1,
    "20045": 1,
    "20047": 1,
    "20049": 1,
    "20051": 1,
    "20053": 1,
    "20055": 1,
    "20057": 1,
    "20059": 1,
    "20061": 1,
    "20063": 1,
    "20065": 1,
    "20067": 1,
    "20069": 1,
    "20071": 1,
    "20073": 1,
    "20075": 1,
    "20077": 1,
    "20079": 1,
    "20081": 1,
    "20083": 1,
    "20085": 1,
    "20087": 1,
    "20089": 1,
    "20091": 1,
    "20093": 1,
    "20095": 1,
    "20097": 1,
    "20099": 1,
    "20101": 1,
    "20103": 1,
    "20105": 1,
    "20107": 1,
    "20109": 1,
    "20111": 1,
    "20113": 1,
    "20115": 1,
    "20117": 1,
    "20119": 1,
    "20121": 1,
    "20123": 1,
    "20125": 1,
    "20127": 1,
    "20129": 1,
    "20131": 1,
    "20133": 1,
    "20135": 1,
    "20137": 1,
    "20139": 1,
    "20141": 1,
    "20143": 1,
    "20145": 1,
    "20147": 1,
    "20149": 1,
    "20151": 1,
    "20153": 1,
    "20155": 1,
    "20157": 1,
    "20159": 1,
    "20161": 1,
    "20163": 1,
    "20165": 1,
    "20167": 1,
    "20169": 1,
    "20171": 1,
    "20173": 1,
    "20175": 1,
    "20177": 1,
    "20179": 1,
    "20181": 1,
    "20183": 1,
    "20185": 1,
    "20187": 1,
    "20189": 1,
    "20191": 1,
    "20193": 1,
    "20195": 1,
    "20197": 1,
    "20199": 1,
    "20201": 1,
    "20203": 1,
    "20205": 1,
    "20207": 1,
    "20209": 1,
    "21001": 1,
    "21003": 1,
    "21005": 1,
    "21007": 1,
    "21009": 1,
    "21011": 1,
    "21013": 1,
    "21015": 1,
    "21017": 1,
    "21019": 1,
    "21021": 1,
    "21023": 1,
    "21025": 1,
    "21027": 1,
    "21029": 1,
    "21031": 1,
    "21033": 1,
    "21035": 1,
    "21037": 1,
    "21039": 1,
    "21041": 1,
    "21043": 1,
    "21045": 1,
    "21047": 1,
    "21049": 1,
    "21051": 1,
    "21053": 1,
    "21055": 1,
    "21057": 1,
    "21059": 1,
    "21061": 1,
    "21063": 1,
    "21065": 1,
    "21067": 1,
    "21069": 1,
    "21071": 1,
    "21073": 1,
    "21075": 1,
    "21077": 1,
    "21079": 1,
    "21081": 1,
    "21083": 1,
    "21085": 1,
    "21087": 0,
    "21089": 1,
    "21091": 1,
    "21093": 1,
    "21095": 1,
    "21097": 1,
    "21099": 1,
    "21101": 1,
    "21103": 1,
    "21105": 1,
    "21107": 1,
    "21109": 1,
    "21111": 1,
    "21113": 1,
    "21115": 1,
    "21117": 1,
    "21119": 1,
    "21121": 1,
    "21123": 1,
    "21125": 1,
    "21127": 1,
    "21129": 1,
    "21131": 1,
    "21133": 1,
    "21135": 1,
    "21137": 1,
    "21139": 1,
    "21141": 1,
    "21143": 1,
    "21145": 1,
    "21147": 1,
    "21149": 1,
    "21151": 1,
    "21153": 1,
    "21155": 1,
    "21157": 1,
    "21159": 1,
    "21161": 1,
    "21163": 1,
    "21165": 1,
    "21167": 1,
    "21169": 1,
    "21171": 1,
    "21173": 1,
    "21175": 1,
    "21177": 1,
    "21179": 1,
    "21181": 1,
    "21183": 1,
    "21185": 1,
    "21187": 1,
    "21189": 1,
    "21191": 1,
    "21193": 1,
    "21195": 1,
    "21197": 1,
    "21199": 1,
    "21201": 1,
    "21203": 1,
    "21205": 1,
    "21207": 1,
    "21209": 1,
    "21211": 1,
    "21213": 1,
    "21215": 1,
    "21217": 1,
    "21219": 1,
    "21221": 1,
    "21223": 1,
    "21225": 1,
    "21227": 1,
    "21229": 1,
    "21231": 1,
    "21233": 1,
    "21235": 1,
    "21237": 1,
    "21239": 1,
    "22001": 16,
    "22003": 13,
    "22005": 15,
    "22007": 17,
    "22009": 12,
    "22011": 12,
    "22013": 7,
    "22015": 8,
    "22017": 8,
    "22019": 13,
    "22021": 9,
    "22023": 17,
    "22025": 9,
    "22027": 7,
    "22029": 9,
    "22031": 8,
    "22033": 14,
    "22035": 7,
    "22037": 12,
    "22039": 11,
    "22041": 9,
    "22043": 8,
    "22045": 19,
    "22047": 12,
    "22049": 7,
    "22051": 0,
    "22053": 15,
    "22055": 13,
    "22057": 19,
    "22059": 8,
    "22061": 7,
    "22063": 17,
    "22065": 7,
    "22067": 8,
    "22069": 12,
    "22071": 14,
    "22073": 11,
    "22075": 20,
    "22077": 12,
    "22079": 14,
    "22081": 8,
    "22083": 8,
    "22085": 9,
    "22087": 18,
    "22089": 19,
    "22091": 13,
    "22093": 16,
    "22095": 18,
    "22097": 12,
    "22099": 17,
    "22101": 18,
    "22103": 18,
    "22105": 17,
    "22107": 7,
    "22109": 19,
    "22111": 8,
    "22113": 17,
    "22115": 10,
    "22117": 15,
    "22119": 6,
    "22121": 12,
    "22123": 7,
    "22125": 11,
    "22127": 6,
    "23001": 3,
    "23003": 1,
    "23005": 3,
    "23007": 3,
    "23009": 1,
    "23011": 3,
    "23013": 2,
    "23015": 3,
    "23017": 4,
    "23019": 1,
    "23021": 0,
    "23023": 2,
    "23025": 2,
    "23027": 1,
    "23029": 1,
    "23031": 3,
    "24001": 6,
    "24003": 6,
    "24005": 6,
    "24009": 7,
    "24011": 7,
    "24013": 5,
    "24015": 7,
    "24017": 7,
    "24019": 6,
    "24021": 6,
    "24023": 5,
    "24025": 7,
    "24027": 5,
    "24029": 7,
    "24031": 5,
    "24033": 5,
    "24035": 7,
    "24037": 7,
    "24039": 7,
    "24041": 7,
    "24043": 5,
    "24045": 6,
    "24047": 6,
    "24510": 0,
    "25001": 8,
    "25003": 5,
    "25005": 8,
    "25007": 8,
    "25009": 6,
    "25011": 5,
    "25013": 6,
    "25015": 5,
    "25017": 6,
    "25019": 6,
    "25021": 7,
    "25023": 8,
    "25025": 7,
    "25027": 6,
    "26001": 1,
    "26003": 1,
    "26005": 1,
    "26007": 1,
    "26009": 1,
    "26011": 1,
    "26013": 1,
    "26015": 1,
    "26017": 1,
    "26019": 1,
    "26021": 1,
    "26023": 1,
    "26025": 1,
    "26027": 1,
    "26029": 1,
    "26031": 1,
    "26033": 1,
    "26035": 1,
    "26037": 1,
    "26039": 1,
    "26041": 1,
    "26043": 1,
    "26045": 1,
    "26047": 1,
    "26049": 1,
    "26051": 1,
    "26053": 1,
    "26055": 1,
    "26057": 1,
    "26059": 1,
    "26061": 1,
    "26063": 1,
    "26065": 1,
    "26067": 1,
    "26069": 1,
    "26071": 1,
    "26073": 1,
    "26075": 1,
    "26077": 1,
    "26079": 1,
    "26081": 1,
    "26083": 1,
    "26085": 1,
    "26087": 1,
    "26089": 1,
    "26091": 1,
    "26093": 1,
    "26095": 1,
    "26097": 1,
    "26099": 1,
    "26101": 1,
    "26103": 1,
    "26105": 1,
    "26107": 1,
    "26109": 1,
    "26111": 1,
    "26113": 1,
    "26115": 1,
    "26117": 1,
    "26119": 1,
    "26121": 1,
    "26123": 1,
    "26125": 1,
    "26127": 1,
    "26129": 1,
    "26131": 1,
    "26133": 1,
    "26135": 1,
    "26137": 1,
    "26139": 1,
    "26141": 1,
    "26143": 1,
    "26145": 1,
    "26147": 1,
    "26149": 1,
    "26151": 1,
    "26153": 1,
    "26155": 1,
    "26157": 1,
    "26159": 1,
    "26161": 1,
    "26163": 1,
    "26165": 1,
    "27001": 1,
    "27003": 1,
    "27005": 1,
    "27007": 1,
    "27009": 1,
    "27011": 1,
    "27013": 1,
    "27015": 1,
    "27017": 1,
    "27019": 1,
    "27021": 1,
    "27023": 1,
    "27025": 1,
    "27027": 1,
    "27029": 1,
    "27031": 1,
    "27033": 1,
    "27035": 1,
    "27037": 1,
    "27039": 1,
    "27041": 1,
    "27043": 1,
    "27045": 1,
    "27047": 1,
    "27049": 1,
    "27051": 1,
    "27053": 1,
    "27055": 1,
    "27057": 1,
    "27059": 1,
    "27061": 1,
    "27063": 1,
    "27065": 1,
    "27067": 1,
    "27069": 1,
    "27071": 1,
    "27073": 1,
    "27075": 0,
    "27077": 1,
    "27079": 1,
    "27081": 1,
    "27083": 1,
    "27085": 1,
    "27087": 1,
    "27089": 1,
    "27091": 1,
    "27093": 1,
    "27095": 1,
    "27097": 1,
    "27099": 1,
    "27101": 1,
    "27103": 1,
    "27105": 1,
    "27107": 1,
    "27109": 1,
    "27111": 1,
    "27113": 1,
    "27115": 1,
    "27117": 1,
    "27119": 1,
    "27121": 1,
    "27123": 1,
    "27125": 1,
    "27127": 1,
    "27129": 1,
    "27131": 1,
    "27133": 1,
    "27135": 1,
    "27137": 1,
    "27139": 1,
    "27141": 1,
    "27143": 1,
    "27145": 1,
    "27147": 1,
    "27149": 1,
    "27151": 1,
    "27153": 1,
    "27155": 1,
    "27157": 1,
    "27159": 1,
    "27161": 1,
    "27163": 1,
    "27165": 1,
    "27167": 1,
    "27169": 1,
    "27171": 1,
    "27173": 1,
    "28001": 6,
    "28003": 2,
    "28005": 9,
    "28007": 5,
    "28009": 2,
    "28011": 2,
    "28013": 3,
    "28015": 4,
    "28017": 3,
    "28019": 3,
    "28021": 6,
    "28023": 7,
    "28025": 4,
    "28027": 2,
    "28029": 8,
    "28031": 11,
    "28033": 2,
    "28035": 12,
    "28037": 6,
    "28039": 14,
    "28041": 12,
    "28043": 4,
    "28045": 14,
    "28047": 17,
    "28049": 7,
    "28051": 5,
    "28053": 2,
    "28055": 3,
    "28057": 3,
    "28059": 17,
    "28061": 9,
    "28063": 0,
    "28065": 11,
    "28067": 11,
    "28069": 5,
    "28071": 2,
    "28073": 11,
    "28075": 7,
    "28077": 8,
    "28079": 4,
    "28081": 3,
    "28083": 2,
    "28085": 9,
    "28087": 4,
    "28089": 6,
    "28091": 10,
    "28093": 2,
    "28095": 4,
    "28097": 4,
    "28099": 5,
    "28101": 5,
    "28103": 5,
    "28105": 4,
    "28107": 2,
    "28109": 16,
    "28111": 10,
    "28113": 11,
    "28115": 3,
    "28117": 2,
    "28119": 2,
    "28121": 7,
    "28123": 5,
    "28125": 2,
    "28127": 6,
    "28129": 6,
    "28131": 16,
    "28133": 2,
    "28135": 2,
    "28137": 2,
    "28139": 2,
    "28141": 2,
    "28143": 2,
    "28145": 2,
    "28147": 8,
    "28149": 4,
    "28151": 3,
    "28153": 10,
    "28155": 3,
    "28157": 8,
    "28159": 5,
    "28161": 2,
    "28163": 4,
    "29001": 1,
    "29003": 1,
    "29005": 1,
    "29007": 1,
    "29009": 1,
    "29011": 1,
    "29013": 1,
    "29015": 1,
    "29017": 1,
    "29019": 1,
    "29021": 1,
    "29023": 1,
    "29025": 1,
    "29027": 1,
    "29029": 1,
    "29031": 1,
    "29033": 1,
    "29035": 1,
    "29037": 1,
    "29039": 1,
    "29041": 1,
    "29043": 1,
    "29045": 1,
    "29047": 1,
    "29049": 1,
    "29051": 1,
    "29053": 1,
    "29055": 1,
    "29057": 1,
    "29059": 1,
    "29061": 1,
    "29063": 1,
    "29065": 1,
    "29067": 1,
    "29069": 1,
    "29071": 1,
    "29073": 1,
    "29075": 1,
    "29077": 1,
    "29079": 1,
    "29081": 1,
    "29083": 1,
    "29085": 1,
    "29087": 1,
    "29089": 1,
    "29091": 1,
    "29093": 1,
    "29095": 1,
    "29097": 1,
    "29099": 1,
    "29101": 1,
    "29103": 1,
    "29105": 1,
    "29107": 1,
    "29109": 1,
    "29111": 1,
    "29113": 1,
    "29115": 1,
    "29117": 1,
    "29119": 1,
    "29121": 1,
    "29123": 1,
    "29125": 1,
    "29127": 1,
    "29129": 1,
    "29131": 1,
    "29133": 1,
    "29135": 1,
    "29137": 1,
    "29139": 1,
    "29141": 1,
    "29143": 1,
    "29145": 1,
    "29147": 1,
    "29149": 1,
    "29151": 1,
    "29153": 1,
    "29155": 1,
    "29157": 1,
    "29159": 1,
    "29161": 1,
    "29163": 1,
    "29165": 1,
    "29167": 1,
    "29169": 1,
    "29171": 1,
    "29173": 1,
    "29175": 1,
    "29177": 1,
    "29179": 1,
    "29181": 1,
    "29183": 1,
    "29185": 1,
    "29186": 1,
    "29187": 1,
    "29189": 2,
    "29195": 1,
    "29197": 1,
    "29199": 1,
    "29201": 1,
    "29203": 1,
    "29205": 1,
    "29207": 1,
    "29209": 1,
    "29211": 1,
    "29213": 1,
    "29215": 1,
    "29217": 1,
    "29219": 1,
    "29221": 1,
    "29223": 1,
    "29225": 1,
    "29227": 1,
    "29229": 1,
    "29510": 0,
    "30001": 1,
    "30003": 1,
    "30005": 1,
    "30007": 1,
    "30009": 1,
    "30011": 1,
    "30013": 1,
    "30015": 1,
    "30017": 1,
    "30019": 1,
    "30021": 1,
    "30023": 1,
    "30025": 1,
    "30027": 1,
    "30029": 1,
    "30031": 1,
    "30033": 1,
    "30035": 1,
    "30037": 1,
    "30039": 1,
    "30041": 1,
    "30043": 1,
    "30045": 1,
    "30047": 1,
    "30049": 1,
    "30051": 1,
    "30053": 1,
    "30055": 1,
    "30057": 1,
    "30059": 1,
    "30061": 1,
    "30063": 1,
    "30065": 1,
    "30067": 1,
    "30069": 1,
    "30071": 1,
    "30073": 1,
    "30075": 1,
    "30077": 1,
    "30079": 1,
    "30081": 1,
    "30083": 1,
    "30085": 1,
    "30087": 1,
    "30089": 1,
    "30091": 1,
    "30093": 1,
    "30095": 1,
    "30097": 1,
    "30099": 1,
    "30101": 1,
    "30103": 1,
    "30105": 1,
    "30107": 1,
    "30109": 1,
    "30111": 1,
    "31001": 1,
    "31003": 1,
    "31005": 1,
    "31007": 1,
    "31009": 1,
    "31011": 1,
    "31013": 1,
    "31015": 1,
    "31017": 1,
    "31019": 1,
    "31021": 1,
    "31023": 1,
    "31025": 1,
    "31027": 1,
    "31029": 1,
    "31031": 1,
    "31033": 1,
    "31035": 1,
    "31037": 1,
    "31039": 1,
    "31041": 1,
    "31043": 1,
    "31045": 1,
    "31047": 1,
    "31049": 1,
    "31051": 1,
    "31053": 1,
    "31055": 1,
    "31057": 1,
    "31059": 1,
    "31061": 1,
    "31063": 1,
    "31065": 1,
    "31067": 1,
    "31069": 1,
    "31071": 1,
    "31073": 1,
    "31075": 1,
    "31077": 1,
    "31079": 1,
    "31081": 1,
    "31083": 1,
    "31085": 1,
    "31087": 1,
    "31089": 1,
    "31091": 1,
    "31093": 1,
    "31095": 1,
    "31097": 1,
    "31099": 1,
    "31101": 1,
    "31103": 1,
    "31105": 1,
    "31107": 1,
    "31109": 1,
    "31111": 1,
    "31113": 1,
    "31115": 1,
    "31117": 1,
    "31119": 1,
    "31121": 1,
    "31123": 1,
    "31125": 1,
    "31127": 1,
    "31129": 1,
    "31131": 1,
    "31133": 1,
    "31135": 1,
    "31137": 1,
    "31139": 1,
    "31141": 1,
    "31143": 1,
    "31145": 1,
    "31147": 1,
    "31149": 1,
    "31151": 1,
    "31153": 1,
    "31155": 1,
    "31157": 1,
    "31159": 1,
    "31161": 1,
    "31163": 1,
    "31165": 1,
    "31167": 1,
    "31169": 1,
    "31171": 1,
    "31173": 1,
    "31175": 1,
    "31177": 1,
    "31179": 1,
    "31181": 1,
    "31183": 1,
    "31185": 1,
    "32001": 1,
    "32003": 1,
    "32005": 1,
    "32007": 1,
    "32009": 1,
    "32011": 1,
    "32013": 1,
    "32015": 1,
    "32017": 1,
    "32019": 1,
    "32021": 1,
    "32023": 1,
    "32027": 1,
    "32029": 1,
    "32031": 1,
    "32033": 1,
    "32510": 1,
    "33001": 5,
    "33003": 5,
    "33005": 3,
    "33007": 4,
    "33009": 5,
    "33011": 3,
    "33013": 3,
    "33015": 4,
    "33017": 4,
    "33019": 4,
    "34001": 7,
    "34003": 7,
    "34005": 6,
    "34007": 6,
    "34009": 7,
    "34011": 7,
    "34013": 7,
    "34015": 6,
    "34017": 6,
    "34019": 7,
    "34021": 7,
    "34023": 7,
    "34025": 7,
    "34027": 7,
    "34029": 6,
    "34031": 7,
    "34033": 6,
    "34035": 7,
    "34037": 6,
    "34039": 7,
    "34041": 6,
    "35001": 1,
    "35003": 1,
    "35005": 1,
    "35006": 1,
    "35007": 1,
    "35009": 1,
    "35011": 0,
    "35013": 1,
    "35015": 1,
    "35017": 1,
    "35019": 1,
    "35021": 1,
    "35023": 1,
    "35025": 1,
    "35027": 1,
    "35028": 1,
    "35029": 1,
    "35031": 1,
    "35033": 1,
    "35035": 1,
    "35037": 1,
    "35039": 1,
    "35041": 1,
    "35043": 1,
    "35045": 1,
    "35047": 1,
    "35049": 1,
    "35051": 1,
    "35053": 1,
    "35055": 1,
    "35057": 1,
    "35059": 1,
    "35061": 1,
    "36001": 4,
    "36003": 2,
    "36005": 5,
    "36007": 2,
    "36009": 2,
    "36011": 2,
    "36013": 2,
    "36015": 2,
    "36017": 2,
    "36019": 3,
    "36021": 4,
    "36023": 2,
    "36025": 4,
    "36027": 4,
    "36029": 2,
    "36031": 4,
    "36033": 3,
    "36035": 3,
    "36037": 2,
    "36039": 6,
    "36041": 3,
    "36043": 3,
    "36045": 2,
    "36047": 5,
    "36049": 2,
    "36051": 2,
    "36053": 2,
    "36055": 2,
    "36057": 3,
    "36059": 8,
    "36061": 5,
    "36063": 2,
    "36065": 2,
    "36067": 2,
    "36069": 2,
    "36071": 7,
    "36073": 2,
    "36075": 2,
    "36077": 3,
    "36079": 7,
    "36081": 5,
    "36083": 5,
    "36085": 5,
    "36087": 7,
    "36089": 2,
    "36091": 3,
    "36093": 4,
    "36095": 5,
    "36097": 2,
    "36099": 2,
    "36101": 2,
    "36103": 9,
    "36105": 5,
    "36107": 2,
    "36109": 2,
    "36111": 6,
    "36113": 4,
    "36115": 3,
    "36117": 2,
    "36119": 7,
    "36121": 2,
    "36123": 2,
    "37001": 8,
    "37003": 3,
    "37005": 5,
    "37007": 9,
    "37009": 5,
    "37011": 4,
    "37013": 16,
    "37015": 13,
    "37017": 14,
    "37019": 19,
    "37021": 4,
    "37023": 4,
    "37025": 4,
    "37027": 4,
    "37029": 11,
    "37031": 17,
    "37033": 7,
    "37035": 3,
    "37037": 8,
    "37039": 1,
    "37041": 13,
    "37043": 1,
    "37045": 3,
    "37047": 16,
    "37049": 17,
    "37051": 11,
    "37053": 12,
    "37055": 17,
    "37057": 10,
    "37059": 4,
    "37061": 14,
    "37063": 7,
    "37065": 11,
    "37067": 7,
    "37069": 7,
    "37071": 3,
    "37073": 10,
    "37075": 2,
    "37077": 8,
    "37079": 14,
    "37081": 8,
    "37083": 11,
    "37085": 8,
    "37087": 3,
    "37089": 4,
    "37091": 11,
    "37093": 8,
    "37095": 18,
    "37097": 4,
    "37099": 3,
    "37101": 11,
    "37103": 15,
    "37105": 7,
    "37107": 14,
    "37109": 3,
    "37111": 5,
    "37113": 3,
    "37115": 4,
    "37117": 12,
    "37119": 3,
    "37121": 3,
    "37123": 9,
    "37125": 7,
    "37127": 10,
    "37129": 17,
    "37131": 11,
    "37133": 16,
    "37135": 8,
    "37137": 17,
    "37139": 11,
    "37141": 17,
    "37143": 11,
    "37145": 8,
    "37147": 14,
    "37149": 5,
    "37151": 8,
    "37153": 8,
    "37155": 10,
    "37157": 7,
    "37159": 5,
    "37161": 4,
    "37163": 12,
    "37165": 8,
    "37167": 6,
    "37169": 7,
    "37171": 4,
    "37173": 2,
    "37175": 3,
    "37177": 12,
    "37179": 6,
    "37181": 8,
    "37183": 7,
    "37185": 8,
    "37187": 11,
    "37189": 4,
    "37191": 12,
    "37193": 4,
    "37195": 11,
    "37197": 4,
    "37199": 4,
    "38001": 0,
    "38003": 0,
    "38005": 0,
    "38007": 0,
    "38009": 0,
    "38011": 0,
    "38013": 0,
    "38015": 0,
    "38017": 0,
    "38019": 0,
    "38021": 0,
    "38023": 0,
    "38025": 0,
    "38027": 0,
    "38029": 0,
    "38031": 0,
    "38033": 0,
    "38035": 0,
    "38037": 0,
    "38039": 0,
    "38041": 0,
    "38043": 0,
    "38045": 0,
    "38047": 0,
    "38049": 0,
    "38051": 0,
    "38053": 0,
    "38055": 0,
    "38057": 0,
    "38059": 0,
    "38061": 0,
    "38063": 0,
    "38065": 0,
    "38067": 0,
    "38069": 0,
    "38071": 0,
    "38073": 0,
    "38075": 0,
    "38077": 0,
    "38079": 0,
    "38081": 0,
    "38083": 0,
    "38085": 0,
    "38087": 0,
    "38089": 0,
    "38091": 0,
    "38093": 0,
    "38095": 0,
    "38097": 0,
    "38099": 0,
    "38101": 0,
    "38103": 0,
    "38105": 0,
    "39001": 1,
    "39003": 1,
    "39005": 1,
    "39007": 2,
    "39009": 1,
    "39011": 1,
    "39013": 1,
    "39015": 1,
    "39017": 1,
    "39019": 1,
    "39021": 1,
    "39023": 1,
    "39025": 1,
    "39027": 1,
    "39029": 1,
    "39031": 1,
    "39033": 1,
    "39035": 2,
    "39037": 1,
    "39039": 1,
    "39041": 1,
    "39043": 1,
    "39045": 1,
    "39047": 1,
    "39049": 1,
    "39051": 1,
    "39053": 1,
    "39055": 1,
    "39057": 1,
    "39059": 1,
    "39061": 1,
    "39063": 1,
    "39065": 1,
    "39067": 1,
    "39069": 1,
    "39071": 1,
    "39073": 1,
    "39075": 1,
    "39077": 1,
    "39079": 1,
    "39081": 1,
    "39083": 1,
    "39085": 1,
    "39087": 1,
    "39089": 1,
    "39091": 1,
    "39093": 1,
    "39095": 1,
    "39097": 1,
    "39099": 1,
    "39101": 1,
    "39103": 1,
    "39105": 1,
    "39107": 1,
    "39109": 1,
    "39111": 1,
    "39113": 1,
    "39115": 1,
    "39117": 1,
    "39119": 1,
    "39121": 1,
    "39123": 1,
    "39125": 1,
    "39127": 1,
    "39129": 1,
    "39131": 1,
    "39133": 1,
    "39135": 1,
    "39137": 1,
    "39139": 1,
    "39141": 1,
    "39143": 1,
    "39145": 1,
    "39147": 1,
    "39149": 1,
    "39151": 1,
    "39153": 1,
    "39155": 1,
    "39157": 1,
    "39159": 1,
    "39161": 1,
    "39163": 1,
    "39165": 1,
    "39167": 1,
    "39169": 1,
    "39171": 1,
    "39173": 1,
    "39175": 1,
    "40001": 1,
    "40003": 1,
    "40005": 1,
    "40007": 1,
    "40009": 1,
    "40011": 1,
    "40013": 1,
    "40015": 1,
    "40017": 1,
    "40019": 1,
    "40021": 1,
    "40023": 1,
    "40025": 1,
    "40027": 1,
    "40029": 1,
    "40031": 1,
    "40033": 1,
    "40035": 1,
    "40037": 1,
    "40039": 1,
    "40041": 1,
    "40043": 1,
    "40045": 1,
    "40047": 1,
    "40049": 1,
    "40051": 1,
    "40053": 1,
    "40055": 1,
    "40057": 1,
    "40059": 1,
    "40061": 1,
    "40063": 1,
    "40065": 1,
    "40067": 1,
    "40069": 1,
    "40071": 1,
    "40073": 1,
    "40075": 1,
    "40077": 1,
    "40079": 1,
    "40081": 1,
    "40083": 1,
    "40085": 1,
    "40087": 1,
    "40089": 1,
    "40091": 1,
    "40093": 1,
    "40095": 1,
    "40097": 1,
    "40099": 1,
    "40101": 1,
    "40103": 1,
    "40105": 1,
    "40107": 1,
    "40109": 1,
    "40111": 1,
    "40113": 1,
    "40115": 1,
    "40117": 1,
    "40119": 1,
    "40121": 1,
    "40123": 1,
    "40125": 1,
    "40127": 1,
    "40129": 1,
    "40131": 1,
    "40133": 1,
    "40135": 1,
    "40137": 1,
    "40139": 1,
    "40141": 1,
    "40143": 1,
    "40145": 1,
    "40147": 1,
    "40149": 1,
    "40151": 1,
    "40153": 1,
    "41001": 0,
    "41003": 0,
    "41005": 0,
    "41007": 0,
    "41009": 0,
    "41011": 0,
    "41013": 0,
    "41015": 0,
    "41017": 0,
    "41019": 0,
    "41021": 0,
    "41023": 0,
    "41025": 0,
    "41027": 0,
    "41029": 0,
    "41031": 0,
    "41033": 0,
    "41035": 0,
    "41037": 0,
    "41039": 0,
    "41041": 0,
    "41043": 0,
    "41045": 0,
    "41047": 0,
    "41049": 0,
    "41051": 0,
    "41053": 0,
    "41055": 0,
    "41057": 0,
    "41059": 0,
    "41061": 0,
    "41063": 0,
    "41065": 0,
    "41067": 0,
    "41069": 0,
    "41071": 0,
    "42001": 3,
    "42003": 3,
    "42005": 3,
    "42007": 3,
    "42009": 4,
    "42011": 4,
    "42013": 3,
    "42015": 3,
    "42017": 7,
    "42019": 3,
    "42021": 3,
    "42023": 4,
    "42025": 4,
    "42027": 3,
    "42029": 6,
    "42031": 3,
    "42033": 3,
    "42035": 3,
    "42037": 3,
    "42039": 3,
    "42041": 3,
    "42043": 4,
    "42045": 6,
    "42047": 3,
    "42049": 3,
    "42051": 3,
    "42053": 4,
    "42055": 4,
    "42057": 4,
    "42059": 3,
    "42061": 4,
    "42063": 3,
    "42065": 3,
    "42067": 4,
    "42069": 4,
    "42071": 4,
    "42073": 3,
    "42075": 3,
    "42077": 5,
    "42079": 6,
    "42081": 3,
    "42083": 3,
    "42085": 3,
    "42087": 3,
    "42089": 6,
    "42091": 7,
    "42093": 3,
    "42095": 6,
    "42097": 3,
    "42099": 3,
    "42101": 7,
    "42103": 6,
    "42105": 4,
    "42107": 3,
    "42109": 3,
    "42111": 4,
    "42113": 6,
    "42115": 5,
    "42117": 3,
    "42119": 3,
    "42121": 3,
    "42123": 3,
    "42125": 3,
    "42127": 6,
    "42129": 3,
    "42131": 7,
    "42133": 4,
    "44001": 7,
    "44003": 7,
    "44005": 7,
    "44007": 6,
    "44009": 7,
    "45001": 5,
    "45003": 5,
    "45005": 8,
    "45007": 5,
    "45009": 8,
    "45011": 8,
    "45013": 8,
    "45015": 11,
    "45017": 11,
    "45019": 11,
    "45021": 6,
    "45023": 0,
    "45025": 11,
    "45027": 11,
    "45029": 10,
    "45031": 11,
    "45033": 11,
    "45035": 10,
    "45037": 5,
    "45039": 7,
    "45041": 11,
    "45043": 12,
    "45045": 6,
    "45047": 5,
    "45049": 8,
    "45051": 13,
    "45053": 9,
    "45055": 10,
    "45057": 8,
    "45059": 5,
    "45061": 10,
    "45063": 8,
    "45065": 5,
    "45067": 11,
    "45069": 11,
    "45071": 6,
    "45073": 6,
    "45075": 10,
    "45077": 6,
    "45079": 10,
    "45081": 5,
    "45083": 6,
    "45085": 11,
    "45087": 5,
    "45089": 11,
    "45091": 7,
    "46003": 0,
    "46005": 0,
    "46007": 0,
    "46009": 0,
    "46011": 0,
    "46013": 0,
    "46015": 0,
    "46017": 0,
    "46019": 0,
    "46021": 0,
    "46023": 0,
    "46025": 0,
    "46027": 0,
    "46029": 0,
    "46031": 0,
    "46033": 0,
    "46035": 0,
    "46037": 0,
    "46039": 0,
    "46041": 0,
    "46043": 0,
    "46045": 0,
    "46047": 0,
    "46049": 0,
    "46051": 0,
    "46053": 0,
    "46055": 0,
    "46057": 0,
    "46059": 0,
    "46061": 0,
    "46063": 0,
    "46065": 0,
    "46067": 0,
    "46069": 0,
    "46071": 0,
    "46073": 0,
    "46075": 0,
    "46077": 0,
    "46079": 0,
    "46081": 0,
    "46083": 0,
    "46085": 0,
    "46087": 0,
    "46089": 0,
    "46091": 0,
    "46093": 0,
    "46095": 0,
    "46097": 0,
    "46099": 0,
    "46101": 0,
    "46103": 0,
    "46105": 0,
    "46107": 0,
    "46109": 0,
    "46111": 0,
    "46113": 0,
    "46115": 0,
    "46117": 0,
    "46119": 0,
    "46121": 0,
    "46123": 0,
    "46125": 0,
    "46127": 0,
    "46129": 0,
    "46135": 0,
    "46137": 0,
    "47001": 1,
    "47003": 1,
    "47005": 1,
    "47007": 1,
    "47009": 1,
    "47011": 1,
    "47013": 1,
    "47015": 1,
    "47017": 1,
    "47019": 1,
    "47021": 1,
    "47023": 1,
    "47025": 1,
    "47027": 1,
    "47029": 1,
    "47031": 1,
    "47033": 1,
    "47035": 1,
    "47037": 1,
    "47039": 1,
    "47041": 1,
    "47043": 1,
    "47045": 1,
    "47047": 1,
    "47049": 1,
    "47051": 1,
    "47053": 1,
    "47055": 1,
    "47057": 1,
    "47059": 1,
    "47061": 1,
    "47063": 1,
    "47065": 1,
    "47067": 1,
    "47069": 1,
    "47071": 1,
    "47073": 1,
    "47075": 1,
    "47077": 1,
    "47079": 1,
    "47081": 1,
    "47083": 1,
    "47085": 1,
    "47087": 1,
    "47089": 1,
    "47091": 1,
    "47093": 1,
    "47095": 1,
    "47097": 1,
    "47099": 1,
    "47101": 1,
    "47103": 1,
    "47105": 1,
    "47107": 1,
    "47109": 1,
    "47111": 1,
    "47113": 1,
    "47115": 1,
    "47117": 1,
    "47119": 1,
    "47121": 1,
    "47123": 1,
    "47125": 1,
    "47127": 1,
    "47129": 1,
    "47131": 1,
    "47133": 1,
    "47135": 1,
    "47137": 1,
    "47139": 1,
    "47141": 1,
    "47143": 1,
    "47145": 1,
    "47147": 1,
    "47149": 1,
    "47151": 1,
    "47153": 1,
    "47155": 1,
    "47157": 1,
    "47159": 1,
    "47161": 1,
    "47163": 1,
    "47165": 1,
    "47167": 1,
    "47169": 1,
    "47171": 1,
    "47173": 1,
    "47175": 1,
    "47177": 1,
    "47179": 1,
    "47181": 1,
    "47183": 1,
    "47185": 1,
    "47187": 1,
    "47189": 1,
    "48001": 5,
    "48003": 3,
    "48005": 6,
    "48007": 15,
    "48009": 4,
    "48011": 3,
    "48013": 6,
    "48015": 7,
    "48017": 3,
    "48019": 3,
    "48021": 4,
    "48023": 3,
    "48025": 11,
    "48027": 4,
    "48029": 10,
    "48031": 3,
    "48033": 3,
    "48035": 3,
    "48037": 6,
    "48039": 10,
    "48041": 6,
    "48043": 3,
    "48045": 3,
    "48047": 11,
    "48049": 3,
    "48051": 5,
    "48053": 3,
    "48055": 4,
    "48057": 12,
    "48059": 3,
    "48061": 13,
    "48063": 3,
    "48065": 3,
    "48067": 5,
    "48069": 3,
    "48071": 9,
    "48073": 5,
    "48075": 3,
    "48077": 3,
    "48079": 3,
    "48081": 3,
    "48083": 3,
    "48085": 0,
    "48087": 3,
    "48089": 6,
    "48091": 6,
    "48093": 3,
    "48095": 3,
    "48097": 3,
    "48099": 3,
    "48101": 4,
    "48103": 3,
    "48105": 3,
    "48107": 3,
    "48109": 3,
    "48111": 3,
    "48113": 7,
    "48115": 4,
    "48117": 3,
    "48119": 3,
    "48121": 5,
    "48123": 8,
    "48125": 3,
    "48127": 3,
    "48129": 3,
    "48131": 7,
    "48133": 3,
    "48135": 3,
    "48137": 3,
    "48139": 4,
    "48141": 5,
    "48143": 3,
    "48145": 3,
    "48147": 3,
    "48149": 4,
    "48151": 3,
    "48153": 4,
    "48155": 4,
    "48157": 9,
    "48159": 4,
    "48161": 3,
    "48163": 4,
    "48165": 3,
    "48167": 10,
    "48169": 4,
    "48171": 3,
    "48173": 3,
    "48175": 9,
    "48177": 5,
    "48179": 0,
    "48181": 4,
    "48183": 5,
    "48185": 5,
    "48187": 5,
    "48189": 3,
    "48191": 3,
    "48193": 3,
    "48195": 3,
    "48197": 3,
    "48199": 7,
    "48201": 0,
    "48203": 5,
    "48205": 3,
    "48207": 3,
    "48209": 3,
    "48211": 3,
    "48213": 4,
    "48215": 13,
    "48217": 4,
    "48219": 3,
    "48221": 3,
    "48223": 4,
    "48225": 4,
    "48227": 3,
    "48229": 3,
    "48231": 4,
    "48233": 3,
    "48235": 3,
    "48237": 0,
    "48239": 9,
    "48241": 7,
    "48243": 3,
    "48245": 7,
    "48247": 11,
    "48249": 14,
    "48251": 3,
    "48253": 3,
    "48255": 6,
    "48257": 4,
    "48259": 3,
    "48261": 11,
    "48263": 3,
    "48265": 3,
    "48267": 3,
    "48269": 3,
    "48271": 3,
    "48273": 12,
    "48275": 3,
    "48277": 4,
    "48279": 4,
    "48281": 3,
    "48283": 4,
    "48285": 7,
    "48287": 4,
    "48289": 4,
    "48291": 8,
    "48293": 3,
    "48295": 3,
    "48297": 8,
    "48299": 3,
    "48301": 3,
    "48303": 6,
    "48305": 4,
    "48307": 3,
    "48309": 5,
    "48311": 6,
    "48313": 5,
    "48315": 4,
    "48317": 3,
    "48319": 3,
    "48321": 11,
    "48323": 4,
    "48325": 4,
    "48327": 3,
    "48329": 3,
    "48331": 5,
    "48333": 3,
    "48335": 3,
    "48337": 3,
    "48339": 8,
    "48341": 3,
    "48343": 4,
    "48345": 4,
    "48347": 7,
    "48349": 5,
    "48351": 7,
    "48353": 3,
    "48355": 14,
    "48357": 3,
    "48359": 3,
    "48361": 7,
    "48363": 3,
    "48365": 5,
    "48367": 4,
    "48369": 3,
    "48371": 3,
    "48373": 7,
    "48375": 5,
    "48377": 3,
    "48379": 3,
    "48381": 4,
    "48383": 3,
    "48385": 3,
    "48387": 3,
    "48389": 3,
    "48391": 12,
    "48393": 0,
    "48395": 4,
    "48397": 3,
    "48399": 3,
    "48401": 4,
    "48403": 7,
    "48405": 6,
    "48407": 8,
    "48409": 15,
    "48411": 3,
    "48413": 3,
    "48415": 3,
    "48417": 3,
    "48419": 6,
    "48421": 3,
    "48423": 7,
    "48425": 3,
    "48427": 9,
    "48429": 3,
    "48431": 3,
    "48433": 3,
    "48435": 3,
    "48437": 3,
    "48439": 7,
    "48441": 3,
    "48443": 3,
    "48445": 4,
    "48447": 3,
    "48449": 4,
    "48451": 5,
    "48453": 7,
    "48455": 6,
    "48457": 7,
    "48459": 4,
    "48461": 3,
    "48463": 3,
    "48465": 4,
    "48467": 4,
    "48469": 10,
    "48471": 8,
    "48473": 7,
    "48475": 3,
    "48477": 5,
    "48479": 8,
    "48481": 8,
    "48483": 3,
    "48485": 3,
    "48487": 3,
    "48489": 12,
    "48491": 4,
    "48493": 4,
    "48495": 3,
    "48497": 4,
    "48499": 4,
    "48501": 3,
    "48503": 3,
    "48505": 6,
    "48507": 4,
    "49001": 0,
    "49003": 0,
    "49005": 0,
    "49007": 0,
    "49009": 0,
    "49011": 0,
    "49013": 0,
    "49015": 0,
    "49017": 0,
    "49019": 0,
    "49021": 0,
    "49023": 0,
    "49025": 0,
    "49027": 0,
    "49029": 0,
    "49031": 0,
    "49033": 0,
    "49035": 0,
    "49037": 0,
    "49039": 0,
    "49041": 0,
    "49043": 0,
    "49045": 0,
    "49047": 0,
    "49049": 0,
    "49051": 0,
    "49053": 0,
    "49055": 0,
    "49057": 0,
    "50001": 2,
    "50003": 2,
    "50005": 2,
    "50007": 2,
    "50009": 2,
    "50011": 2,
    "50013": 2,
    "50015": 2,
    "50017": 2,
    "50019": 2,
    "50021": 2,
    "50023": 2,
    "50025": 2,
    "50027": 2,
    "51001": 9,
    "51003": 5,
    "51005": 4,
    "51007": 6,
    "51009": 5,
    "51011": 5,
    "51013": 4,
    "51015": 5,
    "51017": 4,
    "51019": 4,
    "51021": 2,
    "51023": 5,
    "51025": 7,
    "51027": 2,
    "51029": 5,
    "51031": 6,
    "51033": 6,
    "51035": 2,
    "51036": 7,
    "51037": 0,
    "51041": 9,
    "51043": 5,
    "51045": 4,
    "51047": 5,
    "51049": 6,
    "51051": 2,
    "51053": 7,
    "51057": 10,
    "51059": 4,
    "51061": 5,
    "51063": 4,
    "51065": 6,
    "51067": 7,
    "51069": 0,
    "51071": 3,
    "51073": 7,
    "51075": 5,
    "51077": 4,
    "51079": 5,
    "51081": 6,
    "51083": 7,
    "51085": 6,
    "51087": 8,
    "51089": 4,
    "51091": 5,
    "51093": 9,
    "51095": 8,
    "51097": 11,
    "51099": 7,
    "51101": 9,
    "51103": 11,
    "51105": 2,
    "51107": 4,
    "51109": 6,
    "51111": 8,
    "51113": 5,
    "51115": 10,
    "51117": 7,
    "51119": 10,
    "51121": 4,
    "51125": 7,
    "51127": 9,
    "51131": 10,
    "51133": 12,
    "51135": 7,
    "51137": 4,
    "51139": 4,
    "51141": 3,
    "51143": 6,
    "51145": 7,
    "51147": 5,
    "51149": 6,
    "51153": 5,
    "51155": 3,
    "51157": 6,
    "51159": 7,
    "51161": 3,
    "51163": 5,
    "51165": 4,
    "51167": 3,
    "51169": 2,
    "51171": 5,
    "51173": 2,
    "51175": 6,
    "51177": 4,
    "51179": 4,
    "51181": 8,
    "51183": 7,
    "51185": 2,
    "51187": 5,
    "51191": 2,
    "51193": 11,
    "51195": 2,
    "51197": 2,
    "51199": 8,
    "51510": 4,
    "51515": 0,
    "51520": 3,
    "51530": 4,
    "51540": 4,
    "51550": 9,
    "51570": 5,
    "51580": 2,
    "51590": 6,
    "51595": 6,
    "51600": 0,
    "51610": 4,
    "51620": 0,
    "51630": 4,
    "51640": 3,
    "51650": 11,
    "51660": 4,
    "51670": 6,
    "51678": 3,
    "51680": 4,
    "51683": 4,
    "51685": 3,
    "51690": 5,
    "51700": 10,
    "51710": 9,
    "51720": 2,
    "51730": 5,
    "51735": 8,
    "51740": 9,
    "51750": 2,
    "51760": 0,
    "51770": 0,
    "51775": 2,
    "51790": 4,
    "51800": 10,
    "51810": 9,
    "51820": 4,
    "51830": 8,
    "51840": 3,
    "53001": 0,
    "53003": 0,
    "53005": 0,
    "53007": 0,
    "53009": 0,
    "53011": 0,
    "53013": 0,
    "53015": 0,
    "53017": 0,
    "53019": 0,
    "53021": 0,
    "53023": 0,
    "53025": 0,
    "53027": 0,
    "53029": 0,
    "53031": 0,
    "53033": 0,
    "53035": 0,
    "53037": 0,
    "53039": 0,
    "53041": 0,
    "53043": 0,
    "53045": 0,
    "53047": 0,
    "53049": 0,
    "53051": 0,
    "53053": 0,
    "53055": 0,
    "53057": 0,
    "53059": 0,
    "53061": 0,
    "53063": 0,
    "53065": 0,
    "53067": 0,
    "53069": 0,
    "53071": 0,
    "53073": 0,
    "53075": 0,
    "53077": 0,
    "54001": 3,
    "54003": 3,
    "54005": 3,
    "54007": 3,
    "54009": 2,
    "54011": 2,
    "54013": 2,
    "54015": 3,
    "54017": 2,
    "54019": 3,
    "54021": 2,
    "54023": 3,
    "54025": 3,
    "54027": 3,
    "54029": 2,
    "54031": 3,
    "54033": 2,
    "54035": 2,
    "54037": 3,
    "54039": 3,
    "54041": 3,
    "54043": 2,
    "54045": 2,
    "54047": 2,
    "54049": 2,
    "54051": 2,
    "54053": 2,
    "54055": 2,
    "54057": 3,
    "54059": 2,
    "54061": 2,
    "54063": 2,
    "54065": 3,
    "54067": 4,
    "54069": 2,
    "54071": 4,
    "54073": 2,
    "54075": 4,
    "54077": 3,
    "54079": 2,
    "54081": 3,
    "54083": 4,
    "54085": 2,
    "54087": 2,
    "54089": 2,
    "54091": 3,
    "54093": 4,
    "54095": 2,
    "54097": 3,
    "54099": 2,
    "54101": 3,
    "54103": 2,
    "54105": 2,
    "54107": 2,
    "54109": 3,
    "55001": 1,
    "55003": 1,
    "55005": 1,
    "55007": 1,
    "55009": 1,
    "55011": 1,
    "55013": 1,
    "55015": 1,
    "55017": 1,
    "55019": 1,
    "55021": 1,
    "55023": 1,
    "55025": 1,
    "55027": 1,
    "55029": 1,
    "55031": 1,
    "55033": 1,
    "55035": 1,
    "55037": 1,
    "55039": 1,
    "55041": 1,
    "55043": 1,
    "55045": 0,
    "55047": 1,
    "55049": 1,
    "55051": 1,
    "55053": 1,
    "55055": 1,
    "55057": 1,
    "55059": 1,
    "55061": 1,
    "55063": 1,
    "55065": 1,
    "55067": 1,
    "55069": 1,
    "55071": 1,
    "55073": 1,
    "55075": 1,
    "55077": 1,
    "55078": 1,
    "55079": 1,
    "55081": 1,
    "55083": 1,
    "55085": 1,
    "55087": 1,
    "55089": 1,
    "55091": 1,
    "55093": 1,
    "55095": 1,
    "55097": 1,
    "55099": 1,
    "55101": 1,
    "55103": 1,
    "55105": 1,
    "55107": 1,
    "55109": 1,
    "55111": 1,
    "55113": 1,
    "55115": 1,
    "55117": 1,
    "55119": 1,
    "55121": 1,
    "55123": 1,
    "55125": 1,
    "55127": 1,
    "55129": 1,
    "55131": 1,
    "55133": 1,
    "55135": 1,
    "55137": 1,
    "55139": 1,
    "55141": 1,
    "56001": 0,
    "56003": 0,
    "56005": 0,
    "56007": 0,
    "56009": 0,
    "56011": 0,
    "56013": 0,
    "56015": 0,
    "56017": 0,
    "56019": 0,
    "56021": 0,
    "56023": 0,
    "56025": 0,
    "56027": 0,
    "56029": 0,
    "56031": 0,
    "56033": 0,
    "56035": 0,
    "56037": 0,
    "56039": 0,
    "56041": 0,
    "56043": 0,
    "56045": 0
  }
];

export { disasters };